(function(global, factory) {
  typeof exports === "object" && typeof module !== "undefined" ? factory(exports, require("react/jsx-runtime"), require("@mui/material"), require("react"), require("@mui/system"), require("react-i18next")) : typeof define === "function" && define.amd ? define(["exports", "react/jsx-runtime", "@mui/material", "react", "@mui/system", "react-i18next"], factory) : (global = typeof globalThis !== "undefined" ? globalThis : global || self, factory(global["component-library"] = {}, global.jsxRuntime, global["@mui/material"], global.react, global.system, global.reactI18next));
})(this, function(exports2, jsxRuntime, material, React, system, reactI18next) {
  "use strict";
  function _interopNamespaceDefault(e) {
    const n = Object.create(null, { [Symbol.toStringTag]: { value: "Module" } });
    if (e) {
      for (const k in e) {
        if (k !== "default") {
          const d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: () => e[k]
          });
        }
      }
    }
    n.default = e;
    return Object.freeze(n);
  }
  const React__namespace = /* @__PURE__ */ _interopNamespaceDefault(React);
  void Promise.resolve().then(() => i18next).then(async ({ default: i18n }) => {
    try {
      const [{ default: de }, { default: en }, { default: es }, { default: fr }, { default: it }] = await Promise.all([
        Promise.resolve().then(() => de_DE$1),
        Promise.resolve().then(() => en_US$1),
        Promise.resolve().then(() => es_ES$1),
        Promise.resolve().then(() => fr_FR$1),
        Promise.resolve().then(() => it_IT$1)
      ]);
      const addResources = () => {
        Object.entries({ de, en, es, fr, it }).forEach(
          ([language, resource]) => i18n.addResourceBundle(language, "translation", { componentLibrary: resource }, true)
        );
      };
      if (i18n.isInitialized) {
        addResources();
      } else {
        i18n.on("initialized", () => addResources());
      }
    } catch (error) {
      if (process.env.NODE_ENV !== "production") {
        console.error("Error during i18n initialization", error);
      }
    }
  });
  const enterKeyFrame = material.css`
  @keyframes enter {
    0% {
      opacity: 0;
      transform: scale(0);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
`;
  const getRippleStyles = (rippleColor) => material.css`
  .MuiTouchRipple-child {
    color: ${rippleColor};
    background-color: ${rippleColor};
    animation-name: ${enterKeyFrame};
  }
  .MuiTouchRipple-rippleVisible {
    animation-name: none;
    opacity: 1;
  }
  .MuiTouchRipple-root {
    color: ${rippleColor};
  }
`;
  const upper = (val) => (
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    val[0].toUpperCase() + val.slice(1)
  );
  const getColorStyles = (color, isSelected, tokens) => {
    const { formControl: checkboxRadio } = tokens;
    const colorPrefix = `FormControlElementColor${upper(color)}`;
    const variant = isSelected ? "Checked" : "Unchecked";
    return material.css`
    svg {
      color: ${checkboxRadio[`${colorPrefix}${variant}DefaultIcon`]};
    }
    &.Mui-disabled {
      svg {
        color: ${checkboxRadio[`FormControlElementDisabled${variant}Icon`]};
      }
    }
    :hover {
      background-color: ${checkboxRadio[`${colorPrefix}${variant}HoverRipple`]};
    }
    ${getRippleStyles(checkboxRadio[`${colorPrefix}${variant}ActiveRipple`])};
  `;
  };
  const getCheckboxRadioStyles = (component, tokens) => {
    const { formControl: checkboxRadio, common: common2 } = tokens;
    const classNamePrefix = component === "checkbox" ? "MuiCheckbox" : "MuiRadio";
    return material.css`
    && {
      height: ${checkboxRadio.FormControlElementHeight};
    }
    &.Mui-focusVisible {
      svg {
        outline: ${common2.FocusedDefaultWidth} ${common2.FocusedDefaultColor} ${common2.FocusedDefaultStyle};
        border-radius: ${component === "checkbox" ? common2.BorderRadiusS : common2.BorderRadiusRound};
        offset: ${common2.FocusedOutlineOffset};
      }
      // Disable MUI's default ripple effect for the focused state
      :not(:hover):not(:active) {
        .MuiTouchRipple-child {
          opacity: 0;
        }
      }
    }
    &.${`${classNamePrefix}-colorPrimary`} {
      ${getColorStyles("primary", false, tokens)}
      &.Mui-checked, &.MuiCheckbox-indeterminate {
        ${getColorStyles("primary", true, tokens)}
      }
    }
    &.${`${classNamePrefix}-colorError`} {
      ${getColorStyles("error", false, tokens)}
      &.Mui-checked, &.MuiCheckbox-indeterminate {
        ${getColorStyles("error", true, tokens)}
      }
    }
  `;
  };
  const getSwitchStyles = (tokens) => {
    const { formControl, common: common2 } = tokens;
    return material.css`
    &.MuiSwitch-root {
      justify-content: center;
      align-items: center;
      width: calc(${formControl.FormControlSwitchWidth});
      height: ${formControl.FormControlSwitchHeight};
      padding: 0px; // remove any default padding of MUI Switch
    }
    & .MuiSwitch-switchBase {
      left: calc(${formControl.FormControlSwitchTrackPadding} / 2);
      width: ${formControl.FormControlElementWidth};
      height: ${formControl.FormControlElementHeight};
      background-color: ${formControl.FormControlElementColorPrimaryUncheckedDefaultRipple};
      &:hover {
        background-color: ${formControl.FormControlElementColorPrimaryUncheckedHoverRipple};
      }
      &:active {
        background-color: ${formControl.FormControlElementColorPrimaryUncheckedActiveRipple};
      }
      & .MuiSwitch-thumb {
        width: ${formControl.FormControlElementIconWidth};
        height: ${formControl.FormControlElementIconHeight};
        background-color: ${formControl.FormControlSwitchUncheckedIcon};
      }
      & + .MuiSwitch-track {
        box-sizing: border-box;
        width: calc(${formControl.FormControlSwitchTrackWidth});
        height: calc(${formControl.FormControlSwitchTrackHeight});
        opacity: unset;
        border-radius: ${formControl.FormControlSwitchTrackBorderRadius};
        background-color: ${formControl.FormControlSwitchUncheckedTrack};
      }
      &.Mui-focusVisible {
        & .MuiTouchRipple-root {
          display: none;
        }
        & + .MuiSwitch-track {
          outline: ${`${common2.FocusedDefaultWidth} ${common2.FocusedDefaultColor} ${common2.FocusedDefaultStyle}`};
          outline-offset: ${common2.FocusedOutlineOffset};
        }
      }
    }
    & .MuiSwitch-switchBase.Mui-checked {
      &:hover {
        background-color: ${formControl.FormControlElementColorPrimaryCheckedHoverRipple};
      }
      &:active {
        background-color: ${formControl.FormControlElementColorPrimaryCheckedActiveRipple};
      }
      & .MuiSwitch-thumb {
        background-color: ${formControl.FormControlSwitchCheckedIcon};
      }
      & + .MuiSwitch-track {
        background-color: ${formControl.FormControlSwitchCheckedTrack};
        opacity: unset;
      }
    }
    & .MuiSwitch-switchBase.Mui-disabled {
      & .MuiSwitch-thumb {
        background-color: ${formControl.FormControlElementDisabledUncheckedIcon};
      }
      & + .MuiSwitch-track {
        background-color: ${formControl.FormControlSwitchDisabledTrack};
        opacity: unset;
      }
    }
  `;
  };
  const RootOptions$9 = {
    name: "Switch",
    slot: "Root"
  };
  const Root$a = material.styled(
    material.Switch,
    RootOptions$9
  )((props) => {
    return getSwitchStyles(props.theme.tokens);
  });
  const Switch = (props) => /* @__PURE__ */ jsxRuntime.jsx(Root$a, { ...props });
  Switch.displayName = "Switch";
  const RootOptions$8 = {
    name: "FormControlLabel",
    slot: "Root"
  };
  const Root$9 = material.styled(
    material.FormControlLabel,
    RootOptions$8
  )((props) => {
    const {
      size,
      theme: {
        tokens: { common: common2, formControl }
      }
    } = props;
    const typographyPrefix = `FormControlLabelSize${upper(size)}Typography`;
    const marginPrefix = `FormControlLabelSize${upper(size)}TopMargin`;
    return material.css`
    align-items: start;
    .MuiFormControlLabel-label {
      display: block;
      margin-top: ${formControl[marginPrefix]};
      font-family: ${formControl[`${typographyPrefix}FontFamily`]};
      font-weight: ${formControl[`${typographyPrefix}FontWeight`]};
      line-height: ${formControl[`${typographyPrefix}LineHeight`]};
      font-size: ${formControl[`${typographyPrefix}FontSize`]};
      color: ${formControl.FormControlLabelColor};
      .Mui-disabled {
        color: ${formControl.FormControlLabelColorDisabled};
      }
      .Mui-error & {
        & > .required-asterisk {
          color: ${common2.ColorTextAlert};
        }
      }
    }
    .MuiFormControlLabel-asterisk {
      display: none;
    }
  `;
  });
  const FormControlLabel = ({ size = "m", label, required, ...props }) => {
    return /* @__PURE__ */ jsxRuntime.jsx(
      Root$9,
      {
        ...props,
        label: /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [
          label,
          required && /* @__PURE__ */ jsxRuntime.jsx("span", { className: "required-asterisk", children: " *" })
        ] }),
        labelPlacement: "end",
        required,
        size
      }
    );
  };
  function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) if (Array.isArray(e)) {
      var o = e.length;
      for (t = 0; t < o; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
    } else for (f in e) e[f] && (n && (n += " "), n += f);
    return n;
  }
  function clsx() {
    for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
  }
  const getLinkStyles = (tokens) => {
    const { link, common: common2 } = tokens;
    const getLinkStylesByState = (state) => material.css`
    &.MuiLink-root {
      color: ${link[`LinkColor${upper(state)}Text`]};
      outline: none;
      cursor: pointer;
      &.Mui-focusVisible {
        outline: ${state === "disabled" ? "none" : `${common2.FocusedDefaultWidth} ${common2.FocusedDefaultColor} ${common2.FocusedDefaultStyle}`};
        outline-offset: ${link.LinkInlineFocusedOffset};
      }
    }
  `;
    return material.css`
    &.disabled {
      ${getLinkStylesByState("disabled")};
      pointer-events: none;
    }
    :not(.disabled) {
      ${getLinkStylesByState("default")};
      :link {
        ${getLinkStylesByState("default")};
      }
      :visited {
        ${getLinkStylesByState("visited")};
      }
      :hover {
        ${getLinkStylesByState("hover")};
      }
      :active {
        ${getLinkStylesByState("active")};
      }
    }
  `;
  };
  const Link = React.forwardRef(({ className, disabled, ...rest }, ref) => /* @__PURE__ */ jsxRuntime.jsx(material.Link, { ...rest, className: clsx(className, disabled && "disabled"), ref }));
  Link.displayName = "Link";
  const ButtonSizeLPaddingLeftRight = "16px";
  const ButtonSizeLPaddingTopBottom = "12px";
  const ButtonSizeLGap = "8px";
  const ButtonSizeLTypographyFontFamily = "Inter";
  const ButtonSizeLTypographyFontSize = "16px";
  const ButtonSizeLTypographyFontWeight = 600;
  const ButtonSizeLTypographyLineHeight = "24px";
  const ButtonSizeLBorderWidth = "2px";
  const ButtonSizeLBorderRadius = "0px";
  const ButtonSizeLIconWidth = "24px";
  const ButtonSizeLIconHeight = "24px";
  const ButtonSizeLIconButtonPadding = "12px";
  const ButtonSizeLIconButtonBorderRadius = "10000px";
  const ButtonSizeMPaddingLeftRight = "16px";
  const ButtonSizeMPaddingTopBottom = "8px";
  const ButtonSizeMGap = "8px";
  const ButtonSizeMTypographyFontFamily = "Inter";
  const ButtonSizeMTypographyFontSize = "16px";
  const ButtonSizeMTypographyFontWeight = 600;
  const ButtonSizeMTypographyLineHeight = "24px";
  const ButtonSizeMBorderWidth = "2px";
  const ButtonSizeMBorderRadius = "0px";
  const ButtonSizeMIconWidth = "24px";
  const ButtonSizeMIconHeight = "24px";
  const ButtonSizeMIconButtonPadding = "8px";
  const ButtonSizeMIconButtonBorderRadius = "10000px";
  const ButtonSizeSPaddingLeftRight = "16px";
  const ButtonSizeSPaddingTopBottom = "4px";
  const ButtonSizeSGap = "8px";
  const ButtonSizeSTypographyFontFamily = "Inter";
  const ButtonSizeSTypographyFontSize = "14px";
  const ButtonSizeSTypographyFontWeight = 600;
  const ButtonSizeSTypographyLineHeight = "24px";
  const ButtonSizeSBorderWidth = "2px";
  const ButtonSizeSBorderRadius = "0px";
  const ButtonSizeSIconWidth = "16px";
  const ButtonSizeSIconHeight = "16px";
  const ButtonSizeSIconButtonPadding = "4px";
  const ButtonSizeSIconButtonBorderRadius = "10000px";
  const ButtonVariantPrimaryBorderStyle = "none";
  const ButtonVariantPrimaryDefaultBackgroundColor = "#00ff99";
  const ButtonVariantPrimaryDefaultBorderColor = "#ffffff00";
  const ButtonVariantPrimaryDefaultColor = "#000000";
  const ButtonVariantPrimaryDefaultIconColor = "#000000";
  const ButtonVariantPrimaryHoverBackgroundColor = "#00e58a";
  const ButtonVariantPrimaryHoverBorderColor = "#ffffff00";
  const ButtonVariantPrimaryHoverColor = "#000000";
  const ButtonVariantPrimaryHoverIconColor = "#000000";
  const ButtonVariantPrimaryActiveBackgroundColor = "#00e58a";
  const ButtonVariantPrimaryActiveBorderColor = "#ffffff00";
  const ButtonVariantPrimaryActiveColor = "#000000";
  const ButtonVariantPrimaryActiveIconColor = "#000000";
  const ButtonVariantPrimaryActiveRipple = "#00cc7a";
  const ButtonVariantPrimaryDisabledBackgroundColor = "#e8eaed";
  const ButtonVariantPrimaryDisabledBorderColor = "#ffffff00";
  const ButtonVariantPrimaryDisabledColor = "#9aa0a6";
  const ButtonVariantPrimaryDisabledIconColor = "#9aa0a6";
  const ButtonVariantPrimaryFocusedOutlineColor = "#0f62fe";
  const ButtonVariantSecondaryBorderStyle = "none";
  const ButtonVariantSecondaryDefaultBackgroundColor = "#efedf9";
  const ButtonVariantSecondaryDefaultBorderColor = "#ffffff00";
  const ButtonVariantSecondaryDefaultColor = "#6633cc";
  const ButtonVariantSecondaryDefaultIconColor = "#6633cc";
  const ButtonVariantSecondaryHoverBackgroundColor = "#e8e4f7";
  const ButtonVariantSecondaryHoverBorderColor = "#ffffff00";
  const ButtonVariantSecondaryHoverColor = "#6633cc";
  const ButtonVariantSecondaryHoverIconColor = "#6633cc";
  const ButtonVariantSecondaryActiveBackgroundColor = "#e8e4f7";
  const ButtonVariantSecondaryActiveBorderColor = "#ffffff00";
  const ButtonVariantSecondaryActiveColor = "#6633cc";
  const ButtonVariantSecondaryActiveIconColor = "#6633cc";
  const ButtonVariantSecondaryActiveRipple = "#3d20b614";
  const ButtonVariantSecondaryDisabledBackgroundColor = "#e8eaed";
  const ButtonVariantSecondaryDisabledBorderColor = "#ffffff00";
  const ButtonVariantSecondaryDisabledColor = "#9aa0a6";
  const ButtonVariantSecondaryDisabledIconColor = "#9aa0a6";
  const ButtonVariantSecondaryFocusedOutlineColor = "#0f62fe";
  const ButtonVariantGhostBorderStyle = "solid";
  const ButtonVariantGhostHoverBackgroundColor = "#e8e4f7";
  const ButtonVariantGhostHoverBorderColor = "#6633cc";
  const ButtonVariantGhostHoverColor = "#6633cc";
  const ButtonVariantGhostHoverIconColor = "#6633cc";
  const ButtonVariantGhostActiveBackgroundColor = "#e8e4f7";
  const ButtonVariantGhostActiveBorderColor = "#6633cc";
  const ButtonVariantGhostActiveColor = "#6633cc";
  const ButtonVariantGhostActiveIconColor = "#6633cc";
  const ButtonVariantGhostActiveRipple = "#3d20b614";
  const ButtonVariantGhostDefaultBackgroundColor = "#ffffff00";
  const ButtonVariantGhostDefaultBorderColor = "#6633cc";
  const ButtonVariantGhostDefaultColor = "#6633cc";
  const ButtonVariantGhostDefaultIconColor = "#6633cc";
  const ButtonVariantGhostDisabledBackgroundColor = "#ffffff00";
  const ButtonVariantGhostDisabledBorderColor = "#e8eaed";
  const ButtonVariantGhostDisabledColor = "#9aa0a6";
  const ButtonVariantGhostDisabledIconColor = "#9aa0a6";
  const ButtonVariantGhostFocusedOutlineColor = "#0f62fe";
  const ButtonVariantGhostInvertedBorderStyle = "solid";
  const ButtonVariantGhostInvertedDefaultBackgroundColor = "#ffffff00";
  const ButtonVariantGhostInvertedDefaultBorderColor = "#ffffff";
  const ButtonVariantGhostInvertedDefaultColor = "#ffffff";
  const ButtonVariantGhostInvertedDefaultIconColor = "#ffffff";
  const ButtonVariantGhostInvertedHoverBackgroundColor = "#ffffff1f";
  const ButtonVariantGhostInvertedHoverBorderColor = "#ffffff";
  const ButtonVariantGhostInvertedHoverColor = "#ffffff";
  const ButtonVariantGhostInvertedHoverIconColor = "#ffffff";
  const ButtonVariantGhostInvertedActiveBackgroundColor = "#ffffff1f";
  const ButtonVariantGhostInvertedActiveBorderColor = "#ffffff";
  const ButtonVariantGhostInvertedActiveColor = "#ffffff";
  const ButtonVariantGhostInvertedActiveIconColor = "#ffffff";
  const ButtonVariantGhostInvertedActiveRipple = "#ffffff33";
  const ButtonVariantGhostInvertedFocusedOutlineColor = "#3f81fe";
  const ButtonVariantGhostInvertedDisabledBackgroundColor = "#ffffff00";
  const ButtonVariantGhostInvertedDisabledBorderColor = "#e8eaed";
  const ButtonVariantGhostInvertedDisabledColor = "#e8eaed";
  const ButtonVariantGhostInvertedDisabledIconColor = "#e8eaed";
  const ButtonVariantTertiaryBorderStyle = "none";
  const ButtonVariantTertiaryDefaultBackgroundColor = "#ffffff00";
  const ButtonVariantTertiaryDefaultBorderColor = "#ffffff00";
  const ButtonVariantTertiaryDefaultColor = "#6633cc";
  const ButtonVariantTertiaryDefaultIconColor = "#6633cc";
  const ButtonVariantTertiaryHoverBackgroundColor = "#e8e4f7";
  const ButtonVariantTertiaryHoverBorderColor = "#ffffff00";
  const ButtonVariantTertiaryHoverColor = "#6633cc";
  const ButtonVariantTertiaryHoverIconColor = "#6633cc";
  const ButtonVariantTertiaryActiveBackgroundColor = "#e8e4f7";
  const ButtonVariantTertiaryActiveBorderColor = "#ffffff00";
  const ButtonVariantTertiaryActiveColor = "#6633cc";
  const ButtonVariantTertiaryActiveIconColor = "#6633cc";
  const ButtonVariantTertiaryActiveRipple = "#3d20b614";
  const ButtonVariantTertiaryDisabledBackgroundColor = "#ffffff00";
  const ButtonVariantTertiaryDisabledBorderColor = "#ffffff00";
  const ButtonVariantTertiaryDisabledColor = "#9aa0a6";
  const ButtonVariantTertiaryDisabledIconColor = "#9aa0a6";
  const ButtonVariantTertiaryFocusedOutlineColor = "#0f62fe";
  const ButtonVariantTertiaryInvertedBorderStyle = "none";
  const ButtonVariantTertiaryInvertedDefaultBackgroundColor = "#ffffff00";
  const ButtonVariantTertiaryInvertedDefaultBorderColor = "#ffffff00";
  const ButtonVariantTertiaryInvertedDefaultColor = "#ffffff";
  const ButtonVariantTertiaryInvertedDefaultIconColor = "#ffffff";
  const ButtonVariantTertiaryInvertedHoverBackgroundColor = "#ffffff1f";
  const ButtonVariantTertiaryInvertedHoverBorderColor = "#ffffff00";
  const ButtonVariantTertiaryInvertedHoverColor = "#ffffff";
  const ButtonVariantTertiaryInvertedHoverIconColor = "#ffffff";
  const ButtonVariantTertiaryInvertedActiveBackgroundColor = "#ffffff1f";
  const ButtonVariantTertiaryInvertedActiveBorderColor = "#ffffff00";
  const ButtonVariantTertiaryInvertedActiveColor = "#ffffff";
  const ButtonVariantTertiaryInvertedActiveIconColor = "#ffffff";
  const ButtonVariantTertiaryInvertedActiveRipple = "#ffffff33";
  const ButtonVariantTertiaryInvertedDisabledBackgroundColor = "#ffffff00";
  const ButtonVariantTertiaryInvertedDisabledBorderColor = "#ffffff00";
  const ButtonVariantTertiaryInvertedDisabledColor = "#e8eaed";
  const ButtonVariantTertiaryInvertedDisabledIconColor = "#e8eaed";
  const ButtonVariantTertiaryInvertedFocusedOutlineColor = "#3f81fe";
  const ButtonVariantAlertBorderStyle = "none";
  const ButtonVariantAlertDefaultBackgroundColor = "#c9005c";
  const ButtonVariantAlertDefaultBorderColor = "#ffffff00";
  const ButtonVariantAlertDefaultColor = "#ffffff";
  const ButtonVariantAlertDefaultIconColor = "#ffffff";
  const ButtonVariantAlertHoverBackgroundColor = "#b40059";
  const ButtonVariantAlertHoverBorderColor = "#ffffff00";
  const ButtonVariantAlertHoverColor = "#ffffff";
  const ButtonVariantAlertHoverIconColor = "#ffffff";
  const ButtonVariantAlertActiveBackgroundColor = "#b40059";
  const ButtonVariantAlertActiveBorderColor = "#ffffff00";
  const ButtonVariantAlertActiveColor = "#ffffff";
  const ButtonVariantAlertActiveIconColor = "#ffffff";
  const ButtonVariantAlertActiveRipple = "#8f0052";
  const ButtonVariantAlertDisabledBackgroundColor = "#e8eaed";
  const ButtonVariantAlertDisabledBorderColor = "#ffffff00";
  const ButtonVariantAlertDisabledColor = "#9aa0a6";
  const ButtonVariantAlertDisabledIconColor = "#9aa0a6";
  const ButtonVariantAlertFocusedOutlineColor = "#0f62fe";
  const Button_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    ButtonSizeLBorderRadius,
    ButtonSizeLBorderWidth,
    ButtonSizeLGap,
    ButtonSizeLIconButtonBorderRadius,
    ButtonSizeLIconButtonPadding,
    ButtonSizeLIconHeight,
    ButtonSizeLIconWidth,
    ButtonSizeLPaddingLeftRight,
    ButtonSizeLPaddingTopBottom,
    ButtonSizeLTypographyFontFamily,
    ButtonSizeLTypographyFontSize,
    ButtonSizeLTypographyFontWeight,
    ButtonSizeLTypographyLineHeight,
    ButtonSizeMBorderRadius,
    ButtonSizeMBorderWidth,
    ButtonSizeMGap,
    ButtonSizeMIconButtonBorderRadius,
    ButtonSizeMIconButtonPadding,
    ButtonSizeMIconHeight,
    ButtonSizeMIconWidth,
    ButtonSizeMPaddingLeftRight,
    ButtonSizeMPaddingTopBottom,
    ButtonSizeMTypographyFontFamily,
    ButtonSizeMTypographyFontSize,
    ButtonSizeMTypographyFontWeight,
    ButtonSizeMTypographyLineHeight,
    ButtonSizeSBorderRadius,
    ButtonSizeSBorderWidth,
    ButtonSizeSGap,
    ButtonSizeSIconButtonBorderRadius,
    ButtonSizeSIconButtonPadding,
    ButtonSizeSIconHeight,
    ButtonSizeSIconWidth,
    ButtonSizeSPaddingLeftRight,
    ButtonSizeSPaddingTopBottom,
    ButtonSizeSTypographyFontFamily,
    ButtonSizeSTypographyFontSize,
    ButtonSizeSTypographyFontWeight,
    ButtonSizeSTypographyLineHeight,
    ButtonVariantAlertActiveBackgroundColor,
    ButtonVariantAlertActiveBorderColor,
    ButtonVariantAlertActiveColor,
    ButtonVariantAlertActiveIconColor,
    ButtonVariantAlertActiveRipple,
    ButtonVariantAlertBorderStyle,
    ButtonVariantAlertDefaultBackgroundColor,
    ButtonVariantAlertDefaultBorderColor,
    ButtonVariantAlertDefaultColor,
    ButtonVariantAlertDefaultIconColor,
    ButtonVariantAlertDisabledBackgroundColor,
    ButtonVariantAlertDisabledBorderColor,
    ButtonVariantAlertDisabledColor,
    ButtonVariantAlertDisabledIconColor,
    ButtonVariantAlertFocusedOutlineColor,
    ButtonVariantAlertHoverBackgroundColor,
    ButtonVariantAlertHoverBorderColor,
    ButtonVariantAlertHoverColor,
    ButtonVariantAlertHoverIconColor,
    ButtonVariantGhostActiveBackgroundColor,
    ButtonVariantGhostActiveBorderColor,
    ButtonVariantGhostActiveColor,
    ButtonVariantGhostActiveIconColor,
    ButtonVariantGhostActiveRipple,
    ButtonVariantGhostBorderStyle,
    ButtonVariantGhostDefaultBackgroundColor,
    ButtonVariantGhostDefaultBorderColor,
    ButtonVariantGhostDefaultColor,
    ButtonVariantGhostDefaultIconColor,
    ButtonVariantGhostDisabledBackgroundColor,
    ButtonVariantGhostDisabledBorderColor,
    ButtonVariantGhostDisabledColor,
    ButtonVariantGhostDisabledIconColor,
    ButtonVariantGhostFocusedOutlineColor,
    ButtonVariantGhostHoverBackgroundColor,
    ButtonVariantGhostHoverBorderColor,
    ButtonVariantGhostHoverColor,
    ButtonVariantGhostHoverIconColor,
    ButtonVariantGhostInvertedActiveBackgroundColor,
    ButtonVariantGhostInvertedActiveBorderColor,
    ButtonVariantGhostInvertedActiveColor,
    ButtonVariantGhostInvertedActiveIconColor,
    ButtonVariantGhostInvertedActiveRipple,
    ButtonVariantGhostInvertedBorderStyle,
    ButtonVariantGhostInvertedDefaultBackgroundColor,
    ButtonVariantGhostInvertedDefaultBorderColor,
    ButtonVariantGhostInvertedDefaultColor,
    ButtonVariantGhostInvertedDefaultIconColor,
    ButtonVariantGhostInvertedDisabledBackgroundColor,
    ButtonVariantGhostInvertedDisabledBorderColor,
    ButtonVariantGhostInvertedDisabledColor,
    ButtonVariantGhostInvertedDisabledIconColor,
    ButtonVariantGhostInvertedFocusedOutlineColor,
    ButtonVariantGhostInvertedHoverBackgroundColor,
    ButtonVariantGhostInvertedHoverBorderColor,
    ButtonVariantGhostInvertedHoverColor,
    ButtonVariantGhostInvertedHoverIconColor,
    ButtonVariantPrimaryActiveBackgroundColor,
    ButtonVariantPrimaryActiveBorderColor,
    ButtonVariantPrimaryActiveColor,
    ButtonVariantPrimaryActiveIconColor,
    ButtonVariantPrimaryActiveRipple,
    ButtonVariantPrimaryBorderStyle,
    ButtonVariantPrimaryDefaultBackgroundColor,
    ButtonVariantPrimaryDefaultBorderColor,
    ButtonVariantPrimaryDefaultColor,
    ButtonVariantPrimaryDefaultIconColor,
    ButtonVariantPrimaryDisabledBackgroundColor,
    ButtonVariantPrimaryDisabledBorderColor,
    ButtonVariantPrimaryDisabledColor,
    ButtonVariantPrimaryDisabledIconColor,
    ButtonVariantPrimaryFocusedOutlineColor,
    ButtonVariantPrimaryHoverBackgroundColor,
    ButtonVariantPrimaryHoverBorderColor,
    ButtonVariantPrimaryHoverColor,
    ButtonVariantPrimaryHoverIconColor,
    ButtonVariantSecondaryActiveBackgroundColor,
    ButtonVariantSecondaryActiveBorderColor,
    ButtonVariantSecondaryActiveColor,
    ButtonVariantSecondaryActiveIconColor,
    ButtonVariantSecondaryActiveRipple,
    ButtonVariantSecondaryBorderStyle,
    ButtonVariantSecondaryDefaultBackgroundColor,
    ButtonVariantSecondaryDefaultBorderColor,
    ButtonVariantSecondaryDefaultColor,
    ButtonVariantSecondaryDefaultIconColor,
    ButtonVariantSecondaryDisabledBackgroundColor,
    ButtonVariantSecondaryDisabledBorderColor,
    ButtonVariantSecondaryDisabledColor,
    ButtonVariantSecondaryDisabledIconColor,
    ButtonVariantSecondaryFocusedOutlineColor,
    ButtonVariantSecondaryHoverBackgroundColor,
    ButtonVariantSecondaryHoverBorderColor,
    ButtonVariantSecondaryHoverColor,
    ButtonVariantSecondaryHoverIconColor,
    ButtonVariantTertiaryActiveBackgroundColor,
    ButtonVariantTertiaryActiveBorderColor,
    ButtonVariantTertiaryActiveColor,
    ButtonVariantTertiaryActiveIconColor,
    ButtonVariantTertiaryActiveRipple,
    ButtonVariantTertiaryBorderStyle,
    ButtonVariantTertiaryDefaultBackgroundColor,
    ButtonVariantTertiaryDefaultBorderColor,
    ButtonVariantTertiaryDefaultColor,
    ButtonVariantTertiaryDefaultIconColor,
    ButtonVariantTertiaryDisabledBackgroundColor,
    ButtonVariantTertiaryDisabledBorderColor,
    ButtonVariantTertiaryDisabledColor,
    ButtonVariantTertiaryDisabledIconColor,
    ButtonVariantTertiaryFocusedOutlineColor,
    ButtonVariantTertiaryHoverBackgroundColor,
    ButtonVariantTertiaryHoverBorderColor,
    ButtonVariantTertiaryHoverColor,
    ButtonVariantTertiaryHoverIconColor,
    ButtonVariantTertiaryInvertedActiveBackgroundColor,
    ButtonVariantTertiaryInvertedActiveBorderColor,
    ButtonVariantTertiaryInvertedActiveColor,
    ButtonVariantTertiaryInvertedActiveIconColor,
    ButtonVariantTertiaryInvertedActiveRipple,
    ButtonVariantTertiaryInvertedBorderStyle,
    ButtonVariantTertiaryInvertedDefaultBackgroundColor,
    ButtonVariantTertiaryInvertedDefaultBorderColor,
    ButtonVariantTertiaryInvertedDefaultColor,
    ButtonVariantTertiaryInvertedDefaultIconColor,
    ButtonVariantTertiaryInvertedDisabledBackgroundColor,
    ButtonVariantTertiaryInvertedDisabledBorderColor,
    ButtonVariantTertiaryInvertedDisabledColor,
    ButtonVariantTertiaryInvertedDisabledIconColor,
    ButtonVariantTertiaryInvertedFocusedOutlineColor,
    ButtonVariantTertiaryInvertedHoverBackgroundColor,
    ButtonVariantTertiaryInvertedHoverBorderColor,
    ButtonVariantTertiaryInvertedHoverColor,
    ButtonVariantTertiaryInvertedHoverIconColor
  }, Symbol.toStringTag, { value: "Module" }));
  const BadgeInfoColorInfoSoftBackgroundColor = "#efedf9";
  const BadgeInfoColorInfoSoftTextColor = "#6633cc";
  const BadgeInfoColorInfoBoldBackgroundColor = "#6633cc";
  const BadgeInfoColorInfoBoldTextColor = "#ffffff";
  const BadgeInfoColorSuccessSoftBackgroundColor = "#ebfff7";
  const BadgeInfoColorSuccessSoftTextColor = "#00804d";
  const BadgeInfoColorSuccessBoldBackgroundColor = "#00ff99";
  const BadgeInfoColorSuccessBoldTextColor = "#000000";
  const BadgeInfoColorWarningSoftBackgroundColor = "#fff8ee";
  const BadgeInfoColorWarningSoftTextColor = "#cc360b";
  const BadgeInfoColorWarningBoldBackgroundColor = "#ffa726";
  const BadgeInfoColorWarningBoldTextColor = "#000000";
  const BadgeInfoColorAlertSoftBackgroundColor = "#feebf3";
  const BadgeInfoColorAlertSoftTextColor = "#c9005c";
  const BadgeInfoColorAlertBoldBackgroundColor = "#c9005c";
  const BadgeInfoColorAlertBoldTextColor = "#ffffff";
  const BadgeInfoColorNeutralSoftBackgroundColor = "#eff0f0";
  const BadgeInfoColorNeutralSoftTextColor = "#000000";
  const BadgeInfoColorNeutralBoldBackgroundColor = "#7c8388";
  const BadgeInfoColorNeutralBoldTextColor = "#ffffff";
  const BadgeInfoColorUtilitySoftBackgroundColor = "#ecf2ff";
  const BadgeInfoColorUtilitySoftTextColor = "#0c4ecb";
  const BadgeInfoColorUtilityBoldBackgroundColor = "#0f62fe";
  const BadgeInfoColorUtilityBoldTextColor = "#ffffff";
  const BadgeInfoBorderRadius = "10000px";
  const BadgeInfoPaddingLeftRight = "8px";
  const BadgeInfoPaddingTopBottom = "4px";
  const BadgeInfoGap = "4px";
  const BadgeInfoIconHeight = "16px";
  const BadgeInfoIconWidth = "16px";
  const BadgeInfoLabelMaxWidth = "160px";
  const BadgeInfoLabelTypographyFontFamily = "Inter";
  const BadgeInfoLabelTypographyFontWeight = 500;
  const BadgeInfoLabelTypographyFontSize = "12px";
  const BadgeInfoLabelTypographyLineHeight = "16px";
  const BadgeInfo_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    BadgeInfoBorderRadius,
    BadgeInfoColorAlertBoldBackgroundColor,
    BadgeInfoColorAlertBoldTextColor,
    BadgeInfoColorAlertSoftBackgroundColor,
    BadgeInfoColorAlertSoftTextColor,
    BadgeInfoColorInfoBoldBackgroundColor,
    BadgeInfoColorInfoBoldTextColor,
    BadgeInfoColorInfoSoftBackgroundColor,
    BadgeInfoColorInfoSoftTextColor,
    BadgeInfoColorNeutralBoldBackgroundColor,
    BadgeInfoColorNeutralBoldTextColor,
    BadgeInfoColorNeutralSoftBackgroundColor,
    BadgeInfoColorNeutralSoftTextColor,
    BadgeInfoColorSuccessBoldBackgroundColor,
    BadgeInfoColorSuccessBoldTextColor,
    BadgeInfoColorSuccessSoftBackgroundColor,
    BadgeInfoColorSuccessSoftTextColor,
    BadgeInfoColorUtilityBoldBackgroundColor,
    BadgeInfoColorUtilityBoldTextColor,
    BadgeInfoColorUtilitySoftBackgroundColor,
    BadgeInfoColorUtilitySoftTextColor,
    BadgeInfoColorWarningBoldBackgroundColor,
    BadgeInfoColorWarningBoldTextColor,
    BadgeInfoColorWarningSoftBackgroundColor,
    BadgeInfoColorWarningSoftTextColor,
    BadgeInfoGap,
    BadgeInfoIconHeight,
    BadgeInfoIconWidth,
    BadgeInfoLabelMaxWidth,
    BadgeInfoLabelTypographyFontFamily,
    BadgeInfoLabelTypographyFontSize,
    BadgeInfoLabelTypographyFontWeight,
    BadgeInfoLabelTypographyLineHeight,
    BadgeInfoPaddingLeftRight,
    BadgeInfoPaddingTopBottom
  }, Symbol.toStringTag, { value: "Module" }));
  const BadgeInteractiveSizeSmallGap = "4px";
  const BadgeInteractiveSizeSmallMaxWidth = "160px";
  const BadgeInteractiveSizeSmallBorderRadius = "4px";
  const BadgeInteractiveSizeSmallBorderWidth = "0px";
  const BadgeInteractiveSizeSmallIconHeight = "16px";
  const BadgeInteractiveSizeSmallIconWidth = "16px";
  const BadgeInteractiveSizeSmallPaddingLeftRight = "8px";
  const BadgeInteractiveSizeSmallPaddingTopBottom = "4px";
  const BadgeInteractiveSizeSmallLabelTypographyFontFamily = "Inter";
  const BadgeInteractiveSizeSmallLabelTypographyFontSize = "12px";
  const BadgeInteractiveSizeSmallLabelTypographyFontWeight = 500;
  const BadgeInteractiveSizeSmallLabelTypographyLineHeight = "16px";
  const BadgeInteractiveSizeMediumGap = "8px";
  const BadgeInteractiveSizeMediumMaxWidth = "160px";
  const BadgeInteractiveSizeMediumBorderRadius = "4px";
  const BadgeInteractiveSizeMediumBorderWidth = "0px";
  const BadgeInteractiveSizeMediumIconHeight = "24px";
  const BadgeInteractiveSizeMediumIconWidth = "24px";
  const BadgeInteractiveSizeMediumPaddingLeftRight = "8px";
  const BadgeInteractiveSizeMediumPaddingTopBottom = "4px";
  const BadgeInteractiveSizeMediumLabelTypographyFontFamily = "Inter";
  const BadgeInteractiveSizeMediumLabelTypographyFontSize = "14px";
  const BadgeInteractiveSizeMediumLabelTypographyFontWeight = 500;
  const BadgeInteractiveSizeMediumLabelTypographyLineHeight = "24px";
  const BadgeInteractiveColorPrimaryDefaultBackgroundColor = "#efedf9";
  const BadgeInteractiveColorPrimaryDefaultBorderColor = "#ffffff00";
  const BadgeInteractiveColorPrimaryDefaultTextColor = "#6633cc";
  const BadgeInteractiveColorPrimaryDefaultIconInteractiveColor = "#6633cc";
  const BadgeInteractiveColorPrimaryHoverBackgroundColor = "#e8e4f7";
  const BadgeInteractiveColorPrimaryHoverIconInteractiveColor = "#4d26bd";
  const BadgeInteractiveColorPrimaryActiveBackgroundColor = "#d8d2f0";
  const BadgeInteractiveColorPrimaryActiveIconInteractiveColor = "#1f11ab";
  const BadgeInteractiveColorSecondaryDefaultBackgroundColor = "#eff0f0";
  const BadgeInteractiveColorSecondaryDefaultBorderColor = "#ffffff00";
  const BadgeInteractiveColorSecondaryDefaultTextColor = "#000000";
  const BadgeInteractiveColorSecondaryDefaultIconInteractiveColor = "#5a5e63";
  const BadgeInteractiveColorSecondaryHoverBackgroundColor = "#e7e8e8";
  const BadgeInteractiveColorSecondaryHoverIconInteractiveColor = "#7c8388";
  const BadgeInteractiveColorSecondaryActiveBackgroundColor = "#d8d9d9";
  const BadgeInteractiveColorSecondaryActiveIconInteractiveColor = "#9aa0a6";
  const BadgeInteractive_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    BadgeInteractiveColorPrimaryActiveBackgroundColor,
    BadgeInteractiveColorPrimaryActiveIconInteractiveColor,
    BadgeInteractiveColorPrimaryDefaultBackgroundColor,
    BadgeInteractiveColorPrimaryDefaultBorderColor,
    BadgeInteractiveColorPrimaryDefaultIconInteractiveColor,
    BadgeInteractiveColorPrimaryDefaultTextColor,
    BadgeInteractiveColorPrimaryHoverBackgroundColor,
    BadgeInteractiveColorPrimaryHoverIconInteractiveColor,
    BadgeInteractiveColorSecondaryActiveBackgroundColor,
    BadgeInteractiveColorSecondaryActiveIconInteractiveColor,
    BadgeInteractiveColorSecondaryDefaultBackgroundColor,
    BadgeInteractiveColorSecondaryDefaultBorderColor,
    BadgeInteractiveColorSecondaryDefaultIconInteractiveColor,
    BadgeInteractiveColorSecondaryDefaultTextColor,
    BadgeInteractiveColorSecondaryHoverBackgroundColor,
    BadgeInteractiveColorSecondaryHoverIconInteractiveColor,
    BadgeInteractiveSizeMediumBorderRadius,
    BadgeInteractiveSizeMediumBorderWidth,
    BadgeInteractiveSizeMediumGap,
    BadgeInteractiveSizeMediumIconHeight,
    BadgeInteractiveSizeMediumIconWidth,
    BadgeInteractiveSizeMediumLabelTypographyFontFamily,
    BadgeInteractiveSizeMediumLabelTypographyFontSize,
    BadgeInteractiveSizeMediumLabelTypographyFontWeight,
    BadgeInteractiveSizeMediumLabelTypographyLineHeight,
    BadgeInteractiveSizeMediumMaxWidth,
    BadgeInteractiveSizeMediumPaddingLeftRight,
    BadgeInteractiveSizeMediumPaddingTopBottom,
    BadgeInteractiveSizeSmallBorderRadius,
    BadgeInteractiveSizeSmallBorderWidth,
    BadgeInteractiveSizeSmallGap,
    BadgeInteractiveSizeSmallIconHeight,
    BadgeInteractiveSizeSmallIconWidth,
    BadgeInteractiveSizeSmallLabelTypographyFontFamily,
    BadgeInteractiveSizeSmallLabelTypographyFontSize,
    BadgeInteractiveSizeSmallLabelTypographyFontWeight,
    BadgeInteractiveSizeSmallLabelTypographyLineHeight,
    BadgeInteractiveSizeSmallMaxWidth,
    BadgeInteractiveSizeSmallPaddingLeftRight,
    BadgeInteractiveSizeSmallPaddingTopBottom
  }, Symbol.toStringTag, { value: "Module" }));
  const BadgeNotifyBackgroundColor = "#c9005c";
  const BadgeNotifyTextColor = "#ffffff";
  const BadgeNotifyBorderColor = "#ffffff";
  const BadgeNotifyVariantStandardHeight = "20px";
  const BadgeNotifyVariantStandardMinWidth = "20px";
  const BadgeNotifyVariantStandardPaddingLeftRight = "4px";
  const BadgeNotifyVariantDotPaddingLeftRight = "0px";
  const BadgeNotifyVariantDotHeight = "8px";
  const BadgeNotifyVariantDotMinWidth = "8px";
  const BadgeNotifyBorderRadius = "10000px";
  const BadgeNotifyBorderWidth = "2px";
  const BadgeNotify_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    BadgeNotifyBackgroundColor,
    BadgeNotifyBorderColor,
    BadgeNotifyBorderRadius,
    BadgeNotifyBorderWidth,
    BadgeNotifyTextColor,
    BadgeNotifyVariantDotHeight,
    BadgeNotifyVariantDotMinWidth,
    BadgeNotifyVariantDotPaddingLeftRight,
    BadgeNotifyVariantStandardHeight,
    BadgeNotifyVariantStandardMinWidth,
    BadgeNotifyVariantStandardPaddingLeftRight
  }, Symbol.toStringTag, { value: "Module" }));
  const ConnectorStatusLabelColor = "#000000";
  const ConnectorStatusLabelMaxWidth = "160px";
  const ConnectorStatusLabelTypographyFontFamily = "Inter";
  const ConnectorStatusLabelTypographyFontSize = "14px";
  const ConnectorStatusLabelTypographyFontWeight = 400;
  const ConnectorStatusLabelTypographyLineHeight = "20px";
  const ConnectorStatusVariantSuccessIconColor = "#00ff99";
  const ConnectorStatusVariantWarningIconColor = "#ffa726";
  const ConnectorStatusVariantAlertIconColor = "#c9005c";
  const ConnectorStatusVariantProcessingIconColor = "#6633cc";
  const ConnectorStatusVariantNeutralIconColor = "#7c8388";
  const ConnectorStatusIconBorderRadius = "10000px";
  const ConnectorStatusIconSize = "16px";
  const ConnectorStatusGap = "8px";
  const ConnectorStatus_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    ConnectorStatusGap,
    ConnectorStatusIconBorderRadius,
    ConnectorStatusIconSize,
    ConnectorStatusLabelColor,
    ConnectorStatusLabelMaxWidth,
    ConnectorStatusLabelTypographyFontFamily,
    ConnectorStatusLabelTypographyFontSize,
    ConnectorStatusLabelTypographyFontWeight,
    ConnectorStatusLabelTypographyLineHeight,
    ConnectorStatusVariantAlertIconColor,
    ConnectorStatusVariantNeutralIconColor,
    ConnectorStatusVariantProcessingIconColor,
    ConnectorStatusVariantSuccessIconColor,
    ConnectorStatusVariantWarningIconColor
  }, Symbol.toStringTag, { value: "Module" }));
  const LinkColorDefaultText = "#6633cc";
  const LinkColorDefaultIcon = "#6633cc";
  const LinkColorHoverText = "#7f53d4";
  const LinkColorHoverIcon = "#7f53d4";
  const LinkColorActiveText = "#9772dc";
  const LinkColorActiveIcon = "#9772dc";
  const LinkColorVisitedText = "#1f11ab";
  const LinkColorVisitedIcon = "#1f11ab";
  const LinkColorDisabledText = "#9aa0a6";
  const LinkColorDisabledIcon = "#9aa0a6";
  const LinkStandaloneSizeMGap = "8px";
  const LinkStandaloneSizeMTypographyFontFamily = "Inter";
  const LinkStandaloneSizeMTypographyFontSize = "16px";
  const LinkStandaloneSizeMTypographyFontWeight = 400;
  const LinkStandaloneSizeMTypographyLineHeight = "24px";
  const LinkStandaloneSizeMIconHeight = "24px";
  const LinkStandaloneSizeMIconWidth = "24px";
  const LinkStandaloneSizeSTypographyFontFamily = "Inter";
  const LinkStandaloneSizeSTypographyFontSize = "14px";
  const LinkStandaloneSizeSTypographyFontWeight = 400;
  const LinkStandaloneSizeSTypographyLineHeight = "16px";
  const LinkStandaloneSizeSIconHeight = "16px";
  const LinkStandaloneSizeSIconWidth = "16px";
  const LinkStandaloneSizeSGap = "8px";
  const LinkStandaloneSizeXsTypographyFontFamily = "Inter";
  const LinkStandaloneSizeXsTypographyFontSize = "12px";
  const LinkStandaloneSizeXsTypographyFontWeight = 400;
  const LinkStandaloneSizeXsTypographyLineHeight = "16px";
  const LinkStandaloneSizeXsIconHeight = "16px";
  const LinkStandaloneSizeXsIconWidth = "16px";
  const LinkStandaloneSizeXsGap = "4px";
  const LinkStandaloneFocusedOffset = "2px";
  const LinkStandaloneUnderlineDefault = "none";
  const LinkStandaloneUnderlineHover = "underline";
  const LinkStandaloneUnderlineActive = "underline";
  const LinkStandaloneUnderlineFocus = "none";
  const LinkStandaloneUnderlineVisited = "none";
  const LinkStandaloneUnderlineDisabled = "none";
  const LinkInlineFocusedOffset = "0px";
  const LinkInlineTextDecorationDefault = "underline";
  const LinkInlineTextDecorationFocus = "none";
  const Link_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    LinkColorActiveIcon,
    LinkColorActiveText,
    LinkColorDefaultIcon,
    LinkColorDefaultText,
    LinkColorDisabledIcon,
    LinkColorDisabledText,
    LinkColorHoverIcon,
    LinkColorHoverText,
    LinkColorVisitedIcon,
    LinkColorVisitedText,
    LinkInlineFocusedOffset,
    LinkInlineTextDecorationDefault,
    LinkInlineTextDecorationFocus,
    LinkStandaloneFocusedOffset,
    LinkStandaloneSizeMGap,
    LinkStandaloneSizeMIconHeight,
    LinkStandaloneSizeMIconWidth,
    LinkStandaloneSizeMTypographyFontFamily,
    LinkStandaloneSizeMTypographyFontSize,
    LinkStandaloneSizeMTypographyFontWeight,
    LinkStandaloneSizeMTypographyLineHeight,
    LinkStandaloneSizeSGap,
    LinkStandaloneSizeSIconHeight,
    LinkStandaloneSizeSIconWidth,
    LinkStandaloneSizeSTypographyFontFamily,
    LinkStandaloneSizeSTypographyFontSize,
    LinkStandaloneSizeSTypographyFontWeight,
    LinkStandaloneSizeSTypographyLineHeight,
    LinkStandaloneSizeXsGap,
    LinkStandaloneSizeXsIconHeight,
    LinkStandaloneSizeXsIconWidth,
    LinkStandaloneSizeXsTypographyFontFamily,
    LinkStandaloneSizeXsTypographyFontSize,
    LinkStandaloneSizeXsTypographyFontWeight,
    LinkStandaloneSizeXsTypographyLineHeight,
    LinkStandaloneUnderlineActive,
    LinkStandaloneUnderlineDefault,
    LinkStandaloneUnderlineDisabled,
    LinkStandaloneUnderlineFocus,
    LinkStandaloneUnderlineHover,
    LinkStandaloneUnderlineVisited
  }, Symbol.toStringTag, { value: "Module" }));
  const FormControlFormLabelTypographyFontFamily = "Inter";
  const FormControlFormLabelTypographyFontSize = "16px";
  const FormControlFormLabelTypographyFontWeight = 600;
  const FormControlFormLabelTypographyLineHeight = "24px";
  const FormControlLabelColor = "#000000";
  const FormControlLabelColorDisabled = "#9aa0a6";
  const FormControlLabelSizeMTopMargin = "9px";
  const FormControlLabelSizeMTypographyFontFamily = "Inter";
  const FormControlLabelSizeMTypographyFontSize = "16px";
  const FormControlLabelSizeMTypographyFontWeight = 400;
  const FormControlLabelSizeMTypographyLineHeight = "24px";
  const FormControlLabelSizeSTopMargin = "11px";
  const FormControlLabelSizeSTypographyFontFamily = "Inter";
  const FormControlLabelSizeSTypographyFontSize = "14px";
  const FormControlLabelSizeSTypographyFontWeight = 400;
  const FormControlLabelSizeSTypographyLineHeight = "20px";
  const FormControlLabelSizeXsTopMargin = "13px";
  const FormControlLabelSizeXsTypographyFontFamily = "Inter";
  const FormControlLabelSizeXsTypographyFontSize = "14px";
  const FormControlLabelSizeXsTypographyFontWeight = 400;
  const FormControlLabelSizeXsTypographyLineHeight = "16px";
  const FormControlElementWidth = "42px";
  const FormControlElementHeight = "42px";
  const FormControlElementColorPrimaryUncheckedDefaultRipple = "#ffffff00";
  const FormControlElementColorPrimaryUncheckedDefaultIcon = "#5a5e63";
  const FormControlElementColorPrimaryUncheckedHoverRipple = "#3b3f4214";
  const FormControlElementColorPrimaryUncheckedActiveRipple = "#3b3f421f";
  const FormControlElementColorPrimaryCheckedDefaultRipple = "#ffffff00";
  const FormControlElementColorPrimaryCheckedDefaultIcon = "#6633cc";
  const FormControlElementColorPrimaryCheckedHoverRipple = "#3d20b614";
  const FormControlElementColorPrimaryCheckedActiveRipple = "#3d20b61f";
  const FormControlElementColorErrorUncheckedDefaultRipple = "#ffffff00";
  const FormControlElementColorErrorUncheckedDefaultIcon = "#c9005c";
  const FormControlElementColorErrorUncheckedHoverRipple = "#f0006614";
  const FormControlElementColorErrorUncheckedActiveRipple = "#f000661f";
  const FormControlElementColorErrorCheckedDefaultRipple = "#ffffff00";
  const FormControlElementColorErrorCheckedDefaultIcon = "#c9005c";
  const FormControlElementColorErrorCheckedHoverRipple = "#f0006614";
  const FormControlElementColorErrorCheckedActiveRipple = "#f000661f";
  const FormControlElementDisabledUncheckedRipple = "#ffffff00";
  const FormControlElementDisabledUncheckedIcon = "#9aa0a6";
  const FormControlElementDisabledCheckedRipple = "#ffffff";
  const FormControlElementDisabledCheckedIcon = "#9aa0a6";
  const FormControlElementIconWidth = "24px";
  const FormControlElementIconHeight = "24px";
  const FormControlSwitchWidth = "66px";
  const FormControlSwitchHeight = "42px";
  const FormControlSwitchUncheckedIcon = "#ffffff";
  const FormControlSwitchUncheckedTrack = "#5a5e63";
  const FormControlSwitchCheckedIcon = "#ffffff";
  const FormControlSwitchCheckedTrack = "#6633cc";
  const FormControlSwitchDisabledTrack = "#e8eaed";
  const FormControlSwitchTrackPadding = "4px";
  const FormControlSwitchTrackWidth = "52px";
  const FormControlSwitchTrackHeight = "32px";
  const FormControlSwitchTrackBorderRadius = "10000px";
  const FormControlHelperTextTopMargin = "8px";
  const FormControl_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    FormControlElementColorErrorCheckedActiveRipple,
    FormControlElementColorErrorCheckedDefaultIcon,
    FormControlElementColorErrorCheckedDefaultRipple,
    FormControlElementColorErrorCheckedHoverRipple,
    FormControlElementColorErrorUncheckedActiveRipple,
    FormControlElementColorErrorUncheckedDefaultIcon,
    FormControlElementColorErrorUncheckedDefaultRipple,
    FormControlElementColorErrorUncheckedHoverRipple,
    FormControlElementColorPrimaryCheckedActiveRipple,
    FormControlElementColorPrimaryCheckedDefaultIcon,
    FormControlElementColorPrimaryCheckedDefaultRipple,
    FormControlElementColorPrimaryCheckedHoverRipple,
    FormControlElementColorPrimaryUncheckedActiveRipple,
    FormControlElementColorPrimaryUncheckedDefaultIcon,
    FormControlElementColorPrimaryUncheckedDefaultRipple,
    FormControlElementColorPrimaryUncheckedHoverRipple,
    FormControlElementDisabledCheckedIcon,
    FormControlElementDisabledCheckedRipple,
    FormControlElementDisabledUncheckedIcon,
    FormControlElementDisabledUncheckedRipple,
    FormControlElementHeight,
    FormControlElementIconHeight,
    FormControlElementIconWidth,
    FormControlElementWidth,
    FormControlFormLabelTypographyFontFamily,
    FormControlFormLabelTypographyFontSize,
    FormControlFormLabelTypographyFontWeight,
    FormControlFormLabelTypographyLineHeight,
    FormControlHelperTextTopMargin,
    FormControlLabelColor,
    FormControlLabelColorDisabled,
    FormControlLabelSizeMTopMargin,
    FormControlLabelSizeMTypographyFontFamily,
    FormControlLabelSizeMTypographyFontSize,
    FormControlLabelSizeMTypographyFontWeight,
    FormControlLabelSizeMTypographyLineHeight,
    FormControlLabelSizeSTopMargin,
    FormControlLabelSizeSTypographyFontFamily,
    FormControlLabelSizeSTypographyFontSize,
    FormControlLabelSizeSTypographyFontWeight,
    FormControlLabelSizeSTypographyLineHeight,
    FormControlLabelSizeXsTopMargin,
    FormControlLabelSizeXsTypographyFontFamily,
    FormControlLabelSizeXsTypographyFontSize,
    FormControlLabelSizeXsTypographyFontWeight,
    FormControlLabelSizeXsTypographyLineHeight,
    FormControlSwitchCheckedIcon,
    FormControlSwitchCheckedTrack,
    FormControlSwitchDisabledTrack,
    FormControlSwitchHeight,
    FormControlSwitchTrackBorderRadius,
    FormControlSwitchTrackHeight,
    FormControlSwitchTrackPadding,
    FormControlSwitchTrackWidth,
    FormControlSwitchUncheckedIcon,
    FormControlSwitchUncheckedTrack,
    FormControlSwitchWidth
  }, Symbol.toStringTag, { value: "Module" }));
  const TypographyFontFamilyDefault = "Inter";
  const TypographyFontSize3xs = "10px";
  const TypographyFontSize2xs = "12px";
  const TypographyFontSizeXs = "14px";
  const TypographyFontSizeS = "16px";
  const TypographyFontSizeM = "18px";
  const TypographyFontSizeL = "22px";
  const TypographyFontSizeXl = "26px";
  const TypographyFontSize2xl = "44px";
  const TypographyFontSize3xl = "46px";
  const TypographyFontSize4xl = "48px";
  const TypographyFontWeightLight = 300;
  const TypographyFontWeightRegular = 400;
  const TypographyFontWeightMedium = 500;
  const TypographyFontWeightSemibold = 600;
  const TypographyFontWeightBold = 700;
  const TypographyFontWeightExtrabold = 800;
  const TypographyFontWeightBlack = 900;
  const TypographyLineHeight3xs = "14px";
  const TypographyLineHeight2xs = "16px";
  const TypographyLineHeightXs = "20px";
  const TypographyLineHeightS = "24px";
  const TypographyLineHeightM = "26px";
  const TypographyLineHeightL = "28px";
  const TypographyLineHeightXl = "32px";
  const TypographyLineHeight2xl = "50px";
  const TypographyLineHeight3xl = "54px";
  const TypographyLineHeight4xl = "56px";
  const TypographyTextTransformNone = "none";
  const TypographyTextTransformUppercase = "uppercase";
  const TypographyTextTransformLowercase = "lowercase";
  const TypographyTextTransformCapitalize = "capitalize";
  const TypographyTextDecorationNone = "none";
  const TypographyTextDecorationUnderline = "underline";
  const TypographyTextDecorationLineTrough = "line-trough";
  const Typography_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    TypographyFontFamilyDefault,
    TypographyFontSize2xl,
    TypographyFontSize2xs,
    TypographyFontSize3xl,
    TypographyFontSize3xs,
    TypographyFontSize4xl,
    TypographyFontSizeL,
    TypographyFontSizeM,
    TypographyFontSizeS,
    TypographyFontSizeXl,
    TypographyFontSizeXs,
    TypographyFontWeightBlack,
    TypographyFontWeightBold,
    TypographyFontWeightExtrabold,
    TypographyFontWeightLight,
    TypographyFontWeightMedium,
    TypographyFontWeightRegular,
    TypographyFontWeightSemibold,
    TypographyLineHeight2xl,
    TypographyLineHeight2xs,
    TypographyLineHeight3xl,
    TypographyLineHeight3xs,
    TypographyLineHeight4xl,
    TypographyLineHeightL,
    TypographyLineHeightM,
    TypographyLineHeightS,
    TypographyLineHeightXl,
    TypographyLineHeightXs,
    TypographyTextDecorationLineTrough,
    TypographyTextDecorationNone,
    TypographyTextDecorationUnderline,
    TypographyTextTransformCapitalize,
    TypographyTextTransformLowercase,
    TypographyTextTransformNone,
    TypographyTextTransformUppercase
  }, Symbol.toStringTag, { value: "Module" }));
  const IconSizeS = "16px";
  const IconSizeM = "24px";
  const IconSizeL = "32px";
  const IconPathAccept = "M13.8536 4.14645C14.0488 4.34171 14.0488 4.65829 13.8536 4.85355L6.5 12.2071L3.14645 8.85355C2.95118 8.65829 2.95118 8.34171 3.14645 8.14645C3.34171 7.95118 3.65829 7.95118 3.85355 8.14645L6.5 10.7929L13.1464 4.14645C13.3417 3.95118 13.6583 3.95118 13.8536 4.14645Z";
  const IconPathAccessfree = "M14.49 3.34762H6.29999C6.01999 3.34762 5.79999 3.56762 5.79999 3.84762C5.79999 4.12762 6.01999 4.34762 6.29999 4.34762H11.76C11.81 5.53762 12.78 6.49762 13.99 6.49762V9.83762C13.99 9.83762 13.93 9.83762 13.9 9.83762C13.57 9.83762 13.23 9.93762 13 10.0576C12.75 10.1776 12.65 10.4776 12.78 10.7276C12.9 10.9776 13.2 11.0776 13.45 10.9476C13.55 10.8976 13.74 10.8376 13.93 10.8376C13.96 10.8376 13.96 10.8376 13.99 10.8376V11.6876C13.99 11.9676 14.21 12.1876 14.49 12.1876C14.77 12.1876 14.99 11.9676 14.99 11.6876V3.85762C14.99 3.57762 14.76 3.34762 14.48 3.34762H14.49ZM13.99 5.49762C13.34 5.49762 12.82 4.98762 12.77 4.34762H14V5.49762H13.99ZM2.34999 2.03762C2.14999 1.84762 1.82999 1.85762 1.63999 2.04762C1.44999 2.24762 1.45999 2.56762 1.64999 2.75762L2.25999 3.34762H1.49999C1.21999 3.34762 0.98999 3.57762 0.98999 3.85762V12.4776C0.98999 12.7576 1.21999 12.9876 1.49999 12.9876H12.3L13.64 14.2776C13.84 14.4676 14.16 14.4576 14.35 14.2676C14.54 14.0676 14.53 13.7476 14.34 13.5576L2.34999 2.03762ZM6.27999 7.19762L8.94999 9.76762C8.20999 10.2576 7.19999 10.1876 6.54999 9.52762C5.89999 8.86762 5.82999 7.92762 6.27999 7.19762ZM3.23999 4.34762C3.18999 4.98762 2.66999 5.49762 2.01999 5.49762H1.99999V4.34762H3.23999ZM1.99999 10.8376H2.01999C2.66999 10.8376 3.18999 11.3476 3.23999 11.9876H1.99999V10.8376ZM4.24999 11.9876C4.19999 10.7976 3.22999 9.83762 2.01999 9.83762H1.99999V6.49762H2.01999C2.95999 6.49762 3.75999 5.91762 4.08999 5.09762L5.54999 6.49762C4.72999 7.62762 4.82999 9.21762 5.84999 10.2376C6.86999 11.2576 8.53999 11.3476 9.67999 10.4576L11.27 11.9876H4.24999Z";
  const IconPathAccessPrivate = "M8 2.9234C7.46311 2.9234 6.95215 3.12833 6.5785 3.48704C6.20554 3.84508 6 4.32623 6 4.8234V6.24339H10V4.8234C10 4.32624 9.79446 3.84509 9.42154 3.48705M11 6.24339V4.8234C11 4.04753 10.6787 3.30779 10.1141 2.76567C9.55003 2.22421 8.78924 1.9234 8 1.9234C7.21076 1.9234 6.44999 2.22418 5.88596 2.76565C5.32124 3.30779 5 4.04754 5 4.8234V6.24339H4C3.191 6.24339 2.5 6.87804 2.5 7.70339V12.5034C2.5 13.3287 3.191 13.9634 4 13.9634H12C12.809 13.9634 13.5 13.3287 13.5 12.5034V7.70339C13.5 6.87803 12.809 6.24339 12 6.24339H11ZM4 7.24339C3.70443 7.24339 3.5 7.46839 3.5 7.70339V12.5034C3.5 12.7384 3.70443 12.9634 4 12.9634H12C12.2956 12.9634 12.5 12.7384 12.5 12.5034V7.70339C12.5 7.4684 12.2956 7.24339 12 7.24339H4ZM8 2.9234C8.53688 2.9234 9.04786 3.12835 9.42154 3.48705L8 2.9234ZM8.23097 7.73993C8.47588 7.86749 8.57102 8.16944 8.44346 8.41436L7.82417 9.60339H9C9.17476 9.60339 9.33684 9.69463 9.42748 9.84405C9.51813 9.99346 9.52418 10.1794 9.44346 10.3344L8.44346 12.2544C8.3159 12.4993 8.01395 12.5944 7.76903 12.4668C7.52412 12.3393 7.42898 12.0373 7.55654 11.7924L8.17583 10.6034H7C6.82524 10.6034 6.66316 10.5121 6.57252 10.3627C6.48187 10.2133 6.47582 10.0274 6.55654 9.87242L7.55654 7.95242C7.6841 7.70751 7.98605 7.61237 8.23097 7.73993Z";
  const IconPathAccessPublic = "M10.0053 15.14C9.93531 15.14 9.85531 15.12 9.78531 15.09C9.53531 14.97 9.43531 14.67 9.56531 14.42L10.2053 13.14H9.01531C8.84531 13.14 8.68531 13.05 8.58531 12.9C8.48531 12.75 8.48531 12.57 8.56531 12.41L9.56531 10.41C9.68531 10.16 9.98531 10.06 10.2353 10.19C10.4853 10.31 10.5853 10.61 10.4553 10.86L9.81531 12.14H11.0053C11.1753 12.14 11.3353 12.23 11.4353 12.38C11.5353 12.53 11.5353 12.71 11.4553 12.87L10.4553 14.87C10.3653 15.04 10.1953 15.15 10.0053 15.15V15.14ZM12.5353 4.66995C12.5353 3.30995 11.3953 2.19995 10.0053 2.19995C8.61531 2.19995 7.47531 3.30995 7.47531 4.66995C7.47531 6.02995 8.61531 7.13995 10.0053 7.13995C11.3953 7.13995 12.5353 6.02995 12.5353 4.66995ZM11.5353 4.66995C11.5353 5.47995 10.8453 6.13995 10.0053 6.13995C9.16531 6.13995 8.47531 5.47995 8.47531 4.66995C8.47531 3.85995 9.16531 3.19995 10.0053 3.19995C10.8453 3.19995 11.5353 3.85995 11.5353 4.66995ZM11.2753 8.13995H8.73531C8.27531 8.13995 7.83531 8.24995 7.42531 8.43995C7.05531 7.64995 6.26531 7.13995 5.37531 7.13995H3.74531C2.62531 7.13995 1.66531 7.96995 1.50531 9.07995C1.46531 9.34995 1.65531 9.60995 1.93531 9.63995C1.95531 9.63995 1.98531 9.63995 2.00531 9.63995C2.25531 9.63995 2.46531 9.45995 2.49531 9.20995C2.57531 8.59995 3.11531 8.13995 3.74531 8.13995H5.37531C5.88531 8.13995 6.34531 8.43995 6.53531 8.88995C6.54531 8.91995 6.57531 8.93995 6.59531 8.96995C6.01531 9.49995 5.61531 10.23 5.50531 11.07C5.46531 11.34 5.66531 11.59 5.93531 11.63C6.20531 11.66 6.45531 11.47 6.49531 11.2C6.64531 10.02 7.60531 9.13995 8.72531 9.13995H11.2653C12.3853 9.13995 13.3453 10.03 13.4953 11.2C13.5253 11.45 13.7453 11.64 13.9953 11.64C14.0153 11.64 14.0353 11.64 14.0553 11.64C14.3253 11.6 14.5253 11.35 14.4853 11.08C14.2653 9.40995 12.8853 8.13995 11.2653 8.13995H11.2753ZM6.33531 4.66995C6.33531 3.67995 5.51531 2.87995 4.50531 2.87995C3.49531 2.87995 2.67531 3.67995 2.67531 4.66995C2.67531 5.65995 3.49531 6.45995 4.50531 6.45995C5.51531 6.45995 6.33531 5.65995 6.33531 4.66995ZM5.33531 4.66995C5.33531 5.10995 4.96531 5.45995 4.50531 5.45995C4.04531 5.45995 3.67531 5.10995 3.67531 4.66995C3.67531 4.22995 4.04531 3.87995 4.50531 3.87995C4.96531 3.87995 5.33531 4.22995 5.33531 4.66995Z";
  const IconPathAccount = "M1.5 8.00001C1.5 4.41036 4.41036 1.5 8 1.5C11.5896 1.5 14.5 4.41035 14.5 8.00001C14.5 11.5896 11.5896 14.5 8 14.5C4.41036 14.5 1.5 11.5896 1.5 8.00001ZM8 2.5C4.96264 2.5 2.5 4.96264 2.5 8.00001C2.5 9.30054 2.95151 10.4957 3.70631 11.4373C4.22395 10.2947 5.37395 9.5 6.70993 9.5H9.29047C10.6263 9.5 11.7763 10.2946 12.2938 11.4372C13.0485 10.4956 13.5 9.30048 13.5 8.00001C13.5 4.96264 11.0373 2.5 8 2.5ZM11.5158 12.2296C11.2641 11.2356 10.3628 10.5 9.29047 10.5H6.70993C5.63767 10.5 4.73632 11.2356 4.48426 12.2296C5.43749 13.0229 6.66307 13.5 8 13.5C9.33692 13.5 10.5625 13.0229 11.5158 12.2296ZM5.46647 6.19254C5.46647 4.81469 6.61673 3.72607 8 3.72607C9.38329 3.72607 10.5335 4.81471 10.5335 6.19254C10.5335 7.57039 9.38331 8.65907 8 8.65907C6.61671 8.65907 5.46647 7.57041 5.46647 6.19254ZM8 4.72607C7.13714 4.72607 6.46647 5.39832 6.46647 6.19254C6.46647 6.98681 7.13716 7.65907 8 7.65907C8.86283 7.65907 9.53347 6.98683 9.53347 6.19254C9.53347 5.3983 8.86284 4.72607 8 4.72607Z";
  const IconPathAdd = "M14 8C14 8.28 13.78 8.5 13.5 8.5H8.5V13.5C8.5 13.78 8.28 14 8 14C7.72 14 7.5 13.78 7.5 13.5V8.5H2.5C2.22 8.5 2 8.28 2 8C2 7.72 2.22 7.5 2.5 7.5H7.5V2.5C7.5 2.22 7.72 2 8 2C8.28 2 8.5 2.22 8.5 2.5V7.5H13.5C13.78 7.5 14 7.72 14 8Z";
  const IconPathAddCircle = "M1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8ZM8 2.5C4.96244 2.5 2.5 4.96244 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5ZM8 4.5C8.27614 4.5 8.5 4.72386 8.5 5V7.5H11C11.2761 7.5 11.5 7.72386 11.5 8C11.5 8.27614 11.2761 8.5 11 8.5H8.5V11C8.5 11.2761 8.27614 11.5 8 11.5C7.72386 11.5 7.5 11.2761 7.5 11V8.5H5C4.72386 8.5 4.5 8.27614 4.5 8C4.5 7.72386 4.72386 7.5 5 7.5H7.5V5C7.5 4.72386 7.72386 4.5 8 4.5Z";
  const IconPathAddCircleFilled = "M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM3.96447 8C3.96447 7.72386 4.18832 7.5 4.46447 7.5H7.5V4.46447C7.5 4.18832 7.72386 3.96447 8 3.96447C8.27614 3.96447 8.5 4.18832 8.5 4.46447V7.5H11.5355C11.8117 7.5 12.0355 7.72386 12.0355 8C12.0355 8.27614 11.8117 8.5 11.5355 8.5H8.5V11.5355C8.5 11.8117 8.27614 12.0355 8 12.0355C7.72386 12.0355 7.5 11.8117 7.5 11.5355V8.5H4.46447C4.18832 8.5 3.96447 8.27614 3.96447 8Z";
  const IconPathAlert = "M1.5 8C1.5 4.41 4.41 1.5 8 1.5C11.59 1.5 14.5 4.41 14.5 8C14.5 11.59 11.59 14.5 8 14.5C4.41 14.5 1.5 11.59 1.5 8ZM8 2.5C4.96 2.5 2.5 4.96 2.5 8C2.5 11.04 4.96 13.5 8 13.5C11.04 13.5 13.5 11.04 13.5 8C13.5 4.96 11.04 2.5 8 2.5ZM8 4.5C8.28 4.5 8.5 4.72 8.5 5V8.75C8.5 9.03 8.28 9.25 8 9.25C7.72 9.25 7.5 9.03 7.5 8.75V5C7.5 4.72 7.72 4.5 8 4.5ZM8 10C8.37 10 8.67 10.3 8.67 10.67C8.67 11.04 8.37 11.34 8 11.34C7.63 11.34 7.33 11.04 7.33 10.67C7.33 10.3 7.63 10 8 10Z";
  const IconPathAssign = "M3.23578 3.07146C2.67575 3.63924 2.49354 4.19493 2.3926 4.50275C2.38853 4.51517 2.38459 4.52719 2.38076 4.53879C2.17539 5.38281 2.42868 6.01665 2.59217 6.42578C2.61639 6.48639 2.63864 6.54206 2.65714 6.59276C3.09203 7.35319 3.67484 7.66458 3.85812 7.72567C4.12009 7.81299 4.26167 8.09615 4.17435 8.35813C4.08702 8.6201 3.80386 8.76168 3.54189 8.67435C3.12801 8.53639 2.32609 8.05652 1.76293 7.04283C1.74792 7.01581 1.73544 6.98745 1.72567 6.95813C1.71682 6.93159 1.70015 6.89178 1.67839 6.83978C1.52393 6.47081 1.11258 5.48816 1.41494 4.27874C1.41804 4.26633 1.42162 4.25404 1.42567 4.2419C1.43151 4.22437 1.43777 4.2052 1.44455 4.18447C1.55533 3.84546 1.80188 3.09103 2.54645 2.34646C2.5582 2.33471 2.57053 2.32355 2.58339 2.31303C3.22467 1.78835 3.92071 1.58771 4.45978 1.51679C4.97333 1.44921 5.43922 1.50001 5.40001 1.50001C5.41845 1.50001 5.43689 1.50103 5.45522 1.50307C6.51026 1.6203 7.20958 2.20248 7.45356 2.44646C7.86371 2.85661 8.23554 3.32549 8.37435 3.7419C8.46167 4.00387 8.32009 4.28703 8.05812 4.37435C7.79615 4.46168 7.51299 4.3201 7.42566 4.05813C7.36447 3.87454 7.1363 3.54341 6.74645 3.15357C6.59122 2.99833 6.09476 2.5839 5.35595 2.49822C5.34294 2.49743 5.32821 2.49642 5.31188 2.4953C4.99314 2.47351 4.06014 2.4097 3.23578 3.07146ZM4.02123 4.37237C4.52295 3.73436 5.3098 3.79589 5.82361 4.0528C5.87168 4.07683 5.91556 4.10846 5.95356 4.14646C6.7598 4.9527 7.55586 5.74858 8.34914 6.47148C8.6183 6.28975 8.88186 6.09662 9.15433 5.89681L9.16111 5.89184C9.53171 5.62006 9.91925 5.33586 10.335 5.07601C10.3832 5.04587 10.436 5.02432 10.491 5.01204C10.4974 5.00913 10.5049 5.0056 10.5141 5.00127C10.5242 4.99648 10.5363 4.99067 10.5499 4.9841C10.6012 4.95943 10.6749 4.92393 10.753 4.89044C10.9558 4.80355 11.2528 4.70001 11.6 4.70001C11.9808 4.70001 12.3036 4.85012 12.5221 5.00142C12.6331 5.07823 12.7302 5.16416 12.8053 5.24964C12.8423 5.29177 12.8813 5.34211 12.9142 5.39865C12.9242 5.41584 12.9423 5.44785 12.9594 5.49134L15.6235 9.73413C15.7703 9.96799 15.6998 10.2766 15.4659 10.4235C15.232 10.5703 14.9234 10.4998 14.7766 10.2659L12.0766 5.9659C12.0621 5.94291 12.0496 5.91888 12.0392 5.89406C12.0206 5.8757 11.9917 5.85046 11.9529 5.82361C11.8464 5.7499 11.7192 5.70001 11.6 5.70001C11.4472 5.70001 11.2942 5.74648 11.147 5.80958C11.091 5.83357 11.0447 5.85582 10.996 5.87925C10.9786 5.88764 10.9608 5.89618 10.9422 5.90501C10.9116 5.91949 10.8707 5.93853 10.8295 5.95423L10.8282 5.95475C10.8218 5.95718 10.8122 5.96084 10.7999 5.96505C10.4422 6.19271 10.1015 6.44227 9.74569 6.70321L9.7389 6.7082C9.36829 6.97997 8.98076 7.26417 8.56501 7.52401C8.37684 7.64162 8.13367 7.62114 7.96782 7.47372C7.07665 6.68156 6.18774 5.7948 5.31074 4.91785C5.20393 4.87559 5.10231 4.86201 5.02093 4.87159C4.93436 4.88177 4.86199 4.91737 4.80001 5.00001C4.78581 5.01894 4.77029 5.03684 4.75356 5.05357C4.66721 5.13992 4.61148 5.35579 4.72015 5.61727C5.39641 6.33924 6.0966 7.0395 6.80356 7.74646L6.80657 7.74947C7.52916 8.47206 8.25883 9.20173 8.96434 9.95757L8.96718 9.96056C8.97253 9.96627 8.97867 9.97302 8.98545 9.9808C8.99895 9.99631 9.01524 10.0162 9.0329 10.0403C9.06782 10.0879 9.11049 10.1552 9.14708 10.2406C9.22247 10.4165 9.27064 10.6692 9.17435 10.9581C9.16687 10.9806 9.1578 11.0025 9.14722 11.0236C9.07169 11.1747 8.94311 11.3596 8.74001 11.4865C8.52836 11.6188 8.26522 11.668 7.98594 11.588C7.47085 11.5054 6.9497 11.5003 6.38872 11.5C6.21061 11.5729 6.11293 11.6704 6.08056 11.7423C6.05119 11.9048 6.13421 12.1309 6.37758 12.2325C8.06309 12.8271 9.34923 13.2226 10.0374 13.4193C10.0671 13.4277 10.096 13.439 10.1236 13.4528C10.1577 13.4699 10.3082 13.5076 10.6787 13.4149C10.8177 13.3802 10.9215 13.329 11.0178 13.2713C11.0584 13.2469 11.0941 13.2236 11.1358 13.1965C11.1483 13.1883 11.1614 13.1798 11.1753 13.1709C11.2103 13.1482 11.2519 13.1216 11.2976 13.0953L12.8465 11.5465C13.0417 11.3512 13.3583 11.3512 13.5536 11.5465C13.7488 11.7417 13.7488 12.0583 13.5536 12.2536L11.9536 13.8536C11.9156 13.8916 11.8717 13.9232 11.8236 13.9472C11.8004 13.9588 11.7705 13.9768 11.7185 14.0104C11.7096 14.0162 11.6998 14.0226 11.6894 14.0294C11.6459 14.0577 11.5904 14.0939 11.5323 14.1288C11.3785 14.221 11.1823 14.3198 10.9213 14.3851C10.5106 14.4878 10.0815 14.5267 9.72475 14.3699C9.00628 14.1636 7.71266 13.7641 6.0336 13.1715C6.02712 13.1692 6.02069 13.1668 6.01431 13.1643C5.2748 12.8684 4.95624 12.1135 5.11494 11.4787C5.11804 11.4663 5.12162 11.454 5.12566 11.4419C5.29858 10.9232 5.77933 10.6465 6.14189 10.5257C6.19288 10.5087 6.24627 10.5 6.30001 10.5H6.31797C6.90633 10.5 7.54124 10.5 8.18221 10.6068C8.19045 10.6082 8.19866 10.6098 8.20681 10.6116C7.52222 9.8794 6.81281 9.16993 6.09645 8.45357L6.09345 8.45056C5.37044 7.72755 4.64036 6.99747 3.93448 6.24117C3.90175 6.20611 3.87424 6.16652 3.85279 6.12362C3.60099 5.62002 3.54123 4.8792 4.02123 4.37237ZM8.2396 10.6465L8.24141 10.6484L8.24381 10.6509L8.2451 10.6522L8.24577 10.6529L8.24611 10.6532L8.2397 10.6466L8.2396 10.6465Z";
  const IconPathBatteryCharging = "M8.00035 1.5C8.00035 1.22386 8.22421 1 8.50035 1H11.5004C11.7765 1 12.0004 1.22386 12.0004 1.5C12.0004 1.77614 11.7765 2 11.5004 2H12.5004C13.3288 2 14.0004 2.67157 14.0004 3.5V11.5C14.0004 12.3284 13.3288 13 12.5004 13H10.5004V13.5C10.5004 14.3284 9.82878 15 9.00035 15H4.00035C3.17193 15 2.50035 14.3284 2.50035 13.5V10.5C2.50035 10.2239 2.72421 10 3.00035 10C3.2765 10 3.50035 10.2239 3.50035 10.5V13.5C3.50035 13.7761 3.72421 14 4.00035 14H9.00035C9.2765 14 9.50035 13.7761 9.50035 13.5V13H7.50035C6.67193 13 6.00035 12.3284 6.00035 11.5V3.5C6.00035 2.67157 6.67193 2 7.50035 2H8.50035C8.22421 2 8.00035 1.77614 8.00035 1.5ZM12.5004 12C12.7765 12 13.0004 11.7761 13.0004 11.5V3.5C13.0004 3.22386 12.7765 3 12.5004 3H7.50035C7.22421 3 7.00035 3.22386 7.00035 3.5V11.5C7.00035 11.7761 7.22421 12 7.50035 12H12.5004ZM3.15847 2.02566C3.42044 2.11298 3.56202 2.39614 3.4747 2.65811L2.69407 5H4.69407L3.4747 8.65811C3.38737 8.92009 3.10421 9.06167 2.84224 8.97434C2.58027 8.88702 2.43869 8.60386 2.52601 8.34189L3.30664 6H1.30664L2.52601 2.34189C2.61334 2.07991 2.8965 1.93833 3.15847 2.02566ZM8.00035 6.5C8.00035 6.22386 8.22421 6 8.50035 6H11.5004C11.7765 6 12.0004 6.22386 12.0004 6.5C12.0004 6.77614 11.7765 7 11.5004 7H8.50035C8.22421 7 8.00035 6.77614 8.00035 6.5ZM8.00035 8.5C8.00035 8.22386 8.22421 8 8.50035 8H11.5004C11.7765 8 12.0004 8.22386 12.0004 8.5C12.0004 8.77614 11.7765 9 11.5004 9H8.50035C8.22421 9 8.00035 8.77614 8.00035 8.5ZM8.00035 10.5C8.00035 10.2239 8.22421 10 8.50035 10H11.5004C11.7765 10 12.0004 10.2239 12.0004 10.5C12.0004 10.7761 11.7765 11 11.5004 11H8.50035C8.22421 11 8.00035 10.7761 8.00035 10.5Z";
  const IconPathBatteryConsumption = "M5 12.519C5 12.7849 5.21514 13 5.481 13H10.519C10.7849 13 11 12.7849 11 12.519V4.481C11 4.21514 10.7849 4 10.519 4H5.481C5.21514 4 5 4.21514 5 4.481L5 12.519ZM5.481 14C4.66286 14 4 13.3371 4 12.519L4 4.481C4 3.66286 4.66286 3 5.481 3H6.5C6.22386 3 6 2.77614 6 2.5C6 2.22386 6.22386 2 6.5 2H9.5C9.77614 2 10 2.22386 10 2.5C10 2.77614 9.77614 3 9.5 3H10.519C11.3371 3 12 3.66286 12 4.481V12.519C12 13.3371 11.3371 14 10.519 14H5.481ZM6 11.5C6 11.2239 6.22386 11 6.5 11H9.5C9.77614 11 10 11.2239 10 11.5C10 11.7761 9.77614 12 9.5 12H6.5C6.22386 12 6 11.7761 6 11.5ZM6 9.5C6 9.22386 6.22386 9 6.5 9H9.5C9.77614 9 10 9.22386 10 9.5C10 9.77614 9.77614 10 9.5 10H6.5C6.22386 10 6 9.77614 6 9.5ZM6 7.5C6 7.22386 6.22386 7 6.5 7H9.5C9.77614 7 10 7.22386 10 7.5C10 7.77614 9.77614 8 9.5 8H6.5C6.22386 8 6 7.77614 6 7.5Z";
  const IconPathBatteryHorizontal = "M3.481 5C3.21514 5 3 5.21514 3 5.481V10.519C3 10.7849 3.21514 11 3.481 11H11.519C11.7849 11 12 10.7849 12 10.519V5.481C12 5.21514 11.7849 5 11.519 5H3.481ZM2 5.481C2 4.66286 2.66286 4 3.481 4H11.519C12.3371 4 13 4.66286 13 5.481V6.5C13 6.22386 13.2239 6 13.5 6C13.7761 6 14 6.22386 14 6.5V9.5C14 9.77614 13.7761 10 13.5 10C13.2239 10 13 9.77614 13 9.5V10.519C13 11.3371 12.3371 12 11.519 12H3.481C2.66286 12 2 11.3371 2 10.519V5.481ZM4.5 6C4.77614 6 5 6.22386 5 6.5V9.5C5 9.77614 4.77614 10 4.5 10C4.22386 10 4 9.77614 4 9.5V6.5C4 6.22386 4.22386 6 4.5 6ZM6.5 6C6.77614 6 7 6.22386 7 6.5V9.5C7 9.77614 6.77614 10 6.5 10C6.22386 10 6 9.77614 6 9.5V6.5C6 6.22386 6.22386 6 6.5 6ZM8.5 6C8.77614 6 9 6.22386 9 6.5V9.5C9 9.77614 8.77614 10 8.5 10C8.22386 10 8 9.77614 8 9.5V6.5C8 6.22386 8.22386 6 8.5 6Z";
  const IconPathBatteryVertical = "M5 12.519C5 12.7849 5.21514 13 5.481 13H10.519C10.7849 13 11 12.7849 11 12.519V4.481C11 4.21514 10.7849 4 10.519 4H5.481C5.21514 4 5 4.21514 5 4.481L5 12.519ZM5.481 14C4.66286 14 4 13.3371 4 12.519L4 4.481C4 3.66286 4.66286 3 5.481 3H6.5C6.22386 3 6 2.77614 6 2.5C6 2.22386 6.22386 2 6.5 2H9.5C9.77614 2 10 2.22386 10 2.5C10 2.77614 9.77614 3 9.5 3H10.519C11.3371 3 12 3.66286 12 4.481V12.519C12 13.3371 11.3371 14 10.519 14H5.481ZM6 11.5C6 11.2239 6.22386 11 6.5 11H9.5C9.77614 11 10 11.2239 10 11.5C10 11.7761 9.77614 12 9.5 12H6.5C6.22386 12 6 11.7761 6 11.5ZM6 9.5C6 9.22386 6.22386 9 6.5 9H9.5C9.77614 9 10 9.22386 10 9.5C10 9.77614 9.77614 10 9.5 10H6.5C6.22386 10 6 9.77614 6 9.5ZM6 7.5C6 7.22386 6.22386 7 6.5 7H9.5C9.77614 7 10 7.22386 10 7.5C10 7.77614 9.77614 8 9.5 8H6.5C6.22386 8 6 7.77614 6 7.5Z";
  const IconPathBlock = "M1.5 8.48717C1.5 4.89734 4.41015 1.98718 8 1.98718C11.5899 1.98718 14.5 4.89734 14.5 8.48717C14.5 12.0771 11.5899 14.9872 8 14.9872C4.41015 14.9872 1.5 12.0771 1.5 8.48717ZM3.78488 4.95388C2.98293 5.90958 2.5 7.14198 2.5 8.48717C2.5 11.5248 4.96244 13.9872 8 13.9872C9.33923 13.9872 10.5666 13.5085 11.5205 12.713L3.78488 4.95388ZM4.49428 4.24907L12.2275 12.0057C13.022 11.0521 13.5 9.82547 13.5 8.48717C13.5 5.44962 11.0376 2.98718 8 2.98718C6.66771 2.98718 5.44605 3.4609 4.49428 4.24907Z";
  const IconPathCancel = "M3.14645 3.14645C3.34171 2.95118 3.65829 2.95118 3.85355 3.14645L8 7.29289L12.1464 3.14645C12.3417 2.95118 12.6583 2.95118 12.8536 3.14645C13.0488 3.34171 13.0488 3.65829 12.8536 3.85355L8.70711 8L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L8 8.70711L3.85355 12.8536C3.65829 13.0488 3.34171 13.0488 3.14645 12.8536C2.95118 12.6583 2.95118 12.3417 3.14645 12.1464L7.29289 8L3.14645 3.85355C2.95118 3.65829 2.95118 3.34171 3.14645 3.14645Z";
  const IconPathCancelCircle = "M1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8ZM8 2.5C4.96244 2.5 2.5 4.96244 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5ZM5.14645 5.14645C5.34171 4.95118 5.65829 4.95118 5.85355 5.14645L8 7.29289L10.1464 5.14645C10.3417 4.95118 10.6583 4.95118 10.8536 5.14645C11.0488 5.34171 11.0488 5.65829 10.8536 5.85355L8.70711 8L10.8536 10.1464C11.0488 10.3417 11.0488 10.6583 10.8536 10.8536C10.6583 11.0488 10.3417 11.0488 10.1464 10.8536L8 8.70711L5.85355 10.8536C5.65829 11.0488 5.34171 11.0488 5.14645 10.8536C4.95118 10.6583 4.95118 10.3417 5.14645 10.1464L7.29289 8L5.14645 5.85355C4.95118 5.65829 4.95118 5.34171 5.14645 5.14645Z";
  const IconPathCancelCircleFilled = "M1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8ZM5.85355 5.14645C5.65829 4.95118 5.34171 4.95118 5.14645 5.14645C4.95118 5.34171 4.95118 5.65829 5.14645 5.85355L7.29289 8L5.14645 10.1464C4.95118 10.3417 4.95118 10.6583 5.14645 10.8536C5.34171 11.0488 5.65829 11.0488 5.85355 10.8536L8 8.70711L10.1464 10.8536C10.3417 11.0488 10.6583 11.0488 10.8536 10.8536C11.0488 10.6583 11.0488 10.3417 10.8536 10.1464L8.70711 8L10.8536 5.85355C11.0488 5.65829 11.0488 5.34171 10.8536 5.14645C10.6583 4.95118 10.3417 4.95118 10.1464 5.14645L8 7.29289L5.85355 5.14645Z";
  const IconPathCar = "M3.30133 3.65837C3.55199 3.11712 4.10224 2.85156 4.65 2.85156H11.4C11.9306 2.85156 12.4417 3.1401 12.7296 3.62382L12.738 3.63782L13.5046 5.14036L13.6967 4.77156H15C15.2761 4.77156 15.5 4.99542 15.5 5.27156C15.5 5.54771 15.2761 5.77156 15 5.77156H14.3033L14.0638 6.23156L14.8603 7.76101L14.8723 7.79554C14.8747 7.80231 14.8772 7.80937 14.8797 7.8167C14.9249 7.94612 15 8.16098 15 8.39155V11.9916C15 12.8147 14.3067 13.4516 13.5 13.4516H13C12.1933 13.4516 11.5 12.8147 11.5 11.9916V11.5316H4.5V11.9916C4.5 12.8147 3.80671 13.4516 3 13.4516H2.5C1.69329 13.4516 1 12.8147 1 11.9916V8.39155C1 8.16098 1.07507 7.94612 1.12029 7.8167C1.12285 7.80937 1.12531 7.80231 1.12766 7.79554L1.13966 7.76101L1.93625 6.23156L1.69666 5.77156H1C0.723858 5.77156 0.5 5.54771 0.5 5.27156C0.5 4.99542 0.723858 4.77156 1 4.77156H2.30334L2.50447 5.15774L3.30133 3.65837ZM2.80334 6.73156L2.29456 7.7084L3.65632 8.15662C3.91862 8.24295 4.06127 8.52557 3.97494 8.78787C3.8886 9.05017 3.60598 9.19282 3.34368 9.10649L2 8.66422V11.9916C2 12.2244 2.20671 12.4516 2.5 12.4516H3C3.29329 12.4516 3.5 12.2244 3.5 11.9916V10.5316H12.5V11.9916C12.5 12.2244 12.7067 12.4516 13 12.4516H13.5C13.7933 12.4516 14 12.2244 14 11.9916V8.66422L12.6563 9.10649C12.394 9.19282 12.1114 9.05017 12.0251 8.78787C11.9387 8.52557 12.0814 8.24295 12.3437 8.15662L13.7054 7.7084L13.1967 6.73156H2.80334ZM12.6836 5.73156L11.8631 4.12341C11.7503 3.943 11.5658 3.85156 11.4 3.85156H4.65C4.40359 3.85156 4.25972 3.96433 4.20657 4.08339L4.19957 4.09906L3.33196 5.73156H12.6836ZM7.10059 8.55554C7.10059 8.00323 7.54828 7.55554 8.10059 7.55554C8.65281 7.55554 9.10059 8.0032 9.10059 8.55554C9.10059 9.1078 8.65284 9.55554 8.10059 9.55554C7.54824 9.55554 7.10059 9.10776 7.10059 8.55554Z";
  const IconPathCard = "M7.03996 15.5275C6.66996 15.5275 6.29996 15.3875 6.01996 15.0975L1.26996 10.3675C0.989956 10.0875 0.829956 9.7275 0.829956 9.3475C0.829956 8.9675 0.979956 8.6075 1.26996 8.3275L8.70996 0.9275C9.27996 0.3575 10.18 0.3575 10.76 0.9275L15.51 5.6575C15.77 5.8775 15.93 6.2275 15.94 6.6175C15.95 7.0175 15.8 7.4175 15.51 7.7075L8.06996 15.1075C7.77996 15.3975 7.40996 15.5375 7.04996 15.5375L7.03996 15.5275ZM9.72996 1.4975C9.61996 1.4975 9.49996 1.5475 9.40996 1.6375L1.96996 9.0375C1.87996 9.1275 1.82996 9.2375 1.82996 9.3475C1.82996 9.4575 1.87996 9.5675 1.96996 9.6575L6.71996 14.3875C6.90996 14.5775 7.16996 14.5775 7.35996 14.3875L14.8 6.9875C14.89 6.8975 14.94 6.7675 14.94 6.6375C14.94 6.5775 14.92 6.4675 14.82 6.3775L10.05 1.6375C9.95996 1.5475 9.83996 1.4975 9.72996 1.4975ZM8.42996 11.9075C8.29996 11.9075 8.17996 11.8575 8.07996 11.7675C7.91996 11.6075 7.77996 11.5075 7.61996 11.4475C7.24996 11.2975 6.82996 11.2975 6.44996 11.4475C6.28996 11.5075 6.15996 11.6075 5.98996 11.7675C5.78996 11.9575 5.47996 11.9575 5.27996 11.7675C5.08996 11.5675 5.08996 11.2575 5.27996 11.0575C5.53996 10.8075 5.78996 10.6275 6.06996 10.5175C6.67996 10.2775 7.35996 10.2775 7.97996 10.5175C8.25996 10.6275 8.50996 10.7975 8.76996 11.0575C8.96996 11.2575 8.96996 11.5675 8.76996 11.7675C8.66996 11.8675 8.53996 11.9175 8.41996 11.9175L8.42996 11.9075ZM9.67996 10.5275C9.54996 10.5275 9.41996 10.4775 9.32996 10.3775C8.99996 10.0475 8.66996 9.8275 8.29996 9.6775C7.55996 9.3575 6.56996 9.3275 5.68996 9.6775C5.31996 9.8475 4.93996 10.0975 4.65996 10.3775C4.45996 10.5675 4.14996 10.5775 3.94996 10.3775C3.75996 10.1775 3.75996 9.8675 3.94996 9.6675C4.31996 9.2975 4.79996 8.9775 5.29996 8.7475C6.45996 8.2875 7.73996 8.3275 8.67996 8.7475C9.15996 8.9375 9.60996 9.2375 10.03 9.6575C10.23 9.8575 10.23 10.1675 10.03 10.3675C9.92996 10.4675 9.79996 10.5175 9.67996 10.5175V10.5275ZM6.98996 12.1375C6.68996 12.1375 6.48996 12.3375 6.48996 12.6375C6.48996 12.9375 6.68996 13.1375 6.98996 13.1375C7.28996 13.1375 7.48996 12.9375 7.48996 12.6375C7.48996 12.3375 7.23996 12.1375 6.98996 12.1375Z";
  const IconPathCardAdd = "M12.8501 2.15002H1.8501C1.0201 2.15002 0.350098 2.82002 0.350098 3.65002V10.65C0.350098 11.48 1.0201 12.15 1.8501 12.15H6.8501C7.1301 12.15 7.3501 11.93 7.3501 11.65C7.3501 11.37 7.1301 11.15 6.8501 11.15H1.8501C1.5701 11.15 1.3501 10.93 1.3501 10.65V3.65002C1.3501 3.37002 1.5701 3.15002 1.8501 3.15002H12.8501C13.1301 3.15002 13.3501 3.37002 13.3501 3.65002V5.40002C13.3501 5.68002 13.5701 5.90002 13.8501 5.90002C14.1301 5.90002 14.3501 5.68002 14.3501 5.40002V3.65002C14.3501 2.82002 13.6801 2.15002 12.8501 2.15002ZM2.8501 5.15002C2.5701 5.15002 2.3501 5.37002 2.3501 5.65002C2.3501 5.93002 2.5701 6.15002 2.8501 6.15002C3.3001 6.15002 3.7501 6.24002 4.1701 6.40002C4.6001 6.58002 4.9901 6.83002 5.3301 7.17002C5.6601 7.50002 5.9201 7.89002 6.1001 8.33002C6.2701 8.75002 6.3601 9.19002 6.3601 9.65002C6.3601 9.93002 6.5801 10.15 6.8601 10.15C7.1401 10.15 7.3601 9.93002 7.3601 9.65002C7.3601 9.07002 7.2501 8.50002 7.0301 7.96002C6.8001 7.40002 6.4701 6.90002 6.0401 6.47002C5.6101 6.04002 5.1101 5.71002 4.5501 5.48002C4.0101 5.26002 3.4401 5.15002 2.8601 5.15002H2.8501ZM11.8501 6.40002C9.7801 6.40002 8.1001 8.08002 8.1001 10.15C8.1001 12.22 9.7801 13.9 11.8501 13.9C13.9201 13.9 15.6001 12.22 15.6001 10.15C15.6001 8.08002 13.9201 6.40002 11.8501 6.40002ZM11.8501 12.9C10.3301 12.9 9.1001 11.67 9.1001 10.15C9.1001 8.63002 10.3301 7.40002 11.8501 7.40002C13.3701 7.40002 14.6001 8.63002 14.6001 10.15C14.6001 11.67 13.3701 12.9 11.8501 12.9ZM2.8501 7.15002C2.5701 7.15002 2.3501 7.37002 2.3501 7.65002C2.3501 7.93002 2.5701 8.15002 2.8501 8.15002C3.0501 8.15002 3.2401 8.19002 3.4101 8.26002C3.6001 8.34002 3.7601 8.45002 3.9101 8.59002C4.0501 8.73002 4.1601 8.90002 4.2401 9.09002C4.3101 9.27002 4.3501 9.46002 4.3501 9.66002C4.3501 9.94002 4.5701 10.16 4.8501 10.16C5.1301 10.16 5.3501 9.94002 5.3501 9.66002C5.3501 9.34002 5.2901 9.02002 5.1701 8.72002C5.0401 8.41002 4.8601 8.13002 4.6201 7.89002C4.3801 7.65002 4.1001 7.47002 3.7901 7.34002C3.4901 7.22002 3.1701 7.16002 2.8501 7.16002V7.15002ZM11.8501 8.32002C11.5701 8.32002 11.3501 8.54002 11.3501 8.82002V9.65002H10.5201C10.2401 9.65002 10.0201 9.87002 10.0201 10.15C10.0201 10.43 10.2401 10.65 10.5201 10.65H11.3501V11.48C11.3501 11.76 11.5701 11.98 11.8501 11.98C12.1301 11.98 12.3501 11.76 12.3501 11.48V10.65H13.1801C13.4601 10.65 13.6801 10.43 13.6801 10.15C13.6801 9.87002 13.4601 9.65002 13.1801 9.65002H12.3501V8.82002C12.3501 8.54002 12.1301 8.32002 11.8501 8.32002ZM2.8501 9.15002C2.7201 9.15002 2.5901 9.20002 2.5001 9.30002C2.3001 9.50002 2.3001 9.81002 2.5001 10.01C2.6001 10.11 2.7301 10.16 2.8501 10.16C2.9701 10.16 3.1101 10.11 3.2001 10.01C3.4001 9.81002 3.4001 9.50002 3.2001 9.30002C3.1001 9.20002 2.9701 9.15002 2.8501 9.15002Z";
  const IconPathCardGroup = "M11.9499 6.19001L8.17991 2.56001C7.68991 2.09001 6.89991 2.09001 6.40991 2.56001L0.479912 8.26001C-0.0300879 8.74001 -0.0300879 9.53001 0.479912 10.01L4.24991 13.64C4.73991 14.11 5.52991 14.11 6.01991 13.64L11.9499 7.94001C12.4499 7.46001 12.4499 6.67001 11.9499 6.19001ZM11.2599 7.22001L5.32991 12.91C5.21991 13.01 5.04991 13.01 4.93991 12.91L1.16991 9.29001C1.07991 9.20001 1.07991 9.07001 1.16991 8.98001L7.09991 3.29001C7.19991 3.18001 7.37991 3.19001 7.47991 3.29001L11.2599 6.91001C11.3499 7.00001 11.3499 7.13001 11.2599 7.22001ZM5.66991 11.86C5.66991 12.13 5.43991 12.36 5.16991 12.36C4.89991 12.36 4.66991 12.13 4.66991 11.86C4.66991 11.59 4.88991 11.36 5.16991 11.36C5.44991 11.36 5.66991 11.58 5.66991 11.86ZM6.58991 11.04C6.39991 11.24 6.08991 11.24 5.88991 11.05C5.78991 10.96 5.67991 10.89 5.55991 10.84C5.43991 10.79 5.29991 10.76 5.15991 10.76C5.00991 10.76 4.86991 10.79 4.74991 10.84C4.62991 10.89 4.51991 10.96 4.41991 11.05C4.21991 11.24 3.90991 11.24 3.71991 11.04C3.52991 10.84 3.52991 10.52 3.71991 10.33C3.90991 10.16 4.11991 10.01 4.35991 9.92001C4.60991 9.82001 4.86991 9.76001 5.14991 9.76001C5.42991 9.76001 5.68991 9.82001 5.92991 9.92001C6.16991 10.01 6.38991 10.16 6.56991 10.33C6.76991 10.52 6.77991 10.84 6.57991 11.04H6.58991ZM7.66991 10C7.47991 10.2 7.15991 10.21 6.95991 10.02C6.72991 9.80001 6.45991 9.62001 6.14991 9.49001C5.84991 9.37001 5.50991 9.30001 5.15991 9.30001C4.80991 9.30001 4.45991 9.37001 4.15991 9.49001C3.84991 9.62001 3.57991 9.80001 3.34991 10.02C3.14991 10.21 2.82991 10.2 2.63991 10C2.44991 9.81001 2.44991 9.49001 2.63991 9.30001C2.96991 8.99001 3.34991 8.74001 3.76991 8.57001C4.19991 8.39001 4.65991 8.30001 5.14991 8.30001C5.63991 8.30001 6.09991 8.39001 6.51991 8.57001C6.93991 8.74001 7.32991 8.99001 7.64991 9.30001C7.84991 9.49001 7.84991 9.81001 7.64991 10H7.66991ZM15.4799 7.93001L9.54991 13.63C9.05991 14.1 8.27991 14.1 7.77991 13.63C7.57991 13.43 7.57991 13.12 7.76991 12.92C7.95991 12.72 8.27991 12.71 8.47991 12.9C8.57991 13 8.75991 13 8.85991 12.9L14.7899 7.21001C14.8799 7.12001 14.8799 6.99001 14.7899 6.90001L11.0199 3.28001C10.9099 3.17001 10.7399 3.18001 10.6299 3.28001C10.4299 3.47001 10.1199 3.46001 9.92991 3.26001C9.72991 3.06001 9.73991 2.74001 9.92991 2.55001C10.4199 2.08001 11.2099 2.08001 11.6999 2.55001L15.4699 6.18001C15.9799 6.66001 15.9799 7.45001 15.4699 7.93001H15.4799Z";
  const IconPathChargerElvi = "M3.96019 1.85194C4.04611 1.42229 4.411 1 4.95048 1H10.1505C10.4041 1 10.6435 1.09901 10.8217 1.25341C10.9957 1.40423 11.1412 1.63641 11.15 1.92255L11.7484 8.45439C11.7736 8.72938 11.5711 8.97273 11.2961 8.99792C11.0211 9.02311 10.7777 8.8206 10.7525 8.54561L10.1531 2.00126C10.1509 2.00048 10.1495 2.00014 10.1489 2H4.96336C4.96036 2.00324 4.95645 2.00828 4.95251 2.01542C4.94964 2.02063 4.94703 2.02648 4.94486 2.03285L4.09855 10.944C4.0736 11.2587 4.3012 11.5 4.60048 11.5H6.00033V10.3229C5.68915 9.97032 5.50033 9.50721 5.50033 9C5.50033 8.06811 6.13773 7.28504 7.00033 7.06301V6C7.00033 5.72386 7.22419 5.5 7.50033 5.5C7.77647 5.5 8.00033 5.72386 8.00033 6V7.06301C8.86293 7.28504 9.50033 8.06811 9.50033 9C9.50033 9.50721 9.31151 9.97032 9.00033 10.3229V12.5C9.00033 12.7636 8.91027 13.0222 8.71638 13.2161C8.52249 13.4099 8.26395 13.5 8.00033 13.5C8.00033 13.7739 8.22647 14 8.50033 14H10.0003V11.65C10.0003 11.5174 10.053 11.3902 10.1468 11.2964L11.5468 9.89645C11.6405 9.80268 11.7677 9.75 11.9003 9.75C12.0329 9.75 12.1601 9.80268 12.2539 9.89645L12.6253 10.2679L13.3968 9.49645C13.592 9.30118 13.9086 9.30118 14.1039 9.49645C14.2991 9.69171 14.2991 10.0083 14.1039 10.2036L13.3324 10.975L14.0252 11.6678L14.7965 10.8964C14.9918 10.7012 15.3084 10.7012 15.5036 10.8964C15.6989 11.0917 15.6989 11.4083 15.5036 11.6036L14.7323 12.3749L15.1039 12.7464C15.2991 12.9417 15.2991 13.2583 15.1039 13.4536L13.7039 14.8536C13.6101 14.9473 13.4829 15 13.3503 15H8.50033C7.67419 15 7.00033 14.3261 7.00033 13.5C6.73671 13.5 6.47817 13.4099 6.28428 13.2161C6.09039 13.0222 6.00033 12.7636 6.00033 12.5H4.60048C3.70053 12.5 3.02853 11.7425 3.1022 10.8585L3.10268 10.8527L3.95272 1.90273C3.95433 1.88568 3.95683 1.86873 3.96019 1.85194ZM8.00033 12.5V10.937C7.84052 10.9781 7.67298 11 7.50033 11C7.32768 11 7.16014 10.9781 7.00033 10.937V12.5H8.00033ZM13.1432 14L14.0432 13.1L11.9003 10.9571L11.0003 11.8571V14H13.1432ZM7.50033 8C6.94807 8 6.50033 8.44774 6.50033 9C6.50033 9.55226 6.94807 10 7.50033 10C8.05259 10 8.50033 9.55226 8.50033 9C8.50033 8.44774 8.05259 8 7.50033 8Z";
  const IconPathChargerId = "M5.5 2C4.67614 2 4 2.67614 4 3.5V10C4 10.8239 4.67614 11.5 5.5 11.5H8.5C8.77614 11.5 9 11.7239 9 12C9 12.2761 8.77614 12.5 8.5 12.5H8V13.5C8 13.7905 8.24253 14 8.45 14H10V11.65C10 11.5174 10.0527 11.3902 10.1464 11.2964L11.5464 9.89645C11.6402 9.80268 11.7674 9.75 11.9 9.75C12.0326 9.75 12.1598 9.80268 12.2535 9.89645L12.625 10.2679L13.3964 9.49646C13.5917 9.3012 13.9083 9.3012 14.1036 9.49646C14.2988 9.69173 14.2988 10.0083 14.1036 10.2036L13.3321 10.975L14.0249 11.6678L14.7962 10.8964C14.9914 10.7012 15.308 10.7012 15.5033 10.8964C15.6986 11.0917 15.6986 11.4083 15.5033 11.6036L14.732 12.3749L15.1036 12.7464C15.2988 12.9417 15.2988 13.2583 15.1036 13.4536L13.7036 14.8536C13.6098 14.9473 13.4826 15 13.35 15H10.5C10.4993 15 10.4987 15 10.498 15H8.45C7.65746 15 7 14.3095 7 13.5V12.5H5.5C4.12386 12.5 3 11.3761 3 10V3.5C3 2.12386 4.12386 1 5.5 1H9.5C10.8761 1 12 2.12386 12 3.5V8.5C12 8.77614 11.7761 9 11.5 9C11.2239 9 11 8.77614 11 8.5V3.5C11 2.67614 10.3239 2 9.5 2H5.5ZM11.202 14H13.1429L14.0429 13.1L11.9 10.9571L11 11.8571V14H11.2C11.2007 14 11.2013 14 11.202 14ZM7.80454 4.02448C8.06716 4.10983 8.21086 4.39192 8.12551 4.65454L7.68824 6H8.98823L8.12551 8.65454C8.04016 8.91716 7.75807 9.06087 7.49545 8.97552C7.23283 8.89017 7.08913 8.60808 7.17448 8.34546L7.61175 7H6.31176L7.17448 4.34546C7.25983 4.08284 7.54191 3.93913 7.80454 4.02448Z";
  const IconPathChart = "M6 3.43021C6 2.60484 6.69103 1.97021 7.5 1.97021H8.5C9.30897 1.97021 10 2.60484 10 3.43021V11.5902C10 12.4156 9.30898 13.0502 8.5 13.0502H7.5C6.69102 13.0502 6 12.4156 6 11.5902V3.43021ZM7.5 2.97021C7.20444 2.97021 7 3.19521 7 3.43021V11.5902C7 11.8252 7.20444 12.0502 7.5 12.0502H8.5C8.79556 12.0502 9 11.8252 9 11.5902V3.43021C9 3.19521 8.79556 2.97021 8.5 2.97021H7.5ZM11 5.83022C11 5.00484 11.691 4.37021 12.5 4.37021H13.5C14.309 4.37021 15 5.00484 15 5.83022V11.5902C15 12.4156 14.309 13.0502 13.5 13.0502H12.5C11.691 13.0502 11 12.4156 11 11.5902V5.83022ZM12.5 5.37021C12.2044 5.37021 12 5.59521 12 5.83022V11.5902C12 11.8252 12.2044 12.0502 12.5 12.0502H13.5C13.7956 12.0502 14 11.8252 14 11.5902V5.83022C14 5.59521 13.7956 5.37021 13.5 5.37021H12.5ZM1 8.23021C1 7.40486 1.691 6.77022 2.5 6.77022H3.5C4.309 6.77022 5 7.40486 5 8.23021V11.5902C5 12.4156 4.309 13.0502 3.5 13.0502H2.5C1.691 13.0502 1 12.4156 1 11.5902V8.23021ZM2.5 7.77022C2.20443 7.77022 2 7.99522 2 8.23021V11.5902C2 11.8252 2.20443 12.0502 2.5 12.0502H3.5C3.79557 12.0502 4 11.8252 4 11.5902V8.23021C4 7.99522 3.79557 7.77022 3.5 7.77022H2.5Z";
  const IconPathCheck = "M13.8536 4.14645C14.0488 4.34171 14.0488 4.65829 13.8536 4.85355L6.5 12.2071L3.14645 8.85355C2.95118 8.65829 2.95118 8.34171 3.14645 8.14645C3.34171 7.95118 3.65829 7.95118 3.85355 8.14645L6.5 10.7929L13.1464 4.14645C13.3417 3.95118 13.6583 3.95118 13.8536 4.14645Z";
  const IconPathCheckCircleFilled = "M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM11.1074 6.14645C11.3026 6.34171 11.3026 6.65829 11.1074 6.85355L7.25382 10.7071L4.90035 8.35355C4.70509 8.15828 4.70509 7.8417 4.90036 7.64644C5.09563 7.45118 5.41221 7.45119 5.60747 7.64645L7.25384 9.29289L10.4003 6.14645C10.5955 5.95118 10.9121 5.95118 11.1074 6.14645Z";
  const IconPathCheckboxChecked = "M3.09091 14H12.9091C13.5091 14 14 13.5091 14 12.9091V3.09091C14 2.49091 13.5091 2 12.9091 2H3.09091C2.49091 2 2 2.49091 2 3.09091V12.9091C2 13.5091 2.49091 14 3.09091 14ZM12.3703 5.664C12.5558 5.86851 12.5405 6.18471 12.336 6.37028L6.85714 11.3418L3.66401 8.44435C3.45951 8.25879 3.44416 7.94258 3.62972 7.73808C3.81528 7.53358 4.13149 7.51823 4.33599 7.70379L6.85714 9.9915L11.664 5.62972C11.8685 5.44415 12.1847 5.4595 12.3703 5.664Z";
  const IconPathCheckboxIndeterminate = "M3.09091 14H12.9091C13.5091 14 14 13.5091 14 12.9091V3.09091C14 2.49091 13.5091 2 12.9091 2H3.09091C2.49091 2 2 2.49091 2 3.09091V12.9091C2 13.5091 2.49091 14 3.09091 14ZM4.16667 8C4.16667 7.72386 4.39052 7.5 4.66667 7.5H11.3333C11.6095 7.5 11.8333 7.72386 11.8333 8C11.8333 8.27614 11.6095 8.5 11.3333 8.5H4.66667C4.39052 8.5 4.16667 8.27614 4.16667 8Z";
  const IconPathCheckboxUnchecked = "M12.5 14.5H3.5C2.39772 14.5 1.5 13.6023 1.5 12.5V3.5C1.5 2.39772 2.39772 1.5 3.5 1.5H12.5C13.6023 1.5 14.5 2.39772 14.5 3.5V12.5C14.5 13.6023 13.6023 14.5 12.5 14.5ZM3.5 13.5H12.5C13.05 13.5 13.5 13.05 13.5 12.5V3.5C13.5 2.95 13.05 2.5 12.5 2.5H3.5C2.95 2.5 2.5 2.95 2.5 3.5V12.5C2.5 13.05 2.95 13.5 3.5 13.5Z";
  const IconPathClose = "M3.14645 3.14645C3.34171 2.95118 3.65829 2.95118 3.85355 3.14645L8 7.29289L12.1464 3.14645C12.3417 2.95118 12.6583 2.95118 12.8536 3.14645C13.0488 3.34171 13.0488 3.65829 12.8536 3.85355L8.70711 8L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L8 8.70711L3.85355 12.8536C3.65829 13.0488 3.34171 13.0488 3.14645 12.8536C2.95118 12.6583 2.95118 12.3417 3.14645 12.1464L7.29289 8L3.14645 3.85355C2.95118 3.65829 2.95118 3.34171 3.14645 3.14645Z";
  const IconPathCloseCircle = "M1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8ZM8 2.5C4.96244 2.5 2.5 4.96244 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5ZM5.14645 5.14645C5.34171 4.95118 5.65829 4.95118 5.85355 5.14645L8 7.29289L10.1464 5.14645C10.3417 4.95118 10.6583 4.95118 10.8536 5.14645C11.0488 5.34171 11.0488 5.65829 10.8536 5.85355L8.70711 8L10.8536 10.1464C11.0488 10.3417 11.0488 10.6583 10.8536 10.8536C10.6583 11.0488 10.3417 11.0488 10.1464 10.8536L8 8.70711L5.85355 10.8536C5.65829 11.0488 5.34171 11.0488 5.14645 10.8536C4.95118 10.6583 4.95118 10.3417 5.14645 10.1464L7.29289 8L5.14645 5.85355C4.95118 5.65829 4.95118 5.34171 5.14645 5.14645Z";
  const IconPathCloseCircleFilled = "M2 8C2 4.41015 4.91015 1.5 8.5 1.5C12.0899 1.5 15 4.41015 15 8C15 11.5899 12.0899 14.5 8.5 14.5C4.91015 14.5 2 11.5899 2 8ZM6.35355 5.14645C6.15829 4.95118 5.84171 4.95118 5.64645 5.14645C5.45118 5.34171 5.45118 5.65829 5.64645 5.85355L7.79289 8L5.64645 10.1464C5.45118 10.3417 5.45118 10.6583 5.64645 10.8536C5.84171 11.0488 6.15829 11.0488 6.35355 10.8536L8.5 8.70711L10.6464 10.8536C10.8417 11.0488 11.1583 11.0488 11.3536 10.8536C11.5488 10.6583 11.5488 10.3417 11.3536 10.1464L9.20711 8L11.3536 5.85355C11.5488 5.65829 11.5488 5.34171 11.3536 5.14645C11.1583 4.95118 10.8417 4.95118 10.6464 5.14645L8.5 7.29289L6.35355 5.14645Z";
  const IconPathConnection = "M8.00121 4.35999C6.75121 4.35999 5.51121 4.59999 4.36121 5.05999C3.21121 5.51999 2.16121 6.18999 1.28121 7.03999C1.08121 7.22999 0.761206 7.22999 0.571206 7.02999C0.381206 6.82999 0.381206 6.50999 0.581206 6.31999C1.55121 5.37999 2.71121 4.63999 3.98121 4.12999C5.25121 3.61999 6.61121 3.35999 7.99121 3.35999C9.37121 3.35999 10.7312 3.61999 12.0012 4.12999C13.2712 4.63999 14.4312 5.37999 15.4012 6.31999C15.6012 6.50999 15.6012 6.82999 15.4112 7.02999C15.2212 7.22999 14.9012 7.22999 14.7012 7.03999C13.8212 6.18999 12.7712 5.51999 11.6212 5.05999C10.4712 4.59999 9.23121 4.35999 7.98121 4.35999H8.00121ZM8.00121 7.20999C7.14121 7.20999 6.30121 7.36999 5.51121 7.68999C4.72121 7.99999 4.00121 8.46999 3.40121 9.03999C3.20121 9.22999 2.88121 9.22999 2.69121 9.02999C2.50121 8.82999 2.50121 8.50999 2.70121 8.31999C3.40121 7.64999 4.22121 7.11999 5.13121 6.75999C6.04121 6.39999 7.01121 6.20999 7.99121 6.20999C8.97121 6.20999 9.94121 6.39999 10.8512 6.75999C11.7612 7.11999 12.5812 7.64999 13.2812 8.31999C13.4812 8.50999 13.4812 8.82999 13.2912 9.02999C13.1012 9.22999 12.7812 9.22999 12.5812 9.03999C11.9812 8.45999 11.2612 7.99999 10.4712 7.68999C9.68121 7.37999 8.83121 7.20999 7.98121 7.20999H8.00121ZM8.00121 10.11C7.54121 10.11 7.09121 10.2 6.67121 10.36C6.25121 10.53 5.87121 10.77 5.55121 11.08C5.35121 11.27 5.03121 11.27 4.84121 11.07C4.65121 10.87 4.65121 10.55 4.85121 10.36C5.26121 9.95999 5.76121 9.64999 6.29121 9.42999C6.83121 9.21999 7.41121 9.09999 7.99121 9.09999C8.57121 9.09999 9.16121 9.21999 9.69121 9.42999C10.2212 9.63999 10.7212 9.94999 11.1312 10.35C11.3312 10.54 11.3312 10.86 11.1412 11.06C10.9512 11.26 10.6312 11.26 10.4312 11.07C10.1112 10.77 9.73121 10.53 9.31121 10.36C8.88121 10.19 8.43121 10.1 7.98121 10.1L8.00121 10.11ZM8.00121 13.22C8.41121 13.22 8.75121 12.9 8.75121 12.5C8.75121 12.1 8.41121 11.78 8.00121 11.78C7.59121 11.78 7.25121 12.1 7.25121 12.5C7.25121 12.9 7.59121 13.22 8.00121 13.22Z";
  const IconPathConnectionLost = "M12.9064 11.47C13.1064 11.66 13.1164 11.98 12.9264 12.18C12.7364 12.38 12.4264 12.39 12.2164 12.2L10.4964 10.59C10.4264 10.56 10.3664 10.52 10.3164 10.47C10.0664 10.19 9.74642 9.95001 9.38642 9.79001C8.73642 9.54001 8.02642 9.47001 7.34642 9.60001C6.65642 9.72001 6.02642 10.04 5.52642 10.5C5.32642 10.68 5.01642 10.67 4.82642 10.47C4.63642 10.27 4.64642 9.95001 4.84642 9.76001C5.48642 9.17001 6.28642 8.77001 7.16642 8.61001C7.53642 8.55001 7.92642 8.52001 8.30642 8.55001L6.53642 6.90001C5.35642 7.15001 4.26642 7.72001 3.41642 8.52001C3.20642 8.71001 2.89642 8.70001 2.70642 8.49001C2.51642 8.29001 2.52642 7.98001 2.72642 7.79001C3.55642 7.02001 4.56642 6.43001 5.66642 6.09001L4.17642 4.69001C3.09642 5.14001 2.11642 5.76001 1.29642 6.54001C1.08642 6.73001 0.776417 6.72001 0.586417 6.52001C0.396417 6.31001 0.406417 6.00001 0.606417 5.81001C1.41642 5.05001 2.35642 4.42001 3.37642 3.95001L2.21642 2.87001C2.01642 2.68001 2.00642 2.36001 2.19642 2.16001C2.38642 1.96001 2.69642 1.95001 2.90642 2.14001L12.9064 11.47ZM8.00642 11.75C7.59642 11.75 7.25642 12.09 7.25642 12.5C7.25642 12.91 7.59642 13.25 8.00642 13.25C8.41642 13.25 8.75642 12.92 8.75642 12.5C8.75642 12.08 8.42642 11.75 8.00642 11.75ZM15.4264 5.81001C14.2564 4.71001 12.8264 3.89001 11.2564 3.42001C9.68642 2.94001 8.02642 2.82001 6.39642 3.05001C6.11642 3.09001 5.93642 3.35001 5.97642 3.62001C6.01642 3.90001 6.26642 4.08001 6.53642 4.04001C8.02642 3.83001 9.54642 3.94001 10.9664 4.37001C12.3964 4.81001 13.6864 5.55001 14.7464 6.54001C14.9464 6.73001 15.2664 6.72001 15.4564 6.52001C15.6364 6.31001 15.6264 6.00001 15.4264 5.81001ZM10.9264 6.29001C10.4964 6.12001 10.0564 5.99001 9.60642 5.90001C9.33642 5.84001 9.06642 6.02001 9.01642 6.29001C8.95642 6.56001 9.13642 6.82001 9.40642 6.88001C9.79642 6.96001 10.1864 7.07001 10.5564 7.22001C11.3264 7.52001 12.0364 7.97001 12.6264 8.52001C12.8264 8.71001 13.1464 8.70001 13.3264 8.49001C13.5164 8.29001 13.5064 7.98001 13.3064 7.79001C12.6264 7.15001 11.8164 6.64001 10.9264 6.29001Z";
  const IconPathContactless = "M8.47509 2.52839C8.73544 2.26804 9.15755 2.26804 9.4179 2.52839C10.1052 3.21567 10.6858 4.08877 11.0736 4.96118L11.0787 4.97267L11.0833 4.98435C11.4711 5.95388 11.6667 6.93064 11.6667 7.9998C11.6667 9.05081 11.4775 10.1239 11.0787 11.0269C10.6799 12.0184 10.0866 12.8025 9.4179 13.4712C9.15755 13.7316 8.73544 13.7316 8.47509 13.4712C8.21474 13.2109 8.21474 12.7887 8.47509 12.5284C9.0538 11.9497 9.52988 11.3088 9.84537 10.5201L9.85004 10.5084L9.85514 10.4969C10.1671 9.79505 10.3334 8.90858 10.3334 7.9998C10.3334 7.10895 10.1734 6.30346 9.85004 5.49125C9.52349 4.76034 9.03489 4.031 8.47509 3.4712C8.21474 3.21085 8.21474 2.78874 8.47509 2.52839ZM5.88594 5.02799C6.14629 4.76764 6.5684 4.76764 6.82875 5.02799C7.22782 5.42705 7.55794 5.85761 7.7799 6.41251C7.99065 6.93938 8.09544 7.47 8.09544 8.08868C8.09544 8.70735 7.99065 9.23797 7.7799 9.76484C7.55794 10.3197 7.22782 10.7503 6.82875 11.1494C6.5684 11.4097 6.14629 11.4097 5.88594 11.1494C5.62559 10.889 5.62559 10.4669 5.88594 10.2066C6.20116 9.89134 6.40675 9.60761 6.54193 9.26965C6.68833 8.90367 6.76211 8.54142 6.76211 8.08868C6.76211 7.63593 6.68833 7.27368 6.54193 6.9077C6.40675 6.56975 6.20116 6.28601 5.88594 5.97079C5.62559 5.71044 5.62559 5.28833 5.88594 5.02799ZM3.2334 7.99996C3.2334 7.63177 3.53188 7.33329 3.90007 7.33329H3.92033C4.28852 7.33329 4.58699 7.63177 4.58699 7.99996C4.58699 8.36815 4.28852 8.66663 3.92033 8.66663H3.90007C3.53188 8.66663 3.2334 8.36815 3.2334 7.99996Z";
  const IconPathContactlessCircle = "M1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8ZM8 2.5C4.96244 2.5 2.5 4.96244 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5ZM8.24638 4.79643C8.44164 4.60117 8.75822 4.60117 8.95349 4.79643C9.3502 5.19314 9.6839 5.69529 9.90684 6.19692L9.90684 6.19692C10.1407 6.72323 10.2499 7.34498 10.2499 7.95C10.2499 8.55502 10.1407 9.17677 9.90684 9.70307C9.68389 10.2047 9.3502 10.7068 8.95349 11.1036C8.75822 11.2988 8.44164 11.2988 8.24638 11.1036C8.05112 10.9083 8.05112 10.5917 8.24638 10.3964C8.54967 10.0932 8.81597 9.6953 8.99303 9.29693C9.15912 8.92323 9.24993 8.44498 9.24993 7.95C9.24993 7.45503 9.15912 6.97677 8.99303 6.60306C8.81597 6.20468 8.54967 5.80683 8.24638 5.50354C8.05112 5.30828 8.05112 4.9917 8.24638 4.79643ZM6.8463 6.24647C7.04156 6.0512 7.35814 6.05119 7.55341 6.24645C7.78486 6.47789 7.98156 6.73295 8.11411 7.0643C8.23824 7.37464 8.29987 7.68778 8.29987 8.05C8.29987 8.41222 8.23824 8.72536 8.11411 9.0357C7.98156 9.36705 7.78486 9.62211 7.55342 9.85355C7.35816 10.0488 7.04158 10.0488 6.84631 9.85355C6.65105 9.65829 6.65105 9.34171 6.84631 9.14645C7.01487 8.97789 7.11817 8.83295 7.18563 8.6643C7.26149 8.47464 7.29987 8.28778 7.29987 8.05C7.29987 7.81222 7.26149 7.62536 7.18563 7.4357C7.11817 7.26705 7.01487 7.12211 6.84633 6.95358C6.65106 6.75832 6.65105 6.44174 6.8463 6.24647ZM5.19987 8C5.19987 7.72386 5.42373 7.5 5.69987 7.5H5.71987C5.99601 7.5 6.21987 7.72386 6.21987 8C6.21987 8.27614 5.99601 8.5 5.71987 8.5H5.69987C5.42373 8.5 5.19987 8.27614 5.19987 8Z";
  const IconPathCreditcard = "M2.758 4C2.49217 4 2.25 4.24084 2.25 4.55V5.5H13.73V4.55C13.73 4.22235 13.47 4 13.222 4H2.758ZM13.73 6.5H2.25V11.45C2.25 11.7777 2.50992 12 2.758 12H13.222C13.5028 12 13.73 11.7933 13.73 11.45V6.5ZM1.25 4.55C1.25 3.75916 1.87183 3 2.758 3H13.222C14.0299 3 14.73 3.67765 14.73 4.55V11.45C14.73 12.3067 14.0932 13 13.222 13H2.758C1.95008 13 1.25 12.3223 1.25 11.45V4.55ZM3.17 10.5C3.17 10.2239 3.39386 10 3.67 10H6.54997C6.82611 10 7.04997 10.2239 7.04997 10.5C7.04997 10.7761 6.82611 11 6.54997 11H3.67C3.39386 11 3.17 10.7761 3.17 10.5Z";
  const IconPathCreditcardAdd = "M2 3.09998C1.72614 3.09998 1.5 3.32612 1.5 3.59998V4.59998H13.5V3.59998C13.5 3.32612 13.2739 3.09998 13 3.09998H2ZM1.5 5.59998H14C14.2761 5.59998 14.5 5.37612 14.5 5.09998V3.59998C14.5 2.77383 13.8261 2.09998 13 2.09998H2C1.17386 2.09998 0.5 2.77383 0.5 3.59998V10.6C0.5 11.4261 1.17386 12.1 2 12.1H7C7.27614 12.1 7.5 11.8761 7.5 11.6C7.5 11.3238 7.27614 11.1 7 11.1H2C1.72614 11.1 1.5 10.8738 1.5 10.6V5.59998ZM8.25 10.1C8.25 8.0289 9.92893 6.34998 12 6.34998C14.0711 6.34998 15.75 8.0289 15.75 10.1C15.75 12.1711 14.0711 13.85 12 13.85C9.92893 13.85 8.25 12.1711 8.25 10.1ZM12 7.34998C10.4812 7.34998 9.25 8.58119 9.25 10.1C9.25 11.6188 10.4812 12.85 12 12.85C13.5188 12.85 14.75 11.6188 14.75 10.1C14.75 8.58119 13.5188 7.34998 12 7.34998ZM12 8.25004C12.2761 8.25004 12.5 8.4739 12.5 8.75004V9.59998H13.3497C13.6259 9.59998 13.8497 9.82383 13.8497 10.1C13.8497 10.3761 13.6259 10.6 13.3497 10.6H12.5V11.45C12.5 11.7262 12.2761 11.95 12 11.95C11.7239 11.95 11.5 11.7262 11.5 11.45V10.6H10.6497C10.3736 10.6 10.1497 10.3761 10.1497 10.1C10.1497 9.82383 10.3736 9.59998 10.6497 9.59998H11.5V8.75004C11.5 8.4739 11.7239 8.25004 12 8.25004ZM2.5 9.59998C2.5 9.32383 2.72386 9.09998 3 9.09998H6C6.27614 9.09998 6.5 9.32383 6.5 9.59998C6.5 9.87612 6.27614 10.1 6 10.1H3C2.72386 10.1 2.5 9.87612 2.5 9.59998Z";
  const IconPathCreditcardInactive = "M1.63931 1.94963C1.83054 1.75043 2.14706 1.74397 2.34627 1.93521L3.84561 3.37457C3.84602 3.37496 3.84643 3.37536 3.84683 3.37575L6.34562 5.77459C6.34602 5.77497 6.34642 5.77535 6.34682 5.77573L12.8455 12.0145C12.846 12.0149 12.8465 12.0154 12.847 12.0159L14.3463 13.4552C14.5455 13.6464 14.5519 13.963 14.3607 14.1622C14.1695 14.3614 13.8529 14.3678 13.6537 14.1766L12.2988 12.8759H2.5C1.69329 12.8759 1 12.2391 1 11.4159V4.6959C1 3.95059 1.56832 3.35805 2.27459 3.25261L1.65373 2.65659C1.45453 2.46536 1.44807 2.14884 1.63931 1.94963ZM3.29884 4.2359H2.5C2.20671 4.2359 2 4.46308 2 4.6959V5.6359H4.75718L3.29884 4.2359ZM5.79884 6.6359H2V11.4159C2 11.6487 2.20671 11.8759 2.5 11.8759H11.2572L5.79884 6.6359ZM6 3.7359C6 3.45976 6.22386 3.2359 6.5 3.2359H13.5C14.3067 3.2359 15 3.87272 15 4.6959V11.4159C15 11.692 14.7761 11.9159 14.5 11.9159C14.2239 11.9159 14 11.692 14 11.4159V6.6359H9C8.72386 6.6359 8.5 6.41204 8.5 6.1359C8.5 5.85976 8.72386 5.6359 9 5.6359H14V4.6959C14 4.46308 13.7933 4.2359 13.5 4.2359H6.5C6.22386 4.2359 6 4.01204 6 3.7359ZM3 10.4559C3 10.1798 3.22386 9.9559 3.5 9.9559H6.5C6.77614 9.9559 7 10.1798 7 10.4559C7 10.732 6.77614 10.9559 6.5 10.9559H3.5C3.22386 10.9559 3 10.732 3 10.4559Z";
  const IconPathCookies = "M3.40572 3.39786C4.77535 2.02877 6.60314 1.40527 8.39161 1.51238C8.5301 1.52068 8.65892 1.58614 8.74726 1.69312C8.8356 1.80009 8.87552 1.93896 8.85748 2.07652C8.77868 2.67717 8.96234 3.29753 9.41627 3.75142C9.54333 3.87849 9.69443 3.98253 9.87052 4.07929C10.009 4.15537 10.1033 4.29242 10.125 4.44891C10.1973 4.97111 10.4307 5.47285 10.8303 5.87242C11.5967 6.6389 12.7389 6.80165 13.6698 6.36108C13.809 6.29522 13.9707 6.29714 14.1083 6.36628C14.2458 6.43541 14.3438 6.56405 14.374 6.71501C14.7853 8.7727 14.1951 10.9937 12.5983 12.5906C10.0595 15.1288 5.94393 15.1289 3.40565 12.5906C0.867464 10.0518 0.867435 5.93615 3.40572 3.39786ZM4.11269 4.10511C1.96504 6.25283 1.96501 9.73523 4.1128 11.8835C4.2443 12.015 4.38081 12.1385 4.52171 12.2539C4.63912 11.5425 5.25701 11 6.00162 11C6.83004 11 7.50166 11.6715 7.50166 12.5C7.50166 12.8524 7.38012 13.1764 7.17668 13.4324C8.84478 13.6841 10.6065 13.1678 11.8912 11.8835C13.0931 10.6815 13.6219 9.06142 13.4776 7.48963C12.3178 7.79001 11.0334 7.48979 10.1232 6.57954C9.62488 6.08128 9.31155 5.46973 9.17701 4.83038C9.01738 4.72842 8.85801 4.60738 8.70917 4.45854C8.1632 3.9126 7.8801 3.21129 7.84385 2.50272C6.48797 2.54012 5.1461 3.0721 4.11269 4.10511ZM12.4358 3.19623C12.4358 3.19623 12.439 3.19525 12.4473 3.19643C12.4402 3.19734 12.4358 3.19623 12.4358 3.19623ZM12.4758 3.20295C12.4943 3.20831 12.52 3.21739 12.5541 3.2325C12.7059 3.29978 12.9028 3.4439 13.0883 3.6377C13.2737 3.83149 13.409 4.03459 13.4695 4.18924C13.4832 4.22407 13.4911 4.25013 13.4956 4.26889C13.1112 4.59454 12.6324 4.54831 12.3953 4.3009C12.1588 4.05368 12.1336 3.57281 12.4758 3.20295ZM13.5006 4.30907C13.5006 4.30907 13.4997 4.30458 13.5009 4.29759C13.5017 4.30591 13.5006 4.30907 13.5006 4.30907ZM14.4008 3.82482C14.5116 4.10793 14.6067 4.59279 14.2376 4.94582C13.5238 5.62869 12.3722 5.72273 11.6728 4.9923C10.9739 4.26156 11.1191 3.11459 11.8322 2.43187C12.2011 2.07863 12.6814 2.19513 12.9592 2.31825C13.267 2.45462 13.5677 2.69226 13.8108 2.94633C14.0539 3.20041 14.2781 3.51132 14.4008 3.82482ZM4.00162 6.49995C4.00162 5.39539 4.89705 4.49995 6.00162 4.49995C7.10619 4.49995 8.00166 5.39537 8.00166 6.49995C8.00166 7.6045 7.10619 8.49996 6.00162 8.49996C4.89705 8.49996 4.00162 7.60449 4.00162 6.49995ZM6.00162 5.49995C5.44934 5.49995 5.00162 5.94767 5.00162 6.49995C5.00162 7.05222 5.44934 7.49996 6.00162 7.49996C6.55392 7.49996 7.00166 7.05221 7.00166 6.49995C7.00166 5.94768 6.55393 5.49995 6.00162 5.49995ZM8.50166 9.49996C8.50166 8.67157 9.17316 7.99996 10.0017 7.99996C10.8301 7.99996 11.5017 8.67155 11.5017 9.49996C11.5017 10.3284 10.8301 11 10.0017 11C9.17316 11 8.50166 10.3283 8.50166 9.49996ZM10.0017 8.99996C9.72549 8.99996 9.50166 9.22381 9.50166 9.49996C9.50166 9.7761 9.72549 9.99996 10.0017 9.99996C10.2778 9.99996 10.5017 9.77608 10.5017 9.49996C10.5017 9.22383 10.2778 8.99996 10.0017 8.99996ZM6.00162 12C5.72549 12 5.50162 12.2238 5.50162 12.5C5.50162 12.7761 5.72549 13 6.00162 13C6.27778 13 6.50166 12.7761 6.50166 12.5C6.50166 12.2238 6.27778 12 6.00162 12Z";
  const IconPathCopy = "M11 12.0116H12.5C13.3067 12.0116 14 11.3748 14 10.5516V4.59962C14 4.21601 13.839 3.84792 13.5463 3.56693L11.7463 1.83893C11.454 1.55835 11.0802 1.41162 10.7 1.41162H6.5C5.69329 1.41162 5 2.04844 5 2.87162V4.29162H3.5C2.69329 4.29162 2 4.92844 2 5.75162V13.4316C2 14.2548 2.69329 14.8916 3.5 14.8916H9.5C10.3067 14.8916 11 14.2548 11 13.4316L11 12.0116ZM3.5 5.29162C3.20671 5.29162 3 5.5188 3 5.75162V13.4316C3 13.6644 3.20671 13.8916 3.5 13.8916H9.5C9.79329 13.8916 10 13.6644 10 13.4316L9.99988 7.97961H7.69987C7.42372 7.97961 7.19987 7.75575 7.19987 7.47961V5.29162H3.5ZM8.19987 5.5806V6.97961H9.65718L8.19987 5.5806ZM8.10851 4.3492C8.3412 4.41602 8.56025 4.54035 8.74627 4.71893L10.5463 6.44691C10.8391 6.72803 10.9999 7.09617 10.9999 7.47961L10.9999 11.0116H12.5C12.7933 11.0116 13 10.7844 13 10.5516V4.59962C13 4.50323 12.961 4.39133 12.8537 4.28831L11.0537 2.56031C10.946 2.45689 10.8198 2.41162 10.7 2.41162H6.5C6.20671 2.41162 6 2.6388 6 2.87162V4.29162H7.69987C7.83812 4.29162 7.97554 4.31102 8.10851 4.3492Z";
  const IconPathDashboard = "M4 3.94714C3.70671 3.94714 3.5 4.17433 3.5 4.40714V7.76711C3.5 7.99993 3.70671 8.22711 4 8.22711H6C6.29329 8.22711 6.5 7.99993 6.5 7.76711V4.40714C6.5 4.17433 6.29329 3.94714 6 3.94714H4ZM2.5 4.40714C2.5 3.58396 3.19329 2.94714 4 2.94714H6C6.80671 2.94714 7.5 3.58396 7.5 4.40714V7.76711C7.5 8.59029 6.80671 9.22711 6 9.22711H4C3.19329 9.22711 2.5 8.59029 2.5 7.76711V4.40714ZM10 3.94714C9.70671 3.94714 9.5 4.17433 9.5 4.40714V4.88714C9.5 5.11996 9.70671 5.34714 10 5.34714H12C12.2933 5.34714 12.5 5.11996 12.5 4.88714V4.40714C12.5 4.17433 12.2933 3.94714 12 3.94714H10ZM8.5 4.40714C8.5 3.58396 9.19329 2.94714 10 2.94714H12C12.8067 2.94714 13.5 3.58396 13.5 4.40714V4.88714C13.5 5.71033 12.8067 6.34714 12 6.34714H10C9.19329 6.34714 8.5 5.71033 8.5 4.88714V4.40714ZM10 8.26711C9.70671 8.26711 9.5 8.49429 9.5 8.72711V12.0871C9.5 12.3199 9.70671 12.5471 10 12.5471H12C12.2933 12.5471 12.5 12.3199 12.5 12.0871V8.72711C12.5 8.49429 12.2933 8.26711 12 8.26711H10ZM8.5 8.72711C8.5 7.90393 9.19329 7.26711 10 7.26711H12C12.8067 7.26711 13.5 7.90393 13.5 8.72711V12.0871C13.5 12.9103 12.8067 13.5471 12 13.5471H10C9.19329 13.5471 8.5 12.9103 8.5 12.0871V8.72711ZM4 11.1471C3.70671 11.1471 3.5 11.3743 3.5 11.6071V12.0871C3.5 12.3199 3.70671 12.5471 4 12.5471H6C6.29329 12.5471 6.5 12.3199 6.5 12.0871V11.6071C6.5 11.3743 6.29329 11.1471 6 11.1471H4ZM2.5 11.6071C2.5 10.7839 3.19329 10.1471 4 10.1471H6C6.80671 10.1471 7.5 10.7839 7.5 11.6071V12.0871C7.5 12.9103 6.80671 13.5471 6 13.5471H4C3.19329 13.5471 2.5 12.9103 2.5 12.0871V11.6071Z";
  const IconPathDate = "M5 1.98724C5.27614 1.98724 5.5 2.2111 5.5 2.48724V3.42724H10.5V2.48724C10.5 2.2111 10.7239 1.98724 11 1.98724C11.2761 1.98724 11.5 2.2111 11.5 2.48724V3.42724H12.5C13.3067 3.42724 14 4.06406 14 4.88724V12.5672C14 13.3904 13.3067 14.0272 12.5 14.0272H3.5C2.69329 14.0272 2 13.3904 2 12.5672V4.88724C2 4.06406 2.69329 3.42724 3.5 3.42724H4.5V2.48724C4.5 2.2111 4.72386 1.98724 5 1.98724ZM3.5 4.42724C3.20671 4.42724 3 4.65443 3 4.88724V5.82724H13V4.88724C13 4.65443 12.7933 4.42724 12.5 4.42724H3.5ZM13 6.82724H3V12.5672C3 12.8 3.20671 13.0272 3.5 13.0272H12.5C12.7933 13.0272 13 12.8 13 12.5672V6.82724Z";
  const IconPathDateAndTime = "M5 1.32056C5.27614 1.32056 5.5 1.54441 5.5 1.82056V2.76056H10.5V1.82056C10.5 1.54441 10.7239 1.32056 11 1.32056C11.2761 1.32056 11.5 1.54441 11.5 1.82056V2.76056H12.5C13.3067 2.76056 14 3.39737 14 4.22056V7.23387C14 7.51001 13.7761 7.73387 13.5 7.73387C13.2239 7.73387 13 7.51001 13 7.23387V6.16056H3V11.9005C3 12.1334 3.20671 12.3605 3.5 12.3605H7.83333C8.10948 12.3605 8.33333 12.5844 8.33333 12.8605C8.33333 13.1367 8.10948 13.3605 7.83333 13.3605H3.5C2.69329 13.3605 2 12.7237 2 11.9005V4.22056C2 3.39737 2.69329 2.76056 3.5 2.76056H4.5V1.82056C4.5 1.54441 4.72386 1.32056 5 1.32056ZM3.5 3.76056C3.20671 3.76056 3 3.98774 3 4.22056V5.16056H13V4.22056C13 3.98774 12.7933 3.76056 12.5 3.76056H3.5ZM12.3259 9.16667C10.9493 9.16667 9.83333 10.2826 9.83333 11.6593C9.83333 13.0359 10.9493 14.1519 12.3259 14.1519C13.7025 14.1519 14.8185 13.0359 14.8185 11.6593C14.8185 10.2826 13.7025 9.16667 12.3259 9.16667ZM8.83333 11.6593C8.83333 9.73035 10.397 8.16667 12.3259 8.16667C14.2548 8.16667 15.8185 9.73035 15.8185 11.6593C15.8185 13.5882 14.2548 15.1519 12.3259 15.1519C10.397 15.1519 8.83333 13.5882 8.83333 11.6593ZM12.3255 9.84814C12.6017 9.84814 12.8255 10.072 12.8255 10.3481V11.4521L13.4346 12.0613C13.6299 12.2565 13.6299 12.5731 13.4346 12.7684C13.2394 12.9636 12.9228 12.9636 12.7275 12.7684L11.972 12.0128C11.8782 11.919 11.8255 11.7919 11.8255 11.6593V10.3481C11.8255 10.072 12.0494 9.84814 12.3255 9.84814Z";
  const IconPathDayNight = "M6 2.25C6.27614 2.25 6.5 2.47386 6.5 2.75V3.5C6.5 3.77614 6.27614 4 6 4C5.72386 4 5.5 3.77614 5.5 3.5V2.75C5.5 2.47386 5.72386 2.25 6 2.25ZM7.77639 3.50279C8.45366 3.16416 9.23164 3 10 3C12.7761 3 15 5.22386 15 8C15 10.7761 12.7761 13 10 13C9.23164 13 8.45366 12.8358 7.77639 12.4972C7.607 12.4125 7.5 12.2394 7.5 12.05C7.5 11.8606 7.607 11.6875 7.77639 11.6028C9.1134 10.9343 10 9.60356 10 8C10 6.39644 9.1134 5.06572 7.77639 4.39721C7.607 4.31252 7.5 4.13939 7.5 3.95C7.5 3.76061 7.607 3.58748 7.77639 3.50279ZM9.13656 4.08658C10.2814 5.0034 11 6.39613 11 8C11 9.60387 10.2814 10.9966 9.13657 11.9134C9.41635 11.9708 9.70714 12 10 12C12.2239 12 14 10.2239 14 8C14 5.77614 12.2239 4 10 4C9.70714 4 9.41635 4.0292 9.13656 4.08658ZM1.94658 3.94641C2.14184 3.75115 2.45842 3.75115 2.65369 3.94641L3.15369 4.44641C3.34895 4.64168 3.34895 4.95826 3.15369 5.15352C2.95842 5.34878 2.64184 5.34878 2.44658 5.15352L1.94658 4.65352C1.75132 4.45826 1.75132 4.14168 1.94658 3.94641ZM3 8C3 6.34314 4.34314 5 6 5C7.65688 5 9 6.34315 9 8C9 9.65688 7.65688 11 6 11C4.34315 11 3 9.65688 3 8ZM6 6C4.89543 6 4 6.89543 4 8C4 9.10459 4.89543 10 6 10C7.10459 10 8 9.10459 8 8C8 6.89543 7.10459 6 6 6ZM0.25 8C0.25 7.72386 0.473858 7.5 0.75 7.5H1.5C1.77614 7.5 2 7.72386 2 8C2 8.27614 1.77614 8.5 1.5 8.5H0.75C0.473858 8.5 0.25 8.27614 0.25 8ZM3.15369 10.8464C3.34895 11.0417 3.34895 11.3583 3.15369 11.5536L2.65369 12.0536C2.45842 12.2488 2.14184 12.2488 1.94658 12.0536C1.75132 11.8583 1.75132 11.5417 1.94658 11.3464L2.44658 10.8464C2.64184 10.6512 2.95842 10.6512 3.15369 10.8464ZM6 12C6.27614 12 6.5 12.2239 6.5 12.5V13.25C6.5 13.5261 6.27614 13.75 6 13.75C5.72386 13.75 5.5 13.5261 5.5 13.25V12.5C5.5 12.2239 5.72386 12 6 12Z";
  const IconPathDelete = "M5.16634 2.66667C5.16634 2.02233 5.68868 1.5 6.33301 1.5H9.66634C10.3107 1.5 10.833 2.02233 10.833 2.66667V3.5H13.6663C13.9425 3.5 14.1663 3.72386 14.1663 4C14.1663 4.27614 13.9425 4.5 13.6663 4.5H12.833V12.6667C12.833 13.311 12.3107 13.8333 11.6663 13.8333H4.33301C3.68868 13.8333 3.16634 13.311 3.16634 12.6667V4.5H2.33301C2.05687 4.5 1.83301 4.27614 1.83301 4C1.83301 3.72386 2.05687 3.5 2.33301 3.5H5.16634V2.66667ZM4.16634 4.5V12.6667C4.16634 12.7587 4.24096 12.8333 4.33301 12.8333H11.6663C11.7584 12.8333 11.833 12.7587 11.833 12.6667V4.5H4.16634ZM9.83301 3.5H6.16634V2.66667C6.16634 2.57462 6.24096 2.5 6.33301 2.5H9.66634C9.75839 2.5 9.83301 2.57462 9.83301 2.66667V3.5ZM6.33301 6.5C6.60915 6.5 6.83301 6.72386 6.83301 7V10.3333C6.83301 10.6095 6.60915 10.8333 6.33301 10.8333C6.05687 10.8333 5.83301 10.6095 5.83301 10.3333V7C5.83301 6.72386 6.05687 6.5 6.33301 6.5ZM9.66634 6.5C9.94248 6.5 10.1663 6.72386 10.1663 7V10.3333C10.1663 10.6095 9.94248 10.8333 9.66634 10.8333C9.3902 10.8333 9.16634 10.6095 9.16634 10.3333V7C9.16634 6.72386 9.3902 6.5 9.66634 6.5Z";
  const IconPathDesktop = "M2.73684 2.5C2.44281 2.5 2.25 2.70484 2.25 2.96429V10.0357C2.25 10.2952 2.44281 10.5 2.73684 10.5H13.2632C13.5572 10.5 13.75 10.2952 13.75 10.0357V2.96429C13.75 2.70484 13.5572 2.5 13.2632 2.5H2.73684ZM1.25 2.96429C1.25 2.13088 1.91245 1.5 2.73684 1.5H13.2632C14.0876 1.5 14.75 2.13088 14.75 2.96429V10.0357C14.75 10.8691 14.0876 11.5 13.2632 11.5H8.5V13.5H10.75C11.0261 13.5 11.25 13.7239 11.25 14C11.25 14.2761 11.0261 14.5 10.75 14.5H5.25C4.97386 14.5 4.75 14.2761 4.75 14C4.75 13.7239 4.97386 13.5 5.25 13.5H7.5V11.5H2.73684C1.91245 11.5 1.25 10.8691 1.25 10.0357V2.96429ZM5.3335 4.91666C5.05735 4.91666 4.8335 5.14051 4.8335 5.41666C4.8335 5.6928 5.05735 5.91666 5.3335 5.91666C5.60964 5.91666 5.8335 5.6928 5.8335 5.41666C5.8335 5.14051 5.60964 4.91666 5.3335 4.91666ZM3.8335 5.41666C3.8335 4.58823 4.50507 3.91666 5.3335 3.91666C6.16192 3.91666 6.8335 4.58823 6.8335 5.41666C6.8335 6.24508 6.16192 6.91666 5.3335 6.91666C4.50507 6.91666 3.8335 6.24508 3.8335 5.41666ZM8.83333 4.66667C8.83333 4.39052 9.05719 4.16667 9.33333 4.16667H12C12.2761 4.16667 12.5 4.39052 12.5 4.66667C12.5 4.94281 12.2761 5.16667 12 5.16667H9.33333C9.05719 5.16667 8.83333 4.94281 8.83333 4.66667ZM8.83333 6.66667C8.83333 6.39052 9.05719 6.16667 9.33333 6.16667H12C12.2761 6.16667 12.5 6.39052 12.5 6.66667C12.5 6.94281 12.2761 7.16667 12 7.16667H9.33333C9.05719 7.16667 8.83333 6.94281 8.83333 6.66667ZM5.33317 8.25C4.82816 8.25 4.35063 8.49979 4.11372 8.97361C3.99022 9.2206 3.68989 9.32071 3.4429 9.19721C3.19591 9.07372 3.0958 8.77338 3.21929 8.52639C3.64905 7.66688 4.50485 7.25 5.33317 7.25C6.1615 7.25 7.01729 7.66688 7.44705 8.52639C7.57055 8.77338 7.47043 9.07372 7.22344 9.19721C6.97645 9.32071 6.67612 9.2206 6.55262 8.97361C6.31571 8.49979 5.83818 8.25 5.33317 8.25ZM8.83333 8.66667C8.83333 8.39052 9.05719 8.16667 9.33333 8.16667H12C12.2761 8.16667 12.5 8.39052 12.5 8.66667C12.5 8.94281 12.2761 9.16667 12 9.16667H9.33333C9.05719 9.16667 8.83333 8.94281 8.83333 8.66667Z";
  const IconPathDirection = "M6.83012 1.965C7.48012 1.345 8.52012 1.345 9.17012 1.965L14.5101 7.085C15.1701 7.715 15.1701 8.755 14.5101 9.385L9.17012 14.505C8.52012 15.125 7.48012 15.125 6.83012 14.505L1.49012 9.385C0.830117 8.755 0.830117 7.715 1.49012 7.085L6.83012 1.965ZM7.52012 2.685L2.19012 7.805C1.94012 8.045 1.94012 8.425 2.19012 8.665L7.52012 13.785C7.78012 14.035 8.21012 14.035 8.48012 13.785L13.8201 8.665C14.0701 8.425 14.0701 8.045 13.8201 7.805L8.48012 2.685C8.22012 2.435 7.79012 2.435 7.52012 2.685ZM8.12012 5.495C8.31012 5.295 8.63012 5.285 8.83012 5.485L10.8301 7.405C10.9301 7.495 10.9801 7.625 10.9801 7.765C10.9801 7.905 10.9201 8.035 10.8301 8.125L8.83012 10.045C8.63012 10.235 8.31012 10.225 8.12012 10.035C7.93012 9.835 7.94012 9.515 8.13012 9.325L9.23012 8.265H6.97012C6.68012 8.265 6.47012 8.495 6.47012 8.725V10.165C6.47012 10.445 6.25012 10.665 5.97012 10.665C5.69012 10.665 5.47012 10.445 5.47012 10.165V8.725C5.47012 7.905 6.16012 7.265 6.97012 7.265H9.23012L8.13012 6.205C7.93012 6.015 7.92012 5.695 8.12012 5.495Z";
  const IconPathDirectionEast = "M14.4981 8.12691L4.77029 13.2217L4.76872 13.2226C4.3158 13.4612 3.82404 13.0102 3.99735 12.5442L5.6416 8.12762L3.99642 3.70781C3.82677 3.2441 4.31439 2.79307 4.76798 3.03086L4.76887 3.03133L14.4981 8.12691ZM5.34403 4.46142L6.57895 7.77851C6.66231 8.00317 6.6625 8.25085 6.57914 8.47551L5.34436 11.7922L12.3428 8.12691L5.34403 4.46142Z";
  const IconPathDirectionNorth = "M8.62679 2.002L13.7216 11.7298L13.7224 11.7314C13.961 12.1843 13.5101 12.6761 13.0441 12.5028L8.6275 10.8585L4.20769 12.5037C3.74398 12.6733 3.29294 12.1857 3.53074 11.7321L3.53121 11.7313L8.62679 2.002ZM4.9613 11.1561L8.27839 9.92117C8.50305 9.83781 8.75073 9.83762 8.97539 9.92098L12.2921 11.1558L8.62679 4.15737L4.9613 11.1561Z";
  const IconPathDirectionNorthEast = "M13.8694 2.73804L10.5934 13.2192C10.5932 13.2198 10.593 13.2204 10.5929 13.2209C10.4413 13.7099 9.77473 13.7388 9.56775 13.2867L7.6074 9.00105L3.31881 7.03909C2.87096 6.83115 2.89683 6.16743 3.38571 6.01484C3.38577 6.01483 3.38564 6.01486 3.38571 6.01484C3.38597 6.01476 3.38641 6.01462 3.38667 6.01454L13.8694 2.73804ZM4.8046 6.61906L8.02336 8.09139C8.24116 8.19129 8.41643 8.3663 8.51634 8.5841L9.98849 11.8025L12.3453 4.26212L4.8046 6.61906ZM9.63814 12.9234C9.63806 12.9237 9.63822 12.9231 9.63814 12.9234Z";
  const IconPathDirectionNorthWest = "M3.23792 2.63047L13.7191 5.9065C13.7197 5.90668 13.7202 5.90685 13.7208 5.90703C14.2098 6.05858 14.2387 6.72515 13.7866 6.93213L9.50092 8.89247L7.53897 13.1811C7.33103 13.6289 6.66731 13.6031 6.51472 13.1142C6.5147 13.1141 6.51474 13.1142 6.51472 13.1142C6.51464 13.1139 6.5145 13.1135 6.51442 13.1132L3.23792 2.63047ZM7.11894 11.6953L8.59126 8.47652C8.69117 8.25872 8.86618 8.08345 9.08398 7.98354L12.3024 6.51138L4.76199 4.15455L7.11894 11.6953ZM13.4233 6.86174C13.4236 6.86182 13.423 6.86166 13.4233 6.86174Z";
  const IconPathDirectionSouth = "M8.62679 13.998L13.7216 4.27017L13.7224 4.2686C13.961 3.81567 13.5101 3.32392 13.0441 3.49723L8.6275 5.14148L4.20769 3.4963C3.74398 3.32665 3.29294 3.81427 3.53074 4.26785L3.53121 4.26875L8.62679 13.998ZM4.9613 4.84391L8.27839 6.07883C8.50305 6.16219 8.75073 6.16238 8.97539 6.07902L12.2921 4.84424L8.62679 11.8426L4.9613 4.84391Z";
  const IconPathDirectionSouthEast = "M13.7621 13.3695L3.28089 10.0935C3.28032 10.0933 3.27975 10.0931 3.27918 10.093C2.7902 9.94142 2.76133 9.27485 3.21341 9.06787L7.49908 7.10753L9.46103 2.81893C9.66897 2.37108 10.3327 2.39695 10.4853 2.88583C10.4853 2.88589 10.4853 2.88577 10.4853 2.88583C10.4854 2.88609 10.4855 2.88653 10.4856 2.88679L13.7621 13.3695ZM9.88106 4.30472L8.40874 7.52348C8.30883 7.74128 8.13382 7.91655 7.91602 8.01646L4.69762 9.48862L12.238 11.8455L9.88106 4.30472ZM3.57671 9.13826C3.57645 9.13818 3.57697 9.13834 3.57671 9.13826";
  const IconPathDirectionSouthWest = "M3.13059 13.262L6.40662 2.78076C6.4068 2.7802 6.40697 2.77963 6.40715 2.77906C6.5587 2.29008 7.22527 2.2612 7.43225 2.71329L9.3926 6.99895L13.6812 8.96091C14.129 9.16885 14.1032 9.83257 13.6143 9.98516C13.6142 9.98517 13.6144 9.98514 13.6143 9.98516C13.614 9.98524 13.6136 9.98538 13.6133 9.98546L3.13059 13.262ZM12.1954 9.38094L8.97664 7.90861C8.75884 7.80871 8.58357 7.6337 8.48366 7.4159L7.01151 4.1975L4.65467 11.7379L12.1954 9.38094ZM7.36186 3.07659C7.36194 3.07633 7.36178 3.07685 7.36186 3.07659Z";
  const IconPathDirectionWest = "M2.50187 7.87309L12.2297 2.77827L12.2313 2.77744C12.6842 2.53884 13.176 2.98976 13.0026 3.45578L11.3584 7.87238L13.0036 12.2922C13.1732 12.7559 12.6856 13.2069 12.232 12.9691L12.2311 12.9687L2.50187 7.87309ZM11.656 11.5386L10.421 8.22149C10.3377 7.99683 10.3375 7.74915 10.4209 7.52449L11.6556 4.20777L4.65725 7.87309L11.656 11.5386Z";
  const IconPathDiscount = "M12.3201 2.9356C12.5322 3.11239 12.5609 3.42767 12.3841 3.63981L4.38411 13.2398C4.20733 13.4519 3.89205 13.4806 3.67991 13.3038C3.46777 13.127 3.43911 12.8118 3.61589 12.5996L11.6159 2.99962C11.7927 2.78748 12.108 2.75882 12.3201 2.9356ZM4.5 3.81971C4.20671 3.81971 4 4.0469 4 4.27971V6.19971C4 6.43252 4.20671 6.65971 4.5 6.65971H5.5C5.79329 6.65971 6 6.43252 6 6.19971V4.27971C6 4.0469 5.79329 3.81971 5.5 3.81971H4.5ZM3 4.27971C3 3.45653 3.69329 2.81971 4.5 2.81971H5.5C6.30671 2.81971 7 3.45653 7 4.27971V6.19971C7 7.02289 6.30671 7.65971 5.5 7.65971H4.5C3.69329 7.65971 3 7.02289 3 6.19971V4.27971ZM10.5 9.57971C10.2067 9.57971 10 9.80689 10 10.0397V11.9597C10 12.1925 10.2067 12.4197 10.5 12.4197H11.5C11.7933 12.4197 12 12.1925 12 11.9597V10.0397C12 9.80689 11.7933 9.57971 11.5 9.57971H10.5ZM9 10.0397C9 9.21653 9.69329 8.57971 10.5 8.57971H11.5C12.3067 8.57971 13 9.21653 13 10.0397V11.9597C13 12.7829 12.3067 13.4197 11.5 13.4197H10.5C9.69329 13.4197 9 12.7829 9 11.9597V10.0397Z";
  const IconPathDownload = "M8 2.5C8.27614 2.5 8.5 2.72386 8.5 3V9.29289L10.1464 7.64645C10.3417 7.45118 10.6583 7.45118 10.8536 7.64645C11.0488 7.84171 11.0488 8.15829 10.8536 8.35355L8 11.2071L5.14645 8.35355C4.95118 8.15829 4.95118 7.84171 5.14645 7.64645C5.34171 7.45118 5.65829 7.45118 5.85355 7.64645L7.5 9.29289V3C7.5 2.72386 7.72386 2.5 8 2.5ZM4 13C4 12.7239 4.22386 12.5 4.5 12.5H11.5C11.7761 12.5 12 12.7239 12 13C12 13.2761 11.7761 13.5 11.5 13.5H4.5C4.22386 13.5 4 13.2761 4 13Z";
  const IconPathDrag = "M4.75 4.12002C4.75 3.43002 5.33 2.90002 6 2.90002C6.67 2.90002 7.25 3.43002 7.25 4.12002C7.25 4.81002 6.67 5.34002 6 5.34002C5.33 5.34002 4.75 4.81002 4.75 4.12002ZM8.75 4.12002C8.75 3.43002 9.33 2.90002 10 2.90002C10.67 2.90002 11.25 3.43002 11.25 4.12002C11.25 4.81002 10.67 5.34002 10 5.34002C9.33 5.34002 8.75 4.81002 8.75 4.12002ZM4.75 7.96002C4.75 7.27002 5.33 6.74002 6 6.74002C6.67 6.74002 7.25 7.27002 7.25 7.96002C7.25 8.65002 6.67 9.18002 6 9.18002C5.33 9.18002 4.75 8.65002 4.75 7.96002ZM8.75 7.96002C8.75 7.27002 9.33 6.74002 10 6.74002C10.67 6.74002 11.25 7.27002 11.25 7.96002C11.25 8.65002 10.67 9.18002 10 9.18002C9.33 9.18002 8.75 8.65002 8.75 7.96002ZM4.75 11.8C4.75 11.11 5.33 10.58 6 10.58C6.67 10.58 7.25 11.11 7.25 11.8C7.25 12.49 6.67 13.02 6 13.02C5.33 13.02 4.75 12.49 4.75 11.8ZM8.75 11.8C8.75 11.11 9.33 10.58 10 10.58C10.67 10.58 11.25 11.11 11.25 11.8C11.25 12.49 10.67 13.02 10 13.02C9.33 13.02 8.75 12.49 8.75 11.8Z";
  const IconPathDuration = "M1.5 7.99485C1.5 4.40502 4.41015 1.49487 8 1.49487C11.5899 1.49487 14.5 4.40502 14.5 7.99485C14.5 11.5847 11.5899 14.4949 8 14.4949C4.41015 14.4949 1.5 11.5847 1.5 7.99485ZM8 2.49487C4.96243 2.49487 2.5 4.95731 2.5 7.99485C2.5 11.0324 4.96243 13.4949 8 13.4949C11.0376 13.4949 13.5 11.0324 13.5 7.99485C13.5 4.95731 11.0376 2.49487 8 2.49487ZM8 4.83325C8.27614 4.83325 8.5 5.05711 8.5 5.33325V7.84115L10.4082 10.5396C10.5677 10.765 10.5142 11.077 10.2887 11.2365C10.0632 11.3959 9.7512 11.3424 9.59176 11.1169L7.59176 8.28877C7.53206 8.20435 7.5 8.10349 7.5 8.00008V5.33325C7.5 5.05711 7.72386 4.83325 8 4.83325Z";
  const IconPathEcoSystem = "M11.166 3.16663C11.166 2.89048 11.3899 2.66663 11.666 2.66663H13.666C13.9422 2.66663 14.166 2.89048 14.166 3.16663C14.166 3.44277 13.9422 3.66663 13.666 3.66663H13.0356C15.3471 6.41767 15.2084 10.5214 12.6197 13.1102C12.4244 13.3054 12.1078 13.3054 11.9126 13.1102C11.7173 12.9149 11.7173 12.5983 11.9126 12.4031C14.1695 10.1461 14.254 6.54689 12.166 4.18943V5.16663C12.166 5.44277 11.9422 5.66663 11.666 5.66663C11.3899 5.66663 11.166 5.44277 11.166 5.16663V3.16663ZM8.01353 2.80713L7.66602 3.16663L7.3185 2.80713C7.51231 2.61979 7.81973 2.61979 8.01353 2.80713ZM8.16602 12.1266C9.02696 11.9866 9.73416 11.4926 10.2378 10.8519C10.8316 10.0966 11.166 9.1125 11.166 8.16663C11.166 7.53157 10.9422 6.87619 10.6452 6.27731C10.3451 5.67207 9.95029 5.08507 9.56419 4.57671C9.17693 4.06682 8.7909 3.62621 8.50217 3.31342C8.35754 3.15674 8.23666 3.03142 8.15139 2.94472C8.10873 2.90135 8.07494 2.8676 8.05148 2.84438L8.02421 2.81754L8.01673 2.81024L8.01458 2.80816L8.01353 2.80713C8.01344 2.80705 8.01353 2.80713 7.66602 3.16663C7.3185 2.80713 7.31859 2.80705 7.3185 2.80713L7.31745 2.80816L7.3153 2.81024L7.30782 2.81754L7.28055 2.84438C7.25709 2.8676 7.2233 2.90135 7.18065 2.94472C7.09537 3.03142 6.97449 3.15674 6.82986 3.31342C6.54114 3.62621 6.1551 4.06682 5.76784 4.57671C5.38174 5.08507 4.98694 5.67207 4.68681 6.27731C4.38985 6.87619 4.16602 7.53157 4.16602 8.16663C4.16602 9.1125 4.50043 10.0966 5.09418 10.8519C5.59787 11.4926 6.30507 11.9866 7.16602 12.1266V12.6666C7.16602 12.9428 7.38987 13.1666 7.66602 13.1666C7.94216 13.1666 8.16602 12.9428 8.16602 12.6666V12.1266ZM8.16602 11.1063C8.67289 10.9812 9.1101 10.6684 9.45168 10.2339C9.90543 9.65667 10.166 8.89075 10.166 8.16663C10.166 7.75168 10.0148 7.25706 9.74931 6.72156C9.48694 6.19244 9.13174 5.66068 8.76784 5.18154C8.56206 4.9106 8.35589 4.6596 8.16602 4.43897V8.24952L8.68246 7.73307C8.87773 7.53781 9.19431 7.53781 9.38957 7.73307C9.58483 7.92834 9.58483 8.24492 9.38957 8.44018L8.16602 9.66373V11.1063ZM7.16602 8.24952L6.64957 7.73307C6.45431 7.53781 6.13772 7.53781 5.94246 7.73307C5.7472 7.92834 5.7472 8.24492 5.94246 8.44018L7.16602 9.66373V11.1063C6.65915 10.9812 6.22193 10.6684 5.88035 10.2339C5.4266 9.65667 5.16602 8.89075 5.16602 8.16663C5.16602 7.75168 5.31718 7.25706 5.58272 6.72156C5.84509 6.19244 6.20029 5.66068 6.56419 5.18154C6.76997 4.9106 6.97614 4.6596 7.16602 4.43897V8.24952ZM3.41969 3.22307C3.61495 3.41833 3.61495 3.73492 3.41969 3.93018C1.1628 6.18707 1.07824 9.78612 3.16602 12.1436V11.1666C3.16602 10.8905 3.38987 10.6666 3.66602 10.6666C3.94216 10.6666 4.16602 10.8905 4.16602 11.1666V13.1666C4.16602 13.4428 3.94216 13.6666 3.66602 13.6666H1.66602C1.38987 13.6666 1.16602 13.4428 1.16602 13.1666C1.16602 12.8905 1.38987 12.6666 1.66602 12.6666H2.2966C-0.0148355 9.91558 0.123823 5.81183 2.71258 3.22307C2.90784 3.02781 3.22442 3.02781 3.41969 3.22307Z";
  const IconPathEdit = "M12.6177 3.56474C12.0836 3.0525 11.1442 3.05163 10.5277 3.64346L10.3719 3.79302L12.3463 5.68836C12.3477 5.68971 12.3491 5.69106 12.3504 5.69242L12.5357 5.51456C13.1433 4.93127 13.1373 4.06353 12.6177 3.56474ZM11.6285 6.38548L9.65373 4.48975C9.65247 4.48854 9.65122 4.48733 9.64998 4.48611L3.11477 10.7599C3.03936 10.8321 3 10.927 3 11.0213V12.749H4.8205C4.93787 12.749 5.04595 12.7042 5.12273 12.6305L11.6285 6.38548ZM9.8352 2.92208C10.8007 1.99524 12.3522 1.92424 13.3101 2.84324C14.2815 3.77581 14.2027 5.30051 13.2283 6.23594L5.81527 13.3519C5.81526 13.3519 5.81527 13.3519 5.81527 13.3519C5.54805 13.6084 5.19012 13.749 4.8205 13.749H2.5C2.22386 13.749 2 13.5252 2 13.249V11.0213C2 10.6491 2.15409 10.2953 2.42262 10.0382C2.42258 10.0382 2.42265 10.0381 2.42262 10.0382L9.8352 2.92208Z";
  const IconPathElliFlash = "M8.04607 6.06659C8.27194 6.06659 8.45574 5.89028 8.45574 5.67352C8.45574 5.457 8.27194 5.28077 8.04607 5.28077C7.82021 5.28077 7.63667 5.457 7.63667 5.67352C7.63667 5.89028 7.82021 6.06659 8.04607 6.06659ZM7.28947 3.59789C7.34961 3.59789 7.39867 3.55088 7.39867 3.49316C7.39867 3.43488 7.34961 3.38747 7.28947 3.38747C7.22874 3.38747 7.17934 3.4348 7.17934 3.49316C7.17941 3.55096 7.22874 3.59789 7.28947 3.59789ZM8.04607 4.56996C8.24741 4.56996 8.41094 4.41273 8.41094 4.21952C8.41094 4.0264 8.24741 3.86932 8.04607 3.86932C7.84508 3.86932 7.68134 4.0264 7.68134 4.21952C7.68141 4.41273 7.84514 4.56996 8.04607 4.56996ZM7.28867 5.21107C7.44101 5.21107 7.56501 5.09241 7.56501 4.94668C7.56501 4.80071 7.44107 4.6819 7.28867 4.6819C7.13681 4.6819 7.01327 4.80071 7.01327 4.94668C7.01334 5.09248 7.13681 5.21107 7.28867 5.21107ZM8.80367 3.80033C8.98001 3.80033 9.12381 3.66227 9.12381 3.49268C9.12381 3.32326 8.98001 3.18542 8.80367 3.18542C8.62721 3.18542 8.48347 3.32326 8.48347 3.49268C8.48354 3.66235 8.62721 3.80033 8.80367 3.80033ZM8.04607 2.92948C8.14047 2.92948 8.21707 2.85611 8.21707 2.766C8.21707 2.67581 8.14061 2.60236 8.04607 2.60236C7.95254 2.60236 7.87614 2.67573 7.87614 2.766C7.87614 2.85611 7.95254 2.92948 8.04607 2.92948ZM8.80367 2.20225C8.89741 2.20225 8.97367 2.12903 8.97367 2.03908C8.97367 1.94897 8.89741 1.87559 8.80367 1.87559C8.70954 1.87559 8.63287 1.94897 8.63287 2.03908C8.63294 2.12903 8.70954 2.20225 8.80367 2.20225ZM8.80367 5.25386C8.98001 5.25386 9.12381 5.11611 9.12381 4.94668C9.12381 4.77717 8.98001 4.63942 8.80367 4.63942C8.62721 4.63942 8.48347 4.77717 8.48347 4.94668C8.48354 5.11619 8.62721 5.25386 8.80367 5.25386ZM6.53197 5.93815C6.68394 5.93815 6.80741 5.8194 6.80741 5.67344C6.80741 5.52779 6.68394 5.40913 6.53197 5.40913C6.37968 5.40913 6.25575 5.52779 6.25575 5.67344C6.25583 5.81949 6.37968 5.93815 6.53197 5.93815ZM5.01788 7.29092C5.11142 7.29092 5.18777 7.21764 5.18777 7.12733C5.18777 7.03735 5.11142 6.96388 5.01788 6.96388C4.92369 6.96388 4.84701 7.03722 4.84701 7.12733C4.84709 7.2177 4.92369 7.29092 5.01788 7.29092ZM5.77452 6.57917C5.87743 6.57917 5.96127 6.49911 5.96127 6.40029C5.96127 6.30173 5.87743 6.22147 5.77452 6.22147C5.67201 6.22147 5.58857 6.30173 5.58857 6.40029C5.58857 6.49898 5.67209 6.57917 5.77452 6.57917ZM7.28867 6.79338C7.51447 6.79338 7.69814 6.61706 7.69814 6.40029C7.69814 6.18376 7.51447 6.00761 7.28867 6.00761C7.06288 6.00761 6.87907 6.18376 6.87907 6.40029C6.87907 6.61706 7.06288 6.79338 7.28867 6.79338ZM4.26043 8.01776C4.35397 8.01776 4.43015 7.94442 4.43015 7.85418C4.43015 7.76407 4.35397 7.69072 4.26043 7.69072C4.16623 7.69072 4.08956 7.76407 4.08956 7.85418C4.08965 7.94448 4.16623 8.01776 4.26043 8.01776ZM6.53197 4.32466C6.59219 4.32466 6.64123 4.27741 6.64123 4.21945C6.64123 4.16164 6.59219 4.11463 6.53197 4.11463C6.47183 4.11463 6.42279 4.16164 6.42279 4.21945C6.42287 4.27749 6.47183 4.32466 6.53197 4.32466ZM6.53197 7.52048C6.75781 7.52048 6.94147 7.34404 6.94147 7.12714C6.94147 6.91063 6.75781 6.73437 6.53197 6.73437C6.3061 6.73437 6.12261 6.91063 6.12261 7.12714C6.12261 7.34404 6.3061 7.52048 6.53197 7.52048ZM9.07907 6.40029C9.07907 6.25456 8.95547 6.13597 8.80367 6.13597C8.65147 6.13597 8.52747 6.25456 8.52747 6.40029C8.52747 6.54628 8.65141 6.66506 8.80367 6.66506C8.95554 6.665 9.07907 6.54628 9.07907 6.40029ZM8.04607 7.52048C8.27194 7.52048 8.45574 7.34404 8.45574 7.12714C8.45574 6.91063 8.27194 6.73437 8.04607 6.73437C7.82021 6.73437 7.63667 6.91063 7.63667 7.12714C7.63667 7.34404 7.82021 7.52048 8.04607 7.52048ZM10.3179 8.28746C10.5669 8.28746 10.7696 8.09322 10.7696 7.85431C10.7696 7.6154 10.5669 7.42116 10.3179 7.42116C10.0687 7.42116 9.86614 7.6154 9.86614 7.85431C9.86614 8.09316 10.0687 8.28746 10.3179 8.28746ZM7.28867 7.46122C7.06288 7.46122 6.87907 7.63754 6.87907 7.85418C6.87907 8.07088 7.06288 8.2472 7.28867 8.2472C7.51447 8.2472 7.69814 8.07088 7.69814 7.85418C7.69814 7.63754 7.51454 7.46122 7.28867 7.46122ZM3.50289 8.68618C3.56311 8.68618 3.61216 8.63914 3.61216 8.58103C3.61216 8.52317 3.56311 8.47613 3.50289 8.47613C3.44276 8.47613 3.39371 8.52317 3.39371 8.58103C3.39371 8.63927 3.44268 8.68618 3.50289 8.68618ZM11.0753 7.41328C11.2399 7.41328 11.3735 7.28516 11.3735 7.12746C11.3735 6.96989 11.2398 6.8417 11.0753 6.8417C10.9109 6.8417 10.7771 6.96996 10.7771 7.12746C10.7771 7.28516 10.9109 7.41328 11.0753 7.41328ZM8.04607 8.97456C8.27194 8.97456 8.45574 8.79792 8.45574 8.58109C8.45574 8.36458 8.27194 8.18845 8.04607 8.18845C7.82021 8.18845 7.63667 8.36458 7.63667 8.58109C7.63667 8.79792 7.82021 8.97456 8.04607 8.97456ZM10.3179 2.20225C10.4115 2.20225 10.4878 2.12903 10.4878 2.03908C10.4878 1.94897 10.4115 1.87559 10.3179 1.87559C10.2237 1.87559 10.1471 1.94897 10.1471 2.03908C10.1471 2.12903 10.2237 2.20225 10.3179 2.20225ZM8.80367 7.46122C8.57787 7.46122 8.39407 7.63754 8.39407 7.85418C8.39407 8.07088 8.57787 8.2472 8.80367 8.2472C9.02954 8.2472 9.21314 8.07088 9.21314 7.85418C9.21314 7.63754 9.02961 7.46122 8.80367 7.46122ZM10.3179 6.26425C10.2395 6.26425 10.1757 6.32527 10.1757 6.40023C10.1757 6.47543 10.2395 6.53661 10.3179 6.53661C10.3962 6.53661 10.4598 6.47543 10.4598 6.40023C10.4598 6.32535 10.3962 6.26425 10.3179 6.26425ZM9.56021 5.53749C9.48241 5.53749 9.41907 5.59843 9.41907 5.67344C9.41907 5.74846 9.48241 5.80939 9.56021 5.80939C9.63861 5.80939 9.70234 5.74846 9.70234 5.67344C9.70234 5.59843 9.63861 5.53749 9.56021 5.53749ZM9.56021 7.41328C9.72487 7.41328 9.85861 7.28516 9.85861 7.12746C9.85861 6.96989 9.72481 6.8417 9.56021 6.8417C9.39628 6.8417 9.26301 6.96996 9.26301 7.12746C9.26301 7.28516 9.39634 7.41328 9.56021 7.41328ZM8.80367 9.70135C9.02954 9.70135 9.21314 9.52477 9.21314 9.30788C9.21314 9.09149 9.02954 8.91524 8.80367 8.91524C8.57787 8.91524 8.39407 9.09149 8.39407 9.30788C8.39407 9.52477 8.57787 9.70135 8.80367 9.70135ZM9.56021 4.03296C9.45314 4.03296 9.36587 4.11651 9.36587 4.21952C9.36587 4.32262 9.45307 4.40647 9.56021 4.40647C9.66787 4.40647 9.75548 4.3227 9.75548 4.21952C9.75554 4.11651 9.66794 4.03296 9.56021 4.03296ZM9.56021 8.97456C9.78608 8.97456 9.96981 8.79792 9.96981 8.58109C9.96981 8.36458 9.78608 8.18845 9.56021 8.18845C9.33461 8.18845 9.15081 8.36458 9.15081 8.58109C9.15081 8.79792 9.33468 8.97456 9.56021 8.97456ZM9.56021 1.41706C9.62101 1.41706 9.67041 1.36981 9.67041 1.31177C9.67041 1.25405 9.62108 1.20703 9.56021 1.20703C9.50007 1.20703 9.45107 1.25405 9.45107 1.31177C9.45114 1.36981 9.50007 1.41706 9.56021 1.41706ZM9.56021 3.05214C9.72487 3.05214 9.85861 2.9237 9.85861 2.766C9.85861 2.60831 9.72481 2.48018 9.56021 2.48018C9.39628 2.48018 9.26301 2.60838 9.26301 2.766C9.26301 2.9237 9.39634 3.05214 9.56021 3.05214ZM8.04607 10.4282C8.27194 10.4282 8.45574 10.2518 8.45574 10.035C8.45574 9.81847 8.27194 9.64202 8.04607 9.64202C7.82021 9.64202 7.63667 9.81853 7.63667 10.035C7.63667 10.2518 7.82021 10.4282 8.04607 10.4282ZM8.80367 11.9511C8.65147 11.9511 8.52747 12.0699 8.52747 12.216C8.52747 12.3618 8.65141 12.4807 8.80367 12.4807C8.95547 12.4807 9.07907 12.3618 9.07907 12.216C9.07907 12.0699 8.95554 11.9511 8.80367 11.9511ZM8.04607 11.096C7.82021 11.096 7.63667 11.2723 7.63667 11.4891C7.63667 11.7057 7.82021 11.8817 8.04607 11.8817C8.27194 11.8817 8.45574 11.7057 8.45574 11.4891C8.45581 11.2723 8.27201 11.096 8.04607 11.096ZM8.80367 10.3687C8.57787 10.3687 8.39407 10.5452 8.39407 10.7618C8.39407 10.9787 8.57787 11.1549 8.80367 11.1549C9.02954 11.1549 9.21314 10.9787 9.21314 10.7618C9.21321 10.5452 9.02961 10.3687 8.80367 10.3687ZM9.56021 9.64196C9.33461 9.64196 9.15081 9.81847 9.15081 10.035C9.15081 10.2517 9.33468 10.4281 9.56021 10.4281C9.78608 10.4281 9.96981 10.2517 9.96981 10.035C9.96994 9.81847 9.78621 9.64196 9.56021 9.64196ZM9.56021 11.3257C9.46661 11.3257 9.39028 11.3989 9.39028 11.4891C9.39028 11.5789 9.46661 11.6522 9.56021 11.6522C9.65461 11.6522 9.73127 11.5789 9.73127 11.4891C9.73127 11.3989 9.65468 11.3257 9.56021 11.3257ZM8.04607 12.6354C7.86947 12.6354 7.72607 12.7733 7.72607 12.9427C7.72607 13.1124 7.86947 13.2505 8.04607 13.2505C8.22261 13.2505 8.36627 13.1124 8.36627 12.9427C8.36627 12.7733 8.22261 12.6354 8.04607 12.6354ZM7.28867 11.9087C7.11221 11.9087 6.96847 12.0466 6.96847 12.216C6.96847 12.3854 7.11221 12.5231 7.28867 12.5231C7.46561 12.5231 7.60954 12.3854 7.60954 12.216C7.60954 12.0465 7.46561 11.9087 7.28867 11.9087ZM8.04607 14.2331C7.95254 14.2331 7.87614 14.3065 7.87614 14.3966C7.87614 14.4868 7.95254 14.5603 8.04607 14.5603C8.14047 14.5603 8.21707 14.4869 8.21707 14.3966C8.21707 14.3065 8.14061 14.2331 8.04607 14.2331ZM10.3179 10.5983C10.2237 10.5983 10.1471 10.6718 10.1471 10.7619C10.1471 10.8521 10.2237 10.9255 10.3179 10.9255C10.4115 10.9255 10.4878 10.8521 10.4878 10.7619C10.4878 10.6718 10.4115 10.5983 10.3179 10.5983ZM7.28867 13.3623C7.11221 13.3623 6.96847 13.5001 6.96847 13.6695C6.96847 13.8391 7.11221 13.9773 7.28867 13.9773C7.46561 13.9773 7.60954 13.8391 7.60954 13.6695C7.60954 13.5001 7.46561 13.3623 7.28867 13.3623ZM11.8328 9.20324C11.7721 9.20324 11.7227 9.25021 11.7227 9.30826C11.7227 9.36618 11.7721 9.41309 11.8328 9.41309C11.8929 9.41309 11.942 9.36618 11.942 9.30826C11.942 9.25015 11.8929 9.20324 11.8328 9.20324ZM12.5894 7.02224C12.5293 7.02224 12.4802 7.06948 12.4802 7.12746C12.4802 7.18557 12.5293 7.2328 12.5894 7.2328C12.6497 7.2328 12.6987 7.18557 12.6987 7.12746C12.6987 7.06941 12.6497 7.02224 12.5894 7.02224ZM11.832 7.56855C11.6676 7.56855 11.5339 7.69668 11.5339 7.85418C11.5339 8.01188 11.6677 8.13994 11.832 8.13994C11.9963 8.13994 12.1301 8.01181 12.1301 7.85418C12.1301 7.69668 11.9965 7.56855 11.832 7.56855ZM11.0753 8.24189C10.8801 8.24189 10.7215 8.39408 10.7215 8.58109C10.7215 8.76848 10.8801 8.92074 11.0753 8.92074C11.2705 8.92074 11.4291 8.76848 11.4291 8.58109C11.4291 8.39408 11.2705 8.24189 11.0753 8.24189ZM10.3179 8.91524C10.092 8.91524 9.90841 9.09149 9.90841 9.30788C9.90841 9.52477 10.092 9.70135 10.3179 9.70135C10.5437 9.70135 10.7272 9.52477 10.7272 9.30788C10.7273 9.09149 10.5437 8.91524 10.3179 8.91524ZM11.0753 9.92996C11.0147 9.92996 10.9651 9.97706 10.9651 10.035C10.9651 10.0932 11.0146 10.1404 11.0753 10.1404C11.1355 10.1404 11.1847 10.0932 11.1847 10.035C11.1847 9.977 11.1355 9.92996 11.0753 9.92996ZM6.53197 14.1749C6.40429 14.1749 6.30032 14.2743 6.30032 14.3966C6.30032 14.5189 6.40421 14.6184 6.53197 14.6184C6.65908 14.6184 6.76267 14.5189 6.76267 14.3966C6.76267 14.2743 6.65908 14.1749 6.53197 14.1749ZM5.8837 13.6695C5.8837 13.6114 5.83465 13.5642 5.77452 13.5642C5.7143 13.5642 5.66525 13.6114 5.66525 13.6695C5.66525 13.7275 5.7143 13.7745 5.77452 13.7745C5.83473 13.7745 5.8837 13.7275 5.8837 13.6695ZM5.77452 7.46122C5.54873 7.46122 5.36499 7.63754 5.36499 7.85418C5.36499 8.07088 5.54873 8.2472 5.77452 8.2472C6.00022 8.2472 6.18404 8.07088 6.18404 7.85418C6.18404 7.63754 6.00022 7.46122 5.77452 7.46122ZM5.77452 9.04362C5.62263 9.04362 5.49911 9.16234 5.49911 9.30826C5.49911 9.45418 5.62263 9.57264 5.77452 9.57264C5.92623 9.57264 6.05001 9.45418 6.05001 9.30826C6.05001 9.16221 5.92632 9.04362 5.77452 9.04362ZM5.77452 14.9599C5.68097 14.9599 5.60463 15.0333 5.60463 15.1234C5.60463 15.2135 5.68097 15.287 5.77452 15.287C5.86822 15.287 5.94433 15.2136 5.94433 15.1234C5.94433 15.0332 5.8683 14.9599 5.77452 14.9599ZM4.26043 9.08637C4.13259 9.08637 4.02877 9.18596 4.02877 9.3082C4.02877 9.43031 4.1325 9.52951 4.26043 9.52951C4.38762 9.52951 4.49094 9.43024 4.49094 9.3082C4.49102 9.18602 4.38762 9.08637 4.26043 9.08637ZM5.01788 9.93028C4.95726 9.93028 4.90788 9.97738 4.90788 10.035C4.90788 10.0932 4.95717 10.1404 5.01788 10.1404C5.07809 10.1404 5.12715 10.0932 5.12715 10.035C5.12715 9.97732 5.07817 9.93028 5.01788 9.93028ZM5.01788 8.24189C4.82233 8.24189 4.66327 8.39408 4.66327 8.58109C4.66327 8.76848 4.82224 8.92074 5.01788 8.92074C5.21262 8.92074 5.37086 8.76848 5.37086 8.58109C5.37086 8.39408 5.21262 8.24189 5.01788 8.24189ZM6.53197 12.7208C6.40429 12.7208 6.30032 12.8203 6.30032 12.9426C6.30032 13.065 6.40421 13.1646 6.53197 13.1646C6.65908 13.1646 6.76267 13.065 6.76267 12.9426C6.76267 12.8203 6.65908 12.7208 6.53197 12.7208ZM7.28867 9.70135C7.51447 9.70135 7.69814 9.52477 7.69814 9.30788C7.69814 9.09149 7.51447 8.91524 7.28867 8.91524C7.06288 8.91524 6.87907 9.09149 6.87907 9.30788C6.87907 9.52477 7.06288 9.70135 7.28867 9.70135ZM7.01334 10.7618C7.01334 10.9077 7.13687 11.0265 7.28874 11.0265C7.44107 11.0265 7.56507 10.9077 7.56507 10.7618C7.56507 10.6162 7.44114 10.4974 7.28874 10.4974C7.13681 10.4975 7.01334 10.6162 7.01334 10.7618ZM3.50289 9.87152C3.40935 9.87152 3.33301 9.94468 3.33301 10.0348C3.33301 10.1252 3.40935 10.1988 3.50289 10.1988C3.59701 10.1988 3.67376 10.1252 3.67376 10.0348C3.67368 9.94461 3.59701 9.87152 3.50289 9.87152ZM6.53197 8.18845C6.3061 8.18845 6.12261 8.36458 6.12261 8.58109C6.12261 8.79792 6.3061 8.97456 6.53197 8.97456C6.75781 8.97456 6.94147 8.79792 6.94147 8.58109C6.94161 8.36458 6.75794 8.18845 6.53197 8.18845ZM6.53197 10.1987C6.62559 10.1987 6.70187 10.1253 6.70187 10.035C6.70187 9.94493 6.62559 9.87146 6.53197 9.87146C6.43794 9.87146 6.3611 9.94487 6.3611 10.035C6.36119 10.1253 6.43794 10.1987 6.53197 10.1987ZM7.28867 14.9599C7.19514 14.9599 7.11874 15.0333 7.11874 15.1234C7.11874 15.2135 7.19514 15.287 7.28867 15.287C7.38281 15.287 7.45947 15.2136 7.45947 15.1234C7.45947 15.0332 7.38287 14.9599 7.28867 14.9599ZM6.53197 11.6522C6.62559 11.6522 6.70187 11.5789 6.70187 11.4891C6.70187 11.3988 6.62559 11.3252 6.53197 11.3252C6.43794 11.3252 6.3611 11.3987 6.3611 11.4891C6.36119 11.579 6.43794 11.6522 6.53197 11.6522Z";
  const IconPathEmail = "M1.5 8C1.5 4.42386 4.42386 1.5 8 1.5C9.0367 1.5 10.0112 1.77234 10.8691 2.20054C13.0394 3.23357 14.5 5.45704 14.5 8V8.75C14.5 9.97614 13.4761 11 12.25 11C11.4409 11 10.7198 10.5541 10.323 9.89853C9.77282 10.5709 8.93653 11 8 11C6.34315 11 5 9.65688 5 8C5 6.34314 6.34314 5 8 5C9.65688 5 11 6.34315 11 8V8.75C11 9.42386 11.5761 10 12.25 10C12.9239 10 13.5 9.42386 13.5 8.75V8C13.5 5.84475 12.2627 3.96956 10.4355 3.10164L10.4263 3.0973L10.4264 3.09721C9.68538 2.72671 8.86149 2.5 8 2.5C4.97614 2.5 2.5 4.97614 2.5 8C2.5 11.0239 4.97614 13.5 8 13.5H10.65C10.9261 13.5 11.15 13.7239 11.15 14C11.15 14.2761 10.9261 14.5 10.65 14.5H8C4.42386 14.5 1.5 11.5761 1.5 8ZM10 8C10 6.89543 9.10459 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10459 6.89543 10 8 10C9.10459 10 10 9.10459 10 8Z";
  const IconPathEnergy = "M5.25 2.23999C5.25 1.96385 5.47386 1.73999 5.75 1.73999H10.75C10.9152 1.73999 11.0697 1.82158 11.1629 1.958C11.2561 2.09442 11.2758 2.26804 11.2157 2.42192L10.0453 5.41816L11.6557 5.10896C11.8419 5.07322 12.0323 5.14582 12.1473 5.29646C12.2624 5.4471 12.2824 5.64986 12.199 5.82007L8.19896 13.9801C8.09657 14.189 7.86365 14.2996 7.63704 14.2471C7.41043 14.1945 7.25 13.9926 7.25 13.76V8.63421L5.86669 8.96621C5.71778 9.00195 5.5607 8.96748 5.44044 8.87266C5.32018 8.77785 5.25 8.63316 5.25 8.48002V2.23999ZM6.25 2.73999V7.84582L7.63331 7.51382C7.78223 7.47808 7.9393 7.51256 8.05956 7.60737C8.17982 7.70218 8.25 7.84688 8.25 8.00002V11.6041L10.8598 6.28004L9.34428 6.57102C9.16547 6.60535 8.98213 6.53977 8.86567 6.39982C8.7492 6.25986 8.71802 6.06766 8.78427 5.89807L10.0179 2.73999H6.25Z";
  const IconPathEnergyNonRenewable = "M8.11753 3.49169C8.05244 3.4266 7.94691 3.4266 7.88182 3.49169L5.87345 5.50006H10.1259L9.31285 4.68701C9.31283 4.68699 9.31287 4.68703 9.31285 4.68701L8.11753 3.49169ZM9.66634 3.62629L8.82463 2.78458C8.36902 2.32897 7.63033 2.32897 7.17472 2.78458L6.33301 3.62629L6.15797 3.45125C5.70235 2.99564 4.96366 2.99563 4.50805 3.45125L2.45923 5.50006H1.33301C1.05687 5.50006 0.833008 5.72392 0.833008 6.00006C0.833008 6.2762 1.05687 6.50006 1.33301 6.50006H2.21882L2.70723 10.8957C2.7992 11.7235 3.44186 12.3685 4.24552 12.4822C4.44632 13.0741 5.00659 13.5001 5.66634 13.5001C6.31945 13.5001 6.87507 13.0827 7.08099 12.5001H8.91836C9.12428 13.0827 9.6799 13.5001 10.333 13.5001C10.9928 13.5001 11.553 13.0741 11.7538 12.4822C12.5575 12.3685 13.2002 11.7235 13.2921 10.8957L13.7805 6.50006H14.6663C14.9425 6.50006 15.1663 6.2762 15.1663 6.00006C15.1663 5.72392 14.9425 5.50006 14.6663 5.50006H13.5401L11.4913 3.45125C11.0357 2.99563 10.297 2.99564 9.84138 3.45125L9.66634 3.62629ZM10.3734 4.3334L11.5401 5.50006H12.1259L10.7842 4.15835C10.7191 4.09327 10.6136 4.09327 10.5485 4.15835L10.3734 4.3334ZM12.7744 6.50006H3.22497L3.70111 10.7853C3.73732 11.1111 3.96505 11.3734 4.26457 11.465C4.48005 10.9008 5.02639 10.5001 5.66634 10.5001C6.31945 10.5001 6.87507 10.9175 7.08099 11.5001H8.91836C9.12428 10.9175 9.6799 10.5001 10.333 10.5001C10.973 10.5001 11.5193 10.9008 11.7348 11.465C12.0343 11.3734 12.262 11.1111 12.2982 10.7853L12.7744 6.50006ZM3.87345 5.50006H4.45923L5.6259 4.3334L5.45086 4.15835C5.38577 4.09327 5.28024 4.09327 5.21516 4.15835L3.87345 5.50006ZM5.66634 11.5001C5.3902 11.5001 5.16634 11.7239 5.16634 12.0001C5.16634 12.2762 5.3902 12.5001 5.66634 12.5001C5.94248 12.5001 6.16634 12.2762 6.16634 12.0001C6.16634 11.7239 5.94248 11.5001 5.66634 11.5001ZM10.333 11.5001C10.0569 11.5001 9.83301 11.7239 9.83301 12.0001C9.83301 12.2762 10.0569 12.5001 10.333 12.5001C10.6092 12.5001 10.833 12.2762 10.833 12.0001C10.833 11.7239 10.6092 11.5001 10.333 11.5001Z";
  const IconPathEnergyRenewable = "M12.9675 3.56V3.49C12.9675 3.22 12.7475 3.01 12.4875 3H11.4675C10.8575 3.02 10.0175 3.06 9.1075 3.16C8.1975 3.27 7.2075 3.44 6.3075 3.71C5.4175 3.99 4.5675 4.39 3.9775 4.98C2.2675 6.69 2.3075 9.46 3.8975 11.37L3.0075 12.26C2.8075 12.46 2.8075 12.77 3.0075 12.97C3.1975 13.16 3.5175 13.16 3.7075 12.97L4.5975 12.08C6.5175 13.66 9.2875 13.7 10.9975 11.99C11.5875 11.4 11.9875 10.55 12.2575 9.66C12.5375 8.76 12.7075 7.78 12.8075 6.87C12.9175 5.96 12.9575 5.12 12.9675 4.5C12.9775 4.19 12.9775 3.94 12.9775 3.77C12.9775 3.68 12.9775 3.61 12.9675 3.56ZM4.6875 5.68C5.1075 5.26 5.7775 4.93 6.6075 4.67C7.4275 4.42 8.3475 4.26 9.2175 4.15C9.9775 4.07 10.6875 4.03 11.2575 4.01L6.9275 8.34V6.92C6.9275 6.64 6.6975 6.42 6.4275 6.42C6.1575 6.42 5.9275 6.64 5.9275 6.92V9.34L4.6075 10.66C3.3675 9.1 3.4075 6.96 4.6875 5.68ZM11.8175 6.76C11.7175 7.63 11.5575 8.55 11.3075 9.37C11.0475 10.19 10.7075 10.86 10.2875 11.28C9.0175 12.56 6.8675 12.61 5.3075 11.37L6.6275 10.05H9.0575C9.3275 10.05 9.5575 9.82 9.5575 9.55C9.5575 9.28 9.3275 9.05 9.0575 9.05H7.6275L11.9675 4.72C11.9475 5.28 11.9075 6 11.8175 6.76Z";
  const IconPathEnergySolar = "M8.0201 0.850006C8.3001 0.850006 8.5201 1.07001 8.5201 1.35001V2.68001C8.5201 2.96001 8.3001 3.18001 8.0201 3.18001C7.7401 3.18001 7.5201 2.96001 7.5201 2.68001V1.35001C7.5201 1.07001 7.7401 0.850006 8.0201 0.850006ZM13.0901 2.95001C13.2901 3.15001 13.2901 3.46001 13.0901 3.66001L12.1501 4.60001C11.9501 4.80001 11.6401 4.80001 11.4401 4.60001C11.2401 4.40001 11.2401 4.09001 11.4401 3.89001L12.3801 2.95001C12.5801 2.75001 12.8901 2.75001 13.0901 2.95001ZM2.9501 2.95001C3.1501 2.75001 3.4601 2.75001 3.6601 2.95001L4.6001 3.89001C4.8001 4.09001 4.8001 4.40001 4.6001 4.60001C4.4001 4.80001 4.0901 4.80001 3.8901 4.60001L2.9501 3.66001C2.7501 3.46001 2.7501 3.15001 2.9501 2.95001ZM8.0201 5.18001C6.4601 5.18001 5.1901 6.45001 5.1901 8.01001C5.1901 9.57001 6.4601 10.84 8.0201 10.84C9.5801 10.84 10.8501 9.57001 10.8501 8.01001C10.8501 6.45001 9.5801 5.18001 8.0201 5.18001ZM4.1901 8.01001C4.1901 5.89001 5.9101 4.18001 8.0201 4.18001C10.1301 4.18001 11.8501 5.90001 11.8501 8.01001C11.8501 10.12 10.1301 11.84 8.0201 11.84C5.9101 11.84 4.1901 10.12 4.1901 8.01001ZM0.860098 8.01001C0.860098 7.73001 1.0801 7.51001 1.3601 7.51001H2.6901C2.9701 7.51001 3.1901 7.73001 3.1901 8.01001C3.1901 8.29001 2.9701 8.51001 2.6901 8.51001H1.3501C1.0701 8.51001 0.850098 8.29001 0.850098 8.01001H0.860098ZM12.8601 8.01001C12.8601 7.73001 13.0801 7.51001 13.3601 7.51001H14.6901C14.9701 7.51001 15.1901 7.73001 15.1901 8.01001C15.1901 8.29001 14.9701 8.51001 14.6901 8.51001H13.3601C13.0801 8.51001 12.8601 8.29001 12.8601 8.01001ZM4.6101 11.43C4.8101 11.63 4.8101 11.94 4.6101 12.14L3.6701 13.08C3.4701 13.28 3.1601 13.28 2.9601 13.08C2.7601 12.88 2.7601 12.57 2.9601 12.37L3.9001 11.43C4.1001 11.23 4.4101 11.23 4.6101 11.43ZM11.4501 11.43C11.6501 11.23 11.9601 11.23 12.1601 11.43L13.1001 12.37C13.3001 12.57 13.3001 12.88 13.1001 13.08C12.9001 13.28 12.5901 13.28 12.3901 13.08L11.4501 12.14C11.2501 11.94 11.2501 11.63 11.4501 11.43ZM8.0301 12.85C8.3101 12.85 8.5301 13.07 8.5301 13.35V14.68C8.5301 14.96 8.3101 15.18 8.0301 15.18C7.7501 15.18 7.5301 14.96 7.5301 14.68V13.35C7.5301 13.07 7.7501 12.85 8.0301 12.85Z";
  const IconPathExpandAll = "M8 1.95959L11.3536 5.31315C11.5488 5.50841 11.5488 5.82499 11.3536 6.02026C11.1583 6.21552 10.8417 6.21552 10.6464 6.02026L8 3.37381L5.35355 6.02026C5.15829 6.21552 4.84171 6.21552 4.64645 6.02026C4.45118 5.82499 4.45118 5.50841 4.64645 5.31315L8 1.95959ZM4.64645 9.97982C4.84171 9.78455 5.15829 9.78455 5.35355 9.97982L8 12.6263L10.6464 9.97982C10.8417 9.78455 11.1583 9.78455 11.3536 9.97982C11.5488 10.1751 11.5488 10.4917 11.3536 10.6869L8 14.0405L4.64645 10.6869C4.45118 10.4917 4.45118 10.1751 4.64645 9.97982Z";
  const IconPathExpandLeft = "M11.02 13.6869C11.2152 13.4917 11.2152 13.1751 11.02 12.9798L6.04019 8.00004L11.02 3.02026C11.2152 2.825 11.2152 2.50842 11.02 2.31315C10.8247 2.11789 10.5081 2.11789 10.3129 2.31315L4.62598 8.00004L10.3129 13.6869C10.5081 13.8822 10.8247 13.8822 11.02 13.6869Z";
  const IconPathExpandLeftCircleFilled = "M8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14ZM9.25339 5.14644C9.44866 5.3417 9.44867 5.65828 9.25341 5.85355L7.10705 8L9.25341 10.1465C9.44867 10.3417 9.44866 10.6583 9.25339 10.8536C9.05813 11.0488 8.74154 11.0488 8.54629 10.8535L5.69287 8L8.54629 5.14645C8.74154 4.95119 9.05813 4.95118 9.25339 5.14644Z";
  const IconPathExpandLess = "M2.31344 11.0202C2.5087 11.2155 2.82528 11.2155 3.02055 11.0202L8.00033 6.04043L12.9801 11.0202C13.1754 11.2155 13.4919 11.2155 13.6872 11.0202C13.8825 10.825 13.8825 10.5084 13.6872 10.3131L8.00033 4.62622L2.31344 10.3131C2.11818 10.5084 2.11818 10.825 2.31344 11.0202Z";
  const IconPathExpandLessCircleFilled = "M14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8ZM5.14644 9.25339C5.3417 9.44866 5.65828 9.44867 5.85355 9.25341L8 7.10705L10.1465 9.25341C10.3417 9.44867 10.6583 9.44866 10.8536 9.25339C11.0488 9.05813 11.0488 8.74154 10.8535 8.54629L8 5.69287L5.14645 8.54629C4.95119 8.74154 4.95118 9.05813 5.14644 9.25339Z";
  const IconPathExpandMore = "M2.31344 4.97979C2.5087 4.78452 2.82528 4.78452 3.02055 4.97979L8.00033 9.95957L12.9801 4.97979C13.1754 4.78452 13.4919 4.78452 13.6872 4.97979C13.8825 5.17505 13.8825 5.49163 13.6872 5.68689L8.00033 11.3738L2.31344 5.68689C2.11818 5.49163 2.11818 5.17505 2.31344 4.97979Z";
  const IconPathExpandMoreCircleFilled = "M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM5.14644 6.74661C5.3417 6.55134 5.65828 6.55133 5.85355 6.74659L8 8.89295L10.1465 6.74659C10.3417 6.55133 10.6583 6.55134 10.8536 6.74661C11.0488 6.94187 11.0488 7.25846 10.8535 7.45371L8 10.3071L5.14645 7.45371C4.95119 7.25846 4.95118 6.94187 5.14644 6.74661Z";
  const IconPathExpandRight = "M4.98003 13.6869C4.78477 13.4917 4.78477 13.1751 4.98003 12.9798L9.95981 8.00004L4.98003 3.02026C4.78477 2.825 4.78477 2.50842 4.98003 2.31315C5.17529 2.11789 5.49187 2.11789 5.68714 2.31315L11.374 8.00004L5.68714 13.6869C5.49188 13.8822 5.17529 13.8822 4.98003 13.6869Z";
  const IconPathExpandRightCircleFilled = "M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM6.74661 10.8536C6.55134 10.6583 6.55133 10.3417 6.74659 10.1465L8.89295 8L6.74659 5.85355C6.55133 5.65828 6.55134 5.3417 6.74661 5.14644C6.94187 4.95118 7.25846 4.95119 7.45371 5.14645L10.3071 8L7.45371 10.8535C7.25846 11.0488 6.94187 11.0488 6.74661 10.8536Z";
  const IconPathFavorite = "M7.62159 4.47672C6.81359 3.54114 5.33759 3.17304 4.12401 3.96814L4.12163 3.9697C3.41785 4.42509 3 5.21491 3 6.04991C3 6.90915 3.38276 7.72341 4.16616 8.66827C4.95538 9.62015 6.09687 10.642 7.53133 11.9254L8.01194 12.346L8.47548 11.9693C9.90479 10.6904 11.0444 9.65751 11.8319 8.69565C12.6159 7.73805 13 6.91061 13 6.04991C13 5.21491 12.5822 4.42508 11.8784 3.96969L11.876 3.96814C10.6624 3.17304 9.18641 3.54114 8.37841 4.47672C8.28343 4.58669 8.14531 4.64991 8 4.64991C7.85469 4.64991 7.71657 4.58669 7.62159 4.47672ZM8 3.4457C6.86011 2.46433 5.08403 2.14443 3.57718 3.1309C2.58169 3.77563 2 4.88538 2 6.04991C2 7.24066 2.54224 8.2764 3.39634 9.30654C4.23483 10.3178 5.42524 11.3829 6.81954 12.6304L6.8666 12.6725L7.67075 13.3762C7.85405 13.5366 8.12626 13.5416 8.3153 13.388L9.1153 12.738C9.12145 12.733 9.12749 12.7278 9.1334 12.7225C10.5499 11.4551 11.7573 10.3653 12.6056 9.32915C13.4591 8.28676 14 7.2392 14 6.04991C14 4.8854 13.4183 3.77567 12.4229 3.13093C10.916 2.14442 9.1399 2.46432 8 3.4457Z";
  const IconPathFeedback = "M8 6.96005C7.6 6.96005 7.25 7.30005 7.25 7.68005C7.25 8.06005 7.6 8.40005 8 8.40005C8.4 8.40005 8.75 8.06005 8.75 7.68005C8.75 7.30005 8.4 6.96005 8 6.96005ZM5 6.96005C4.6 6.96005 4.25 7.30005 4.25 7.68005C4.25 8.06005 4.6 8.40005 5 8.40005C5.4 8.40005 5.75 8.06005 5.75 7.68005C5.75 7.30005 5.4 6.96005 5 6.96005ZM11 6.96005C10.6 6.96005 10.25 7.30005 10.25 7.68005C10.25 8.06005 10.6 8.40005 11 8.40005C11.4 8.40005 11.75 8.06005 11.75 7.68005C11.75 7.30005 11.4 6.96005 11 6.96005ZM1.5 7.34005C1.5 4.20005 4.51 1.80005 8 1.80005C11.49 1.80005 14.5 4.15005 14.5 7.34005C14.5 10.53 11.5 12.98 8 12.98C7.03 12.98 6.15 12.81 5.35 12.51C4.41 13.08 3.6 13.27 2.39 13.36C2.19 13.38 1.99 13.26 1.9 13.08C1.81 12.9 1.84 12.67 1.98 12.52C2.33 12.14 2.51 11.85 2.63 11.56C2.73 11.32 2.78 11.06 2.83 10.73C2 9.80005 1.5 8.60005 1.5 7.34005ZM8 2.80005C4.89 2.80005 2.5 4.91005 2.5 7.34005C2.5 8.40005 2.94 9.43005 3.71 10.21C3.82 10.32 3.87 10.47 3.85 10.62C3.8 11.09 3.73 11.51 3.56 11.94C3.52 12.04 3.48 12.13 3.43 12.23C4.01 12.11 4.48 11.91 5.03 11.54C5.17 11.45 5.34 11.43 5.5 11.5C6.24 11.81 7.07 11.99 8.01 11.99C11.11 11.99 13.51 9.84005 13.51 7.35005C13.51 4.86005 11.11 2.80005 8 2.80005Z";
  const IconPathFile = "M4 2.5C3.72614 2.5 3.5 2.72614 3.5 3V13C3.5 13.2739 3.72614 13.5 4 13.5H12C12.2739 13.5 12.5 13.2739 12.5 13V6H9.5C9.22386 6 9 5.77614 9 5.5V2.5H4ZM4 1.5C3.17386 1.5 2.5 2.17386 2.5 3V13C2.5 13.8261 3.17386 14.5 4 14.5H12C12.8261 14.5 13.5 13.8261 13.5 13V5.4C13.5 5.01322 13.3443 4.63722 13.0536 4.34645L10.6536 1.94645C10.3628 1.65567 9.98678 1.5 9.6 1.5H4ZM10 2.70711V5H12.2929L10 2.70711ZM5 9.5C5 9.22386 5.22386 9 5.5 9H9.5C9.77614 9 10 9.22386 10 9.5C10 9.77614 9.77614 10 9.5 10H5.5C5.22386 10 5 9.77614 5 9.5ZM5 11.5C5 11.2239 5.22386 11 5.5 11H7.5C7.77614 11 8 11.2239 8 11.5C8 11.7761 7.77614 12 7.5 12H5.5C5.22386 12 5 11.7761 5 11.5Z";
  const IconPathFileCode = "M4 2.5C3.72614 2.5 3.5 2.72614 3.5 3V13C3.5 13.2739 3.72614 13.5 4 13.5H12C12.2739 13.5 12.5 13.2739 12.5 13V6H9.5C9.22386 6 9 5.77614 9 5.5V2.5H4ZM4 1.5C3.17386 1.5 2.5 2.17386 2.5 3V13C2.5 13.8261 3.17386 14.5 4 14.5H12C12.8261 14.5 13.5 13.8261 13.5 13V5.4C13.5 5.01322 13.3443 4.63722 13.0536 4.34645L10.6536 1.94645C10.3628 1.65567 9.98678 1.5 9.6 1.5H4ZM10 2.70711V5H12.2929L10 2.70711ZM5.31311 6.97978C5.50838 6.78452 5.82496 6.78452 6.02022 6.97978L6.33333 7.29289L6.64645 6.97978C6.84171 6.78452 7.15829 6.78452 7.35355 6.97978C7.54882 7.17504 7.54882 7.49162 7.35355 7.68689L7.04044 8L7.35355 8.31311C7.54882 8.50838 7.54882 8.82496 7.35355 9.02022C7.15829 9.21548 6.84171 9.21548 6.64645 9.02022L6.33333 8.70711L6.02022 9.02022C5.82496 9.21548 5.50838 9.21548 5.31311 9.02022C5.11785 8.82496 5.11785 8.50838 5.31311 8.31311L5.62623 8L5.31311 7.68689C5.11785 7.49162 5.11785 7.17504 5.31311 6.97978ZM8.5 8.66667C8.5 8.39052 8.72386 8.16667 9 8.16667H10C10.2761 8.16667 10.5 8.39052 10.5 8.66667C10.5 8.94281 10.2761 9.16667 10 9.16667H9C8.72386 9.16667 8.5 8.94281 8.5 8.66667ZM5 11.5C5 11.2239 5.22386 11 5.5 11H8.83333C9.10948 11 9.33333 11.2239 9.33333 11.5C9.33333 11.7761 9.10948 12 8.83333 12H5.5C5.22386 12 5 11.7761 5 11.5Z";
  const IconPathFilter = "M2 5.08691C2 4.81077 2.22386 4.58691 2.5 4.58691H13.5C13.7761 4.58691 14 4.81077 14 5.08691C14 5.36306 13.7761 5.58691 13.5 5.58691H2.5C2.22386 5.58691 2 5.36306 2 5.08691ZM3.5 7.96694C3.5 7.6908 3.72386 7.46694 4 7.46694H12C12.2761 7.46694 12.5 7.6908 12.5 7.96694C12.5 8.24308 12.2761 8.46694 12 8.46694H4C3.72386 8.46694 3.5 8.24308 3.5 7.96694ZM6 10.8469C6 10.5708 6.22386 10.3469 6.5 10.3469H9.5C9.77614 10.3469 10 10.5708 10 10.8469C10 11.1231 9.77614 11.3469 9.5 11.3469H6.5C6.22386 11.3469 6 11.1231 6 10.8469Z";
  const IconPathFlashlight = "M8 0.166504C8.27614 0.166504 8.5 0.390362 8.5 0.666504V2.00001C8.5 2.27615 8.27614 2.50001 8 2.50001C7.72386 2.50001 7.5 2.27615 7.5 2.00001V0.666504C7.5 0.390362 7.72386 0.166504 8 0.166504ZM4.34622 0.981015C4.54143 0.7857 4.85801 0.785615 5.05333 0.980825L5.99633 1.92333C6.19165 2.11853 6.19173 2.43512 5.99652 2.63043C5.80131 2.82575 5.48473 2.82583 5.28941 2.63062L4.34641 1.68812C4.15109 1.49291 4.15101 1.17633 4.34622 0.981015ZM11.6534 0.981013C11.8487 1.17633 11.8486 1.49291 11.6533 1.68812L10.7103 2.63062C10.5149 2.82583 10.1984 2.82575 10.0032 2.63043C9.80794 2.43512 9.80803 2.11854 10.0033 1.92333L10.9463 0.980826C11.1417 0.785616 11.4582 0.7857 11.6534 0.981013ZM4 4.5C4 4.22386 4.22386 4 4.5 4H11.5C11.7761 4 12 4.22386 12 4.5V5.0845C12 6.55131 11.1936 7.82961 10 8.50035V13C10 14.1046 9.10461 15 8 15C6.89539 15 6 14.1046 6 13V8.50026C4.80629 7.8295 4 6.55127 4 5.0845V4.5ZM7 8.89234V13C7 13.5523 7.44768 14 8 14C8.55232 14 9 13.5523 9 13V8.89242C8.70633 8.96275 8.39978 9 8.08453 9H7.916C7.60056 9 7.29383 8.96272 7 8.89234ZM5 5V5.0845C5 6.69481 6.30509 8 7.916 8H8.08453C9.69485 8 11 6.69486 11 5.0845V5H5Z";
  const IconPathFolder = "M3 4.42725C2.70421 4.42725 2.5 4.65203 2.5 4.88725V11.6072C2.5 11.8425 2.7042 12.0672 3 12.0672H13C13.2958 12.0672 13.5 11.8425 13.5 11.6072V6.32725C13.5 6.09202 13.2958 5.86725 13 5.86725H7.558C7.27957 5.86725 7.0097 5.75341 6.81772 5.54679L5.78231 4.42844C5.78111 4.42792 5.77878 4.42725 5.7755 4.42725H3ZM1.5 4.88725C1.5 4.06166 2.19079 3.42725 3 3.42725H5.7755C6.05353 3.42725 6.32422 3.54085 6.51639 3.74937C6.5162 3.74916 6.51658 3.74958 6.51639 3.74937L7.54968 4.86544C7.54927 4.86527 7.54987 4.86555 7.54968 4.86544C7.55128 4.86613 7.55471 4.86725 7.558 4.86725H13C13.8093 4.86725 14.5 5.50167 14.5 6.32725V11.6072C14.5 12.4328 13.8092 13.0672 13 13.0672H3C2.1908 13.0672 1.5 12.4329 1.5 11.6072V4.88725Z";
  const IconPathGrid = "M1.5 6.13481C1.5 5.17688 2.30294 4.43481 3.25 4.43481C4.19706 4.43481 5 5.17688 5 6.13481C5 7.09278 4.19704 7.83479 3.25 7.83479C2.30296 7.83479 1.5 7.09278 1.5 6.13481ZM3.25 5.43481C2.81635 5.43481 2.5 5.76725 2.5 6.13481C2.5 6.50237 2.81634 6.83479 3.25 6.83479C3.68366 6.83479 4 6.50237 4 6.13481C4 5.76725 3.68365 5.43481 3.25 5.43481ZM6.25 6.13481C6.25 5.17688 7.05296 4.43481 8 4.43481C8.94704 4.43481 9.75 5.17688 9.75 6.13481C9.75 7.09278 8.94702 7.83479 8 7.83479C7.05298 7.83479 6.25 7.09278 6.25 6.13481ZM8 5.43481C7.56637 5.43481 7.25 5.76726 7.25 6.13481C7.25 6.50237 7.56635 6.83479 8 6.83479C8.43365 6.83479 8.75 6.50237 8.75 6.13481C8.75 5.76726 8.43363 5.43481 8 5.43481ZM11 6.13481C11 5.17688 11.803 4.43481 12.75 4.43481C13.697 4.43481 14.5 5.17688 14.5 6.13481C14.5 7.09278 13.697 7.83479 12.75 7.83479C11.803 7.83479 11 7.09278 11 6.13481ZM12.75 5.43481C12.3164 5.43481 12 5.76726 12 6.13481C12 6.50237 12.3164 6.83479 12.75 6.83479C13.1836 6.83479 13.5 6.50237 13.5 6.13481C13.5 5.76726 13.1836 5.43481 12.75 5.43481ZM1.5 10.4548C1.5 9.49689 2.30293 8.75479 3.25 8.75479C4.19707 8.75479 5 9.49689 5 10.4548C5 11.4128 4.19705 12.1548 3.25 12.1548C2.30295 12.1548 1.5 11.4128 1.5 10.4548ZM3.25 9.75479C2.81636 9.75479 2.5 10.0872 2.5 10.4548C2.5 10.8224 2.81634 11.1548 3.25 11.1548C3.68366 11.1548 4 10.8224 4 10.4548C4 10.0872 3.68364 9.75479 3.25 9.75479ZM6.25 10.4548C6.25 9.49689 7.05296 8.75479 8 8.75479C8.94704 8.75479 9.75 9.49689 9.75 10.4548C9.75 11.4128 8.94702 12.1548 8 12.1548C7.05298 12.1548 6.25 11.4128 6.25 10.4548ZM8 9.75479C7.56638 9.75479 7.25 10.0873 7.25 10.4548C7.25 10.8224 7.56636 11.1548 8 11.1548C8.43364 11.1548 8.75 10.8224 8.75 10.4548C8.75 10.0873 8.43362 9.75479 8 9.75479ZM11 10.4548C11 9.49689 11.803 8.75479 12.75 8.75479C13.697 8.75479 14.5 9.49689 14.5 10.4548C14.5 11.4128 13.697 12.1548 12.75 12.1548C11.803 12.1548 11 11.4128 11 10.4548ZM12.75 9.75479C12.3164 9.75479 12 10.0873 12 10.4548C12 10.8224 12.3164 11.1548 12.75 11.1548C13.1836 11.1548 13.5 10.8224 13.5 10.4548C13.5 10.0873 13.1836 9.75479 12.75 9.75479Z";
  const IconPathGroup = "M7.46653 6.03346C7.46653 4.65558 8.61678 3.56696 10.0001 3.56696C11.3834 3.56696 12.5335 4.6556 12.5335 6.03346C12.5335 7.4113 11.3834 8.49998 10.0001 8.49998C8.61677 8.49998 7.46653 7.41132 7.46653 6.03346ZM10.0001 4.56696C9.1372 4.56696 8.46653 5.2392 8.46653 6.03346C8.46653 6.82771 9.13721 7.49998 10.0001 7.49998C10.8629 7.49998 11.5335 6.82774 11.5335 6.03346C11.5335 5.23918 10.8629 4.56696 10.0001 4.56696ZM2.66673 6.03346C2.66673 5.02947 3.50356 4.24396 4.50023 4.24396C5.4969 4.24396 6.33373 5.02947 6.33373 6.03346C6.33373 7.03747 5.4969 7.82298 4.50023 7.82298C3.50355 7.82298 2.66673 7.03747 2.66673 6.03346ZM4.50023 5.24396C4.02395 5.24396 3.66673 5.61311 3.66673 6.03346C3.66673 6.45383 4.02396 6.82298 4.50023 6.82298C4.9765 6.82298 5.33373 6.45383 5.33373 6.03346C5.33373 5.61311 4.9765 5.24396 4.50023 5.24396ZM1.50472 10.4319C1.65567 9.33438 2.60827 8.49998 3.74806 8.49998H5.37656C6.27943 8.49998 7.06201 9.02256 7.42524 9.78246C7.82299 9.60107 8.26349 9.49998 8.72906 9.49998H11.2711C12.9387 9.49998 14.2847 10.7969 14.496 12.4361C14.5313 12.7099 14.3379 12.9606 14.064 12.9959C13.7901 13.0312 13.5395 12.8378 13.5042 12.5639C13.3514 11.3791 12.3924 10.5 11.2711 10.5H8.72906C7.60774 10.5 6.64867 11.3791 6.49596 12.5639C6.46066 12.8378 6.21002 13.0312 5.93614 12.9959C5.66227 12.9606 5.46886 12.7099 5.50416 12.4361C5.61085 11.6083 6.00687 10.8679 6.58752 10.3377C6.56982 10.3118 6.55432 10.2838 6.54137 10.254C6.35026 9.8135 5.90286 9.49998 5.37656 9.49998H3.74806C3.10185 9.49998 2.57745 9.97159 2.4954 10.5681C2.45777 10.8417 2.2055 11.0329 1.93193 10.9953C1.65836 10.9577 1.4671 10.7054 1.50472 10.4319Z";
  const IconPathGroupAuthorisation = "M10.0768 3.37493C8.74503 2.85777 7.25496 2.85777 5.92318 3.37493C5.66576 3.47489 5.37605 3.34724 5.27609 3.08983C5.17613 2.83241 5.30378 2.5427 5.56119 2.44274C7.12583 1.83517 8.87416 1.83517 10.4388 2.44275C10.6962 2.54271 10.8239 2.83241 10.7239 3.08983C10.6239 3.34725 10.3342 3.47489 10.0768 3.37493ZM2.75716 4.17456C2.75716 3.61428 3.22431 3.19456 3.75716 3.19456C4.29001 3.19456 4.75716 3.61428 4.75716 4.17456C4.75716 4.73484 4.29002 5.15456 3.75716 5.15456C3.22431 5.15456 2.75716 4.73484 2.75716 4.17456ZM11.2429 4.17456C11.2429 3.61431 11.7099 3.19456 12.2429 3.19456C12.7757 3.19456 13.2429 3.61427 13.2429 4.17456C13.2429 4.73485 12.7757 5.15456 12.2429 5.15456C11.7099 5.15456 11.2429 4.7348 11.2429 4.17456ZM8.38607 6.10706C8.09942 6.10706 7.81652 6.16434 7.55541 6.27471C7.29887 6.38405 7.06845 6.54002 6.87667 6.73285L6.87633 6.73319C6.8587 6.75089 6.8414 6.76885 6.82444 6.78707H8C8.27614 6.78707 8.5 7.01093 8.5 7.28707C8.5 7.56321 8.27614 7.78707 8 7.78707H6.29985C6.25079 8.01101 6.23794 8.24032 6.26131 8.46707H7.5C7.77614 8.46707 8 8.69093 8 8.96707C8 9.24321 7.77614 9.46707 7.5 9.46707H6.63087C6.70328 9.57125 6.78535 9.66964 6.87635 9.76098L6.87663 9.76126C7.06843 9.95407 7.29885 10.1101 7.55532 10.2194C7.8165 10.3298 8.09944 10.3871 8.38607 10.3871C8.67272 10.3871 8.95572 10.3298 9.2168 10.2194C9.47327 10.1101 9.70372 9.95407 9.89565 9.76119C10.0904 9.56546 10.407 9.56469 10.6028 9.75947C10.7985 9.95426 10.7993 10.2708 10.6045 10.4666C10.3203 10.7522 9.98161 10.9806 9.60804 11.1397L9.60695 11.1401C9.22164 11.3031 8.80589 11.3871 8.38607 11.3871C7.96622 11.3871 7.55055 11.3031 7.16521 11.1401L7.16409 11.1397C6.79053 10.9806 6.45182 10.7521 6.16767 10.4665C5.88106 10.1788 5.65295 9.84036 5.49638 9.46881L5.49597 9.46782C5.49586 9.46757 5.49576 9.46732 5.49565 9.46707H4.5C4.22386 9.46707 4 9.24321 4 8.96707C4 8.69093 4.22386 8.46707 4.5 8.46707H5.2577C5.24181 8.24037 5.25051 8.01243 5.28381 7.78707H5C4.72386 7.78707 4.5 7.56321 4.5 7.28707C4.5 7.01093 4.72386 6.78707 5 6.78707H5.60889C5.75522 6.50853 5.94355 6.25263 6.16763 6.02768C6.45182 5.74194 6.79056 5.51355 7.16408 5.35446L7.16517 5.354C7.55057 5.19094 7.96626 5.10706 8.38607 5.10706C8.80585 5.10706 9.22162 5.19093 9.60699 5.35401C9.8613 5.46163 9.98022 5.75503 9.8726 6.00934C9.76498 6.26365 9.47158 6.38257 9.21727 6.27495C8.95611 6.16443 8.67295 6.10706 8.38607 6.10706ZM2.63349 5.61879C2.88796 5.72602 3.00734 6.01923 2.90011 6.27371C2.36663 7.53985 2.36663 8.95429 2.90011 10.2204C3.00734 10.4749 2.88797 10.7681 2.63349 10.8753C2.37902 10.9825 2.0858 10.8632 1.97858 10.6087C1.34047 9.09429 1.34048 7.39985 1.97858 5.88542C2.0858 5.63094 2.37901 5.51157 2.63349 5.61879ZM13.3664 5.61879C13.6209 5.51157 13.9141 5.63094 14.0213 5.88542C14.6594 7.39985 14.6594 9.09429 14.0213 10.6087C13.9141 10.8632 13.6209 10.9826 13.3664 10.8753C13.1119 10.7681 12.9925 10.4749 13.0998 10.2204C13.6333 8.95429 13.6333 7.53986 13.0998 6.27371C12.9925 6.01923 13.1119 5.72602 13.3664 5.61879ZM2.75716 12.3196C2.75716 11.7593 3.2243 11.3396 3.75716 11.3396C4.29002 11.3396 4.75716 11.7593 4.75716 12.3196C4.75716 12.8798 4.29002 13.2996 3.75716 13.2996C3.2243 13.2996 2.75716 12.8798 2.75716 12.3196ZM11.2429 12.3196C11.2429 11.7594 11.7099 11.3396 12.2429 11.3396C12.7757 11.3396 13.2429 11.7593 13.2429 12.3196C13.2429 12.8799 12.7757 13.2996 12.2429 13.2996C11.7099 13.2996 11.2429 12.8798 11.2429 12.3196ZM5.27609 13.4042C5.37605 13.1468 5.66576 13.0191 5.92318 13.1191C7.25496 13.6362 8.74503 13.6362 10.0768 13.1191C10.3342 13.0191 10.6239 13.1468 10.7239 13.4042C10.8239 13.6616 10.6962 13.9513 10.4388 14.0513C8.87416 14.6589 7.12583 14.6589 5.56119 14.0513C5.30378 13.9513 5.17613 13.6616 5.27609 13.4042Z";
  const IconPathGroupLoadmanagement = "M10.0768 3.37488C8.74504 2.85779 7.25496 2.85779 5.92316 3.37488C5.66574 3.47483 5.37604 3.34718 5.27609 3.08976C5.17614 2.83234 5.30379 2.54263 5.56121 2.44268C7.12584 1.83519 8.87416 1.83519 10.4388 2.44268C10.6962 2.54263 10.8238 2.83234 10.7239 3.08976C10.624 3.34718 10.3342 3.47483 10.0768 3.37488ZM2.75749 4.17425C2.75749 3.61396 3.22464 3.19425 3.75749 3.19425C4.29033 3.19425 4.75749 3.61396 4.75749 4.17425C4.75749 4.73453 4.29034 5.15425 3.75749 5.15425C3.22464 5.15425 2.75749 4.73453 2.75749 4.17425ZM11.2425 4.17425C11.2425 3.61396 11.7097 3.19425 12.2425 3.19425C12.7754 3.19425 13.2425 3.61396 13.2425 4.17425C13.2425 4.73453 12.7754 5.15425 12.2425 5.15425C11.7097 5.15425 11.2425 4.73453 11.2425 4.17425ZM8.16401 4.89473C8.42487 4.9853 8.56291 5.2702 8.47234 5.53107L7.70289 7.74707H9.7029L8.47234 11.2911C8.38176 11.5519 8.09686 11.69 7.83599 11.5994C7.57513 11.5088 7.43709 11.2239 7.52766 10.9631L8.29711 8.74707H6.29711L7.52766 5.20306C7.61824 4.94219 7.90314 4.80415 8.16401 4.89473ZM2.63343 5.6191C2.88791 5.72631 3.00729 6.01952 2.90008 6.274C2.36664 7.54017 2.36664 8.95461 2.90008 10.2207C3.00729 10.4752 2.88791 10.7684 2.63343 10.8757C2.37895 10.9829 2.08574 10.8635 1.97852 10.609C1.34049 9.0946 1.34049 7.40018 1.97852 5.88575C2.08574 5.63127 2.37895 5.51189 2.63343 5.6191ZM13.3664 5.6191C13.6209 5.51189 13.9141 5.63127 14.0213 5.88575C14.6593 7.40018 14.6593 9.0946 14.0213 10.609C13.9141 10.8635 13.6209 10.9829 13.3664 10.8757C13.1119 10.7684 12.9925 10.4752 13.0998 10.2207C13.6332 8.95461 13.6332 7.54017 13.0998 6.274C12.9925 6.01952 13.1119 5.72631 13.3664 5.6191ZM2.75749 12.3199C2.75749 11.7595 3.22468 11.3399 3.75749 11.3399C4.2903 11.3399 4.75749 11.7595 4.75749 12.3199C4.75749 12.8802 4.29034 13.2999 3.75749 13.2999C3.22463 13.2999 2.75749 12.8802 2.75749 12.3199ZM11.2425 12.3199C11.2425 11.7595 11.7097 11.3399 12.2425 11.3399C12.7753 11.3399 13.2425 11.7595 13.2425 12.3199C13.2425 12.8802 12.7754 13.2999 12.2425 13.2999C11.7097 13.2999 11.2425 12.8802 11.2425 12.3199ZM5.27609 13.4061C5.37604 13.1486 5.66574 13.021 5.92316 13.1209C7.25496 13.638 8.74504 13.638 10.0768 13.1209C10.3342 13.021 10.6239 13.1486 10.7239 13.4061C10.8238 13.6635 10.6962 13.9532 10.4388 14.0531C8.87416 14.6606 7.12584 14.6606 5.56121 14.0531C5.30379 13.9532 5.17614 13.6635 5.27609 13.4061Z";
  const IconPathGroupWork = "M10.08 3.28878C8.75 2.76878 7.26 2.76878 5.93 3.28878C5.67 3.38878 5.38 3.25878 5.28 2.99878C5.18 2.73878 5.31 2.44878 5.57 2.34878C7.13 1.74878 8.87 1.74878 10.44 2.35878C10.7 2.45878 10.83 2.74878 10.73 3.00878C10.63 3.26878 10.34 3.39878 10.08 3.29878V3.28878ZM2.76 4.08878C2.76 3.52878 3.23 3.10878 3.76 3.10878C4.29 3.10878 4.76 3.52878 4.76 4.08878C4.76 4.64878 4.29 5.06878 3.76 5.06878C3.23 5.06878 2.76 4.64878 2.76 4.08878ZM11.25 4.08878C11.25 3.52878 11.72 3.10878 12.25 3.10878C12.78 3.10878 13.25 3.52878 13.25 4.08878C13.25 4.64878 12.78 5.06878 12.25 5.06878C11.72 5.06878 11.25 4.64878 11.25 4.08878ZM2.63 5.52878C2.88 5.63878 3 5.92878 2.9 6.17878C2.37 7.44878 2.37 8.85878 2.9 10.1288C3.01 10.3788 2.89 10.6788 2.63 10.7788C2.38 10.8888 2.08 10.7688 1.98 10.5088C1.34 9.00878 1.34 7.30878 1.98 5.79878C2.09 5.54878 2.38 5.42878 2.63 5.52878ZM13.36 5.52878C13.61 5.41878 13.91 5.53878 14.01 5.79878C14.65 7.30878 14.65 9.00878 14.01 10.5188C13.9 10.7688 13.61 10.8888 13.36 10.7888C13.11 10.6788 12.99 10.3888 13.09 10.1388C13.62 8.86878 13.62 7.45878 13.09 6.18878C12.98 5.93878 13.1 5.63878 13.36 5.53878V5.52878ZM2.76 12.2288C2.76 11.6688 3.23 11.2488 3.76 11.2488C4.29 11.2488 4.76 11.6688 4.76 12.2288C4.76 12.7888 4.29 13.2088 3.76 13.2088C3.23 13.2088 2.76 12.7888 2.76 12.2288ZM11.25 12.2288C11.25 11.6688 11.72 11.2488 12.25 11.2488C12.78 11.2488 13.25 11.6688 13.25 12.2288C13.25 12.7888 12.78 13.2088 12.25 13.2088C11.72 13.2088 11.25 12.7888 11.25 12.2288ZM5.28 13.3088C5.38 13.0488 5.67 12.9188 5.93 13.0188C7.26 13.5388 8.75 13.5388 10.08 13.0188C10.34 12.9188 10.63 13.0488 10.73 13.3088C10.83 13.5688 10.7 13.8588 10.44 13.9588C8.88 14.5688 7.13 14.5688 5.56 13.9588C5.3 13.8588 5.17 13.5688 5.27 13.3088H5.28ZM7.5 5.50878C7.5 5.22878 7.28 5.00878 7 5.00878C6.72 5.00878 6.5 5.22878 6.5 5.50878V6.44878C6.31 6.44878 6.12 6.51878 5.98 6.65878C5.84 6.79878 5.75 6.98878 5.75 7.18878V7.72878C5.75 8.01878 5.81 8.29878 5.93 8.56878C6.05 8.82878 6.22 9.06878 6.43 9.25878C6.64 9.45878 6.89 9.60878 7.16 9.70878C7.27 9.74878 7.38 9.77878 7.5 9.80878V9.82878C7.5 9.94878 7.45 10.0588 7.36 10.1488C7.27 10.2388 7.14 10.2888 7 10.2888H6C5.72 10.2888 5.5 10.5088 5.5 10.7888C5.5 11.0688 5.72 11.2888 6 11.2888H7C7.39 11.2888 7.77 11.1388 8.05 10.8688C8.33 10.5988 8.5 10.2188 8.5 9.82878V9.80878C8.61 9.78878 8.73 9.74878 8.84 9.70878C9.11 9.60878 9.36 9.45878 9.57 9.25878C9.78 9.05878 9.95 8.82878 10.07 8.56878C10.19 8.30878 10.25 8.01878 10.25 7.73878V7.19878C10.25 6.99878 10.17 6.80878 10.02 6.66878C9.88 6.52878 9.69 6.45878 9.5 6.45878V5.51878C9.5 5.23878 9.28 5.01878 9 5.01878C8.72 5.01878 8.5 5.23878 8.5 5.51878V6.45878H7.5V5.51878V5.50878ZM6.75 7.44878V7.72878C6.75 7.87878 6.78 8.01878 6.84 8.15878C6.9 8.29878 6.99 8.41878 7.11 8.52878C7.22 8.63878 7.36 8.71878 7.51 8.77878C7.66 8.83878 7.82 8.85878 7.98 8.85878C7.98 8.85878 8 8.85878 8.01 8.85878C8.17 8.85878 8.33 8.83878 8.48 8.77878C8.63 8.71878 8.77 8.63878 8.88 8.52878C8.99 8.41878 9.08 8.29878 9.15 8.15878C9.21 8.01878 9.24 7.87878 9.24 7.72878V7.44878H6.74H6.75Z";
  const IconPathHeater = "M2 3.5C2 3.22386 2.22386 3 2.5 3H13.5C13.7761 3 14 3.22386 14 3.5V4H14.25C14.5261 4 14.75 4.22386 14.75 4.5C14.75 4.77614 14.5261 5 14.25 5H14V12.5C14 12.7761 13.7761 13 13.5 13H11.5V13.5C11.5 13.7761 11.2761 14 11 14C10.7239 14 10.5 13.7761 10.5 13.5V13H5.5V13.5C5.5 13.7761 5.27614 14 5 14C4.72386 14 4.5 13.7761 4.5 13.5V13H2.5C2.22386 13 2 12.7761 2 12.5V3.5ZM13 12V4H3V12H13ZM5 5.5C5.27614 5.5 5.5 5.72386 5.5 6V10C5.5 10.2761 5.27614 10.5 5 10.5C4.72386 10.5 4.5 10.2761 4.5 10V6C4.5 5.72386 4.72386 5.5 5 5.5ZM8 5.5C8.27614 5.5 8.5 5.72386 8.5 6V10C8.5 10.2761 8.27614 10.5 8 10.5C7.72386 10.5 7.5 10.2761 7.5 10V6C7.5 5.72386 7.72386 5.5 8 5.5ZM11 5.5C11.2761 5.5 11.5 5.72386 11.5 6V10C11.5 10.2761 11.2761 10.5 11 10.5C10.7239 10.5 10.5 10.2761 10.5 10V6C10.5 5.72386 10.7239 5.5 11 5.5Z";
  const IconPathHelp = "M8 1.5C4.41 1.5 1.5 4.41 1.5 8C1.5 11.59 4.41 14.5 8 14.5C11.59 14.5 14.5 11.59 14.5 8C14.5 4.41 11.59 1.5 8 1.5ZM8 2.5C4.96 2.5 2.5 4.96 2.5 8C2.5 11.04 4.96 13.5 8 13.5C11.04 13.5 13.5 11.04 13.5 8C13.5 4.96 11.04 2.5 8 2.5ZM8.5 11.33C8.5 11.05 8.28 10.83 8 10.83C7.72 10.83 7.5 11.05 7.5 11.33C7.5 11.61 7.72 11.83 8 11.83C8.28 11.83 8.5 11.61 8.5 11.33ZM8.5 4.56C7.21 4.23 6.05 5.2 6.05 6.44C6.05 6.72 6.27 6.94 6.55 6.94C6.83 6.94 7.05 6.72 7.05 6.44C7.05 6.27 7.09 6.11 7.17 5.98C7.37 5.63 7.79 5.41 8.25 5.53C8.56 5.61 8.82 5.87 8.9 6.18C9.01 6.6 8.85 6.98 8.56 7.2C7.96 7.65 7.49 8.34 7.49 9.17C7.49 9.45 7.71 9.67 7.99 9.67C8.27 9.67 8.49 9.45 8.49 9.17C8.49 8.73 8.73 8.31 9.15 8C9.75 7.55 10.08 6.76 9.86 5.93C9.69 5.27 9.15 4.73 8.49 4.56H8.5Z";
  const IconPathInfo = "M8 5.7C8.33 5.7 8.6 5.43 8.6 5.1C8.6 4.77 8.33 4.5 8 4.5C7.67 4.5 7.4 4.77 7.4 5.1C7.4 5.43 7.67 5.7 8 5.7ZM1.5 8C1.5 4.41 4.41 1.5 8 1.5C11.59 1.5 14.5 4.41 14.5 8C14.5 11.59 11.59 14.5 8 14.5C4.41 14.5 1.5 11.59 1.5 8ZM8 2.5C4.96 2.5 2.5 4.96 2.5 8C2.5 11.04 4.96 13.5 8 13.5C11.04 13.5 13.5 11.04 13.5 8C13.5 4.96 11.04 2.5 8 2.5ZM6.5 8C6.5 7.72 6.72 7.5 7 7.5H8C8.28 7.5 8.5 7.72 8.5 8V11C8.5 11.28 8.28 11.5 8 11.5C7.72 11.5 7.5 11.28 7.5 11V8.5H7C6.72 8.5 6.5 8.28 6.5 8Z";
  const IconPathLabel = "M3.5 4.8136C3.20421 4.8136 3 5.03838 3 5.2736V11.0336C3 11.2688 3.20422 11.4936 3.5 11.4936H11.465C11.6408 11.4936 11.7973 11.409 11.8862 11.2809L14.0582 8.1536L11.8863 5.0265C11.7974 4.89835 11.6412 4.8136 11.465 4.8136H3.5ZM2 5.2736C2 4.44802 2.69079 3.8136 3.5 3.8136H11.465C11.9578 3.8136 12.4256 4.04963 12.7077 4.45605C12.7076 4.45598 12.7077 4.45613 12.7077 4.45605L15.2758 8.15361L12.7078 11.8509C12.4257 12.2576 11.9572 12.4936 11.465 12.4936H3.5C2.69078 12.4936 2 11.8591 2 11.0336V5.2736ZM8 8.15361C8 7.06308 8.91491 6.2136 10 6.2136C11.0851 6.2136 12 7.06308 12 8.15361C12 9.24405 11.0851 10.0936 10 10.0936C8.91489 10.0936 8 9.24405 8 8.15361ZM10 7.2136C9.42829 7.2136 9 7.65347 9 8.15361C9 8.65369 9.42831 9.09361 10 9.09361C10.5717 9.09361 11 8.65369 11 8.15361C11 7.65347 10.5717 7.2136 10 7.2136Z";
  const IconPathLanguage = "M1.5 7.99999C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 7.99999C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 7.99999ZM6.14017 13.1776C5.0028 12.769 4.03904 11.9963 3.38946 11H5.32082C5.44112 11.5247 5.59259 12.0075 5.77069 12.435C5.88147 12.7008 6.00464 12.9503 6.14017 13.1776ZM6.34956 11C6.44765 11.3854 6.5636 11.7379 6.69377 12.0503C6.90491 12.5571 7.1436 12.9345 7.38308 13.1776C7.62083 13.4189 7.829 13.5 8 13.5C8.17101 13.5 8.37918 13.4189 8.61693 13.1776C8.85641 12.9345 9.0951 12.5571 9.30624 12.0503C9.4364 11.7379 9.55235 11.3854 9.65045 11H6.34956ZM9.85213 10H6.14788C6.0528 9.3813 6 8.70767 6 7.99999C6 7.47874 6.02865 6.97597 6.08173 6.5H9.91827C9.97135 6.97597 10 7.47874 10 7.99999C10 8.70767 9.9472 9.3813 9.85213 10ZM10.6792 11C10.5589 11.5247 10.4074 12.0075 10.2293 12.435C10.1185 12.7008 9.99537 12.9503 9.85983 13.1776C10.9972 12.769 11.961 11.9963 12.6105 11H10.6792ZM13.1251 10H10.8629C10.9523 9.36848 11 8.69571 11 7.99999C11 7.48494 10.9738 6.98247 10.924 6.5H13.293C13.4278 6.97683 13.5 7.47999 13.5 7.99999C13.5 8.70558 13.3671 9.38013 13.1251 10ZM12.9003 5.5C12.268 4.26303 11.181 3.29705 9.85984 2.8224C9.99538 3.04972 10.1185 3.29919 10.2293 3.56505C10.4627 4.1251 10.6503 4.7802 10.782 5.5H12.9003ZM9.76383 5.5C9.64679 4.91627 9.49081 4.39263 9.30624 3.94967C9.0951 3.44294 8.85641 3.06551 8.61693 2.8224C8.37918 2.58106 8.17101 2.5 8 2.5C7.829 2.5 7.62083 2.58106 7.38308 2.8224C7.1436 3.06551 6.90491 3.44294 6.69377 3.94967C6.5092 4.39264 6.35321 4.91627 6.23618 5.5H9.76383ZM5.21801 5.5C5.3497 4.7802 5.53734 4.1251 5.77069 3.56505C5.88147 3.29919 6.00463 3.04972 6.14017 2.8224C4.81898 3.29705 3.73204 4.26303 3.09971 5.5H5.21801ZM2.70703 6.5C2.57217 6.97683 2.5 7.47999 2.5 7.99999C2.5 8.70558 2.63286 9.38013 2.87494 10H5.13708C5.04775 9.36848 5 8.69571 5 7.99999C5 7.48494 5.02617 6.98247 5.07601 6.5H2.70703Z";
  const IconPathLaunch = "M12.1283 2.5C11.9423 2.5 11.745 2.50983 11.5472 2.52965C11.3055 2.55373 11.0673 2.59521 10.834 2.65279L13.3476 5.17085C13.405 4.93765 13.4463 4.69963 13.4704 4.45775C13.4713 4.44823 13.4725 4.43874 13.474 4.4293C13.4989 4.27123 13.5 4.09706 13.5 3.875V2.5H12.1283ZM12.9773 6.2005C12.9491 6.18195 12.9223 6.16025 12.8975 6.13538L9.87073 3.10324C9.84591 3.07837 9.82425 3.05154 9.80575 3.02325C8.7768 3.51643 7.89012 4.33082 7.25672 5.33167L7.25605 5.33272L5.62345 7.89825C5.59908 7.94048 5.60023 7.98671 5.61548 8.02134L6.00093 8.40748C6.02193 8.42852 6.04067 8.45096 6.05714 8.4745L7.95815 10.3789C8.00236 10.4231 8.06276 10.4242 8.10085 10.3993L8.1052 10.3964L10.6712 8.75775C11.6716 8.11573 12.485 7.22894 12.9773 6.2005ZM10.4504 10.0853L8.74941 11.1716L9.7729 12.1969C9.94138 11.9249 10.0881 11.5913 10.2044 11.2289C10.3321 10.8311 10.4136 10.4286 10.4504 10.0853ZM7.25041 11.0854L4.92955 8.76038C4.89853 8.7293 4.86974 8.69682 4.84317 8.66313L2.67287 6.48895C2.47803 6.29376 2.47803 5.97767 2.67287 5.78248C3.13281 5.32171 3.8014 5.0013 4.43896 4.79595C5.08304 4.5885 5.75801 4.47857 6.27807 4.47857H6.40642C6.47425 4.47857 6.53892 4.49208 6.5979 4.51655C7.71519 2.91181 9.44865 1.73386 11.4475 1.53463M5.96849 5.49341L4.84866 7.25315L3.77821 6.18079C4.04987 6.01169 4.38325 5.86448 4.74553 5.7478C5.17461 5.6096 5.60908 5.52545 5.96849 5.49341ZM7.25041 11.0854L9.46431 13.3032C9.55811 13.3972 9.68542 13.45 9.81818 13.45C9.95094 13.45 10.0783 13.3972 10.172 13.3032C10.6319 12.8425 10.9517 12.173 11.1566 11.5345C11.3636 10.8894 11.4733 10.2135 11.4733 9.69286V9.56429C11.4733 9.51972 11.4674 9.47652 11.4565 9.4354C13.0699 8.31221 14.2598 6.58142 14.4641 4.57027C14.5001 4.33234 14.5 4.09052 14.5 3.89108L14.5 2C14.5 1.72386 14.2761 1.5 14 1.5H12.1283C11.9081 1.5 11.6774 1.51161 11.4475 1.53463M9.47593 5.96071C9.16224 5.96071 8.90642 6.21571 8.90642 6.53214C8.90642 6.84858 9.16224 7.10357 9.47593 7.10357C9.78963 7.10357 10.0455 6.84858 10.0455 6.53214C10.0455 6.21571 9.78963 5.96071 9.47593 5.96071ZM7.90642 6.53214C7.90642 5.66511 8.60827 4.96071 9.47593 4.96071C10.3436 4.96071 11.0455 5.66511 11.0455 6.53214C11.0455 7.39918 10.3436 8.10357 9.47593 8.10357C8.60827 8.10357 7.90642 7.39918 7.90642 6.53214ZM3.86126 9.10327C4.05669 9.29836 4.05698 9.61494 3.86189 9.81038L3.10253 10.5711C2.90744 10.7665 2.59086 10.7668 2.39543 10.5717C2.19999 10.3766 2.19971 10.0601 2.39479 9.86462L3.15415 9.1039C3.34924 8.90847 3.66582 8.90819 3.86126 9.10327ZM5.3806 10.6253C5.57569 10.8208 5.57541 11.1373 5.37998 11.3324L2.35324 14.3539C2.15781 14.549 1.84123 14.5487 1.64614 14.3532C1.45105 14.1578 1.45132 13.8412 1.64676 13.6461L4.67349 10.6247C4.86893 10.4296 5.18551 10.4299 5.3806 10.6253ZM6.91189 12.1594C7.10594 12.3558 7.10397 12.6724 6.9075 12.8665L6.14815 13.6165C5.95168 13.8105 5.6351 13.8085 5.44105 13.6121C5.247 13.4156 5.24897 13.099 5.44544 12.905L6.20479 12.155C6.40126 11.9609 6.71784 11.9629 6.91189 12.1594Z";
  const IconPathLayers = "M8.10036 3.36671C8.0411 3.32226 7.95961 3.32226 7.90036 3.36671L3.67813 6.53337C3.58924 6.60004 3.58924 6.73337 3.67813 6.80004L7.90036 9.96671C7.95961 10.0112 8.0411 10.0112 8.10036 9.96671L12.3226 6.80004C12.4115 6.73337 12.4115 6.60004 12.3226 6.53337L8.10036 3.36671ZM7.30036 2.56671C7.71517 2.2556 8.28554 2.2556 8.70036 2.56671L12.9226 5.73337C13.5448 6.20004 13.5448 7.13337 12.9226 7.60004L8.70036 10.7667C8.28554 11.0778 7.71517 11.0778 7.30036 10.7667L3.07813 7.60004C2.45591 7.13337 2.45591 6.20004 3.07813 5.73337L7.30036 2.56671ZM2.26702 9.03337C2.43271 8.81246 2.74611 8.76769 2.96702 8.93337L7.90036 12.6334C7.95961 12.6778 8.0411 12.6778 8.10036 12.6334L13.0337 8.93337C13.2546 8.76769 13.568 8.81246 13.7337 9.03337C13.8994 9.25429 13.8546 9.56769 13.6337 9.73337L8.70036 13.4334C8.28554 13.7445 7.71517 13.7445 7.30036 13.4334L2.36702 9.73337C2.14611 9.56769 2.10134 9.25429 2.26702 9.03337Z";
  const IconPathLight = "M10 14.49C10 14.77 9.78 14.99 9.5 14.99H6.5C6.22 14.99 6 14.77 6 14.49C6 14.21 6.22 13.99 6.5 13.99H9.5C9.78 13.99 10 14.21 10 14.49ZM13.5 6.81C13.5 7.74 13.25 8.65 12.76 9.46C12.28 10.26 11.59 10.93 10.75 11.39H10.74C10.66 11.44 10.6 11.49 10.56 11.56C10.52 11.62 10.5 11.69 10.5 11.77V12.1C10.5 12.37 10.39 12.62 10.2 12.8C10.01 12.98 9.76 13.08 9.5 13.08H8.02C8.02 13.08 8.01 13.08 8 13.08C7.99 13.08 7.99 13.08 7.98 13.08H6.5C6.24 13.08 5.99 12.98 5.8 12.8C5.61 12.62 5.5 12.37 5.5 12.1V11.79C5.5 11.72 5.48 11.65 5.45 11.58C5.41 11.52 5.36 11.46 5.29 11.42C4.45 10.96 3.75 10.3 3.26 9.5C2.77 8.68 2.5 7.77 2.5 6.83C2.5 5.89 2.75 4.97 3.23 4.16C3.71 3.35 4.41 2.68 5.24 2.21C6.08 1.75 7.02 1.5 7.99 1.5C8.96 1.5 9.9 1.74 10.74 2.2C11.58 2.66 12.28 3.33 12.76 4.14C13.25 4.95 13.5 5.87 13.5 6.8V6.81ZM12.5 6.81C12.5 6.06 12.3 5.32 11.9 4.66C11.5 4 10.94 3.46 10.25 3.08C9.56 2.7 8.78 2.5 7.99 2.5C7.2 2.5 6.41 2.7 5.73 3.09C5.04 3.47 4.48 4.02 4.09 4.68C3.7 5.34 3.5 6.08 3.5 6.83C3.5 7.58 3.72 8.32 4.11 8.97C4.51 9.62 5.08 10.16 5.77 10.54H5.78C6 10.67 6.18 10.86 6.31 11.08C6.44 11.3 6.5 11.55 6.5 11.8V12.07C6.5 12.07 6.5 12.07 6.5 12.09V12.07H7.5V9.42L6.15 8.13C5.95 7.94 5.94 7.62 6.14 7.42C6.34 7.22 6.65 7.21 6.85 7.41L8 8.52L9.15 7.41C9.35 7.22 9.67 7.22 9.86 7.42C10.05 7.62 10.05 7.94 9.85 8.13L8.5 9.42V12.07H9.5V11.74C9.5 11.48 9.58 11.23 9.72 11.02C9.86 10.81 10.05 10.63 10.27 10.51C10.95 10.13 11.51 9.59 11.9 8.94C12.29 8.29 12.49 7.55 12.49 6.81H12.5Z";
  const IconPathLink = "M12.4258 3.92097C11.4478 2.98207 9.85386 2.98207 8.87588 3.92097L7.46187 5.27841C6.49534 6.20627 6.49535 7.70197 7.46187 8.62979C7.66108 8.82103 7.66754 9.13754 7.47631 9.33675C7.28507 9.53596 6.96856 9.54243 6.76935 9.35119C5.39285 8.0298 5.39286 5.87844 6.76934 4.55702L8.18334 3.19959C9.54828 1.88921 11.7534 1.8892 13.1183 3.19958C14.4948 4.52099 14.4949 6.67234 13.1184 7.99373L12.0579 9.01185C11.8587 9.20309 11.5422 9.19664 11.3509 8.99744C11.1597 8.79824 11.1661 8.48172 11.3653 8.29048L12.4258 7.27237C13.3923 6.34454 13.3924 4.84883 12.4258 3.92097ZM8.52304 6.94702C8.71427 6.74781 9.03078 6.74134 9.23 6.93257C10.6065 8.25396 10.6065 10.4053 9.23001 11.7267M9.23001 11.7267L7.81601 13.0842C6.45105 14.3946 4.24596 14.3946 2.88098 13.0842C1.50451 11.7628 1.50452 9.6114 2.88099 8.29002L3.94149 7.27191C4.14069 7.08067 4.45721 7.08713 4.64845 7.28633C4.83969 7.48554 4.83323 7.80205 4.63403 7.99329L3.57352 9.0114C2.60701 9.93923 2.60701 11.435 3.57351 12.3628C4.55153 13.3017 6.14547 13.3017 7.12347 12.3628L8.53747 11.0054C9.50401 10.0775 9.50402 8.58181 8.53748 7.65398C8.33827 7.46275 8.3318 7.14623 8.52304 6.94702";
  const IconPathList = "M6 4.5C6 4.22 6.22 4 6.5 4H12C12.28 4 12.5 4.22 12.5 4.5C12.5 4.78 12.28 5 12 5H6.5C6.22 5 6 4.78 6 4.5ZM6 8C6 7.72 6.22 7.5 6.5 7.5H12C12.28 7.5 12.5 7.72 12.5 8C12.5 8.28 12.28 8.5 12 8.5H6.5C6.22 8.5 6 8.28 6 8ZM6 11.5C6 11.22 6.22 11 6.5 11H12C12.28 11 12.5 11.22 12.5 11.5C12.5 11.78 12.28 12 12 12H6.5C6.22 12 6 11.78 6 11.5ZM4 8.75C4.41 8.75 4.75 8.41 4.75 8C4.75 7.59 4.41 7.25 4 7.25C3.59 7.25 3.25 7.59 3.25 8C3.25 8.41 3.59 8.75 4 8.75ZM4 5.25C4.41 5.25 4.75 4.91 4.75 4.5C4.75 4.09 4.41 3.75 4 3.75C3.59 3.75 3.25 4.09 3.25 4.5C3.25 4.91 3.59 5.25 4 5.25ZM4 12.25C4.41 12.25 4.75 11.91 4.75 11.5C4.75 11.09 4.41 10.75 4 10.75C3.59 10.75 3.25 11.09 3.25 11.5C3.25 11.91 3.59 12.25 4 12.25Z";
  const IconPathListInfo = "M5.33 6.69995C5.7 6.69995 6 6.39995 6 6.02995C6 5.65995 5.7 5.35995 5.33 5.35995C4.96 5.35995 4.66 5.65995 4.66 6.02995C4.66 6.39995 4.96 6.69995 5.33 6.69995ZM5.33 12.03C5.7 12.03 6 11.73 6 11.36C6 10.99 5.7 10.69 5.33 10.69C4.96 10.69 4.66 10.99 4.66 11.36C4.66 11.73 4.96 12.03 5.33 12.03ZM5.33 9.35995C5.7 9.35995 6 9.05995 6 8.68995C6 8.31995 5.7 8.01995 5.33 8.01995C4.96 8.01995 4.66 8.31995 4.66 8.68995C4.66 9.05995 4.96 9.35995 5.33 9.35995ZM11.91 3.27995C12.19 3.27995 12.41 3.05995 12.41 2.77995C12.41 2.49995 12.19 2.27995 11.91 2.27995C11.63 2.27995 11.41 2.49995 11.41 2.77995C11.41 3.05995 11.63 3.27995 11.91 3.27995ZM8.16 4.02995C8.16 1.90995 9.88 0.199951 11.99 0.199951C14.1 0.199951 15.82 1.91995 15.82 4.02995C15.82 6.13995 14.1 7.85995 11.99 7.85995C9.88 7.85995 8.16 6.13995 8.16 4.02995ZM11.99 1.19995C10.43 1.19995 9.16 2.46995 9.16 4.02995C9.16 5.58995 10.43 6.85995 11.99 6.85995C13.55 6.85995 14.82 5.58995 14.82 4.02995C14.82 2.46995 13.55 1.19995 11.99 1.19995ZM4.1 2.52995C3.78 2.52995 3.5 2.80995 3.5 3.12995V12.93C3.5 13.25 3.78 13.53 4.1 13.53H11.9C12.22 13.53 12.5 13.25 12.5 12.93V8.72995C12.5 8.44995 12.72 8.22995 13 8.22995C13.28 8.22995 13.5 8.44995 13.5 8.72995V12.93C13.5 13.81 12.78 14.53 11.9 14.53H4.1C3.22 14.53 2.5 13.81 2.5 12.93V3.12995C2.5 2.24995 3.22 1.52995 4.1 1.52995H7.63C7.91 1.52995 8.13 1.74995 8.13 2.02995C8.13 2.30995 7.91 2.52995 7.63 2.52995H4.1ZM10.83 4.35995C10.83 4.07995 11.05 3.85995 11.33 3.85995H11.83C12.2 3.85995 12.5 4.15995 12.5 4.52995V5.35995C12.5 5.63995 12.28 5.85995 12 5.85995C11.72 5.85995 11.5 5.63995 11.5 5.35995V4.85995H11.33C11.05 4.85995 10.83 4.63995 10.83 4.35995ZM7 8.68995C7 8.40995 7.22 8.18995 7.5 8.18995H9.17C9.45 8.18995 9.67 8.40995 9.67 8.68995C9.67 8.96995 9.45 9.18995 9.17 9.18995H7.5C7.22 9.18995 7 8.96995 7 8.68995ZM7 11.36C7 11.08 7.22 10.86 7.5 10.86H10.5C10.78 10.86 11 11.08 11 11.36C11 11.64 10.78 11.86 10.5 11.86H7.5C7.22 11.86 7 11.64 7 11.36Z";
  const IconPathListOutlined = "M5.5 7.40001C5.15 7.40001 4.9 7.69001 4.9 7.98001C4.9 8.27001 5.2 8.56001 5.5 8.56001C5.8 8.56001 6.1 8.27001 6.1 7.98001C6.1 7.69001 5.85 7.40001 5.5 7.40001ZM5.5 5.00001C5.15 5.00001 4.9 5.29001 4.9 5.58001C4.9 5.87001 5.2 6.16001 5.5 6.16001C5.8 6.16001 6.1 5.87001 6.1 5.58001C6.1 5.29001 5.85 5.00001 5.5 5.00001ZM5.5 9.80001C5.15 9.80001 4.9 10.09 4.9 10.38C4.9 10.67 5.2 10.96 5.5 10.96C5.8 10.96 6.1 10.67 6.1 10.38C6.1 10.09 5.85 9.80001 5.5 9.80001ZM3.5 3.20001C3.21 3.20001 3 3.43001 3 3.66001V12.3C3 12.53 3.21 12.76 3.5 12.76H12.5C12.79 12.76 13 12.53 13 12.3V3.66001C13 3.43001 12.79 3.20001 12.5 3.20001H3.5ZM2 3.66001C2 2.84001 2.69 2.20001 3.5 2.20001H12.5C13.31 2.20001 14 2.84001 14 3.66001V12.3C14 13.12 13.31 13.76 12.5 13.76H3.5C2.69 13.76 2 13.12 2 12.3V3.66001ZM7 5.58001C7 5.30001 7.22 5.08001 7.5 5.08001H10.5C10.78 5.08001 11 5.30001 11 5.58001C11 5.86001 10.78 6.08001 10.5 6.08001H7.5C7.22 6.08001 7 5.86001 7 5.58001ZM7 7.98001C7 7.70001 7.22 7.48001 7.5 7.48001H10.5C10.78 7.48001 11 7.70001 11 7.98001C11 8.26001 10.78 8.48001 10.5 8.48001H7.5C7.22 8.48001 7 8.26001 7 7.98001ZM7 10.38C7 10.1 7.22 9.88001 7.5 9.88001H10.5C10.78 9.88001 11 10.1 11 10.38C11 10.66 10.78 10.88 10.5 10.88H7.5C7.22 10.88 7 10.66 7 10.38Z";
  const IconPathLoading = "M8 3.1731C5.21921 3.1731 3 5.33228 3 7.95312C3 8.22926 2.77614 8.45312 2.5 8.45312C2.22386 8.45312 2 8.22926 2 7.95312C2 4.74191 4.70579 2.1731 8 2.1731C11.2942 2.1731 14 4.74191 14 7.95312C14 11.1643 11.2942 13.7331 8 13.7331C7.72386 13.7331 7.5 13.5093 7.5 13.2331C7.5 12.957 7.72386 12.7331 8 12.7331C10.7808 12.7331 13 10.5739 13 7.95312C13 5.33228 10.7808 3.1731 8 3.1731Z";
  const IconPathLocation = "M7.7701 14.36L7.9901 14.46L8.2101 14.36H8.2201C8.2201 14.36 8.2501 14.34 8.2701 14.33C8.3101 14.31 8.3701 14.28 8.4401 14.24C8.5901 14.16 8.8001 14.04 9.0501 13.89C9.5501 13.58 10.2201 13.13 10.8901 12.54C12.2101 11.38 13.6301 9.60002 13.6301 7.33002C13.6301 4.31002 11.0901 1.90002 7.9901 1.90002C4.8901 1.90002 2.3501 4.31002 2.3501 7.33002C2.3501 9.60002 3.7701 11.37 5.0901 12.54C5.7601 13.13 6.4301 13.58 6.9301 13.89C7.1801 14.04 7.3901 14.16 7.5401 14.24C7.6101 14.28 7.6701 14.31 7.7101 14.33C7.7301 14.34 7.7501 14.35 7.7601 14.35H7.7701V14.36ZM7.9901 2.90002C5.4101 2.90002 3.3501 4.90002 3.3501 7.33002C3.3501 9.17002 4.5001 10.69 5.7501 11.79C6.3701 12.33 6.9801 12.75 7.4501 13.04C7.6701 13.18 7.8601 13.28 7.9901 13.35C8.1201 13.28 8.3101 13.17 8.5301 13.04C8.9901 12.75 9.6101 12.33 10.2301 11.79C11.4801 10.69 12.6301 9.17002 12.6301 7.33002C12.6301 4.90002 10.5701 2.89002 7.9901 2.89002V2.90002ZM7.9901 4.37002C6.3101 4.37002 4.9201 5.68002 4.9201 7.34002C4.9201 9.00002 6.3101 10.31 7.9901 10.31C9.6701 10.31 11.0601 9.00002 11.0601 7.34002C11.0601 5.68002 9.6701 4.37002 7.9901 4.37002ZM7.9901 5.37002C6.8301 5.37002 5.9201 6.27002 5.9201 7.34002C5.9201 8.41002 6.8301 9.31002 7.9901 9.31002C9.1501 9.31002 10.0601 8.41002 10.0601 7.34002C10.0601 6.27002 9.1501 5.37002 7.9901 5.37002Z";
  const IconPathLocked = "M8 2.5C6.87614 2.5 6 3.37614 6 4.5V6H10V4.5C10 3.37614 9.12386 2.5 8 2.5ZM11 6V4.5C11 2.82386 9.67614 1.5 8 1.5C6.32386 1.5 5 2.82386 5 4.5V6H4C3.17386 6 2.5 6.67386 2.5 7.5V12.5C2.5 13.3261 3.17386 14 4 14H12C12.8261 14 13.5 13.3261 13.5 12.5V7.5C13.5 6.67386 12.8261 6 12 6H11ZM4 7C3.72614 7 3.5 7.22614 3.5 7.5V12.5C3.5 12.7739 3.72614 13 4 13H12C12.2739 13 12.5 12.7739 12.5 12.5V7.5C12.5 7.22614 12.2739 7 12 7H4ZM6 10C6 8.89546 6.89546 8 8 8C9.10454 8 10 8.89546 10 10C10 11.1045 9.10454 12 8 12C6.89546 12 6 11.1045 6 10ZM8 9C7.44774 9 7 9.44774 7 10C7 10.5523 7.44774 11 8 11C8.55226 11 9 10.5523 9 10C9 9.44774 8.55226 9 8 9Z";
  const IconPathLogin = "M6.33268 2.96716C6.33268 2.69102 6.55654 2.46716 6.83268 2.46716H12.166C12.4422 2.46716 12.666 2.69102 12.666 2.96716V13.5271C12.666 13.8033 12.4422 14.0271 12.166 14.0271H6.83268C6.55654 14.0271 6.33268 13.8033 6.33268 13.5271C6.33268 13.251 6.55654 13.0271 6.83268 13.0271H11.666V3.46716H6.83268C6.55654 3.46716 6.33268 3.24331 6.33268 2.96716ZM5.47266 5.23382C5.66792 5.03856 5.98451 5.03856 6.17977 5.23382L9.18497 8.23902L6.16014 11.2639C5.96488 11.4591 5.64829 11.4591 5.45303 11.2639C5.25777 11.0686 5.25777 10.752 5.45303 10.5568L7.27076 8.73902H2C1.72386 8.73902 1.5 8.51517 1.5 8.23902C1.5 7.96288 1.72386 7.73902 2 7.73902H7.27076L5.47266 5.94093C5.2774 5.74567 5.2774 5.42908 5.47266 5.23382Z";
  const IconPathMachineAirCon = "M1.5 5C1.5 4.17157 2.17157 3.5 3 3.5H13C13.8284 3.5 14.5 4.17157 14.5 5V8C14.5 8.82843 13.8284 9.5 13 9.5H3C2.17157 9.5 1.5 8.82843 1.5 8V5ZM3 4.5C2.72386 4.5 2.5 4.72386 2.5 5V8C2.5 8.27614 2.72386 8.5 3 8.5H13C13.2761 8.5 13.5 8.27614 13.5 8V5C13.5 4.72386 13.2761 4.5 13 4.5H3ZM3.5 7C3.5 6.72386 3.72386 6.5 4 6.5H12C12.2761 6.5 12.5 6.72386 12.5 7C12.5 7.27614 12.2761 7.5 12 7.5H4C3.72386 7.5 3.5 7.27614 3.5 7ZM11.2783 10.584C11.508 10.7372 11.5701 11.0476 11.417 11.2773L10.9717 11.9453C10.9652 11.9549 10.9649 11.96 10.9649 11.9626C10.9647 11.9669 10.9658 11.9737 10.9699 11.9814C10.974 11.9891 10.9791 11.9938 10.9828 11.9961C10.9849 11.9974 10.9894 12 11.0009 12C11.8277 12 12.3209 12.9215 11.8623 13.6094L11.417 14.2774C11.2638 14.5071 10.9533 14.5692 10.7236 14.416C10.4938 14.2628 10.4317 13.9524 10.5849 13.7226L11.0302 13.0547C11.0366 13.0451 11.0369 13.04 11.037 13.0374C11.0371 13.0331 11.0361 13.0263 11.0319 13.0186C11.0278 13.0109 11.0227 13.0062 11.0191 13.0039C11.0169 13.0026 11.0125 13 11.0009 13C10.1741 13 9.68098 12.0785 10.1396 11.3906L10.5849 10.7227C10.7381 10.4929 11.0485 10.4308 11.2783 10.584ZM5.27828 10.584C5.50804 10.7372 5.57013 11.0476 5.41695 11.2773L4.97165 11.9453C4.96524 11.9549 4.96493 11.96 4.96485 11.9626C4.96473 11.9669 4.9658 11.9737 4.96991 11.9814C4.97401 11.9891 4.97912 11.9938 4.98278 11.9961C4.98493 11.9974 4.98938 12 5.00093 12C5.82772 12 6.32088 12.9215 5.86225 13.6094L5.41695 14.2774C5.26378 14.5071 4.95334 14.5692 4.72358 14.416C4.49381 14.2628 4.43173 13.9524 4.5849 13.7226L5.0302 13.0547C5.03661 13.0451 5.03693 13.04 5.037 13.0374C5.03713 13.0331 5.03605 13.0263 5.03195 13.0186C5.02784 13.0109 5.02274 13.0062 5.01908 13.0039C5.01693 13.0026 5.01248 13 5.00093 13C4.17413 13 3.68098 12.0785 4.1396 11.3906L4.5849 10.7227C4.73808 10.4929 5.04851 10.4308 5.27828 10.584ZM8.27828 10.584C8.50804 10.7372 8.57013 11.0476 8.41695 11.2773L7.97165 11.9453C7.96524 11.9549 7.96493 11.96 7.96485 11.9626C7.96473 11.9669 7.9658 11.9737 7.96991 11.9814C7.97401 11.9891 7.97912 11.9938 7.98278 11.9961C7.98493 11.9974 7.98938 12 8.00093 12C8.82772 12 9.32088 12.9215 8.86225 13.6094L8.41695 14.2774C8.26378 14.5071 7.95334 14.5692 7.72358 14.416C7.49381 14.2628 7.43173 13.9524 7.5849 13.7226L8.0302 13.0547C8.03661 13.0451 8.03693 13.04 8.037 13.0374C8.03713 13.0331 8.03605 13.0263 8.03195 13.0186C8.02784 13.0109 8.02274 13.0062 8.01908 13.0039C8.01693 13.0026 8.01248 13 8.00093 13C7.17413 13 6.68098 12.0785 7.1396 11.3906L7.5849 10.7227C7.73808 10.4929 8.04851 10.4308 8.27828 10.584Z";
  const IconPathMachineDish = "M2.5 2C2.5 1.72386 2.72386 1.5 3 1.5H13C13.2761 1.5 13.5 1.72386 13.5 2V14C13.5 14.2761 13.2761 14.5 13 14.5H3C2.72386 14.5 2.5 14.2761 2.5 14V2ZM3.5 4.5V13.5H12.5V4.5H3.5ZM6.5 3.5H3.5V2.5H6.5V3.5ZM7.5 3.5H8.5V2.5H7.5V3.5ZM9.5 2.5V3.5H12.5V2.5H9.5ZM6.25131 5.10775C6.49004 5.24654 6.57105 5.55258 6.43225 5.79131L5.93225 6.65131C5.79346 6.89004 5.48742 6.97105 5.24869 6.83225C5.00996 6.69346 4.92895 6.38742 5.06775 6.14869L5.56775 5.28869C5.70654 5.04996 6.01258 4.96895 6.25131 5.10775ZM9.74869 5.10775C9.98742 4.96895 10.2935 5.04996 10.4323 5.28869L10.9323 6.14869C11.071 6.38742 10.99 6.69346 10.7513 6.83225C10.5126 6.97105 10.2065 6.89004 10.0677 6.65131L9.56775 5.79131C9.42895 5.55258 9.50996 5.24654 9.74869 5.10775ZM8 5.5C8.27614 5.5 8.5 5.72386 8.5 6V7C8.5 7.27614 8.27614 7.5 8 7.5C7.72386 7.5 7.5 7.27614 7.5 7V6C7.5 5.72386 7.72386 5.5 8 5.5Z";
  const IconPathMachineDryer = "M2.5 2C2.5 1.72386 2.72386 1.5 3 1.5H13C13.2761 1.5 13.5 1.72386 13.5 2V14C13.5 14.2761 13.2761 14.5 13 14.5H3C2.72386 14.5 2.5 14.2761 2.5 14V2ZM3.5 2.5V13.5H12.5V2.5H3.5ZM5.5 3.5C5.77614 3.5 6 3.72386 6 4V4.01C6 4.28614 5.77614 4.51 5.5 4.51C5.22386 4.51 5 4.28614 5 4.01V4C5 3.72386 5.22386 3.5 5.5 3.5ZM7.5 4C7.5 3.72386 7.72386 3.5 8 3.5H8.01C8.28614 3.5 8.51 3.72386 8.51 4C8.51 4.27614 8.28614 4.5 8.01 4.5H8C7.72386 4.5 7.5 4.27614 7.5 4ZM10 4C10 3.72386 10.2239 3.5 10.5 3.5H10.51C10.7861 3.5 11.01 3.72386 11.01 4C11.01 4.27614 10.7861 4.5 10.51 4.5H10.5C10.2239 4.5 10 4.27614 10 4ZM8 6.5C6.61929 6.5 5.5 7.61929 5.5 9C5.5 10.3807 6.61929 11.5 8 11.5C9.20948 11.5 10.2184 10.6411 10.45 9.5H9.33333C9.05719 9.5 8.83333 9.27614 8.83333 9C8.83333 8.72386 9.05719 8.5 9.33333 8.5H10.45C10.2184 7.35888 9.20948 6.5 8 6.5ZM4.5 9C4.5 7.067 6.067 5.5 8 5.5C9.933 5.5 11.5 7.067 11.5 9C11.5 10.933 9.933 12.5 8 12.5C6.067 12.5 4.5 10.933 4.5 9Z";
  const IconPathMachineWaching = "M2.5 2C2.5 1.72386 2.72386 1.5 3 1.5H13C13.2761 1.5 13.5 1.72386 13.5 2V14C13.5 14.2761 13.2761 14.5 13 14.5H3C2.72386 14.5 2.5 14.2761 2.5 14V2ZM3.5 4.5V13.5H12.5V4.5H3.5ZM5.5 3.5H3.5V2.5H5.5V3.5ZM6.5 3.5H12.5V2.5H6.5V3.5ZM8 6.5C6.61929 6.5 5.5 7.61929 5.5 9C5.5 10.3807 6.61929 11.5 8 11.5C9.20948 11.5 10.2184 10.6411 10.45 9.5H9.33333C9.05719 9.5 8.83333 9.27614 8.83333 9C8.83333 8.72386 9.05719 8.5 9.33333 8.5H10.45C10.2184 7.35888 9.20948 6.5 8 6.5ZM4.5 9C4.5 7.067 6.067 5.5 8 5.5C9.933 5.5 11.5 7.067 11.5 9C11.5 10.933 9.933 12.5 8 12.5C6.067 12.5 4.5 10.933 4.5 9Z";
  const IconPathMail = "M3.40209 4.11523L7.99222 7.31985C7.99229 7.31989 7.99484 7.3216 7.9998 7.3216C8.00471 7.3216 8.00737 7.32012 8.00804 7.31966C8.00803 7.31967 8.00805 7.31966 8.00804 7.31966L12.5979 4.11523H3.40209ZM13.5 4.70503L8.58022 8.13979C8.23324 8.38168 7.76708 8.38245 7.41978 8.13979L2.5 4.70503V11.2953C2.5 11.5305 2.70422 11.7553 3 11.7553H13C13.2958 11.7553 13.5 11.5305 13.5 11.2953V4.70503ZM1.5 4.57523C1.5 3.74965 2.19079 3.11523 3 3.11523H13C13.8093 3.11523 14.5 3.74966 14.5 4.57523V11.2953C14.5 12.1208 13.8093 12.7553 13 12.7553H3C2.19078 12.7553 1.5 12.1208 1.5 11.2953V4.57523Z";
  const IconPathMailResend = "M3.57333 4.5L7.99441 7.81581C7.99422 7.81569 7.99462 7.81594 7.99441 7.81581C7.99463 7.81567 7.99544 7.81591 7.99567 7.81575L12.4252 4.5H3.57333ZM13.5 4.94457V12C13.5 12.2761 13.7239 12.5 14 12.5C14.2761 12.5 14.5 12.2761 14.5 12V4.89C14.5 4.0705 13.7696 3.5 13 3.5H3C2.23042 3.5 1.5 4.0705 1.5 4.89V11.11C1.5 11.9295 2.23042 12.5 3 12.5H10.4929L9.34645 13.6464C9.15118 13.8417 9.15118 14.1583 9.34645 14.3536C9.54171 14.5488 9.85829 14.5488 10.0536 14.3536L12.0536 12.3536C12.2488 12.1583 12.2488 11.8417 12.0536 11.6464L10.0536 9.64645C9.85829 9.45118 9.54171 9.45118 9.34645 9.64645C9.15118 9.84171 9.15118 10.1583 9.34645 10.3536L10.4929 11.5H3C2.66958 11.5 2.5 11.2705 2.5 11.11V4.945L7.4 8.62L7.40725 8.62534C7.76201 8.88155 8.22799 8.88155 8.58275 8.62534L13.5 4.94457Z";
  const IconPathMaintainance = "M11.1715 2.04018C9.67837 1.65407 8.01092 2.01738 6.82814 3.15227C5.60941 4.32228 5.23015 6.00107 5.69721 7.48871L2.03788 10.5751L2.03627 10.5765C1.36972 11.1316 1.30652 12.1316 1.94156 12.7412L3.24756 13.995C3.86725 14.5899 4.87047 14.5364 5.44226 13.9057L5.4438 13.904L5.45194 13.8952L8.67476 10.3746C10.2103 10.8309 11.9542 10.4789 13.1776 9.30445C14.3628 8.16668 14.7513 6.54837 14.3427 5.09162C14.3017 4.94517 14.1961 4.82538 14.0561 4.76614C13.916 4.70689 13.7565 4.71464 13.6228 4.78719L11.264 6.06729L10.1628 5.01012L11.4772 2.77796C11.5568 2.6427 11.5683 2.47789 11.5082 2.33287C11.4482 2.18786 11.3235 2.07947 11.1715 2.04018ZM8.157 9.45918C8.29544 9.30791 8.51221 9.2565 8.70384 9.3295C9.97226 9.81268 11.4681 9.55931 12.485 8.58306C13.2267 7.87112 13.5594 6.92255 13.4912 5.99639L11.4198 7.12049C11.2285 7.2243 10.9921 7.19245 10.835 7.04173L9.18505 5.45775C9.0179 5.29729 8.98289 5.04301 9.10046 4.84335L10.2452 2.8994C9.26407 2.83375 8.26441 3.16009 7.52058 3.87374C6.50773 4.84618 6.25419 6.26127 6.74789 7.4553C6.83105 7.65642 6.77456 7.88823 6.60819 8.02855L2.67678 11.3444C2.44784 11.5345 2.44765 11.8409 2.63409 12.0199L3.94009 13.2736C4.14132 13.4668 4.49769 13.4601 4.70241 13.2329L4.70958 13.2251L4.71562 13.2185L8.157 9.45918Z";
  const IconPathMap = "M13.7783 2.55176C13.9168 2.64458 14 2.80038 14 2.96717V12.5671C14 12.7924 13.8494 12.9898 13.6322 13.0493L10.2909 13.9656C10.2908 13.9657 10.2908 13.9657 10.2907 13.9657C10.0883 14.0213 9.87368 14.0127 9.67674 13.9421L9.67618 13.9419L6.012 12.6229L2.69024 13.9895C2.53601 14.053 2.36028 14.0354 2.22172 13.9425C2.08316 13.8497 2 13.6939 2 13.5271V3.92717C2 3.70195 2.15057 3.50453 2.36777 3.44497L5.70895 2.52874C5.70903 2.52872 5.70911 2.52869 5.70918 2.52867C5.70922 2.52866 5.70925 2.52866 5.70928 2.52865C5.91188 2.47301 6.1264 2.48167 6.32311 2.55213L6.32385 2.5524L9.988 3.87144L13.3098 2.50477C13.464 2.44131 13.6397 2.45894 13.7783 2.55176ZM9.5 4.75858L6.5 3.67863V11.7357L9.5 12.8157V4.75858ZM10.5 12.8714V4.74212L13 3.71354V12.1858L10.5 12.8714ZM5.5 11.7522V3.62295L3 4.30851V12.7808L5.5 11.7522Z";
  const IconPathMenu = "M3.5 5.41479C3.5 5.13865 3.72386 4.91479 4 4.91479H12C12.2761 4.91479 12.5 5.13865 12.5 5.41479C12.5 5.69094 12.2761 5.91479 12 5.91479H4C3.72386 5.91479 3.5 5.69094 3.5 5.41479ZM2 8.29477C2 8.01863 2.22386 7.79477 2.5 7.79477H13.5C13.7761 7.79477 14 8.01863 14 8.29477C14 8.57091 13.7761 8.79477 13.5 8.79477H2.5C2.22386 8.79477 2 8.57091 2 8.29477ZM3.5 11.1748C3.5 10.8986 3.72386 10.6748 4 10.6748H12C12.2761 10.6748 12.5 10.8986 12.5 11.1748C12.5 11.4509 12.2761 11.6748 12 11.6748H4C3.72386 11.6748 3.5 11.4509 3.5 11.1748Z";
  const IconPathModeLight = "M8.0201 0.850006C8.3001 0.850006 8.5201 1.07001 8.5201 1.35001V2.68001C8.5201 2.96001 8.3001 3.18001 8.0201 3.18001C7.7401 3.18001 7.5201 2.96001 7.5201 2.68001V1.35001C7.5201 1.07001 7.7401 0.850006 8.0201 0.850006ZM13.0901 2.95001C13.2901 3.15001 13.2901 3.46001 13.0901 3.66001L12.1501 4.60001C11.9501 4.80001 11.6401 4.80001 11.4401 4.60001C11.2401 4.40001 11.2401 4.09001 11.4401 3.89001L12.3801 2.95001C12.5801 2.75001 12.8901 2.75001 13.0901 2.95001ZM2.9501 2.95001C3.1501 2.75001 3.4601 2.75001 3.6601 2.95001L4.6001 3.89001C4.8001 4.09001 4.8001 4.40001 4.6001 4.60001C4.4001 4.80001 4.0901 4.80001 3.8901 4.60001L2.9501 3.66001C2.7501 3.46001 2.7501 3.15001 2.9501 2.95001ZM8.0201 5.18001C6.4601 5.18001 5.1901 6.45001 5.1901 8.01001C5.1901 9.57001 6.4601 10.84 8.0201 10.84C9.5801 10.84 10.8501 9.57001 10.8501 8.01001C10.8501 6.45001 9.5801 5.18001 8.0201 5.18001ZM4.1901 8.01001C4.1901 5.89001 5.9101 4.18001 8.0201 4.18001C10.1301 4.18001 11.8501 5.90001 11.8501 8.01001C11.8501 10.12 10.1301 11.84 8.0201 11.84C5.9101 11.84 4.1901 10.12 4.1901 8.01001ZM0.860098 8.01001C0.860098 7.73001 1.0801 7.51001 1.3601 7.51001H2.6901C2.9701 7.51001 3.1901 7.73001 3.1901 8.01001C3.1901 8.29001 2.9701 8.51001 2.6901 8.51001H1.3501C1.0701 8.51001 0.850098 8.29001 0.850098 8.01001H0.860098ZM12.8601 8.01001C12.8601 7.73001 13.0801 7.51001 13.3601 7.51001H14.6901C14.9701 7.51001 15.1901 7.73001 15.1901 8.01001C15.1901 8.29001 14.9701 8.51001 14.6901 8.51001H13.3601C13.0801 8.51001 12.8601 8.29001 12.8601 8.01001ZM4.6101 11.43C4.8101 11.63 4.8101 11.94 4.6101 12.14L3.6701 13.08C3.4701 13.28 3.1601 13.28 2.9601 13.08C2.7601 12.88 2.7601 12.57 2.9601 12.37L3.9001 11.43C4.1001 11.23 4.4101 11.23 4.6101 11.43ZM11.4501 11.43C11.6501 11.23 11.9601 11.23 12.1601 11.43L13.1001 12.37C13.3001 12.57 13.3001 12.88 13.1001 13.08C12.9001 13.28 12.5901 13.28 12.3901 13.08L11.4501 12.14C11.2501 11.94 11.2501 11.63 11.4501 11.43ZM8.0301 12.85C8.3101 12.85 8.5301 13.07 8.5301 13.35V14.68C8.5301 14.96 8.3101 15.18 8.0301 15.18C7.7501 15.18 7.5301 14.96 7.5301 14.68V13.35C7.5301 13.07 7.7501 12.85 8.0301 12.85Z";
  const IconPathMoreHorizontal = "M2.75 7.97C2.75 7.28 3.33 6.75 4 6.75C4.67 6.75 5.25 7.28 5.25 7.97C5.25 8.66 4.67 9.19 4 9.19C3.33 9.19 2.75 8.66 2.75 7.97ZM6.75 7.97C6.75 7.28 7.33 6.75 8 6.75C8.67 6.75 9.25 7.28 9.25 7.97C9.25 8.66 8.67 9.19 8 9.19C7.33 9.19 6.75 8.66 6.75 7.97ZM10.75 7.97C10.75 7.28 11.33 6.75 12 6.75C12.67 6.75 13.25 7.28 13.25 7.97C13.25 8.66 12.67 9.19 12 9.19C11.33 9.19 10.75 8.66 10.75 7.97Z";
  const IconPathMoreVertical = "M7.97 13.25C7.28 13.25 6.75 12.67 6.75 12C6.75 11.33 7.28 10.75 7.97 10.75C8.66 10.75 9.19 11.33 9.19 12C9.19 12.67 8.66 13.25 7.97 13.25ZM7.97 9.25C7.28 9.25 6.75 8.67 6.75 8C6.75 7.33 7.28 6.75 7.97 6.75C8.66 6.75 9.19 7.33 9.19 8C9.19 8.67 8.66 9.25 7.97 9.25ZM7.97 5.25C7.28 5.25 6.75 4.67 6.75 4C6.75 3.33 7.28 2.75 7.97 2.75C8.66 2.75 9.19 3.33 9.19 4C9.19 4.67 8.66 5.25 7.97 5.25Z";
  const IconPathMyLocation = "M8.5,10c1.1,0,2-0.9,2-2s-0.9-2-2-2s-2,0.9-2,2S7.4,10,8.5,10z M8,13v1c0,0.3,0.2,0.5,0.5,0.5S9,14.3,9,14v-1c2.4-0.2,4.2-2.1,4.5-4.5h1C14.8,8.5,15,8.3,15,8s-0.2-0.5-0.5-0.5h-1C13.2,5.1,11.4,3.3,9,3V2c0-0.3-0.2-0.5-0.5-0.5S8,1.7,8,2v1C5.6,3.3,3.8,5.1,3.5,7.5h-1C2.2,7.5,2,7.7,2,8s0.2,0.5,0.5,0.5h1C3.8,10.9,5.6,12.7,8,13z M12.5,8c0,2.2-1.8,4-4,4s-4-1.8-4-4c0-2.2,1.8-4,4-4S12.5,5.8,12.5,8z";
  const IconPathNavigateBack = "M13.0251 8C13.0251 7.72386 12.8013 7.5 12.5251 7.5H5.05827L8.56586 3.84626C8.7571 3.64706 8.75064 3.33054 8.55143 3.13931C8.35223 2.94807 8.03571 2.95453 7.84447 3.15373L3.19206 8L7.84447 12.8463C8.03571 13.0455 8.35223 13.0519 8.55143 12.8607C8.75064 12.6695 8.7571 12.3529 8.56586 12.1537L5.05827 8.5H12.5251C12.8013 8.5 13.0251 8.27614 13.0251 8Z";
  const IconPathNavigateDown = "M8 3.47479C8.27614 3.47479 8.5 3.69865 8.5 3.97479V11.4417L12.1537 7.93408C12.3529 7.74284 12.6695 7.7493 12.8607 7.94851C13.0519 8.14771 13.0455 8.46423 12.8463 8.65547L8 13.3079L3.15373 8.65547C2.95453 8.46423 2.94807 8.14771 3.13931 7.94851C3.33054 7.7493 3.64706 7.74284 3.84627 7.93408L7.5 11.4417V3.97479C7.5 3.69865 7.72386 3.47479 8 3.47479Z";
  const IconPathNavigateLeft = "M12.5254 8C12.5254 7.72386 12.3015 7.5 12.0254 7.5H4.55852L8.0661 3.84626C8.25734 3.64706 8.25088 3.33054 8.05168 3.13931C7.85247 2.94807 7.53595 2.95453 7.34472 3.15373L2.6923 8L7.34472 12.8463C7.53595 13.0455 7.85247 13.0519 8.05168 12.8607C8.25088 12.6695 8.25734 12.3529 8.0661 12.1537L4.55852 8.5H12.0254C12.3015 8.5 12.5254 8.27614 12.5254 8Z";
  const IconPathNavigateRight = "M3.47461 8C3.47461 7.72386 3.69847 7.5 3.97461 7.5L11.4415 7.5L7.9339 3.84626C7.74266 3.64706 7.74912 3.33054 7.94832 3.13931C8.14753 2.94807 8.46405 2.95453 8.65528 3.15373L13.3077 8L8.65528 12.8463C8.46405 13.0455 8.14753 13.0519 7.94832 12.8607C7.74912 12.6695 7.74266 12.3529 7.9339 12.1537L11.4415 8.5H3.97461C3.69847 8.5 3.47461 8.27614 3.47461 8Z";
  const IconPathNavigateUp = "M8 12.5252C8.27614 12.5252 8.5 12.3013 8.5 12.0252V4.55834L12.1537 8.06592C12.3529 8.25716 12.6695 8.2507 12.8607 8.05149C13.0519 7.85229 13.0455 7.53577 12.8463 7.34453L8 2.69212L3.15373 7.34453C2.95453 7.53577 2.94807 7.85229 3.13931 8.05149C3.33054 8.2507 3.64706 8.25716 3.84627 8.06592L7.5 4.55834V12.0252C7.5 12.3013 7.72386 12.5252 8 12.5252Z";
  const IconPathNotifications = "M7.99939 1.50708C8.27553 1.50708 8.49939 1.73094 8.49939 2.00708V2.97369C10.7342 3.21294 12.4994 5.0367 12.4994 7.28706V9.82389C12.4994 9.92313 12.5343 10.0215 12.6021 10.103L13.3381 10.9872C13.8956 11.6584 13.3658 12.5871 12.5634 12.5871H10.2925C10.297 12.6439 10.2993 12.7012 10.2993 12.7591C10.2993 14.0085 9.24997 14.9871 7.99926 14.9871C6.74855 14.9871 5.69926 14.0085 5.69926 12.7591C5.69926 12.7012 5.70152 12.6439 5.70599 12.5871H3.43538C2.63359 12.5871 2.1022 11.6591 2.66045 10.9878L3.39624 10.1039C3.46455 10.0217 3.49938 9.92302 3.49938 9.82389V7.28706C3.49938 5.0367 5.26458 3.21293 7.49939 2.97369V2.00708C7.49939 1.73094 7.72325 1.50708 7.99939 1.50708ZM6.71175 12.5871C6.70352 12.643 6.69926 12.7004 6.69926 12.7591C6.69926 13.4181 7.26197 13.9871 7.99926 13.9871C8.73655 13.9871 9.29926 13.4181 9.29926 12.7591C9.29926 12.7003 9.295 12.643 9.28679 12.5871H6.71175ZM7.99939 3.94708C6.04708 3.94708 4.49938 5.46163 4.49938 7.28706V9.82389C4.49938 10.1606 4.38021 10.4843 4.16551 10.7428L3.46276 11.5871H12.5363L11.8336 10.7428C11.8336 10.7428 11.8336 10.7429 11.8336 10.7428C11.6185 10.4845 11.4994 10.1605 11.4994 9.82389V7.28706C11.4994 5.46162 9.95168 3.94708 7.99939 3.94708Z";
  const IconPathOpenInFull = "M9.25 2.96716C9.25 2.69102 9.47386 2.46716 9.75 2.46716H14V6.56713C14 6.84327 13.7761 7.06713 13.5 7.06713C13.2239 7.06713 13 6.84327 13 6.56713V4.14027L3.74283 13.0271L6.25 13.0271C6.52614 13.0271 6.75 13.251 6.75 13.5271C6.75 13.8033 6.52614 14.0271 6.25 14.0271L2 14.0271L2 9.92716C2 9.65102 2.22386 9.42716 2.5 9.42716C2.77614 9.42716 3 9.65102 3 9.92716L3 12.354L12.2572 3.46716H9.75C9.47386 3.46716 9.25 3.24331 9.25 2.96716Z";
  const IconPathOpenInNew = "M3.5 3.46716C3.20671 3.46716 3 3.69435 3 3.92716V12.5671C3 12.7999 3.20671 13.0271 3.5 13.0271H12.5C12.7933 13.0271 13 12.7999 13 12.5671V8.91913C13 8.64299 13.2239 8.41913 13.5 8.41913C13.7761 8.41913 14 8.64299 14 8.91913V12.5671C14 13.3903 13.3067 14.0271 12.5 14.0271H3.5C2.69329 14.0271 2 13.3903 2 12.5671V3.92716C2 3.10398 2.69329 2.46716 3.5 2.46716H7.3C7.57614 2.46716 7.8 2.69102 7.8 2.96716C7.8 3.24331 7.57614 3.46716 7.3 3.46716H3.5ZM9.25 2.96716C9.25 2.69102 9.47386 2.46716 9.75 2.46716H14V6.56713C14 6.84327 13.7761 7.06713 13.5 7.06713C13.2239 7.06713 13 6.84327 13 6.56713V4.14027L6.84627 10.0478C6.64706 10.2391 6.33054 10.2326 6.13931 10.0334C5.94807 9.83419 5.95453 9.51767 6.15374 9.32644L12.2572 3.46716H9.75C9.47386 3.46716 9.25 3.24331 9.25 2.96716Z";
  const IconPathOrder = "M5 2.16675H8.83333C9.10948 2.16675 9.33333 2.39061 9.33333 2.66675V4.32306C9.33333 4.59921 9.10948 4.82306 8.83333 4.82306H6V9.29615C6 9.57229 5.77614 9.79615 5.5 9.79615C5.22386 9.79615 5 9.57229 5 9.29615V7.14627H3C2.70371 7.14627 2.5 7.37364 2.5 7.60031V12.3794C2.5 12.606 2.70371 12.8334 3 12.8334H13C13.2963 12.8334 13.5 12.606 13.5 12.3794V7.60031C13.5 7.37364 13.2963 7.14627 13 7.14627H7.5C7.22386 7.14627 7 6.92241 7 6.64627C7 6.37013 7.22386 6.14627 7.5 6.14627H13C13.8037 6.14627 14.5 6.77754 14.5 7.60031V12.3794C14.5 13.2021 13.8037 13.8334 13 13.8334H3C2.19629 13.8334 1.5 13.2021 1.5 12.3794V7.60031C1.5 6.77754 2.19629 6.14627 3 6.14627H5V2.16675ZM6 3.82306H8.33333V3.16675H6V3.82306Z";
  const IconPathOrganization = "M14.5 13.7H14V5.19995C14 4.36995 13.33 3.69995 12.5 3.69995H10V3.19995C10 2.36995 9.33 1.69995 8.5 1.69995H3.5C2.67 1.69995 2 2.36995 2 3.19995V13.7H1.5C1.22 13.7 1 13.92 1 14.2C1 14.48 1.22 14.7 1.5 14.7H14.5C14.78 14.7 15 14.48 15 14.2C15 13.92 14.78 13.7 14.5 13.7ZM3 3.19995C3 2.91995 3.22 2.69995 3.5 2.69995H8.5C8.78 2.69995 9 2.91995 9 3.19995V3.69995H7.5C6.67 3.69995 6 4.36995 6 5.19995V13.7H3V3.19995ZM9.1 13.7V11.94C9.1 11.75 8.95 11.6 8.76 11.6H8.25C8.06 11.6 7.91 11.75 7.91 11.94V13.7H7.01V5.19995C7.01 4.91995 7.23 4.69995 7.51 4.69995H12.51C12.79 4.69995 13.01 4.91995 13.01 5.19995V13.7H9.11H9.1ZM9.1 5.89995V6.49995C9.1 6.66995 8.97 6.79995 8.8 6.79995H8.2C8.03 6.79995 7.9 6.66995 7.9 6.49995V5.89995C7.9 5.72995 8.03 5.59995 8.2 5.59995H8.8C8.97 5.59995 9.1 5.72995 9.1 5.89995ZM5.1 3.89995V4.49995C5.1 4.66995 4.97 4.79995 4.8 4.79995H4.2C4.03 4.79995 3.9 4.66995 3.9 4.49995V3.89995C3.9 3.72995 4.03 3.59995 4.2 3.59995H4.8C4.97 3.59995 5.1 3.72995 5.1 3.89995ZM5.1 5.89995V6.49995C5.1 6.66995 4.97 6.79995 4.8 6.79995H4.2C4.03 6.79995 3.9 6.66995 3.9 6.49995V5.89995C3.9 5.72995 4.03 5.59995 4.2 5.59995H4.8C4.97 5.59995 5.1 5.72995 5.1 5.89995ZM5.1 7.89995V8.49995C5.1 8.66995 4.97 8.79995 4.8 8.79995H4.2C4.03 8.79995 3.9 8.66995 3.9 8.49995V7.89995C3.9 7.72995 4.03 7.59995 4.2 7.59995H4.8C4.97 7.59995 5.1 7.72995 5.1 7.89995ZM9.1 7.95995V8.43995C9.1 8.63995 8.94 8.79995 8.74 8.79995H8.26C8.06 8.79995 7.9 8.63995 7.9 8.43995V7.95995C7.9 7.75995 8.06 7.59995 8.26 7.59995H8.74C8.94 7.59995 9.1 7.75995 9.1 7.95995ZM9.1 9.95995V10.44C9.1 10.64 8.94 10.8 8.74 10.8H8.26C8.06 10.8 7.9 10.64 7.9 10.44V9.95995C7.9 9.75995 8.06 9.59995 8.26 9.59995H8.74C8.94 9.59995 9.1 9.75995 9.1 9.95995ZM12.1 5.95995V6.43995C12.1 6.63995 11.94 6.79995 11.74 6.79995H11.26C11.06 6.79995 10.9 6.63995 10.9 6.43995V5.95995C10.9 5.75995 11.06 5.59995 11.26 5.59995H11.74C11.94 5.59995 12.1 5.75995 12.1 5.95995ZM12.1 7.95995V8.43995C12.1 8.63995 11.94 8.79995 11.74 8.79995H11.26C11.06 8.79995 10.9 8.63995 10.9 8.43995V7.95995C10.9 7.75995 11.06 7.59995 11.26 7.59995H11.74C11.94 7.59995 12.1 7.75995 12.1 7.95995ZM12.1 9.95995V10.44C12.1 10.64 11.94 10.8 11.74 10.8H11.26C11.06 10.8 10.9 10.64 10.9 10.44V9.95995C10.9 9.75995 11.06 9.59995 11.26 9.59995H11.74C11.94 9.59995 12.1 9.75995 12.1 9.95995ZM12.1 11.9V12.5C12.1 12.67 11.97 12.8 11.8 12.8H11.2C11.03 12.8 10.9 12.67 10.9 12.5V11.9C10.9 11.73 11.03 11.6 11.2 11.6H11.8C11.97 11.6 12.1 11.73 12.1 11.9Z";
  const IconPathOutletCee16A = "M6.96 10.15C6.96 9.57002 7.43 9.11002 8 9.11002C8.57 9.11002 9.04 9.58002 9.04 10.15C9.04 10.72 8.57 11.19 8 11.19C7.43 11.19 6.96 10.72 6.96 10.15ZM11.17 8.12002C11.31 7.68002 11.07 7.21002 10.63 7.07002C10.19 6.93002 9.72 7.17002 9.58 7.61002C9.44 8.05002 9.68 8.52002 10.12 8.66002C10.56 8.80002 11.03 8.56002 11.17 8.12002ZM9.96 4.96002C9.59 4.69002 9.07 4.77002 8.8 5.14002C8.53 5.51002 8.61 6.03002 8.98 6.30002C9.35 6.57002 9.87 6.49002 10.14 6.12002C10.41 5.75002 10.33 5.23002 9.96 4.96002ZM6.04 4.96002C5.67 5.23002 5.59 5.75002 5.86 6.12002C6.13 6.49002 6.65 6.57002 7.02 6.30002C7.39 6.03002 7.47 5.51002 7.2 5.14002C6.93 4.77002 6.41 4.69002 6.04 4.96002ZM4.83 8.12002C4.97 8.56002 5.44 8.80002 5.88 8.66002C6.32 8.52002 6.56 8.05002 6.42 7.61002C6.28 7.17002 5.81 6.93002 5.37 7.07002C4.93 7.21002 4.69 7.68002 4.83 8.12002ZM8.5 13.13V13.49C8.5 13.77 8.28 13.99 8 13.99C7.72 13.99 7.5 13.77 7.5 13.49V13.13C4.7 12.88 2.5 10.52 2.5 7.66002C2.5 4.62002 4.97 2.15002 8 2.15002C11.03 2.15002 13.5 4.62002 13.5 7.65002C13.5 10.51 11.3 12.87 8.5 13.12V13.13ZM12.5 7.66002C12.5 5.18002 10.48 3.16002 8 3.16002C5.52 3.16002 3.5 5.17002 3.5 7.65002C3.5 10.13 5.52 12.15 8 12.15C10.48 12.15 12.5 10.13 12.5 7.65002V7.66002Z";
  const IconPathOutletCee32A = "M6.75 10.5C6.75 9.81 7.31 9.25 8 9.25C8.69 9.25 9.25 9.81 9.25 10.5C9.25 11.19 8.69 11.75 8 11.75C7.31 11.75 6.75 11.19 6.75 10.5ZM11.8 8.06C11.97 7.53 11.68 6.97 11.16 6.8C10.64 6.63 10.07 6.92 9.9 7.44C9.73 7.96 10.02 8.53 10.54 8.7C11.06 8.87 11.63 8.58 11.8 8.06ZM10.35 4.26C9.9 3.94 9.28 4.03 8.95 4.48C8.62 4.93 8.72 5.55 9.17 5.88C9.62 6.21 10.24 6.11 10.57 5.66C10.9 5.21 10.8 4.59 10.35 4.26ZM5.65 4.26C5.2 4.58 5.1 5.21 5.43 5.66C5.76 6.11 6.38 6.21 6.83 5.88C7.28 5.55 7.38 4.93 7.05 4.48C6.72 4.03 6.1 3.93 5.65 4.26ZM4.2 8.06C4.37 8.59 4.93 8.87 5.46 8.7C5.99 8.53 6.27 7.97 6.1 7.44C5.93 6.91 5.37 6.63 4.84 6.8C4.31 6.97 4.03 7.53 4.2 8.06ZM8.5 13.98V14.51C8.5 14.79 8.28 15.01 8 15.01C7.72 15.01 7.5 14.79 7.5 14.51V13.98C4.15 13.72 1.5 10.92 1.5 7.51C1.5 3.92 4.42 1 8 1C11.58 1 14.5 3.92 14.5 7.5C14.5 11.08 11.85 13.72 8.5 13.97V13.98ZM13.5 7.51C13.5 4.48 11.03 2.01 8 2.01C4.97 2.01 2.5 4.47 2.5 7.5C2.5 10.53 4.97 13 8 13C11.03 13 13.5 10.53 13.5 7.5V7.51Z";
  const IconPathOutletChAdeMo1 = "M12.2325 8.51C12.2325 9.2 11.6725 9.76 10.9825 9.76C10.2925 9.76 9.7325 9.2 9.7325 8.51C9.7325 7.82 10.2925 7.26 10.9825 7.26C11.6725 7.26 12.2325 7.82 12.2325 8.51ZM4.9925 7.26C4.3025 7.26 3.7425 7.82 3.7425 8.51C3.7425 9.2 4.3025 9.76 4.9925 9.76C5.6825 9.76 6.2425 9.2 6.2425 8.51C6.2425 7.82 5.6825 7.26 4.9925 7.26ZM7.8425 12.36L8.8425 11.36C9.0425 11.16 9.0425 10.85 8.8425 10.65C8.6525 10.46 8.3325 10.46 8.1325 10.65L7.1325 11.65C6.9325 11.85 6.9325 12.16 7.1325 12.36C7.2325 12.46 7.3625 12.51 7.4825 12.51C7.6025 12.51 7.7425 12.46 7.8325 12.36H7.8425ZM8.8425 12.36C9.0425 12.16 9.0425 11.85 8.8425 11.65L7.8425 10.65C7.6525 10.46 7.3325 10.46 7.1325 10.65C6.9325 10.85 6.9325 11.16 7.1325 11.36L8.1325 12.36C8.2325 12.46 8.3625 12.51 8.4825 12.51C8.6025 12.51 8.7425 12.46 8.8325 12.36H8.8425ZM7.8425 6.36L8.8425 5.36C9.0425 5.16 9.0425 4.85 8.8425 4.65C8.6525 4.46 8.3325 4.46 8.1325 4.65L7.1325 5.65C6.9325 5.85 6.9325 6.16 7.1325 6.36C7.2325 6.46 7.3625 6.51 7.4825 6.51C7.6025 6.51 7.7425 6.46 7.8325 6.36H7.8425ZM8.8425 6.36C9.0425 6.16 9.0425 5.85 8.8425 5.65L7.8425 4.65C7.6525 4.46 7.3325 4.46 7.1325 4.65C6.9325 4.85 6.9325 5.16 7.1325 5.36L8.1325 6.36C8.2325 6.46 8.3625 6.51 8.4825 6.51C8.6025 6.51 8.7425 6.46 8.8325 6.36H8.8425ZM12.5825 13.1C14.7225 10.96 15.0825 7.66 13.5025 5.11L14.3425 4.27C14.5325 4.08 14.5325 3.76 14.3425 3.56L12.9325 2.15C12.8425 2.06 12.7125 2 12.5825 2C12.4525 2 12.3225 2.05 12.2325 2.15L11.3925 2.99C9.3125 1.72 6.6725 1.72 4.6025 3L3.7625 2.16C3.5725 1.97 3.2425 1.97 3.0525 2.16L1.6425 3.57C1.4525 3.76 1.4525 4.08 1.6425 4.28L2.4825 5.12C0.9025 7.67 1.2625 10.97 3.4025 13.11C4.6325 14.34 6.2625 15.01 7.9925 15.01C9.7225 15.01 11.3525 14.33 12.5825 13.11V13.1ZM3.4025 3.22L4.1825 4C4.3525 4.17 4.6225 4.2 4.8225 4.05C6.7225 2.7 9.2625 2.7 11.1625 4.05C11.3625 4.19 11.6325 4.17 11.8025 4L12.5825 3.22L13.2925 3.93L12.5125 4.71C12.3425 4.88 12.3225 5.15 12.4625 5.35C14.0225 7.54 13.7725 10.51 11.8825 12.41C10.8425 13.45 9.4625 14.02 8.0025 14.02C6.5425 14.02 5.1525 13.45 4.1225 12.41C2.2225 10.51 1.9825 7.54 3.5425 5.35C3.6825 5.15 3.6625 4.88 3.4925 4.71L2.7125 3.93L3.4225 3.22H3.4025Z";
  const IconPathOutletCombo1 = "M8.7799 5.15995C8.7799 5.56995 8.4399 5.90995 8.0299 5.90995C7.6199 5.90995 7.2799 5.56995 7.2799 5.15995C7.2799 4.74995 7.6199 4.40995 8.0299 4.40995C8.4399 4.40995 8.7799 4.74995 8.7799 5.15995ZM6.8099 3.00995C6.5299 3.00995 6.3099 3.22995 6.3099 3.50995C6.3099 3.78995 6.5299 4.00995 6.8099 4.00995C7.0899 4.00995 7.3099 3.78995 7.3099 3.50995C7.3099 3.22995 7.0899 3.00995 6.8099 3.00995ZM9.2499 3.00995C8.9699 3.00995 8.7499 3.22995 8.7499 3.50995C8.7499 3.78995 8.9699 4.00995 9.2499 4.00995C9.5299 4.00995 9.7499 3.78995 9.7499 3.50995C9.7499 3.22995 9.5299 3.00995 9.2499 3.00995ZM10.4699 4.40995C10.0599 4.40995 9.7199 4.74995 9.7199 5.15995C9.7199 5.56995 10.0599 5.90995 10.4699 5.90995C10.8799 5.90995 11.2199 5.56995 11.2199 5.15995C11.2199 4.74995 10.8799 4.40995 10.4699 4.40995ZM9.2499 6.46995C8.8399 6.46995 8.4999 6.80995 8.4999 7.21995C8.4999 7.62995 8.8399 7.96995 9.2499 7.96995C9.6599 7.96995 9.9999 7.62995 9.9999 7.21995C9.9999 6.80995 9.6599 6.46995 9.2499 6.46995ZM5.5899 4.40995C5.1799 4.40995 4.8399 4.74995 4.8399 5.15995C4.8399 5.56995 5.1799 5.90995 5.5899 5.90995C5.9999 5.90995 6.3399 5.56995 6.3399 5.15995C6.3399 4.74995 5.9999 4.40995 5.5899 4.40995ZM5.8899 11.28C5.3399 11.28 4.8899 11.73 4.8899 12.28C4.8899 12.83 5.3399 13.28 5.8899 13.28C6.4399 13.28 6.8899 12.83 6.8899 12.28C6.8899 11.73 6.4399 11.28 5.8899 11.28ZM10.1599 11.28C9.6099 11.28 9.1599 11.73 9.1599 12.28C9.1599 12.83 9.6099 13.28 10.1599 13.28C10.7099 13.28 11.1599 12.83 11.1599 12.28C11.1599 11.73 10.7099 11.28 10.1599 11.28ZM6.8099 6.46995C6.3999 6.46995 6.0599 6.80995 6.0599 7.21995C6.0599 7.62995 6.3999 7.96995 6.8099 7.96995C7.2199 7.96995 7.5599 7.62995 7.5599 7.21995C7.5599 6.80995 7.2199 6.46995 6.8099 6.46995ZM13.3299 12.28C13.3299 13.75 12.1499 14.95 10.6999 14.95H5.3599C3.9099 14.95 2.7299 13.75 2.7299 12.28C2.7299 10.94 3.7099 9.83995 4.9899 9.64995C3.5799 8.66995 2.6499 7.02995 2.6499 5.15995C2.6499 4.10995 2.9499 3.08995 3.5099 2.20995C4.0099 1.41995 4.9099 0.949951 5.9099 0.949951H10.1399C11.1399 0.949951 12.0399 1.41995 12.5499 2.21995C13.1099 3.09995 13.4099 4.11995 13.4099 5.16995C13.4099 7.02995 12.4799 8.67995 11.0799 9.65995C12.3499 9.84995 13.3399 10.95 13.3399 12.29L13.3299 12.28ZM8.0299 9.60995C10.4399 9.60995 12.4099 7.60995 12.4099 5.15995C12.4099 4.29995 12.1699 3.46995 11.7099 2.74995C11.3899 2.24995 10.7899 1.93995 10.1499 1.93995H5.9099C5.2599 1.93995 4.6599 2.24995 4.3499 2.74995C3.8899 3.46995 3.6499 4.29995 3.6499 5.15995C3.6499 7.61995 5.6099 9.60995 8.0299 9.60995ZM12.3299 12.28C12.3299 11.36 11.5999 10.61 10.6999 10.61H5.3599C4.4599 10.61 3.7299 11.36 3.7299 12.28C3.7299 13.2 4.4599 13.95 5.3599 13.95H10.6899C11.5899 13.95 12.3199 13.2 12.3199 12.28H12.3299Z";
  const IconPathOutletCombo2 = "M5.99999 13.47C6.54999 13.47 6.99999 13.02 6.99999 12.47C6.99999 11.92 6.54999 11.47 5.99999 11.47C5.44999 11.47 4.99999 11.92 4.99999 12.47C4.99999 13.02 5.44999 13.47 5.99999 13.47ZM9.99999 13.47C10.55 13.47 11 13.02 11 12.47C11 11.92 10.55 11.47 9.99999 11.47C9.44999 11.47 8.99999 11.92 8.99999 12.47C8.99999 13.02 9.44999 13.47 9.99999 13.47ZM7.99999 8.21995C8.40999 8.21995 8.74999 7.87995 8.74999 7.46995C8.74999 7.05995 8.40999 6.71995 7.99999 6.71995C7.58999 6.71995 7.24999 7.05995 7.24999 7.46995C7.24999 7.87995 7.58999 8.21995 7.99999 8.21995ZM6.49999 4.96995C6.90999 4.96995 7.24999 4.62995 7.24999 4.21995C7.24999 3.80995 6.90999 3.46995 6.49999 3.46995C6.08999 3.46995 5.74999 3.80995 5.74999 4.21995C5.74999 4.62995 6.08999 4.96995 6.49999 4.96995ZM5.99999 6.96995C6.27999 6.96995 6.49999 6.74995 6.49999 6.46995C6.49999 6.18995 6.27999 5.96995 5.99999 5.96995C5.71999 5.96995 5.49999 6.18995 5.49999 6.46995C5.49999 6.74995 5.71999 6.96995 5.99999 6.96995ZM9.99999 6.96995C10.28 6.96995 10.5 6.74995 10.5 6.46995C10.5 6.18995 10.28 5.96995 9.99999 5.96995C9.71999 5.96995 9.49999 6.18995 9.49999 6.46995C9.49999 6.74995 9.71999 6.96995 9.99999 6.96995ZM9.49999 4.96995C9.90999 4.96995 10.25 4.62995 10.25 4.21995C10.25 3.80995 9.90999 3.46995 9.49999 3.46995C9.08999 3.46995 8.74999 3.80995 8.74999 4.21995C8.74999 4.62995 9.08999 4.96995 9.49999 4.96995ZM13 12.45C12.94 11.13 11.85 9.96995 10.45 9.96995H9.82999V9.82995C11.55 9.11995 12.75 7.40995 12.75 5.44995C12.75 2.83995 10.61 0.699951 7.99999 0.699951C5.38999 0.699951 3.24999 2.83995 3.24999 5.44995C3.24999 7.40995 4.44999 9.11995 6.16999 9.82995V9.96995H5.49999C4.10999 9.96995 2.98999 11.08 2.98999 12.47C2.98999 13.86 4.09999 14.97 5.49999 14.97H10.49C11.88 14.97 12.99 13.86 12.99 12.47C12.99 12.47 12.99 12.46 12.99 12.45H13ZM4.24999 5.44995C4.24999 3.38995 5.93999 1.69995 7.99999 1.69995C10.06 1.69995 11.75 3.38995 11.75 5.44995C11.75 7.09995 10.67 8.51995 9.17999 9.00995C8.96999 9.07995 8.82999 9.26995 8.82999 9.48995V9.97995H7.16999V9.48995C7.16999 9.26995 7.02999 9.07995 6.81999 9.00995C5.31999 8.52995 4.23999 7.09995 4.23999 5.44995H4.24999ZM10.5 13.97H5.50999C4.66999 13.97 3.99999 13.31 3.99999 12.47C3.99999 11.63 4.65999 10.97 5.50999 10.97H10.45C11.28 10.97 11.96 11.66 12 12.48C12 13.31 11.34 13.97 10.5 13.97Z";
  const IconPathOutletSchuko = "M7 8C7 8.55 6.55 9 6 9C5.45 9 5 8.55 5 8C5 7.45 5.45 7 6 7C6.55 7 7 7.45 7 8ZM10 7C9.45 7 9 7.45 9 8C9 8.55 9.45 9 10 9C10.55 9 11 8.55 11 8C11 7.45 10.55 7 10 7ZM14.5 7V9C14.5 9.28 14.28 9.5 14 9.5H13V11.97C13 12.09 12.96 12.21 12.88 12.3C11.65 13.7 9.87 14.5 8 14.5C6.13 14.5 4.36 13.7 3.12 12.3C3.04 12.21 3 12.09 3 11.97V9.5H2C1.72 9.5 1.5 9.28 1.5 9V7C1.5 6.72 1.72 6.5 2 6.5H3V4.03C3 3.91 3.04 3.79 3.12 3.7C3.75 2.99 4.53 2.42 5.39 2.04C6.21 1.69 7.1 1.5 7.98 1.5C7.98 1.5 7.99 1.5 8 1.5C8.01 1.5 8.01 1.5 8.02 1.5C8.9 1.5 9.78 1.68 10.6 2.04C11.46 2.42 12.25 2.99 12.87 3.7C12.95 3.79 12.99 3.91 12.99 4.03V6.5H13.99C14.27 6.5 14.49 6.72 14.49 7H14.5ZM13.5 7.5H12.5C12.37 7.5 12.24 7.45 12.15 7.35C12.06 7.25 12 7.13 12 7V4.23C11.49 3.69 10.88 3.26 10.2 2.96C9.66 2.72 9.08 2.58 8.5 2.53V3.5C8.5 3.78 8.28 4 8 4C7.72 4 7.5 3.78 7.5 3.5V2.53C6.92 2.58 6.34 2.72 5.8 2.96C5.13 3.25 4.51 3.69 4 4.23V7C4 7.28 3.78 7.5 3.5 7.5H2.5V8.5H3.5C3.78 8.5 4 8.72 4 9V11.78C4.92 12.76 6.17 13.36 7.5 13.48V12.51C7.5 12.23 7.72 12.01 8 12.01C8.28 12.01 8.5 12.23 8.5 12.51V13.48C9.83 13.36 11.08 12.76 12 11.78V9.01C12 8.88 12.05 8.75 12.15 8.66C12.25 8.57 12.37 8.51 12.5 8.51H13.5V7.51V7.5Z";
  const IconPathOutletType1 = "M9 15H7C6.72 15 6.5 14.78 6.5 14.5V13.82C3.58 13.13 1.5 10.54 1.5 7.5C1.5 3.92 4.42 1 8 1C11.58 1 14.5 3.92 14.5 7.5C14.5 10.54 12.42 13.13 9.5 13.82V14.5C9.5 14.78 9.28 15 9 15ZM7.5 14H8.5V13.41C8.5 13.17 8.68 12.96 8.92 12.92C11.58 12.47 13.5 10.19 13.5 7.5C13.5 4.47 11.03 2 8 2C4.97 2 2.5 4.47 2.5 7.5C2.5 10.19 4.43 12.47 7.08 12.92C7.32 12.96 7.5 13.17 7.5 13.41V14ZM8 9.5C7.45 9.5 7 9.95 7 10.5C7 11.05 7.45 11.5 8 11.5C8.55 11.5 9 11.05 9 10.5C9 9.95 8.55 9.5 8 9.5ZM6 4.5C5.45 4.5 5 4.95 5 5.5C5 6.05 5.45 6.5 6 6.5C6.55 6.5 7 6.05 7 5.5C7 4.95 6.55 4.5 6 4.5ZM5 8.25C4.59 8.25 4.25 8.59 4.25 9C4.25 9.41 4.59 9.75 5 9.75C5.41 9.75 5.75 9.41 5.75 9C5.75 8.59 5.41 8.25 5 8.25ZM11 8.25C10.59 8.25 10.25 8.59 10.25 9C10.25 9.41 10.59 9.75 11 9.75C11.41 9.75 11.75 9.41 11.75 9C11.75 8.59 11.41 8.25 11 8.25ZM10 4.5C9.45 4.5 9 4.95 9 5.5C9 6.05 9.45 6.5 10 6.5C10.55 6.5 11 6.05 11 5.5C11 4.95 10.55 4.5 10 4.5Z";
  const IconPathOutletType2 = "M9 7.65002C9 8.20002 8.55 8.65002 8 8.65002C7.45 8.65002 7 8.20002 7 7.65002C7 7.10002 7.45 6.65002 8 6.65002C8.55 6.65002 9 7.10002 9 7.65002ZM6.5 5.03002C6.15 5.03002 5.88 5.31002 5.88 5.65002C5.88 5.99002 6.16 6.27002 6.5 6.27002C6.84 6.27002 7.12 5.99002 7.12 5.65002C7.12 5.31002 6.84 5.03002 6.5 5.03002ZM9.5 5.03002C9.15 5.03002 8.88 5.31002 8.88 5.65002C8.88 5.99002 9.16 6.27002 9.5 6.27002C9.84 6.27002 10.12 5.99002 10.12 5.65002C10.12 5.31002 9.84 5.03002 9.5 5.03002ZM11 6.65002C10.45 6.65002 10 7.10002 10 7.65002C10 8.20002 10.45 8.65002 11 8.65002C11.55 8.65002 12 8.20002 12 7.65002C12 7.10002 11.55 6.65002 11 6.65002ZM9.5 9.15002C8.95 9.15002 8.5 9.60002 8.5 10.15C8.5 10.7 8.95 11.15 9.5 11.15C10.05 11.15 10.5 10.7 10.5 10.15C10.5 9.60002 10.05 9.15002 9.5 9.15002ZM5 6.65002C4.45 6.65002 4 7.10002 4 7.65002C4 8.20002 4.45 8.65002 5 8.65002C5.55 8.65002 6 8.20002 6 7.65002C6 7.10002 5.55 6.65002 5 6.65002ZM6.5 9.15002C5.95 9.15002 5.5 9.60002 5.5 10.15C5.5 10.7 5.95 11.15 6.5 11.15C7.05 11.15 7.5 10.7 7.5 10.15C7.5 9.60002 7.05 9.15002 6.5 9.15002ZM14.5 7.65002C14.5 6.40002 14.14 5.18002 13.46 4.13002C12.86 3.20002 11.79 2.65002 10.6 2.65002H5.4C4.21 2.65002 3.14 3.20002 2.54 4.13002C1.86 5.18002 1.5 6.40002 1.5 7.65002C1.5 11.23 4.42 14.15 8 14.15C11.58 14.15 14.5 11.23 14.5 7.65002ZM2.5 7.65002C2.5 6.59002 2.8 5.56002 3.38 4.68002C3.79 4.05002 4.56 3.65002 5.4 3.65002H10.6C11.44 3.65002 12.21 4.04002 12.62 4.68002C13.19 5.57002 13.5 6.59002 13.5 7.65002C13.5 10.68 11.03 13.15 8 13.15C4.97 13.15 2.5 10.68 2.5 7.65002Z";
  const IconPathParkingDriveway = "M5.78361 1.97264C5.92039 1.90699 6.07957 1.90699 6.21634 1.97264L9.2163 3.41263C9.38965 3.49584 9.49993 3.67109 9.49993 3.86339V5.76339L12.4999 5.7634C12.8914 5.7634 13.2706 5.91261 13.5533 6.18397C13.8366 6.45598 13.9999 6.82934 13.9999 7.22339C13.9999 7.61743 13.8366 7.9908 13.5533 8.2628C13.2706 8.53424 12.8914 8.68338 12.4999 8.68338H11.4999C11.361 8.68338 11.2315 8.73659 11.139 8.82535C11.0473 8.91344 10.9999 9.02823 10.9999 9.14339C10.9999 9.25859 11.0474 9.37336 11.139 9.46135C11.2316 9.55018 11.3611 9.60339 11.4999 9.60339H11.9999C12.524 9.60339 13.0304 9.80318 13.4068 10.1645L13.4069 10.1646C13.784 10.5266 13.9999 11.022 13.9999 11.5434C13.9999 12.0647 13.784 12.5601 13.4069 12.9221L13.4068 12.9222C13.0304 13.2835 12.524 13.4833 11.9999 13.4833H10.4999C10.2238 13.4833 9.99993 13.2595 9.99993 12.9833C9.99993 12.7072 10.2238 12.4833 10.4999 12.4833H11.9999C12.2715 12.4833 12.5282 12.3795 12.7144 12.2008C12.8998 12.0227 12.9999 11.7858 12.9999 11.5434C12.9999 11.3009 12.8998 11.064 12.7144 10.8859C12.5282 10.7072 12.2715 10.6034 11.9999 10.6034H11.4999C11.1084 10.6034 10.7292 10.4541 10.4466 10.1829L10.4465 10.1828C10.1631 9.91073 9.99993 9.53734 9.99993 9.14339C9.99993 8.74941 10.1631 8.37606 10.4465 8.10397L10.4466 8.10385C10.7293 7.83255 11.1085 7.68339 11.4999 7.68339H12.4999C12.6389 7.68339 12.7683 7.63018 12.8607 7.54148L12.8607 7.54141C12.9525 7.45335 12.9999 7.33852 12.9999 7.22339C12.9999 7.10825 12.9525 6.99342 12.8607 6.90536L12.8607 6.90534C12.7683 6.81661 12.6388 6.76339 12.4999 6.76339L3 6.76337C2.72386 6.76337 2.5 6.53951 2.5 6.26337V3.86339C2.5 3.67109 2.61028 3.49584 2.78363 3.41263L5.78361 1.97264ZM8.49993 5.76338H3.49999V4.178L5.99998 2.97801L8.49993 4.178V5.76338ZM7.6966 8.68338H4.30332L3.82416 9.60339H8.17577L7.6966 8.68338ZM8.49993 10.6034H3.49999V11.5234H3.98858C3.99238 11.5233 3.99618 11.5233 4 11.5233C4.00381 11.5233 4.00762 11.5233 4.01141 11.5234H7.98858C7.99238 11.5233 7.99618 11.5233 8 11.5233C8.00381 11.5233 8.00762 11.5233 8.01142 11.5234H8.49993V10.6034ZM8.49999 12.5234H8.99993C9.27607 12.5234 9.49993 12.2995 9.49993 12.0234V10.1034C9.49993 10.023 9.48053 9.94374 9.44339 9.87242L8.44339 7.95242C8.35728 7.78709 8.18634 7.68339 7.99993 7.68339H3.99999C3.81358 7.68339 3.64265 7.78709 3.55654 7.95242L2.55654 9.87242C2.5194 9.94374 2.5 10.023 2.5 10.1034V12.0234C2.5 12.2995 2.72386 12.5234 3 12.5234H3.5V12.9833C3.5 13.2594 3.72386 13.4833 4 13.4833C4.27614 13.4833 4.49999 13.2594 4.49999 12.9833V12.5234H7.5V12.9833C7.5 13.2594 7.72386 13.4833 8 13.4833C8.27614 13.4833 8.49999 13.2594 8.49999 12.9833V12.5234Z";
  const IconPathParkingGarage = "M8.21636 2.45262C8.07959 2.38697 7.92041 2.38697 7.78363 2.45262L1.78363 5.33262C1.61027 5.41583 1.5 5.59109 1.5 5.78338V12.4834H0.999997C0.723855 12.4834 0.499997 12.7072 0.499997 12.9834C0.499997 13.2595 0.723855 13.4834 0.999997 13.4834H1.99901L14 13.4834L15 13.4834C15.2761 13.4834 15.5 13.2595 15.5 12.9834C15.5 12.7072 15.2761 12.4834 15 12.4834H14.5V5.78338C14.5 5.59109 14.3897 5.41583 14.2164 5.33262L8.21636 2.45262ZM13.5 12.4834H2.5V6.098L8 3.458L13.5 6.098V12.4834ZM10.4435 6.03241C10.3573 5.86708 10.1864 5.76338 10 5.76338H6C5.81359 5.76338 5.64265 5.86708 5.55654 6.03241L4.55654 7.9524C4.51939 8.02372 4.5 8.10295 4.5 8.18337V10.1034C4.5 10.3795 4.72386 10.6034 5 10.6034H5.5V11.0634C5.5 11.3395 5.72386 11.5634 6 11.5634C6.27614 11.5634 6.5 11.3395 6.5 11.0634V10.6034H9.5V11.0634C9.5 11.3395 9.72386 11.5634 10 11.5634C10.2761 11.5634 10.5 11.3395 10.5 11.0634V10.6034H11C11.2761 10.6034 11.5 10.3795 11.5 10.1034V8.18337C11.5 8.10295 11.4806 8.02372 11.4435 7.9524L10.4435 6.03241ZM5.5 9.60337V8.68337H10.5V9.60337H5.5ZM10.1758 7.68337H5.82417L6.30333 6.76338H9.69666L10.1758 7.68337Z";
  const IconPathParkingLot = "M8.5 2.5C8.77614 2.5 9 2.72386 9 3V13C9 13.2761 8.77614 13.5 8.5 13.5C8.22386 13.5 8 13.2761 8 13V3C8 2.72386 8.22386 2.5 8.5 2.5ZM2 5C2 4.17386 2.67386 3.5 3.5 3.5H5.5C6.32614 3.5 7 4.17386 7 5V12C7 12.2761 6.77614 12.5 6.5 12.5H2.5C2.22386 12.5 2 12.2761 2 12V5ZM3.5 4.5C3.22614 4.5 3 4.72614 3 5V11.5H6V5C6 4.72614 5.77386 4.5 5.5 4.5H3.5ZM10 5C10 4.17386 10.6739 3.5 11.5 3.5H13.5C14.3261 3.5 15 4.17386 15 5V12C15 12.2761 14.7761 12.5 14.5 12.5H10.5C10.2239 12.5 10 12.2761 10 12V5ZM11.5 4.5C11.2261 4.5 11 4.72614 11 5V11.5H14V5C14 4.72614 13.7739 4.5 13.5 4.5H11.5ZM3.5 6C3.5 5.72386 3.72386 5.5 4 5.5H5C5.27614 5.5 5.5 5.72386 5.5 6C5.5 6.27614 5.27614 6.5 5 6.5H4C3.72386 6.5 3.5 6.27614 3.5 6ZM11.5 6C11.5 5.72386 11.7239 5.5 12 5.5H13C13.2761 5.5 13.5 5.72386 13.5 6C13.5 6.27614 13.2761 6.5 13 6.5H12C11.7239 6.5 11.5 6.27614 11.5 6ZM3.5 10C3.5 9.72386 3.72386 9.5 4 9.5H5C5.27614 9.5 5.5 9.72386 5.5 10C5.5 10.2761 5.27614 10.5 5 10.5H4C3.72386 10.5 3.5 10.2761 3.5 10ZM11.5 10C11.5 9.72386 11.7239 9.5 12 9.5H13C13.2761 9.5 13.5 9.72386 13.5 10C13.5 10.2761 13.2761 10.5 13 10.5H12C11.7239 10.5 11.5 10.2761 11.5 10Z";
  const IconPathParkingMotorway = "M4.50737 2.33794C4.54896 2.09837 4.75686 1.92346 5 1.92346H11C11.2431 1.92346 11.451 2.09837 11.4926 2.33794L11.8676 4.49794C11.9149 4.77001 11.7326 5.02886 11.4605 5.07609C11.1885 5.12333 10.9296 4.94106 10.8824 4.66899L10.5793 2.92346H8.5V4.58346C8.5 4.85961 8.27614 5.08346 8 5.08346C7.72386 5.08346 7.5 4.85961 7.5 4.58346V2.92346H5.42067L5.11763 4.66899C5.0704 4.94106 4.81155 5.12333 4.53947 5.07609C4.2674 5.02886 4.08514 4.77001 4.13237 4.49794L4.50737 2.33794ZM1.85311 6.76346L1.51614 8.05744C1.44655 8.32467 1.60676 8.59772 1.87399 8.66731C2.14122 8.7369 2.41427 8.57669 2.48386 8.30946L2.88647 6.76346H3.73874L2.50737 13.8579C2.48213 14.0033 2.52241 14.1524 2.61741 14.2654C2.71241 14.3783 2.85244 14.4435 3 14.4435H13C13.1476 14.4435 13.2876 14.3783 13.3826 14.2654C13.4776 14.1524 13.5179 14.0033 13.4926 13.8579L12.2613 6.76346H13.1135L13.5161 8.30946C13.5857 8.57669 13.8588 8.7369 14.126 8.66731C14.3932 8.59772 14.5535 8.32467 14.4839 8.05744L14.1469 6.76346H15C15.2761 6.76346 15.5 6.53961 15.5 6.26346C15.5 5.98732 15.2761 5.76346 15 5.76346H13.5113C13.504 5.7633 13.4967 5.7633 13.4893 5.76346H11.6766C11.6706 5.76335 11.6646 5.76335 11.6585 5.76346H4.34145C4.33541 5.76335 4.32938 5.76335 4.32337 5.76346H2.51066C2.5033 5.7633 2.49597 5.7633 2.48866 5.76346H1C0.723858 5.76346 0.5 5.98732 0.5 6.26346C0.5 6.53961 0.723858 6.76346 1 6.76346H1.85311ZM4.75369 6.76346L3.59426 13.4435H7.5V6.76346H4.75369ZM8.5 6.76346V13.4435H12.4057L11.2463 6.76346H8.5Z";
  const IconPathParkingStreet = "M4.50737 2.33769C4.54896 2.09813 4.75686 1.92322 5 1.92322H11C11.2431 1.92322 11.451 2.09813 11.4926 2.33769L13.4926 13.8577C13.5179 14.0031 13.4776 14.1522 13.3826 14.2651C13.2876 14.378 13.1476 14.4432 13 14.4432H3C2.85244 14.4432 2.71241 14.378 2.61741 14.2651C2.5224 14.1522 2.48213 14.0031 2.50737 13.8577L4.50737 2.33769ZM8.50001 13.4432V12.9832C8.50001 12.7071 8.27615 12.4832 8.00001 12.4832C7.72386 12.4832 7.50001 12.7071 7.50001 12.9832V13.4432H3.59429L5.42068 2.92322H10.5793L12.4057 13.4432H8.50001ZM8.00001 3.84322C8.27615 3.84322 8.50001 4.06708 8.50001 4.34322V5.30322C8.50001 5.57936 8.27615 5.80322 8.00001 5.80322C7.72386 5.80322 7.50001 5.57936 7.50001 5.30322V4.34322C7.50001 4.06708 7.72386 3.84322 8.00001 3.84322ZM8.00001 6.72323C8.27615 6.72323 8.50001 6.94709 8.50001 7.22323V8.18323C8.50001 8.45937 8.27615 8.68323 8.00001 8.68323C7.72386 8.68323 7.50001 8.45937 7.50001 8.18323V7.22323C7.50001 6.94709 7.72386 6.72323 8.00001 6.72323ZM8.00001 9.60323C8.27615 9.60323 8.50001 9.82709 8.50001 10.1032V11.0632C8.50001 11.3394 8.27615 11.5632 8.00001 11.5632C7.72386 11.5632 7.50001 11.3394 7.50001 11.0632V10.1032C7.50001 9.82709 7.72386 9.60323 8.00001 9.60323Z";
  const IconPathParkingUnderground = "M0.5 3.8634C0.5 3.58726 0.723858 3.3634 1 3.3634H15C15.2761 3.3634 15.5 3.58726 15.5 3.8634C15.5 4.13955 15.2761 4.3634 15 4.3634H14.5V12.9834C14.5 13.2595 14.2761 13.4834 14 13.4834H2C1.72386 13.4834 1.5 13.2595 1.5 12.9834V4.3634H1C0.723858 4.3634 0.5 4.13955 0.5 3.8634ZM2.5 4.3634V12.4834H13.5V4.3634H2.5ZM5.55654 6.03243C5.64265 5.8671 5.81359 5.7634 6 5.7634H10C10.1864 5.7634 10.3573 5.8671 10.4435 6.03243L11.4435 7.95242C11.4806 8.02375 11.5 8.10297 11.5 8.18339V10.1034C11.5 10.3795 11.2761 10.6034 11 10.6034H10.5V11.0634C10.5 11.3395 10.2761 11.5634 10 11.5634C9.72386 11.5634 9.5 11.3395 9.5 11.0634V10.6034H6.5V11.0634C6.5 11.3395 6.27614 11.5634 6 11.5634C5.72386 11.5634 5.5 11.3395 5.5 11.0634V10.6034H5C4.72386 10.6034 4.5 10.3795 4.5 10.1034V8.18339C4.5 8.10297 4.5194 8.02375 4.55654 7.95242L5.55654 6.03243ZM10.5 9.60339V8.68339H5.5V9.60339H10.5ZM5.82417 7.68339H10.1758L9.69667 6.7634H6.30334L5.82417 7.68339Z";
  const IconPathPayment = "M4.45121 3.00012C4.44401 2.99996 4.43678 2.99996 4.42954 3.00012H2C1.72385 3.00012 1.5 3.22398 1.5 3.50012V5.92966C1.49984 5.9369 1.49984 5.94413 1.5 5.95133V10.0489C1.49984 10.0561 1.49984 10.0633 1.5 10.0706V12.5001C1.5 12.7763 1.72385 13.0001 2 13.0001H4.42954C4.43678 13.0003 4.44401 13.0003 4.45121 13.0001H12.5488C12.556 13.0003 12.5632 13.0003 12.5705 13.0001H15C15.2761 13.0001 15.5 12.7763 15.5 12.5001V10.0706C15.5002 10.0633 15.5002 10.0561 15.5 10.0489V5.95133C15.5002 5.94413 15.5002 5.9369 15.5 5.92966V3.50012C15.5 3.22398 15.2761 3.00012 15 3.00012H12.5705C12.5632 2.99996 12.556 2.99996 12.5488 3.00012H4.45121ZM12 4.00012H5C5 5.37626 3.87614 6.50012 2.5 6.50012V9.50012C3.87614 9.50012 5 10.624 5 12.0001H12C12 10.624 13.1239 9.50012 14.5 9.50012V6.50012C13.1239 6.50012 12 5.37626 12 4.00012ZM13 4.00012C13 4.82398 13.6761 5.50012 14.5 5.50012V4.00012H13ZM13 12.0001H14.5V10.5001C13.6761 10.5001 13 11.1763 13 12.0001ZM4 12.0001C4 11.1763 3.32385 10.5001 2.5 10.5001V12.0001H4ZM2.5 5.50012C3.32385 5.50012 4 4.82398 4 4.00012H2.5V5.50012ZM8.5 6.00012C7.39543 6.00012 6.5 6.89555 6.5 8.00012C6.5 9.10469 7.39543 10.0001 8.5 10.0001C9.60457 10.0001 10.5 9.10469 10.5 8.00012C10.5 6.89555 9.60457 6.00012 8.5 6.00012ZM5.5 8.00012C5.5 6.34326 6.84314 5.00012 8.5 5.00012C10.1569 5.00012 11.5 6.34326 11.5 8.00012C11.5 9.65697 10.1569 11.0001 8.5 11.0001C6.84314 11.0001 5.5 9.65697 5.5 8.00012Z";
  const IconPathPhone = "M2 3C2 2.72386 2.22386 2.5 2.5 2.5H5.3C5.57614 2.5 5.8 2.72386 5.8 3C5.8 3.98653 5.98793 4.92516 6.316 5.76878C6.38786 5.95356 6.34375 6.16336 6.20355 6.30355L4.37293 8.13418C5.21752 9.55429 6.44571 10.7825 7.86582 11.6271L9.69645 9.79645C9.83664 9.65625 10.0464 9.61214 10.2312 9.684C11.0748 10.0121 12.0135 10.2 13 10.2C13.2761 10.2 13.5 10.4239 13.5 10.7V13.5C13.5 13.7761 13.2761 14 13 14C11.1179 14 9.28712 13.5298 7.71471 12.6912L7.71145 12.6894C5.87648 11.6933 4.3067 10.1235 3.31057 8.28855L3.30881 8.2853L3.30882 8.28529C2.4702 6.71288 2 4.88207 2 3ZM8.79836 12.1087C9.93591 12.6172 11.1983 12.9248 12.5 12.9879V11.1857C11.6856 11.1391 10.9043 10.9798 10.1778 10.7293L8.79836 12.1087ZM3.89125 7.20164C3.38279 6.06409 3.07522 4.80168 3.01212 3.5H4.81429C4.86091 4.31443 5.02018 5.09572 5.27069 5.8222L3.89125 7.20164Z";
  const IconPathPhoneSignal = "M3 2C2.72614 2 2.5 2.22614 2.5 2.5V13.5C2.5 13.7739 2.72614 14 3 14H9C9.27386 14 9.5 13.7739 9.5 13.5V2.5C9.5 2.22614 9.27386 2 9 2H3ZM1.5 2.5C1.5 1.67386 2.17386 1 3 1H9C9.82614 1 10.5 1.67386 10.5 2.5V13.5C10.5 14.3261 9.82614 15 9 15H3C2.17386 15 1.5 14.3261 1.5 13.5V2.5ZM12.9967 4.84648C13.192 4.65122 13.5086 4.65122 13.7038 4.84648C14.1005 5.24319 14.4342 5.74534 14.6572 6.24696L14.661 6.25558L14.6645 6.26434C14.8875 6.82185 15.0003 7.38477 15.0003 8.00003C15.0003 8.60173 14.8923 9.21997 14.661 9.74442C14.4298 10.3184 14.0866 10.7708 13.7038 11.1536C13.5086 11.3488 13.192 11.3488 12.9967 11.1536C12.8014 10.9583 12.8014 10.6417 12.9967 10.4465C13.312 10.1312 13.5673 9.78623 13.736 9.36434L13.7395 9.35558L13.7434 9.34696C13.9094 8.97326 14.0003 8.49501 14.0003 8.00003C14.0003 7.51851 13.9142 7.08402 13.7395 6.64453C13.5625 6.24903 13.2978 5.8547 12.9967 5.55359C12.8014 5.35832 12.8014 5.04174 12.9967 4.84648ZM11.5462 6.24646C11.7414 6.0512 12.058 6.0512 12.2533 6.24646C12.4847 6.47791 12.6814 6.73296 12.814 7.06432C12.9381 7.37466 12.9997 7.68779 12.9997 8.05002C12.9997 8.41224 12.9381 8.72538 12.814 9.03571C12.6814 9.36707 12.4847 9.62213 12.2533 9.85357C12.058 10.0488 11.7414 10.0488 11.5462 9.85357C11.3509 9.65831 11.3509 9.34173 11.5462 9.14646C11.7147 8.97791 11.818 8.83296 11.8855 8.66432C11.9614 8.47466 11.9997 8.28779 11.9997 8.05002C11.9997 7.81224 11.9614 7.62538 11.8855 7.43571C11.818 7.26707 11.7147 7.12213 11.5462 6.95357C11.3509 6.75831 11.3509 6.44173 11.5462 6.24646ZM4 12.5C4 12.2239 4.22386 12 4.5 12H7.5C7.77614 12 8 12.2239 8 12.5C8 12.7761 7.77614 13 7.5 13H4.5C4.22386 13 4 12.7761 4 12.5Z";
  const IconPathPin = "M8.5 12V14.5M5.5 2H11.5M11.397 8.6763L10.5 2H6.5L5.603 8.6763C4.4321 9.2793 3.5 10.3286 3.5 12H13.5C13.5 10.3286 12.5679 9.2793 11.397 8.6763Z";
  const IconPathPlug = "M11 5H10V2.5C10 2.22 9.78 2 9.5 2C9.22 2 9 2.22 9 2.5V5H7V2.5C7 2.22 6.78 2 6.5 2C6.22 2 6 2.22 6 2.5V5H5C4.45 5 4 5.45 4 6V7.12C4 9.13 5.51 10.72 7.51 10.95C7.51 10.97 7.51 10.98 7.51 11V11.5C7.51 12.33 6.84 13 6.01 13H4C3.72 13 3.5 13.22 3.5 13.5C3.5 13.78 3.72 14 4 14H6C7.38 14 8.5 12.88 8.5 11.5V11C8.5 11 8.5 10.97 8.5 10.95C10.5 10.72 12.01 9.13 12.01 7.12V6C12.01 5.45 11.56 5 11.01 5H11ZM11 7.12C11 8.73 9.68 10 8 10C6.32 10 5 8.74 5 7.12V6H11V7.12Z";
  const IconPathPlugAndCharge = "M13.2599 6.19999C13.2599 6.14999 13.2099 6.10999 13.1499 6.10999H7.9799C7.5099 6.10999 7.1299 6.47999 7.1299 6.92999C7.1299 7.37999 7.5099 7.74999 7.9799 7.74999H13.1499C13.1999 7.74999 13.2499 7.70999 13.2599 7.65999C13.2999 7.41999 13.3099 7.17999 13.3099 6.92999C13.3099 6.67999 13.2899 6.43999 13.2599 6.19999ZM7.9799 10.4C5.9799 10.4 4.3599 8.83999 4.3599 6.92999C4.3599 5.01999 5.9799 3.45999 7.9799 3.45999C9.0799 3.45999 10.0599 3.92999 10.7299 4.66999C10.7699 4.70999 10.8299 4.71999 10.8799 4.67999L12.0499 3.76999C12.0499 3.76999 12.0899 3.72999 12.0899 3.69999C12.0899 3.66999 12.0899 3.64999 12.0699 3.61999C11.0899 2.50999 9.6299 1.79999 7.9899 1.79999C5.0399 1.80999 2.6499 4.09999 2.6499 6.92999V14.51C2.6499 14.57 2.6999 14.61 2.7599 14.61H4.2599C4.3199 14.61 4.3699 14.56 4.3699 14.51V10.81C4.3699 10.74 4.3999 10.72 4.4599 10.77C5.3999 11.57 6.6399 12.05 7.9899 12.05C9.6199 12.05 11.0899 11.34 12.0699 10.23C12.0899 10.21 12.0999 10.18 12.0899 10.15C12.0899 10.12 12.0699 10.1 12.0499 10.08L10.8799 9.16999C10.8799 9.16999 10.7699 9.13999 10.7299 9.17999C10.0699 9.91999 9.0799 10.39 7.9799 10.39V10.4Z";
  const IconPathPointer = "M6.49957 2.3797C6.20628 2.3797 5.99957 2.60688 5.99957 2.8397V9.55969C5.99957 9.77499 5.86176 9.96611 5.65749 10.0341C5.45322 10.1021 5.22835 10.0317 5.09932 9.85936L3.95823 8.33525C3.73788 8.07987 3.37821 8.06531 3.14584 8.28839C3.13786 8.29604 3.12963 8.30343 3.12117 8.31055C2.96838 8.43889 2.93329 8.73102 3.11911 8.93488L3.12727 8.94383L5.87716 12.1119C5.90283 12.1415 5.92494 12.174 5.94303 12.2087L6.30291 12.8997H11.1983L12.7561 9.95273C12.7564 9.95227 12.7566 9.95182 12.7568 9.95136C12.9136 9.64972 12.9996 9.25195 12.9996 8.88769V8.11969C12.9996 7.88688 12.7929 7.65969 12.4996 7.65969C12.2063 7.65969 11.9996 7.88688 11.9996 8.11969V8.59969C11.9996 8.87584 11.7757 9.09969 11.4996 9.09969C11.2234 9.09969 10.9996 8.87584 10.9996 8.59969V6.1997C10.9996 5.96688 10.7929 5.7397 10.4996 5.7397C10.2063 5.7397 9.99959 5.96688 9.99959 6.1997V7.15969C9.99959 7.43584 9.77573 7.65969 9.49959 7.65969C9.22344 7.65969 8.99959 7.43584 8.99959 7.15969V5.7197C8.99959 5.48688 8.79288 5.2597 8.49959 5.2597C8.2063 5.2597 7.99959 5.48688 7.99959 5.7197V7.15969C7.99959 7.43584 7.77573 7.65969 7.49959 7.65969C7.22344 7.65969 6.99959 7.43584 6.99959 7.15969V2.8397C6.99959 2.60689 6.79288 2.3797 6.49957 2.3797ZM7.99959 4.34394V2.8397C7.99959 2.01651 7.30629 1.3797 6.49957 1.3797C5.69286 1.3797 4.99957 2.01652 4.99957 2.8397V8.05761L4.74982 7.72403C4.74462 7.71708 4.73924 7.71027 4.73368 7.7036C4.15674 7.01127 3.13056 6.92949 2.46511 7.55578C1.83312 8.09963 1.86906 9.04256 2.37554 9.60355L5.08334 12.7229L5.55612 13.6307C5.64223 13.796 5.81316 13.8997 5.99957 13.8997H11.4996C11.6849 13.8997 11.855 13.7972 11.9416 13.6334L13.6416 10.4174L13.643 10.4147C13.8859 9.94847 13.9996 9.38689 13.9996 8.88769V8.11969C13.9996 7.29651 13.3063 6.65969 12.4996 6.65969C12.3257 6.65969 12.1571 6.68928 11.9996 6.74393V6.1997C11.9996 5.37652 11.3063 4.7397 10.4996 4.7397C10.2343 4.7397 9.98131 4.80856 9.76118 4.93026C9.49046 4.52318 9.01849 4.2597 8.49959 4.2597C8.32572 4.2597 8.15711 4.28928 7.99959 4.34394Z";
  const IconPathPower = "M8 2.46753C8.27614 2.46753 8.5 2.69139 8.5 2.96753V7.76751C8.5 8.04365 8.27614 8.26751 8 8.26751C7.72386 8.26751 7.5 8.04365 7.5 7.76751V2.96753C7.5 2.69139 7.72386 2.46753 8 2.46753ZM5.25128 3.64757C5.40589 3.87637 5.34575 4.18719 5.11696 4.34181C3.83045 5.21119 3 6.63993 3 8.24751C3 10.8684 5.21921 13.0275 8 13.0275C10.7808 13.0275 13 10.8684 13 8.24751C13 6.64036 12.1695 5.21118 10.883 4.3418C10.6542 4.18719 10.5941 3.87637 10.7487 3.64757C10.9033 3.41877 11.2142 3.35864 11.443 3.51326C12.9834 4.55428 14 6.28346 14 8.24751C14 11.4587 11.2942 14.0275 8 14.0275C4.70579 14.0275 2 11.4587 2 8.24751C2 6.283 3.01655 4.55427 4.55704 3.51325C4.78584 3.35864 5.09666 3.41878 5.25128 3.64757Z";
  const IconPathPriceFixed = "M6.91649 2.85529C6.47459 2.61867 5.98043 2.49655 5.47916 2.50007C4.9779 2.5036 4.48551 2.63266 4.04697 2.87547C3.60842 3.11828 3.23771 3.4671 2.96869 3.89007C2.69966 4.31304 2.5409 4.79667 2.50691 5.29679C2.47291 5.79691 2.56478 6.29758 2.77409 6.75306C2.98341 7.20854 3.30352 7.60431 3.70517 7.90423C4.10682 8.20415 4.57722 8.39865 5.0734 8.46997C5.34673 8.50926 5.53646 8.76269 5.49717 9.03602C5.45789 9.30935 5.20446 9.49909 4.93112 9.4598C4.26957 9.36471 3.64239 9.10538 3.10686 8.7055C2.57133 8.30562 2.14453 7.77793 1.86545 7.17063C1.58637 6.56334 1.46389 5.8958 1.50921 5.22898C1.55453 4.56217 1.76621 3.91734 2.1249 3.35339C2.48359 2.78944 2.97787 2.32436 3.56258 2.00062C4.14729 1.67687 4.8038 1.5048 5.47213 1.5001C6.14046 1.4954 6.79932 1.65822 7.38853 1.97371C7.97774 2.2892 8.47851 2.7473 8.84509 3.30615C8.99655 3.53705 8.93216 3.84701 8.70126 3.99847C8.47036 4.14993 8.16039 4.08554 8.00893 3.85464C7.73399 3.43549 7.3584 3.09191 6.91649 2.85529ZM5.81919 3.82349C5.98177 3.9105 6.08327 4.07993 6.08327 4.26432V6.73532C6.08327 7.01147 5.85941 7.23532 5.58327 7.23532C5.30712 7.23532 5.08327 7.01147 5.08327 6.73532V5.19858L5.03712 5.22935C4.80735 5.38252 4.49692 5.32044 4.34374 5.09067C4.19056 4.86091 4.25265 4.55047 4.48242 4.3973L5.30592 3.8483C5.45934 3.74601 5.65662 3.73648 5.81919 3.82349ZM10.5 5.49984C10.1022 5.49984 9.72064 5.65787 9.43934 5.93918C9.15804 6.22048 9 6.60201 9 6.99984V7.99984H12V6.99984C12 6.60201 11.842 6.22048 11.5607 5.93918C11.2794 5.65787 10.8978 5.49984 10.5 5.49984ZM13 7.99984V6.99984C13 6.3368 12.7366 5.70091 12.2678 5.23207C11.7989 4.76323 11.163 4.49984 10.5 4.49984C9.83696 4.49984 9.20107 4.76323 8.73223 5.23207C8.26339 5.70091 8 6.3368 8 6.99984V7.99984H7.5664C6.97744 7.99984 6.5 8.47728 6.5 9.06624V13.4334C6.5 14.0224 6.97744 14.4998 7.5664 14.4998H13.4336C14.0226 14.4998 14.5 14.0224 14.5 13.4334V9.06624C14.5 8.47728 14.0226 7.99984 13.4336 7.99984H13ZM7.5664 8.99984C7.52973 8.99984 7.5 9.02957 7.5 9.06624V13.4334C7.5 13.4701 7.52973 13.4998 7.5664 13.4998H13.4336C13.4703 13.4998 13.5 13.4701 13.5 13.4334V9.06624C13.5 9.02957 13.4703 8.99984 13.4336 8.99984H7.5664ZM10.5 10.7498C10.2239 10.7498 10 10.9737 10 11.2498C10 11.526 10.2239 11.7498 10.5 11.7498C10.7761 11.7498 11 11.526 11 11.2498C11 10.9737 10.7761 10.7498 10.5 10.7498ZM9 11.2498C9 10.4214 9.67157 9.74984 10.5 9.74984C11.3284 9.74984 12 10.4214 12 11.2498C12 12.0783 11.3284 12.7498 10.5 12.7498C9.67157 12.7498 9 12.0783 9 11.2498Z";
  const IconPathPrint = "M13 4.70001H12V2.20001C12 1.92001 11.78 1.70001 11.5 1.70001H4.5C4.22 1.70001 4 1.92001 4 2.20001V4.70001H3C2.17 4.70001 1.5 5.37001 1.5 6.20001V11.2C1.5 11.48 1.72 11.7 2 11.7H4V14.2C4 14.48 4.22 14.7 4.5 14.7H11.5C11.78 14.7 12 14.48 12 14.2V11.7H14C14.28 11.7 14.5 11.48 14.5 11.2V6.20001C14.5 5.37001 13.83 4.70001 13 4.70001ZM5 2.70001H11V4.70001H5V2.70001ZM11 13.7H5V9.70001H11V13.7ZM13.5 10.7H12V9.20001C12 8.92001 11.78 8.70001 11.5 8.70001H4.5C4.22 8.70001 4 8.92001 4 9.20001V10.7H2.5V6.20001C2.5 5.92001 2.72 5.70001 3 5.70001H13C13.28 5.70001 13.5 5.92001 13.5 6.20001V10.7ZM12.25 7.20001C12.25 7.61001 11.91 7.95001 11.5 7.95001C11.09 7.95001 10.75 7.61001 10.75 7.20001C10.75 6.79001 11.09 6.45001 11.5 6.45001C11.91 6.45001 12.25 6.79001 12.25 7.20001Z";
  const IconPathPriority = "M7.99967 3.33337C8.36786 3.33337 8.66634 3.63185 8.66634 4.00004V8.66671C8.66634 9.0349 8.36786 9.33337 7.99967 9.33337C7.63148 9.33337 7.33301 9.0349 7.33301 8.66671V4.00004C7.33301 3.63185 7.63148 3.33337 7.99967 3.33337ZM7.99967 11.3334C8.36786 11.3334 8.66634 11.6319 8.66634 12V12.0034C8.66634 12.3716 8.36786 12.67 7.99967 12.67C7.63148 12.67 7.33301 12.3716 7.33301 12.0034V12C7.33301 11.6319 7.63148 11.3334 7.99967 11.3334Z";
  const IconPathPriorityHigh = "M5.1059 2.19229C5.20066 2.07094 5.34604 2 5.5 2H10.5C10.654 2 10.7994 2.07094 10.8941 2.19229C10.9889 2.31365 11.0224 2.4719 10.9851 2.62127L9.48508 8.62127C9.42943 8.84385 9.22944 9 9 9H7C6.77057 9 6.57058 8.84385 6.51493 8.62127L5.01493 2.62127C4.97759 2.4719 5.01115 2.31365 5.1059 2.19229ZM6.14039 3L7.39039 8H8.60962L9.85962 3H6.14039ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13C8.55229 13 9 12.5523 9 12C9 11.4477 8.55229 11 8 11ZM6 12C6 10.8954 6.89543 10 8 10C9.10457 10 10 10.8954 10 12C10 13.1046 9.10457 14 8 14C6.89543 14 6 13.1046 6 12Z";
  const IconPathPrivacy = "M7.86414 1.51881C7.95298 1.49373 8.04703 1.49373 8.13587 1.51881L12.3736 2.71536C13.0562 2.8745 13.5 3.48353 13.5 4.15V7.25C13.5 10.479 11.3497 13.3574 8.16518 14.4719C8.05824 14.5094 7.94176 14.5094 7.83483 14.4719C4.65032 13.3574 2.5 10.479 2.5 7.25V4.15C2.5 3.48353 2.94377 2.8745 3.62636 2.71536L7.86414 1.51881ZM8 2.51955L3.88586 3.68119C3.8768 3.68375 3.86766 3.68605 3.85847 3.68809C3.64965 3.7345 3.5 3.92139 3.5 4.15V7.25C3.5 9.96646 5.27756 12.4433 8 13.4681C10.7224 12.4433 12.5 9.96646 12.5 7.25V4.15C12.5 3.92139 12.3504 3.7345 12.1415 3.68809C12.1323 3.68605 12.1232 3.68375 12.1141 3.68119L8 2.51955ZM10.6353 5.60145C10.8554 5.7682 10.8986 6.08182 10.7319 6.30193L8.08036 9.80193C7.98584 9.9267 7.83835 10 7.68182 10C7.52529 10 7.37779 9.9267 7.28327 9.80193L5.76812 7.80193C5.60137 7.58182 5.64463 7.2682 5.86474 7.10145C6.08485 6.9347 6.39846 6.97796 6.56521 7.19807L7.68182 8.67199L9.93479 5.69807C10.1015 5.47796 10.4152 5.4347 10.6353 5.60145Z";
  const IconPathPrivatePublic = "M4.67 10.29C4.67 10.02 4.44 9.79 4.17 9.79H3.17C3.08 9.79 3 9.72 3 9.63V4.96C3 4.87 3.08 4.79 3.17 4.79H8.5C8.59 4.79 8.67 4.87 8.67 4.96V5.29C8.67 5.57 8.89 5.79 9.17 5.79C9.45 5.79 9.67 5.57 9.67 5.29V4.96C9.67 4.32 9.14 3.79 8.5 3.79H8.33V3.29C8.33 1.91 7.21 0.800003 5.83 0.800003C4.45 0.800003 3.33 1.91 3.33 3.29V3.79H3.17C2.52 3.79 2 4.32 2 4.96V9.63C2 10.27 2.52 10.79 3.17 10.79H4.17C4.44 10.79 4.67 10.57 4.67 10.29ZM4.33 3.29C4.33 2.47 5.01 1.79 5.83 1.79C6.65 1.79 7.33 2.47 7.33 3.29V3.79H4.33V3.29ZM14.33 10.29C14.33 12.96 12.17 15.12 9.5 15.12C8.2 15.12 7.02 14.61 6.15 13.78C5.95 13.59 5.95 13.27 6.14 13.07C6.33 12.87 6.65 12.87 6.85 13.07C7.54 13.73 8.47 14.14 9.5 14.14C9.61 14.14 9.72 14.14 9.83 14.12V13.18C9.5 13.18 8.83 12.96 8.83 12.09L8.5 11.36L9.17 10.64H10.5C10.83 10.64 11.5 10.85 11.5 11.73V12.45C11.69 12.45 12.16 12.53 12.47 12.72C13.01 12.06 13.33 11.22 13.33 10.3C13.33 9.31 12.95 8.4 12.33 7.72C12.14 7.51 12.16 7.2 12.36 7.01C12.56 6.83 12.88 6.84 13.07 7.04C13.85 7.9 14.33 9.05 14.33 10.3V10.29ZM5.83 6.29C6.39 6.29 6.83 6.74 6.83 7.29C6.83 7.84 6.39 8.29 5.83 8.29C5.27 8.29 4.83 7.85 4.83 7.29C4.83 6.73 5.28 6.29 5.83 6.29ZM13.85 4.31L4.19 13.98C3.99 14.17 3.68 14.17 3.48 13.98C3.29 13.78 3.29 13.47 3.48 13.27L13.14 3.61C13.34 3.41 13.66 3.41 13.85 3.61C14.05 3.8 14.05 4.12 13.85 4.31Z";
  const IconPathRadioChecked = "M8 2.5C4.96 2.5 2.5 4.96 2.5 8C2.5 11.04 4.96 13.5 8 13.5C11.04 13.5 13.5 11.04 13.5 8C13.5 4.96 11.04 2.5 8 2.5ZM1.5 8C1.5 4.41 4.41 1.5 8 1.5C11.59 1.5 14.5 4.41 14.5 8C14.5 11.59 11.59 14.5 8 14.5C4.41 14.5 1.5 11.59 1.5 8ZM8 11.5C9.93 11.5 11.5 9.93 11.5 8C11.5 6.07 9.93 4.5 8 4.5C6.07 4.5 4.5 6.07 4.5 8C4.5 9.93 6.07 11.5 8 11.5Z";
  const IconPathRadioUnchecked = "M8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5ZM1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8Z";
  const IconPathRebootHard = "M8.5 11.2498C8.15 11.2498 7.87 10.9798 7.87 10.6498C7.87 10.3198 8.15 10.0498 8.5 10.0498C8.85 10.0498 9.13 10.3198 9.13 10.6498C9.13 10.9798 8.85 11.2498 8.5 11.2498ZM3.5 4.8698C4.58 3.3098 6.41 2.2998 8.49 2.2998C11.78 2.2998 14.49 4.8698 14.49 8.0798C14.49 11.2898 11.78 13.8598 8.49 13.8598C6.17 13.8598 4.15 12.5898 3.15 10.7198C3.02 10.4798 3.11 10.1698 3.36 10.0398C3.6 9.9098 3.91 9.9998 4.04 10.2498C4.86 11.7998 6.55 12.8698 8.5 12.8698C11.28 12.8698 13.5 10.7098 13.5 8.0898C13.5 5.4698 11.27 3.2998 8.49 3.2998C6.75 3.2998 5.23 4.1498 4.34 5.4198H5.51C5.79 5.4198 6.01 5.6398 6.01 5.9198C6.01 6.1998 5.79 6.4198 5.51 6.4198H2.5V3.5198C2.5 3.2398 2.72 3.0198 3 3.0198C3.28 3.0198 3.5 3.2398 3.5 3.5198V4.8698ZM8.5 4.6998C8.78 4.6998 9 4.9198 9 5.1998V8.7998C9 9.0798 8.78 9.2998 8.5 9.2998C8.22 9.2998 8 9.0798 8 8.7998V5.1998C8 4.9198 8.22 4.6998 8.5 4.6998Z";
  const IconPathRebootSoft = "M3.51245 4.90562C4.59154 3.35427 6.42654 2.33984 8.50005 2.33984C11.7943 2.33984 14.5001 4.90866 14.5001 8.11984C14.5001 11.3311 11.7943 13.8998 8.50005 13.8998C6.17812 13.8998 4.15575 12.628 3.15826 10.7548C3.02846 10.5111 3.12083 10.2083 3.36457 10.0785C3.60831 9.94872 3.91112 10.0411 4.04091 10.2848C4.86435 11.8312 6.54691 12.8998 8.50005 12.8998C11.2808 12.8998 13.5001 10.7407 13.5001 8.11984C13.5001 5.49903 11.2808 3.33984 8.50005 3.33984C6.76277 3.33984 5.24002 4.18531 4.34519 5.45984H5.51245C5.78859 5.45984 6.01245 5.6837 6.01245 5.95984C6.01245 6.23599 5.78859 6.45984 5.51245 6.45984H2.51245V3.55984C2.51245 3.2837 2.73631 3.05984 3.01245 3.05984C3.28859 3.05984 3.51245 3.2837 3.51245 3.55984V4.90562ZM8.50005 4.73984C8.77619 4.73984 9.00005 4.9637 9.00005 5.23984V7.90673L10.3463 9.19914C10.5455 9.39038 10.552 9.7069 10.3607 9.9061C10.1695 10.1053 9.85299 10.1118 9.65379 9.92053L8.15379 8.48053C8.05557 8.38624 8.00005 8.25599 8.00005 8.11984V5.23984C8.00005 4.9637 8.22391 4.73984 8.50005 4.73984Z";
  const IconPathRefresh = "M8 3.33984C5.21921 3.33984 3 5.49903 3 8.11984C3 10.7407 5.21921 12.8998 8 12.8998C9.95314 12.8998 11.6357 11.8312 12.4591 10.2848C12.5889 10.0411 12.8917 9.94872 13.1355 10.0785C13.3792 10.2083 13.4716 10.5111 13.3418 10.7548C12.3443 12.628 10.3219 13.8998 8 13.8998C4.70579 13.8998 2 11.3311 2 8.11984C2 4.90866 4.70579 2.33984 8 2.33984C10.0735 2.33984 11.9085 3.35427 12.9876 4.90562V3.55984C12.9876 3.2837 13.2115 3.05984 13.4876 3.05984C13.7637 3.05984 13.9876 3.2837 13.9876 3.55984V6.45984H10.9876C10.7115 6.45984 10.4876 6.23599 10.4876 5.95984C10.4876 5.6837 10.7115 5.45984 10.9876 5.45984H12.1549C11.26 4.18531 9.73728 3.33984 8 3.33984Z";
  const IconPathRemove = "M2.5 8C2.5 7.72386 2.72386 7.5 3 7.5H14C14.2761 7.5 14.5 7.72386 14.5 8C14.5 8.27614 14.2761 8.5 14 8.5H3C2.72386 8.5 2.5 8.27614 2.5 8Z";
  const IconPathRemoveCircle = "M1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8ZM8 2.5C4.96244 2.5 2.5 4.96244 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5ZM4.5 8C4.5 7.72386 4.72386 7.5 5 7.5H11C11.2761 7.5 11.5 7.72386 11.5 8C11.5 8.27614 11.2761 8.5 11 8.5H5C4.72386 8.5 4.5 8.27614 4.5 8Z";
  const IconPathRemoveCircleFilled = "M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM3.96447 8C3.96447 7.72386 4.18832 7.5 4.46447 7.5H11.5355C11.8117 7.5 12.0355 7.72386 12.0355 8C12.0355 8.27614 11.8117 8.5 11.5355 8.5H4.46447C4.18832 8.5 3.96447 8.27614 3.96447 8Z";
  const IconPathRestore = "M3 4.9054C4.07911 3.35417 5.91403 2.33984 7.98747 2.33984C11.2816 2.33984 13.9875 4.90866 13.9875 8.11984C13.9875 11.3311 11.2816 13.8998 7.98747 13.8998C5.66555 13.8998 3.64315 12.628 2.64563 10.7549C2.51583 10.5111 2.6082 10.2083 2.85194 10.0785C3.09567 9.94872 3.39848 10.0411 3.52828 10.2848C4.35175 11.8312 6.03434 12.8998 7.98747 12.8998C10.7682 12.8998 12.9875 10.7407 12.9875 8.11984C12.9875 5.49903 10.7682 3.33984 7.98747 3.33984C6.25017 3.33984 4.72742 4.18531 3.83259 5.45984H5C5.27614 5.45984 5.5 5.6837 5.5 5.95984C5.5 6.23599 5.27614 6.45984 5 6.45984H2V3.55984C2 3.2837 2.22386 3.05984 2.5 3.05984C2.77614 3.05984 3 3.2837 3 3.55984V4.9054Z";
  const IconPathRestoreWarning = "M8 11.25C7.65 11.25 7.37 10.98 7.37 10.65C7.37 10.32 7.65 10.05 8 10.05C8.35 10.05 8.63 10.32 8.63 10.65C8.63 10.98 8.35 11.25 8 11.25ZM3 4.87C4.08 3.31 5.91 2.3 7.99 2.3C11.28 2.3 13.99 4.87 13.99 8.08C13.99 11.29 11.28 13.86 7.99 13.86C5.67 13.86 3.65 12.59 2.65 10.72C2.52 10.48 2.61 10.17 2.86 10.04C3.1 9.91 3.41 10 3.54 10.25C4.36 11.8 6.05 12.87 8 12.87C10.78 12.87 13 10.71 13 8.09C13 5.47 10.77 3.3 7.99 3.3C6.25 3.3 4.73 4.15 3.84 5.42H5.01C5.29 5.42 5.51 5.64 5.51 5.92C5.51 6.2 5.29 6.42 5.01 6.42H2V3.52C2 3.24 2.22 3.02 2.5 3.02C2.78 3.02 3 3.24 3 3.52V4.87ZM8 4.7C8.28 4.7 8.5 4.92 8.5 5.2V8.8C8.5 9.08 8.28 9.3 8 9.3C7.72 9.3 7.5 9.08 7.5 8.8V5.2C7.5 4.92 7.72 4.7 8 4.7Z";
  const IconPathRoute = "M8.4199 7.16998C8.3099 7.16998 8.2099 7.17998 8.1199 7.20998C7.8499 7.27998 7.5799 7.11998 7.5099 6.85998C7.4399 6.58998 7.5999 6.31998 7.8599 6.24998C8.0399 6.19998 8.2299 6.17998 8.4199 6.17998H8.9099C9.1899 6.17998 9.4099 6.39998 9.4099 6.67998C9.4099 6.95998 9.1899 7.17998 8.9099 7.17998H8.4199V7.16998ZM10.3599 6.66998C10.3599 6.38998 10.5799 6.16998 10.8599 6.16998H11.3499C11.6299 6.16998 11.8499 6.38998 11.8499 6.66998C11.8499 6.94998 11.6299 7.16998 11.3499 7.16998H10.8599C10.5799 7.16998 10.3599 6.94998 10.3599 6.66998ZM6.9399 7.41998C7.2099 7.48998 7.3699 7.76998 7.2899 8.02998C7.2599 8.12998 7.2499 8.22998 7.2499 8.32998C7.2499 8.42998 7.2599 8.53998 7.2899 8.62998C7.3599 8.89998 7.1999 9.16998 6.9399 9.23998C6.6699 9.30998 6.3999 9.14998 6.3299 8.88998C6.2799 8.70998 6.2599 8.51998 6.2599 8.32998C6.2599 8.13998 6.2899 7.94998 6.3299 7.76998C6.3999 7.49998 6.6799 7.33998 6.9399 7.41998ZM7.5099 9.81998C7.5799 9.54998 7.8599 9.38998 8.1199 9.46998C8.2199 9.49998 8.3199 9.50998 8.4199 9.50998H8.9599C9.2399 9.50998 9.4599 9.72998 9.4599 10.01C9.4599 10.29 9.2399 10.51 8.9599 10.51H8.4199C8.2299 10.51 8.0399 10.48 7.8599 10.44C7.5899 10.37 7.4299 10.09 7.5099 9.82998V9.81998ZM10.6399 10.01C10.6399 9.72998 10.8599 9.50998 11.1399 9.50998H11.6799C11.8999 9.50998 12.1199 9.53998 12.3299 9.58998C12.5999 9.65998 12.7599 9.93998 12.6799 10.2C12.6099 10.47 12.3299 10.63 12.0699 10.55C11.9499 10.52 11.8199 10.5 11.6799 10.5H11.1399C10.8599 10.5 10.6399 10.28 10.6399 9.99998V10.01ZM13.4899 11.01C13.7599 10.94 14.0299 11.1 14.0999 11.36C14.1599 11.57 14.1799 11.78 14.1799 12.01C14.1799 12.24 14.1499 12.45 14.0999 12.66C14.0299 12.93 13.7499 13.09 13.4899 13.01C13.2199 12.94 13.0599 12.66 13.1399 12.4C13.1699 12.28 13.1899 12.15 13.1899 12.01C13.1899 11.87 13.1699 11.74 13.1399 11.62C13.0699 11.35 13.2299 11.08 13.4899 11.01ZM12.6899 13.81C12.7599 14.08 12.5999 14.35 12.3399 14.42C12.1299 14.48 11.9199 14.5 11.6899 14.5H10.6899C10.4099 14.5 10.1899 14.28 10.1899 14C10.1899 13.72 10.4099 13.5 10.6899 13.5H11.6899C11.8299 13.5 11.9599 13.48 12.0799 13.45C12.3499 13.38 12.6199 13.54 12.6899 13.8V13.81ZM5.1899 14.01C5.1899 13.73 5.4099 13.51 5.6899 13.51H6.6899C6.9699 13.51 7.1899 13.73 7.1899 14.01C7.1899 14.29 6.9699 14.51 6.6899 14.51H5.6899C5.4099 14.51 5.1899 14.29 5.1899 14.01ZM13.2799 2.09998C12.7299 2.09998 12.2799 2.54998 12.2799 3.09998C12.2799 3.64998 12.7299 4.09998 13.2799 4.09998C13.8299 4.09998 14.2799 3.64998 14.2799 3.09998C14.2799 2.54998 13.8299 2.09998 13.2799 2.09998ZM11.2799 3.09998C11.2799 1.99998 12.1799 1.09998 13.2799 1.09998C14.3799 1.09998 15.2799 1.99998 15.2799 3.09998C15.2799 4.01998 14.6599 4.78998 13.8199 5.02998C13.8299 5.06998 13.8399 5.11998 13.8399 5.16998V6.83998C13.8399 7.11998 13.6199 7.33998 13.3399 7.33998C13.0599 7.33998 12.8399 7.11998 12.8399 6.83998V5.16998C12.8399 5.16998 12.8399 5.08998 12.8499 5.05998C11.9499 4.86998 11.2699 4.05998 11.2699 3.09998H11.2799ZM2.9099 8.49998C2.0799 8.49998 1.4099 9.16998 1.4099 9.99998C1.4099 10.83 2.0799 11.5 2.9099 11.5C3.7399 11.5 4.4099 10.83 4.4099 9.99998C4.4099 9.16998 3.7399 8.49998 2.9099 8.49998ZM0.409902 9.99998C0.409902 8.61998 1.5299 7.49998 2.9099 7.49998C4.2899 7.49998 5.4099 8.61998 5.4099 9.99998C5.4099 11.18 4.5999 12.16 3.4999 12.43C3.4999 12.45 3.4999 12.48 3.4999 12.5V14.17C3.4999 14.45 3.2799 14.67 2.9999 14.67C2.7199 14.67 2.4999 14.45 2.4999 14.17V12.5C2.4999 12.5 2.4999 12.48 2.4999 12.47C1.3099 12.28 0.399902 11.25 0.399902 9.99998H0.409902Z";
  const IconPathSave = "M3 2.5C2.70948 2.5 2.5 2.70948 2.5 3V13C2.5 13.2905 2.70948 13.5 3 13.5H4V8.5C4 7.65719 4.65719 7 5.5 7H10.5C11.3428 7 12 7.65719 12 8.5V13.5H13C13.2905 13.5 13.5 13.2905 13.5 13V5.06667C13.5 4.94128 13.459 4.83277 13.3464 4.72022L11.2798 2.65355C11.2691 2.64287 11.2589 2.6317 11.2492 2.62009C11.2058 2.56795 11.1191 2.5178 11 2.50383V4.5C11 5.34281 10.3428 6 9.5 6H5.5C4.65719 6 4 5.34281 4 4.5V2.5H3ZM3 1.5C2.15719 1.5 1.5 2.15719 1.5 3V13C1.5 13.8428 2.15719 14.5 3 14.5H13C13.8428 14.5 14.5 13.8428 14.5 13V5.06667C14.5 4.65872 14.341 4.30057 14.0536 4.01311L12.0009 1.96044C11.719 1.63591 11.3058 1.5 10.9333 1.5H3ZM5 2.5V4.5C5 4.79052 5.20948 5 5.5 5H9.5C9.79052 5 10 4.79052 10 4.5V2.5H5ZM11 13.5V8.5C11 8.20948 10.7905 8 10.5 8H5.5C5.20948 8 5 8.20948 5 8.5V13.5H11ZM9 3C9.27614 3 9.5 3.22386 9.5 3.5V4C9.5 4.27614 9.27614 4.5 9 4.5C8.72386 4.5 8.5 4.27614 8.5 4V3.5C8.5 3.22386 8.72386 3 9 3Z";
  const IconPathScooter = "M8 2.66675C7.44772 2.66675 7 3.11446 7 3.66675C7 4.21903 7.44772 4.66675 8 4.66675C8.55228 4.66675 9 4.21903 9 3.66675C9 3.11446 8.55228 2.66675 8 2.66675ZM9.54038 4.94246C9.72604 4.71853 9.86381 4.45345 9.93797 4.16294C9.95829 4.16545 9.97899 4.16675 10 4.16675H11C11.1326 4.16675 11.2598 4.11407 11.3536 4.0203L12.2071 3.16675H13C13.2761 3.16675 13.5 2.94289 13.5 2.66675C13.5 2.39061 13.2761 2.16675 13 2.16675H12C11.8674 2.16675 11.7402 2.21943 11.6464 2.31319L10.7929 3.16675H10C9.97899 3.16675 9.95829 3.16804 9.93797 3.17056C9.71727 2.30601 8.93329 1.66675 8 1.66675C7.06671 1.66675 6.28273 2.30601 6.06203 3.17056C6.04171 3.16804 6.02101 3.16675 6 3.16675H5.20711L4.35355 2.31319C4.25979 2.21943 4.13261 2.16675 4 2.16675H3C2.72386 2.16675 2.5 2.39061 2.5 2.66675C2.5 2.94289 2.72386 3.16675 3 3.16675H3.79289L4.64645 4.0203C4.74021 4.11407 4.86739 4.16675 5 4.16675H6C6.02101 4.16675 6.04171 4.16545 6.06203 4.16294C6.13619 4.45345 6.27396 4.71853 6.45962 4.94246C5.03988 5.47113 4 6.71059 4 8.22675V12.1667C4 12.4429 4.22386 12.6667 4.5 12.6667H6.5V13.1667C6.5 13.9952 7.17157 14.6667 8 14.6667C8.82843 14.6667 9.5 13.9952 9.5 13.1667V12.6667H11.5C11.7761 12.6667 12 12.4429 12 12.1667V8.22675C12 6.71059 10.9601 5.47113 9.54038 4.94246ZM9.5 11.6667H11V8.22675C11 6.87413 9.71936 5.66675 8 5.66675C6.28064 5.66675 5 6.87413 5 8.22675V11.6667H6.5V11.1667C6.5 10.3383 7.17157 9.66675 8 9.66675C8.82843 9.66675 9.5 10.3383 9.5 11.1667V11.6667ZM7 7.66675C7 7.39061 7.22386 7.16675 7.5 7.16675H8.5C8.77614 7.16675 9 7.39061 9 7.66675C9 7.94289 8.77614 8.16675 8.5 8.16675H7.5C7.22386 8.16675 7 7.94289 7 7.66675ZM8 10.6667C7.72386 10.6667 7.5 10.8906 7.5 11.1667V13.1667C7.5 13.4429 7.72386 13.6667 8 13.6667C8.27614 13.6667 8.5 13.4429 8.5 13.1667V11.1667C8.5 10.8906 8.27614 10.6667 8 10.6667Z";
  const IconPathScooterElectric = "M3.5 2.5C3.5 2.22386 3.72386 2 4 2H6.11803L6.95869 2.42033C7.22848 2.16008 7.59554 2 8 2C8.40446 2 8.77152 2.16008 9.04131 2.42033L9.88197 2H12C12.2761 2 12.5 2.22386 12.5 2.5C12.5 2.77614 12.2761 3 12 3H10.118L9.48867 3.31468C9.49615 3.37541 9.5 3.43725 9.5 3.5C9.5 4.15311 9.0826 4.70873 8.5 4.91465V9.06278C9.02628 9.19779 9.46825 9.54111 9.73318 10H10.5C10.7761 10 11 10.2239 11 10.5C11 10.7761 10.7761 11 10.5 11H10V12.5C10 12.7761 9.77614 13 9.5 13C9.22386 13 9 12.7761 9 12.5V11C9 10.4461 8.55386 10 8 10C7.44614 10 7 10.4461 7 11V12.5C7 12.7761 6.77614 13 6.5 13C6.22386 13 6 12.7761 6 12.5V11H5.5C5.22386 11 5 10.7761 5 10.5C5 10.2239 5.22386 10 5.5 10H6.26682C6.53175 9.54111 6.97372 9.19779 7.5 9.06278V4.91465C6.9174 4.70873 6.5 4.15311 6.5 3.5C6.5 3.43725 6.50385 3.37541 6.51133 3.31468L5.88197 3H4C3.72386 3 3.5 2.77614 3.5 2.5ZM8 3C7.72386 3 7.5 3.22386 7.5 3.5C7.5 3.77614 7.72386 4 8 4C8.27614 4 8.5 3.77614 8.5 3.5C8.5 3.22386 8.27614 3 8 3ZM8 10.5C8.27614 10.5 8.5 10.7239 8.5 11V14C8.5 14.2761 8.27614 14.5 8 14.5C7.72386 14.5 7.5 14.2761 7.5 14V11C7.5 10.7239 7.72386 10.5 8 10.5Z";
  const IconPathSearch = "M1.4707 6.50012C1.4707 3.72244 3.72244 1.4707 6.5001 1.4707C9.27775 1.4707 11.5295 3.72244 11.5295 6.50012C11.5295 7.66843 11.1311 8.7437 10.4628 9.59751L13.8667 12.8653C14.0776 13.0677 14.0845 13.4029 13.882 13.6138C13.6795 13.8247 13.3444 13.8315 13.1335 13.6291L9.72651 10.3584C8.85323 11.0894 7.72806 11.5295 6.5001 11.5295C3.72244 11.5295 1.4707 9.27776 1.4707 6.50012ZM6.5001 2.5295C4.3072 2.5295 2.5295 4.3072 2.5295 6.50012C2.5295 8.693 4.3072 10.4707 6.5001 10.4707C8.69299 10.4707 10.4707 8.69299 10.4707 6.50012C10.4707 4.3072 8.69299 2.5295 6.5001 2.5295Z";
  const IconPathSelectedPartners = "M15.1401 4.79999C15.1401 4.22999 14.8301 3.68999 14.3401 3.40999L8.8001 0.209993C8.3001 -0.0800073 7.6901 -0.0800073 7.1901 0.209993L1.6501 3.40999C1.1501 3.69999 0.850098 4.22999 0.850098 4.79999V11.19C0.850098 11.76 1.1601 12.3 1.6501 12.58L7.1801 15.78C7.4301 15.92 7.7101 15.99 7.9801 15.99C8.2501 15.99 8.5401 15.92 8.7801 15.78L14.3101 12.58C14.7701 12.32 15.0701 11.84 15.1101 11.32L15.1401 4.79999ZM14.3601 11.2C14.3601 11.5 14.2201 11.77 13.9601 11.92L8.4301 15.12C8.1701 15.27 7.8501 15.27 7.5801 15.12L2.0501 11.92C1.7901 11.77 1.6301 11.49 1.6301 11.19V4.79999C1.6301 4.49999 1.7901 4.21999 2.0501 4.06999L7.5701 0.879993C7.7001 0.799993 7.8501 0.769993 7.9901 0.769993C8.1301 0.769993 8.2801 0.809993 8.4101 0.879993L13.9401 4.07999C14.2001 4.22999 14.3601 4.50999 14.3601 4.80999V11.2ZM11.0601 7.05999L10.5801 7.37999C10.2801 7.57999 9.8801 7.49999 9.6801 7.20999L8.5501 5.55999C8.2901 5.17999 7.7301 5.17999 7.4701 5.55999L6.3401 7.20999C6.1401 7.50999 5.7301 7.57999 5.4401 7.37999L4.9601 7.05999C4.4101 6.68999 3.7201 7.28999 4.0101 7.88999L4.1601 8.18999C4.4701 8.82999 4.7301 9.49999 4.9301 10.18L4.9501 10.25C5.0301 10.53 5.2901 10.72 5.5801 10.72H10.4701C10.7601 10.72 11.0101 10.53 11.1001 10.25L11.1201 10.18C11.3201 9.49999 11.5801 8.83999 11.8901 8.18999L12.0401 7.88999C12.3301 7.28999 11.6401 6.68999 11.0901 7.05999H11.0601ZM8.9401 8.71999L8.6101 9.28999C8.5501 9.38999 8.4401 9.44999 8.3301 9.44999H7.6801C7.5601 9.44999 7.4601 9.38999 7.4001 9.28999L7.0701 8.71999C7.0101 8.61999 7.0101 8.48999 7.0701 8.38999L7.4001 7.81999C7.4601 7.71999 7.5701 7.65999 7.6801 7.65999H8.3301C8.4501 7.65999 8.5501 7.71999 8.6101 7.81999L8.9401 8.38999C9.0001 8.48999 9.0001 8.61999 8.9401 8.71999Z";
  const IconPathSettings = "M6.00454 1.93304C6.03805 1.68503 6.24977 1.5 6.50004 1.5H9.50004C9.7503 1.5 9.96202 1.68503 9.99553 1.93304L10.2092 3.51436C10.4073 3.61644 10.589 3.72875 10.7575 3.83849L12.2643 3.23576C12.4952 3.14341 12.7589 3.23475 12.8831 3.45014L14.3831 6.05014C14.5085 6.26749 14.4534 6.54413 14.2543 6.6968L12.9749 7.67761C12.991 7.89966 12.9918 8.11274 12.9768 8.32381L14.2543 9.3032C14.4534 9.45587 14.5085 9.73251 14.3831 9.94986L12.8831 12.5499C12.7589 12.7652 12.4952 12.8566 12.2643 12.7642L10.7575 12.1615C10.589 12.2713 10.4073 12.3836 10.2092 12.4856L9.99553 14.067C9.96202 14.315 9.7503 14.5 9.50004 14.5H6.50004C6.25479 14.5 6.04574 14.3221 6.00648 14.08L5.74858 12.4896C5.54755 12.3865 5.36327 12.2727 5.19255 12.1615L3.68573 12.7642C3.45486 12.8566 3.1912 12.7652 3.06694 12.5499L1.56694 9.94986C1.44155 9.73251 1.49668 9.45587 1.69582 9.3032L2.97374 8.32346C2.9588 8.11011 2.9588 7.88989 2.97374 7.67654L1.69582 6.6968C1.49668 6.54413 1.44155 6.26749 1.56694 6.05014L3.06694 3.45014C3.19029 3.23633 3.45121 3.14453 3.68126 3.234L5.23997 3.84016C5.40923 3.72989 5.59181 3.61696 5.79085 3.51436L6.00454 1.93304ZM6.93701 2.5L6.74553 3.91696C6.72198 4.09122 6.60862 4.2403 6.447 4.30957C6.14564 4.43873 5.88233 4.61273 5.57739 4.81603C5.4418 4.90641 5.27068 4.92506 5.11881 4.866L3.71871 4.32152L2.65227 6.17001L3.80425 7.0532C3.94764 7.16312 4.02056 7.34185 3.99501 7.52071C3.95171 7.82381 3.95171 8.17619 3.99501 8.47929C4.02056 8.65815 3.94764 8.83688 3.80425 8.9468L2.65227 9.82999L3.71662 11.6749L5.06434 11.1358C5.21721 11.0746 5.39039 11.0926 5.52739 11.184C5.83233 11.3873 6.09564 11.5613 6.397 11.6904C6.5543 11.7578 6.66619 11.901 6.69359 12.07L6.92549 13.5H9.06306L9.25454 12.083C9.27809 11.9088 9.39145 11.7597 9.55308 11.6904C9.85444 11.5613 10.1177 11.3873 10.4227 11.184C10.5597 11.0926 10.7329 11.0746 10.8857 11.1358L12.2335 11.6749L13.2978 9.82999L12.1458 8.9468C12.0024 8.83688 11.9295 8.65815 11.9551 8.47929C11.998 8.17893 11.9991 7.87396 11.9539 7.51202C11.9319 7.33585 12.0049 7.16122 12.1458 7.0532L13.2978 6.17001L12.2335 4.32515L10.8857 4.86424C10.7329 4.92539 10.5597 4.90736 10.4227 4.81603C10.1177 4.61273 9.85443 4.43873 9.55308 4.30957C9.39145 4.2403 9.27809 4.09122 9.25454 3.91696L9.06306 2.5H6.93701ZM8.00004 6.5C7.17161 6.5 6.50004 7.17157 6.50004 8C6.50004 8.82843 7.17161 9.5 8.00004 9.5C8.82846 9.5 9.50004 8.82843 9.50004 8C9.50004 7.17157 8.82846 6.5 8.00004 6.5ZM5.50004 8C5.50004 6.61929 6.61932 5.5 8.00004 5.5C9.38075 5.5 10.5 6.61929 10.5 8C10.5 9.38071 9.38075 10.5 8.00004 10.5C6.61932 10.5 5.50004 9.38071 5.50004 8Z";
  const IconPathSolarPanel = "M4.5 2.5C3.67157 2.5 3 3.17157 3 4C3 4.82843 3.67157 5.5 4.5 5.5C5.32843 5.5 6 4.82843 6 4C6 3.17157 5.32843 2.5 4.5 2.5ZM2 4C2 2.61929 3.11929 1.5 4.5 1.5C5.88071 1.5 7 2.61929 7 4C7 5.38071 5.88071 6.5 4.5 6.5C3.11929 6.5 2 5.38071 2 4ZM8 4C8 3.72386 8.22386 3.5 8.5 3.5H9.25C9.52614 3.5 9.75 3.72386 9.75 4C9.75 4.27614 9.52614 4.5 9.25 4.5H8.5C8.22386 4.5 8 4.27614 8 4ZM6.97523 6.47493C7.17049 6.27967 7.48707 6.27968 7.68233 6.47494L8.21282 7.00544C8.40808 7.20071 8.40808 7.51729 8.21281 7.71255C8.01755 7.90781 7.70096 7.90781 7.50571 7.71254L6.97522 7.18204C6.77996 6.98678 6.77996 6.67019 6.97523 6.47493ZM12.3536 6.64645C12.5488 6.84171 12.5488 7.15829 12.3536 7.35355L10.5 9.20711V13.5H13.5C13.7761 13.5 14 13.7239 14 14C14 14.2761 13.7761 14.5 13.5 14.5H4.5C4.22386 14.5 4 14.2761 4 14C4 13.7239 4.22386 13.5 4.5 13.5H9.5V10.2071L7.85355 11.8536C7.65829 12.0488 7.34171 12.0488 7.14645 11.8536C6.95118 11.6583 6.95118 11.3417 7.14645 11.1464L9.64604 8.64686C9.64631 8.64658 9.64658 8.64631 9.64686 8.64604L11.6464 6.64645C11.8417 6.45118 12.1583 6.45118 12.3536 6.64645ZM4.5 7.5C4.77614 7.5 5 7.72386 5 8V8.75C5 9.02614 4.77614 9.25 4.5 9.25C4.22386 9.25 4 9.02614 4 8.75V8C4 7.72386 4.22386 7.5 4.5 7.5Z";
  const IconPathSolarRoof = "M6.11104 1.14395C6.30768 1.33782 6.30993 1.6544 6.11605 1.85104L5.41605 2.56104C5.22218 2.75768 4.90561 2.75992 4.70896 2.56605C4.51232 2.37218 4.51008 2.05561 4.70395 1.85896L5.40395 1.14896C5.59782 0.952321 5.9144 0.950076 6.11104 1.14395ZM9.88896 1.14395C10.0856 0.950076 10.4022 0.952321 10.5961 1.14896L11.2961 1.85896C11.4899 2.05561 11.4877 2.37218 11.291 2.56605C11.0944 2.75992 10.7778 2.75768 10.5839 2.56104L9.88395 1.85104C9.69008 1.6544 9.69232 1.33782 9.88896 1.14395ZM7.94 2C8.21614 2 8.44 2.22386 8.44 2.5V3.5C8.44 3.77614 8.21614 4 7.94 4C7.66386 4 7.44 3.77614 7.44 3.5V2.5C7.44 2.22386 7.66386 2 7.94 2ZM3.55279 5.27639C3.63748 5.107 3.81061 5 4 5H12C12.1894 5 12.3625 5.107 12.4472 5.27639L13.4427 7.26741C13.446 7.27355 13.4491 7.27978 13.4521 7.28607L14.4472 9.27639C14.5247 9.43139 14.5164 9.61546 14.4253 9.76287C14.3342 9.91027 14.1733 10 14 10H13.5V14.3333C13.5 14.6095 13.2761 14.8333 13 14.8333H3C2.72386 14.8333 2.5 14.6095 2.5 14.3333V10H2C1.82671 10 1.66578 9.91027 1.57468 9.76287C1.48357 9.61546 1.47529 9.43139 1.55279 9.27639L2.54794 7.28609C2.55093 7.27978 2.55405 7.27355 2.55729 7.26739L3.55279 5.27639ZM3.30902 8L2.80902 9H7.44V8H3.30902ZM7.44 7H3.80902L4.30902 6H7.44V7ZM8.44 8V9H13.191L12.691 8H8.44ZM12.191 7H8.44V6H11.691L12.191 7ZM12.5 10H3.5V13.8333H6.5V11.5C6.5 11.2239 6.72386 11 7 11H9C9.27614 11 9.5 11.2239 9.5 11.5V13.8333H12.5V10ZM8.5 13.8333V12H7.5V13.8333H8.5Z";
  const IconPathSolarShade = "M10.3536 1.64645C10.5488 1.84171 10.5488 2.15829 10.3536 2.35355L6.68689 6.02022C6.49163 6.21548 6.17505 6.21548 5.97978 6.02022C5.78452 5.82496 5.78452 5.50838 5.97978 5.31311L9.64645 1.64645C9.84171 1.45118 10.1583 1.45118 10.3536 1.64645ZM13.3536 2.64645C13.5488 2.84171 13.5488 3.15829 13.3536 3.35355L10.3536 6.35355C10.1583 6.54882 9.84171 6.54882 9.64645 6.35355C9.45119 6.15829 9.45119 5.84171 9.64645 5.64645L12.6465 2.64645C12.8417 2.45118 13.1583 2.45118 13.3536 2.64645ZM14.3536 5.64645C14.5488 5.84171 14.5488 6.15829 14.3536 6.35355L12.3536 8.35355C12.1583 8.54882 11.8417 8.54882 11.6465 8.35355C11.4512 8.15829 11.4512 7.84171 11.6465 7.64645L13.6465 5.64645C13.8417 5.45118 14.1583 5.45118 14.3536 5.64645ZM3.01868 7.53129C3.07933 7.31565 3.276 7.16667 3.5 7.16667H9.5C9.72401 7.16667 9.92068 7.31565 9.98133 7.53129L11.4813 12.8646C11.5237 13.0153 11.4931 13.1771 11.3986 13.3019C11.304 13.4267 11.1565 13.5 11 13.5H2C1.84347 13.5 1.69597 13.4267 1.60145 13.3019C1.50693 13.1771 1.4763 13.0153 1.51868 12.8646L3.01868 7.53129ZM7 12.5H10.34L9.82667 10.6749H7V12.5ZM6 10.6749V12.5H2.66003L3.17334 10.6749H6ZM7 9.6749H9.54542L9.12123 8.16667H7V9.6749ZM6 8.16667V9.6749H3.45459L3.87878 8.16667H6Z";
  const IconPathSolarSun = "M3.5 2C3.5 1.72386 3.72386 1.5 4 1.5H5C5.27615 1.5 5.5 1.72386 5.5 2C5.5 2.27614 5.27615 2.5 5 2.5H4C3.72386 2.5 3.5 2.27614 3.5 2ZM6.5 1.5C6.77615 1.5 7 1.72386 7 2C7 2.55386 7.44615 3 8 3C8.55386 3 9 2.55386 9 2C9 1.72386 9.22386 1.5 9.5 1.5C9.77615 1.5 10 1.72386 10 2C10 3.10614 9.10615 4 8 4C6.89386 4 6 3.10614 6 2C6 1.72386 6.22386 1.5 6.5 1.5ZM10.5 2C10.5 1.72386 10.7239 1.5 11 1.5H12C12.2761 1.5 12.5 1.72386 12.5 2C12.5 2.27614 12.2761 2.5 12 2.5H11C10.7239 2.5 10.5 2.27614 10.5 2ZM5.46645 3.64645C5.66171 3.45118 5.9783 3.45118 6.17356 3.64645C6.36882 3.84171 6.36882 4.15829 6.17356 4.35355L5.46356 5.06355C5.26829 5.25882 4.95171 5.25882 4.75645 5.06355C4.56119 4.86829 4.56119 4.55171 4.75645 4.35645L5.46645 3.64645ZM9.93645 3.64645C10.1317 3.45118 10.4483 3.45118 10.6436 3.64645L11.3536 4.35645C11.5488 4.55171 11.5488 4.86829 11.3536 5.06355C11.1583 5.25882 10.8417 5.25882 10.6465 5.06355L9.93645 4.35355C9.74119 4.15829 9.74119 3.84171 9.93645 3.64645ZM8 4.5C8.27615 4.5 8.5 4.72386 8.5 5V6C8.5 6.27614 8.27615 6.5 8 6.5C7.72386 6.5 7.5 6.27614 7.5 6V5C7.5 4.72386 7.72386 4.5 8 4.5ZM6.49059 7.5H4C3.78479 7.5 3.59372 7.63772 3.52566 7.84189L2.64046 10.4975C2.63785 10.5047 2.63541 10.5121 2.63313 10.5195L1.52566 13.8419C1.47484 13.9944 1.50041 14.162 1.59438 14.2924C1.68836 14.4227 1.83928 14.5 2 14.5H5.49176C5.49767 14.5001 5.50357 14.5001 5.50945 14.5H10.4906C10.4964 14.5001 10.5023 14.5001 10.5083 14.5H14C14.1607 14.5 14.3116 14.4227 14.4056 14.2924C14.4996 14.162 14.5252 13.9944 14.4743 13.8419L13.3669 10.5195C13.3646 10.5121 13.3622 10.5047 13.3595 10.4975L12.4743 7.84189C12.4063 7.63772 12.2152 7.5 12 7.5H9.50942C9.50356 7.4999 9.49768 7.4999 9.49179 7.5H6.50822C6.50233 7.4999 6.49645 7.4999 6.49059 7.5ZM9.07644 8.5H6.92357L6.64579 10.1667H9.35422L9.07644 8.5ZM10.0902 8.5L10.368 10.1667H12.1952L11.6396 8.5H10.0902ZM12.5285 11.1667H10.5347L10.9236 13.5H13.3063L12.5285 11.1667ZM9.90977 13.5L9.52088 11.1667H6.47912L6.09023 13.5H9.90977ZM5.07644 13.5L5.46533 11.1667H3.47149L2.69372 13.5H5.07644ZM3.80483 10.1667H5.632L5.90977 8.5H4.36038L3.80483 10.1667Z";
  const IconPathSort = "M3.5 5.08716C3.5 4.81102 3.72386 4.58716 4 4.58716H12C12.2761 4.58716 12.5 4.81102 12.5 5.08716C12.5 5.3633 12.2761 5.58716 12 5.58716H4C3.72386 5.58716 3.5 5.3633 3.5 5.08716ZM3.5 7.96718C3.5 7.69104 3.72386 7.46718 4 7.46718H8.5C8.77614 7.46718 9 7.69104 9 7.96718C9 8.24333 8.77614 8.46718 8.5 8.46718H4C3.72386 8.46718 3.5 8.24333 3.5 7.96718ZM3.5 10.8472C3.5 10.571 3.72386 10.3472 4 10.3472H6.5C6.77614 10.3472 7 10.571 7 10.8472C7 11.1233 6.77614 11.3472 6.5 11.3472H4C3.72386 11.3472 3.5 11.1233 3.5 10.8472Z";
  const IconPathSpeed = "M8.00049 2.5C8.27663 2.5 8.50049 2.72386 8.50049 3V4C8.50049 4.27614 8.27663 4.5 8.00049 4.5C7.72435 4.5 7.50049 4.27614 7.50049 4V3C7.50049 2.72386 7.72435 2.5 8.00049 2.5ZM1.28317 5.28243C1.47843 5.08717 1.79501 5.08717 1.99027 5.28243L2.69727 5.98943C2.89253 6.1847 2.89253 6.50128 2.69727 6.69654C2.50201 6.8918 2.18542 6.8918 1.99016 6.69654L1.28316 5.98954C1.0879 5.79428 1.0879 5.47769 1.28317 5.28243ZM14.7183 5.28243C14.9135 5.47769 14.9135 5.79428 14.7183 5.98954L14.0113 6.69654C13.816 6.8918 13.4994 6.8918 13.3042 6.69654C13.1089 6.50128 13.1089 6.1847 13.3042 5.98943L14.0112 5.28243C14.2064 5.08717 14.523 5.08717 14.7183 5.28243ZM8.00049 6.5C4.96263 6.5 2.50049 8.96214 2.50049 12C2.50049 12.2761 2.27663 12.5 2.00049 12.5C1.72435 12.5 1.50049 12.2761 1.50049 12C1.50049 8.40986 4.41035 5.5 8.00049 5.5C11.5906 5.5 14.5005 8.40986 14.5005 12C14.5005 12.2761 14.2766 12.5 14.0005 12.5C13.7243 12.5 13.5005 12.2761 13.5005 12C13.5005 8.96214 11.0383 6.5 8.00049 6.5ZM9.16457 7.65299C9.43132 7.72439 9.58968 7.99852 9.51827 8.26527L8.8496 10.7633C9.24273 11.0337 9.50049 11.4868 9.50049 12C9.50049 12.8284 8.82892 13.5 8.00049 13.5C7.17206 13.5 6.50049 12.8284 6.50049 12C6.50049 11.2109 7.10984 10.5641 7.88368 10.5045L8.55228 8.0067C8.62369 7.73995 8.89781 7.58159 9.16457 7.65299ZM8.10825 11.5116C8.07354 11.504 8.03748 11.5 8.00049 11.5C7.72435 11.5 7.50049 11.7239 7.50049 12C7.50049 12.2761 7.72435 12.5 8.00049 12.5C8.27663 12.5 8.50049 12.2761 8.50049 12C8.50049 11.7766 8.354 11.5874 8.15184 11.5233C8.14456 11.5217 8.13727 11.5199 8.12999 11.518C8.12266 11.516 8.11541 11.5139 8.10825 11.5116Z";
  const IconPathSpeedHigh = "M7.99951 2.5C8.27565 2.5 8.49951 2.72386 8.49951 3V4C8.49951 4.27614 8.27565 4.5 7.99951 4.5C7.72337 4.5 7.49951 4.27614 7.49951 4V3C7.49951 2.72386 7.72337 2.5 7.99951 2.5ZM1.28219 5.28243C1.47745 5.08717 1.79403 5.08717 1.9893 5.28243L2.6963 5.98943C2.89156 6.18469 2.89156 6.50128 2.6963 6.69654C2.50103 6.8918 2.18445 6.8918 1.98919 6.69654L1.28219 5.98954C1.08693 5.79428 1.08693 5.4777 1.28219 5.28243ZM14.7173 5.28243C14.9126 5.4777 14.9126 5.79428 14.7173 5.98954L14.0103 6.69654C13.815 6.8918 13.4984 6.8918 13.3032 6.69654C13.1079 6.50128 13.1079 6.18469 13.3032 5.98943L14.0102 5.28243C14.2054 5.08717 14.522 5.08717 14.7173 5.28243ZM7.99951 6.5C4.96165 6.5 2.49951 8.96214 2.49951 12C2.49951 12.2761 2.27565 12.5 1.99951 12.5C1.72337 12.5 1.49951 12.2761 1.49951 12C1.49951 8.40986 4.40937 5.5 7.99951 5.5C11.5897 5.5 14.4995 8.40986 14.4995 12C14.4995 12.2761 14.2757 12.5 13.9995 12.5C13.7234 12.5 13.4995 12.2761 13.4995 12C13.4995 8.96214 11.0374 6.5 7.99951 6.5ZM11.8963 9.74996C12.0344 9.98909 11.9525 10.2949 11.7133 10.433L9.47452 11.7258C9.49093 11.8147 9.49951 11.9064 9.49951 12C9.49951 12.8284 8.82794 13.5 7.99951 13.5C7.17108 13.5 6.49951 12.8284 6.49951 12C6.49951 11.1716 7.17108 10.5 7.99951 10.5C8.37166 10.5 8.71216 10.6355 8.97435 10.8599L11.2133 9.56701C11.4524 9.42892 11.7582 9.51083 11.8963 9.74996ZM8.40894 11.7129C8.31848 11.5842 8.16883 11.5 7.99951 11.5C7.72337 11.5 7.49951 11.7239 7.49951 12C7.49951 12.2761 7.72337 12.5 7.99951 12.5C8.27565 12.5 8.49951 12.2761 8.49951 12C8.49951 11.9248 8.4829 11.8534 8.45313 11.7894C8.44473 11.7774 8.43678 11.765 8.42931 11.752C8.42189 11.7392 8.4151 11.7261 8.40894 11.7129Z";
  const IconPathSpeedLow = "M8 2.5C8.27614 2.5 8.5 2.72386 8.5 3V4C8.5 4.27614 8.27614 4.5 8 4.5C7.72386 4.5 7.5 4.27614 7.5 4V3C7.5 2.72386 7.72386 2.5 8 2.5ZM1.28317 5.28243C1.47843 5.08717 1.79501 5.08717 1.99027 5.28243L2.69727 5.98943C2.89253 6.1847 2.89253 6.50128 2.69727 6.69654C2.50201 6.8918 2.18543 6.8918 1.99017 6.69654L1.28317 5.98954C1.0879 5.79428 1.0879 5.4777 1.28317 5.28243ZM14.7188 5.28243C14.914 5.4777 14.914 5.79428 14.7188 5.98954L14.0118 6.69654C13.8165 6.8918 13.4999 6.8918 13.3047 6.69654C13.1094 6.50128 13.1094 6.18469 13.3047 5.98943L14.0117 5.28243C14.2069 5.08717 14.5235 5.08717 14.7188 5.28243ZM8 6.5C4.96214 6.5 2.5 8.96214 2.5 12C2.5 12.2761 2.27614 12.5 2 12.5C1.72386 12.5 1.5 12.2761 1.5 12C1.5 8.40986 4.40986 5.5 8 5.5C11.5901 5.5 14.5 8.40986 14.5 12C14.5 12.2761 14.2761 12.5 14 12.5C13.7239 12.5 13.5 12.2761 13.5 12C13.5 8.96214 11.0379 6.5 8 6.5ZM4.1041 9.74999C4.24217 9.51085 4.54797 9.42892 4.78711 9.56699L7.02569 10.8595C7.2878 10.6353 7.6281 10.5 8 10.5C8.82843 10.5 9.5 11.1716 9.5 12C9.5 12.8284 8.82843 13.5 8 13.5C7.17157 13.5 6.5 12.8284 6.5 12C6.5 11.9061 6.50862 11.8143 6.52512 11.7252L4.2871 10.433C4.04796 10.2949 3.96603 9.98914 4.1041 9.74999ZM7.5558 11.7702C7.52014 11.839 7.5 11.9172 7.5 12C7.5 12.2761 7.72386 12.5 8 12.5C8.27614 12.5 8.5 12.2761 8.5 12C8.5 11.7239 8.27614 11.5 8 11.5C7.82326 11.5 7.66794 11.5917 7.57902 11.7301C7.57555 11.7368 7.57192 11.7434 7.56812 11.75C7.56415 11.7569 7.56004 11.7636 7.5558 11.7702Z";
  const IconPathStation = "M4.16699 4.08313C3.8737 4.08313 3.66699 4.31031 3.66699 4.54313V11.7232H8.66699V4.54313C8.66699 4.31031 8.46028 4.08313 8.16699 4.08313H4.16699ZM9.66699 5.33912V4.54313C9.66699 3.71995 8.9737 3.08313 8.16699 3.08313H4.16699C3.36028 3.08313 2.66699 3.71995 2.66699 4.54313V11.7232H2.16699C1.89085 11.7232 1.66699 11.947 1.66699 12.2232C1.66699 12.4993 1.89085 12.7232 2.16699 12.7232H13.167C13.4431 12.7232 13.667 12.4993 13.667 12.2232C13.667 11.947 13.4431 11.7232 13.167 11.7232H9.66699V6.33912H9.81699C10.3103 6.33912 10.667 6.71029 10.667 7.1351V9.3431C10.667 10.1663 11.3603 10.8031 12.167 10.8031C12.9737 10.8031 13.667 10.1663 13.667 9.3431V5.52312H14.167C14.4431 5.52312 14.667 5.29926 14.667 5.02312V3.72712C14.667 3.45097 14.4431 3.22712 14.167 3.22712C13.8909 3.22712 13.667 3.45097 13.667 3.72712V4.52312H12.667V3.72712C12.667 3.45097 12.4431 3.22712 12.167 3.22712C11.8909 3.22712 11.667 3.45097 11.667 3.72712V5.02312C11.667 5.29926 11.8909 5.52312 12.167 5.52312H12.667V9.3431C12.667 9.57591 12.4603 9.8031 12.167 9.8031C11.8737 9.8031 11.667 9.57591 11.667 9.3431V7.1351C11.667 6.1199 10.8237 5.33912 9.81699 5.33912H9.66699ZM6.33074 5.22282C6.5916 5.3134 6.72965 5.5983 6.63907 5.85917L6.26963 6.92316H7.46962L6.63907 9.31517C6.54849 9.57603 6.26359 9.71408 6.00273 9.6235C5.74186 9.53292 5.60382 9.24802 5.6944 8.98716L6.06383 7.92316H4.86384L5.6944 5.53116C5.78497 5.27029 6.06987 5.13225 6.33074 5.22282Z";
  const IconPathStationGroup = "M7.5 3.40344C7.20671 3.40344 7 3.63063 7 3.86344V12.9634H13V3.86344C13 3.63063 12.7933 3.40344 12.5 3.40344H7.5ZM14 12.9634V3.86344C14 3.04026 13.3067 2.40344 12.5 2.40344H7.5C6.69984 2.40344 6.01126 3.02997 6.00014 3.84344C6.00009 3.84344 6.00018 3.84344 6.00014 3.84344L5.5 3.84344C4.69329 3.84344 4 4.48026 4 5.30344V5.76344H3.5C2.6933 5.76344 2 6.40024 2 7.22343V12.9634H1.5C1.22386 12.9634 1 13.1873 1 13.4634C1 13.7396 1.22386 13.9634 1.5 13.9634H14.5C14.7761 13.9634 15 13.7396 15 13.4634C15 13.1873 14.7761 12.9634 14.5 12.9634H14ZM6 12.9634H5V5.30344C5 5.07063 5.20671 4.84344 5.5 4.84344H6V12.9634ZM4 6.76344H3.5C3.2067 6.76344 3 6.99062 3 7.22343V12.9634H4V6.76344ZM10.1637 4.68713C10.4246 4.77771 10.5626 5.06261 10.4721 5.32347L10.1026 6.38743H11.3026L10.4721 8.77949C10.3815 9.04036 10.0966 9.17841 9.83573 9.08783C9.57487 8.99726 9.43682 8.71236 9.5274 8.45149L9.89685 7.38743H8.69683L9.5274 4.99545C9.61798 4.73459 9.90288 4.59655 10.1637 4.68713Z";
  const IconPathStationLarge = "M3.5 2.74988C3.20671 2.74988 3 2.97706 3 3.20988V13.7232H9.33333V3.20988C9.33333 2.97706 9.12663 2.74988 8.83333 2.74988H3.5ZM10.3333 6.00586V3.20988C10.3333 2.38669 9.64004 1.74988 8.83333 1.74988H3.5C2.69329 1.74988 2 2.38669 2 3.20988V13.7232H1.5C1.22386 13.7232 1 13.9471 1 14.2232C1 14.4994 1.22386 14.7232 1.5 14.7232H13.1667C13.4428 14.7232 13.6667 14.4994 13.6667 14.2232C13.6667 13.9471 13.4428 13.7232 13.1667 13.7232H10.3333V7.00586H10.4833C10.9766 7.00586 11.3333 7.37704 11.3333 7.80185V11.3432C11.3333 12.1664 12.0266 12.8032 12.8333 12.8032C13.64 12.8032 14.3333 12.1664 14.3333 11.3432V5.5232H14.8333C15.1095 5.5232 15.3333 5.29934 15.3333 5.0232V3.7272C15.3333 3.45106 15.1095 3.2272 14.8333 3.2272C14.5572 3.2272 14.3333 3.45106 14.3333 3.7272V4.5232H13.3333V3.7272C13.3333 3.45106 13.1095 3.2272 12.8333 3.2272C12.5572 3.2272 12.3333 3.45106 12.3333 3.7272V5.0232C12.3333 5.29934 12.5572 5.5232 12.8333 5.5232H13.3333V11.3432C13.3333 11.576 13.1266 11.8032 12.8333 11.8032C12.54 11.8032 12.3333 11.576 12.3333 11.3432V7.80185C12.3333 6.78665 11.49 6.00586 10.4833 6.00586H10.3333ZM6.33041 4.55624C6.59128 4.64682 6.72932 4.93172 6.63874 5.19258L6.2693 6.25658H7.46929L6.63874 8.64858C6.54817 8.90945 6.26327 9.04749 6.0024 8.95691C5.74154 8.86634 5.60349 8.58144 5.69407 8.32057L6.06351 7.25658H4.86351L5.69407 4.86457C5.78465 4.60371 6.06955 4.46566 6.33041 4.55624Z";
  const IconPathSticker = "M4.5 2.41187C4.20671 2.41187 4 2.63905 4 2.87187V3.33187H8.5V2.41187H4.5ZM4.5 1.41187C3.69329 1.41187 3 2.04868 3 2.87187V13.4319C3 14.255 3.69329 14.8919 4.5 14.8919H11.5C12.3067 14.8919 13 14.255 13 13.4319V5.17586C13 4.79225 12.839 4.42416 12.5463 4.14317L10.1463 1.83917C9.854 1.5586 9.48025 1.41187 9.1 1.41187H4.5ZM9.5 2.60497V4.77187H11.7572L9.5 2.60497ZM12 5.77187H9C8.72386 5.77187 8.5 5.54801 8.5 5.27187V4.33187H4V13.4319C4 13.6647 4.20671 13.8919 4.5 13.8919H11.5C11.7933 13.8919 12 13.6647 12 13.4319V5.77187ZM4.83333 6.66691C4.83333 6.39077 5.05719 6.16691 5.33333 6.16691H7.33333C7.60948 6.16691 7.83333 6.39077 7.83333 6.66691V8.66691C7.83333 8.94305 7.60948 9.16691 7.33333 9.16691H5.33333C5.05719 9.16691 4.83333 8.94305 4.83333 8.66691V6.66691ZM5.83333 7.16691V8.16691H6.83333V7.16691H5.83333ZM5 10.5519C5 10.2757 5.22386 10.0519 5.5 10.0519H10.5C10.7761 10.0519 11 10.2757 11 10.5519C11 10.828 10.7761 11.0519 10.5 11.0519H5.5C5.22386 11.0519 5 10.828 5 10.5519ZM6.5 12.4719C6.5 12.1957 6.72386 11.9719 7 11.9719H9C9.27614 11.9719 9.5 12.1957 9.5 12.4719C9.5 12.748 9.27614 12.9719 9 12.9719H7C6.72386 12.9719 6.5 12.748 6.5 12.4719Z";
  const IconPathStopCircle = "M1.5 8.11001C1.5 4.63001 4.43 1.85001 8 1.85001C11.57 1.85001 14.5 4.63001 14.5 8.11001C14.5 11.59 11.57 14.37 8 14.37C4.43 14.37 1.5 11.59 1.5 8.11001ZM8 2.85001C4.94 2.85001 2.5 5.22001 2.5 8.11001C2.5 11 4.94 13.37 8 13.37C11.06 13.37 13.5 11 13.5 8.11001C13.5 5.22001 11.06 2.85001 8 2.85001ZM10 10.51H6C5.72 10.51 5.5 10.3 5.5 10.03V6.19001C5.5 5.93001 5.72 5.71001 6 5.71001H10C10.28 5.71001 10.5 5.93001 10.5 6.19001V10.03C10.5 10.29 10.28 10.51 10 10.51Z";
  const IconPathSwitch = "M4.5 2.2738L7.84627 5.48622C8.04547 5.67746 8.05193 5.99397 7.86069 6.19318C7.66946 6.39238 7.35294 6.39884 7.15373 6.20761L5 4.14002V10.1669C5 10.4431 4.77614 10.6669 4.5 10.6669C4.22386 10.6669 4 10.4431 4 10.1669V4.14002L1.84627 6.20761C1.64706 6.39884 1.33054 6.39238 1.13931 6.19318C0.94807 5.99397 0.954529 5.67746 1.15373 5.48622L4.5 2.2738ZM11.5 5.82691C11.7761 5.82691 12 6.05077 12 6.32691V12.3538L14.1537 10.2862C14.3529 10.095 14.6695 10.1014 14.8607 10.3007C15.0519 10.4999 15.0455 10.8164 14.8463 11.0076L11.5 14.22L8.15373 11.0076C7.95453 10.8164 7.94807 10.4999 8.13931 10.3007C8.33054 10.1014 8.64706 10.095 8.84627 10.2862L11 12.3538V6.32691C11 6.05077 11.2239 5.82691 11.5 5.82691Z";
  const IconPathTime = "M1.5 7.99485C1.5 4.40502 4.41015 1.49487 8 1.49487C11.5899 1.49487 14.5 4.40502 14.5 7.99485C14.5 11.5847 11.5899 14.4949 8 14.4949C4.41015 14.4949 1.5 11.5847 1.5 7.99485ZM8 2.49487C4.96243 2.49487 2.5 4.95731 2.5 7.99485C2.5 11.0324 4.96243 13.4949 8 13.4949C11.0376 13.4949 13.5 11.0324 13.5 7.99485C13.5 4.95731 11.0376 2.49487 8 2.49487ZM8 4.83325C8.27614 4.83325 8.5 5.05711 8.5 5.33325V7.84115L10.4082 10.5396C10.5677 10.765 10.5142 11.077 10.2887 11.2365C10.0632 11.3959 9.7512 11.3424 9.59176 11.1169L7.59176 8.28877C7.53206 8.20435 7.5 8.10349 7.5 8.00008V5.33325C7.5 5.05711 7.72386 4.83325 8 4.83325Z";
  const IconPathUnlink = "M8.69876 4.09065C8.69876 4.09065 8.69876 4.09065 8.69875 4.09065L7.99176 4.76937C7.79256 4.96061 7.47604 4.95415 7.2848 4.75495C7.09356 4.55574 7.10002 4.23923 7.29922 4.04799L8.00622 3.36926L8.00623 3.36926C9.37124 2.05888 11.5763 2.05888 12.9413 3.36926L12.9413 3.36927C14.3177 4.69068 14.3177 6.84205 12.9413 8.16344L12.2343 8.84216C12.0351 9.0334 11.7186 9.02694 11.5273 8.82773C11.3361 8.62853 11.3426 8.31201 11.5418 8.12077L12.2488 7.44205C13.2152 6.51423 13.2153 5.01851 12.2488 4.09064C11.2707 3.15175 9.67681 3.15175 8.69876 4.09065ZM5.52377 2.55077C5.79991 2.55077 6.02377 2.77463 6.02377 3.05077V4.40869C6.02377 4.68484 5.79991 4.90869 5.52377 4.90869C5.24762 4.90869 5.02377 4.68484 5.02377 4.40869V3.05077C5.02377 2.77463 5.24762 2.55077 5.52377 2.55077ZM2.19564 5.76609C2.19564 5.48995 2.4195 5.26609 2.69564 5.26609H4.11013C4.38627 5.26609 4.61013 5.48995 4.61013 5.76609C4.61013 6.04223 4.38627 6.26609 4.11013 6.26609H2.69564C2.4195 6.26609 2.19564 6.04223 2.19564 5.76609ZM4.47072 7.45648C4.66196 7.65568 4.6555 7.9722 4.4563 8.16344L3.74931 8.84216C2.78279 9.77005 2.78278 11.2657 3.7493 12.1936C4.72732 13.1325 6.32125 13.1325 7.2993 12.1936L8.00629 11.5149C8.2055 11.3236 8.52202 11.3301 8.71325 11.5293C8.90449 11.7285 8.89803 12.045 8.69883 12.2363L7.99183 12.915L7.99182 12.915C6.62681 14.2253 4.42176 14.2253 3.05678 12.915L3.05677 12.915C1.6803 11.5935 1.6803 9.44223 3.05677 8.12078L3.38215 8.45971L3.05677 8.12078L3.76376 7.44206C3.96296 7.25082 4.27948 7.25727 4.47072 7.45648ZM11.388 10.5181C11.388 10.242 11.6119 10.0181 11.888 10.0181H13.3025C13.5786 10.0181 13.8025 10.242 13.8025 10.5181C13.8025 10.7943 13.5786 11.0181 13.3025 11.0181H11.888C11.6119 11.0181 11.388 10.7943 11.388 10.5181ZM10.474 11.3755C10.7501 11.3755 10.974 11.5994 10.974 11.8755V13.2335C10.974 13.5096 10.7501 13.7335 10.474 13.7335C10.1978 13.7335 9.97396 13.5096 9.97396 13.2335V11.8755C9.97396 11.5994 10.1978 11.3755 10.474 11.3755Z";
  const IconPathUnlocked = "M8.00013 2.5C7.04561 2.5 6.24097 3.17588 6.03872 4.10621C5.98006 4.37605 5.71376 4.54725 5.44392 4.48859C5.17408 4.42993 5.00288 4.16363 5.06155 3.89379C5.3593 2.52412 6.55466 1.5 8.00013 1.5C9.67628 1.5 11.0001 2.82386 11.0001 4.5V6H12C12.8261 6 13.5 6.67386 13.5 7.5V12.5C13.5 13.3261 12.8261 14 12 14H4C3.17386 14 2.5 13.3261 2.5 12.5V7.5C2.5 6.67386 3.17386 6 4 6H10.0001V4.5C10.0001 3.37614 9.12399 2.5 8.00013 2.5ZM4 7C3.72614 7 3.5 7.22614 3.5 7.5V12.5C3.5 12.7739 3.72614 13 4 13H12C12.2739 13 12.5 12.7739 12.5 12.5V7.5C12.5 7.22614 12.2739 7 12 7H4ZM6 10C6 8.89546 6.89546 8 8 8C9.10454 8 10 8.89546 10 10C10 11.1045 9.10454 12 8 12C6.89546 12 6 11.1045 6 10ZM8 9C7.44774 9 7 9.44774 7 10C7 10.5523 7.44774 11 8 11C8.55226 11 9 10.5523 9 10C9 9.44774 8.55226 9 8 9Z";
  const IconPathUpdate = "M8 3.33984C5.21921 3.33984 3 5.49903 3 8.11984C3 10.7407 5.21921 12.8998 8 12.8998C9.95314 12.8998 11.6357 11.8312 12.4592 10.2848C12.589 10.0411 12.8918 9.94872 13.1356 10.0785C13.3793 10.2083 13.4717 10.5111 13.3419 10.7549C12.3443 12.628 10.3219 13.8998 8 13.8998C4.70579 13.8998 2 11.3311 2 8.11984C2 4.90866 4.70579 2.33984 8 2.33984C10.0735 2.33984 11.9085 3.35427 12.9876 4.90562V3.55984C12.9876 3.2837 13.2115 3.05984 13.4876 3.05984C13.7637 3.05984 13.9876 3.2837 13.9876 3.55984V6.45984H10.9876C10.7115 6.45984 10.4876 6.23599 10.4876 5.95984C10.4876 5.6837 10.7115 5.45984 10.9876 5.45984H12.1549C11.26 4.18531 9.73728 3.33984 8 3.33984ZM8 4.73984C8.27614 4.73984 8.5 4.9637 8.5 5.23984V7.90673L9.84627 9.19914C10.0455 9.39038 10.0519 9.7069 9.86069 9.9061C9.66946 10.1053 9.35294 10.1118 9.15373 9.92053L7.65373 8.48053C7.55552 8.38625 7.5 8.25599 7.5 8.11984V5.23984C7.5 4.9637 7.72386 4.73984 8 4.73984Z";
  const IconPathUpload = "M8 13.5C8.27614 13.5 8.5 13.2761 8.5 13V6.70711L10.1464 8.35355C10.3417 8.54882 10.6583 8.54882 10.8536 8.35355C11.0488 8.15829 11.0488 7.84171 10.8536 7.64645L8 4.79289L5.14645 7.64645C4.95118 7.84171 4.95118 8.15829 5.14645 8.35355C5.34171 8.54882 5.65829 8.54882 5.85355 8.35355L7.5 6.70711V13C7.5 13.2761 7.72386 13.5 8 13.5ZM4 3C4 3.27614 4.22386 3.5 4.5 3.5H11.5C11.7761 3.5 12 3.27614 12 3C12 2.72386 11.7761 2.5 11.5 2.5H4.5C4.22386 2.5 4 2.72386 4 3Z";
  const IconPathUploadCloud = "M8 3.37158C6.64206 3.37158 5.44703 4.12881 4.77856 5.24113C4.6929 5.38367 4.54198 5.47429 4.37591 5.48291C2.78544 5.56544 1.5 6.88779 1.5 8.48757C1.5 10.135 2.82967 11.4916 4.5 11.4916H6.5C6.77614 11.4916 7 11.7154 7 11.9916C7 12.2677 6.77614 12.4916 6.5 12.4916H4.5C2.27033 12.4916 0.5 10.6802 0.5 8.48757C0.5 6.43311 2.07401 4.74091 4.06132 4.50653C4.91547 3.24078 6.35159 2.37158 8 2.37158C10.2115 2.37158 12.0202 3.89084 12.5549 5.89432C14.2117 6.07031 15.5 7.46459 15.5 9.15957C15.5 10.9627 14.0351 12.4916 12.2 12.4916H11.5C11.2239 12.4916 11 12.2677 11 11.9916C11 11.7154 11.2239 11.4916 11.5 11.4916H12.2C13.4649 11.4916 14.5 10.4285 14.5 9.15957C14.5 7.90181 13.476 6.87558 12.2 6.87558H12.15C11.9076 6.87558 11.7002 6.70176 11.6577 6.46313C11.3481 4.72188 9.84576 3.37158 8 3.37158ZM8.65373 7.31088C8.84722 7.12513 9.15279 7.12513 9.34627 7.31088L11.3463 9.23088C11.5455 9.42211 11.5519 9.73863 11.3607 9.93784C11.1695 10.137 10.8529 10.1435 10.6537 9.95226L9.5 8.84468V13.4316C9.5 13.7077 9.27614 13.9316 9 13.9316C8.72386 13.9316 8.5 13.7077 8.5 13.4316V8.84468L7.34627 9.95226C7.14706 10.1435 6.83054 10.137 6.63931 9.93784C6.44807 9.73863 6.45453 9.42211 6.65373 9.23088L8.65373 7.31088Z";
  const IconPathVisibilityOn = "M10.6801 8C10.6801 9.47 9.4901 10.67 8.0101 10.67C6.5301 10.67 5.3401 9.48 5.3401 8C5.3401 7.73 5.3901 7.47 5.4701 7.23C5.6801 7.69 6.1401 8 6.6801 8C7.4201 8 8.0101 7.4 8.0101 6.67C8.0101 6.13 7.6901 5.68 7.2401 5.46C7.4901 5.38 7.7401 5.33 8.0101 5.33C9.4801 5.33 10.6801 6.52 10.6801 8ZM14.7501 8.29C14.7501 8.29 14.4001 8.76 14.2301 8.95C13.8901 9.34 13.4101 9.86 12.8001 10.38C11.6001 11.41 9.8601 12.5 7.8501 12.5C5.8401 12.5 4.0901 11.41 2.8901 10.38C2.2801 9.86 1.8001 9.34 1.4601 8.95C1.3001 8.76 1.1701 8.59 1.0801 8.48C1.0301 8.42 0.940098 8.29 0.940098 8.29C0.880098 8.2 0.850098 8.1 0.850098 8C0.850098 7.9 0.880098 7.8 0.940098 7.71H0.950098L0.980098 7.66C1.0001 7.63 1.0301 7.58 1.0801 7.52C1.1701 7.41 1.3001 7.24 1.4601 7.05C1.8001 6.66 2.2801 6.14 2.8901 5.62C4.0901 4.59 5.8301 3.5 7.8501 3.5C9.8701 3.5 11.6001 4.59 12.8001 5.62C13.4101 6.14 13.8901 6.66 14.2301 7.05C14.4001 7.24 14.5301 7.41 14.6101 7.52C14.6601 7.58 14.7501 7.71 14.7501 7.71C14.8801 7.88 14.8801 8.12 14.7501 8.29ZM13.7201 8C13.6501 7.92 13.5701 7.81 13.4701 7.7C13.1601 7.34 12.7101 6.86 12.1501 6.38C11.0201 5.41 9.5101 4.5 7.8501 4.5C6.1901 4.5 4.6701 5.41 3.5401 6.38C2.9801 6.86 2.5301 7.34 2.2201 7.7C2.1301 7.81 2.0401 7.92 1.9801 8C2.0401 8.08 2.1301 8.19 2.2201 8.3C2.5301 8.66 2.9801 9.14 3.5401 9.62C4.6701 10.59 6.1801 11.5 7.8501 11.5C9.5201 11.5 11.0201 10.59 12.1501 9.62C12.7101 9.14 13.1601 8.66 13.4701 8.3C13.5701 8.19 13.6501 8.08 13.7201 8Z";
  const IconPathVisibilityOff = "M2.40671 5.7092C2.24612 5.48483 1.93396 5.43276 1.70938 5.59317C1.48468 5.75368 1.43263 6.06595 1.59314 6.29066L2 6.00004C1.59314 6.29066 1.59302 6.2905 1.59314 6.29066L1.59435 6.29235L1.59649 6.29532L1.60352 6.30499L1.62848 6.33873C1.64991 6.36741 1.68091 6.40819 1.7211 6.45934C1.80145 6.5616 1.91876 6.7056 2.07014 6.87743C2.16235 6.9821 2.26748 7.09742 2.38486 7.22015C2.18559 7.43231 2.01802 7.59992 1.84645 7.77149L1.84521 7.77273C1.63258 7.98535 1.41377 8.20416 1.13143 8.51218C0.94483 8.71574 0.958581 9.03202 1.16214 9.21862C1.3657 9.40521 1.68198 9.39146 1.86858 9.1879C2.13569 8.89651 2.34157 8.69058 2.55356 8.47859L2.5548 8.47735C2.72499 8.30716 2.89914 8.13301 3.10667 7.91232C3.19119 7.98653 3.27888 8.06125 3.36965 8.136C3.9446 8.6095 4.65716 9.09555 5.47882 9.45257C5.33183 10.0065 5.23022 10.387 5.02276 11.0509C4.9404 11.3145 5.08729 11.5949 5.35087 11.6773C5.61444 11.7596 5.89488 11.6127 5.97724 11.3492C6.18114 10.6967 6.28763 10.3031 6.4249 9.78618C6.92137 9.92077 7.44801 10 8 10C8.55195 10 9.07855 9.92078 9.57498 9.78621C9.71225 10.3031 9.81874 10.6967 10.0226 11.3492C10.105 11.6127 10.3854 11.7596 10.649 11.6773C10.9126 11.5949 11.0595 11.3145 10.9771 11.0509C10.7697 10.387 10.668 10.0065 10.5211 9.45262C11.3428 9.0956 12.0554 8.60952 12.6304 8.136C12.7234 8.05936 12.8133 7.98274 12.8998 7.90668C13.3549 8.36227 13.6419 8.65362 14.1317 9.1879C14.3183 9.39146 14.6346 9.40521 14.8381 9.21862C15.0417 9.03202 15.0554 8.71574 14.8688 8.51218C14.3702 7.96824 14.0726 7.66582 13.6212 7.21387C13.7361 7.09348 13.8392 6.98032 13.9299 6.87743C14.0812 6.7056 14.1986 6.5616 14.2789 6.45934C14.3191 6.40819 14.3501 6.36741 14.3715 6.33873L14.3965 6.30499L14.4035 6.29532L14.4057 6.29235L14.4064 6.29135C14.4065 6.29119 14.4069 6.29066 14 6.00004L14.4064 6.29135C14.5669 6.06664 14.5153 5.75368 14.2906 5.59317C14.066 5.43272 13.7538 5.48468 13.5933 5.7092L13.589 5.71516L13.5706 5.73996C13.5537 5.76255 13.5276 5.79697 13.4926 5.84152C13.4225 5.93067 13.3172 6.0601 13.1795 6.2164C12.9036 6.52962 12.5007 6.94732 11.9946 7.36407C10.9733 8.2052 9.58389 9.00004 8 9.00004C6.41611 9.00004 5.02672 8.2052 4.00536 7.36407C3.49929 6.94732 3.09643 6.52962 2.8205 6.2164C2.68281 6.0601 2.57746 5.93067 2.50742 5.84152C2.47242 5.79697 2.44628 5.76255 2.42939 5.73996L2.41105 5.71516L2.40671 5.7092C2.40671 5.7092 2.40671 5.7092 2.40671 5.7092Z";
  const IconPathVoucher = "M7.25287 15.8922C7.00289 15.8887 6.75431 15.7852 6.56699 15.5926L4.90075 13.8792C4.81201 13.7879 4.75383 13.6571 4.75565 13.5271C4.75746 13.3971 4.80927 13.2678 4.91052 13.1792C5.18426 12.913 5.32914 12.565 5.33444 12.185C5.33975 11.8051 5.19465 11.453 4.93844 11.1794C4.41604 10.6321 3.47613 10.6189 2.93864 11.1515C2.746 11.3388 2.41604 11.3342 2.22871 11.1416L0.562469 9.42815C0.385 9.24565 0.278501 8.99414 0.282131 8.73417C0.285762 8.47419 0.389242 8.22561 0.581737 8.04828L8.13517 0.693027C8.52044 0.31837 9.14038 0.327027 9.51503 0.712295L11.1813 2.42573C11.27 2.51697 11.3282 2.6478 11.3264 2.77779C11.3246 2.90777 11.2727 3.03706 11.1715 3.12566C10.6139 3.66793 10.6013 4.56784 11.1436 5.12546C11.6661 5.66281 12.606 5.67594 13.1434 5.15339C13.3462 4.9562 13.6561 4.96053 13.8533 5.1633L15.5196 6.87673C15.8942 7.262 15.8856 7.88194 15.5003 8.2566L7.94699 15.6019C7.75436 15.7892 7.50298 15.8857 7.25301 15.8822L7.25287 15.8922ZM5.92609 13.5034L7.28669 14.9026L14.81 7.55689L13.459 6.18789C12.5307 6.77499 11.2125 6.63657 10.4337 5.82562C9.62526 4.99425 9.533 3.72284 10.1561 2.79145L8.79547 1.39231L1.27203 8.74799L2.62305 10.117C3.55134 9.52989 4.86954 9.66831 5.64829 10.4793C6.10182 10.9456 6.34342 11.5491 6.33434 12.199C6.32778 12.669 6.18137 13.127 5.92595 13.5134L5.92609 13.5034ZM5.82388 7.93146C6.02651 7.74427 6.03098 7.4243 5.83379 7.22153L5.56759 6.94779C5.3704 6.74502 5.06043 6.74069 4.85766 6.93787C4.65502 7.12506 4.65056 7.44503 4.84774 7.64781L5.11395 7.92155C5.21254 8.02294 5.34183 8.07475 5.46182 8.07642C5.58181 8.0781 5.72249 8.03006 5.81388 7.93132L5.82388 7.93146ZM9.16622 11.3685C9.36899 11.1713 9.37332 10.8613 9.17613 10.6585L8.90993 10.3848C8.7226 10.1922 8.40277 10.1777 8.2 10.3749C7.99722 10.5721 7.99289 10.882 8.19008 11.0848L8.45629 11.3586C8.55488 11.4599 8.68417 11.5117 8.80416 11.5134C8.92415 11.5151 9.06483 11.4671 9.15622 11.3683L9.16622 11.3685ZM7.49998 9.65503C7.70275 9.45784 7.70708 9.14787 7.50989 8.9451L7.24369 8.67136C7.0465 8.46859 6.73653 8.46426 6.53376 8.66144C6.33098 8.85863 6.32666 9.1686 6.52384 9.37138L6.79005 9.64512C6.88864 9.74651 7.01793 9.79832 7.13792 9.79999C7.25791 9.80167 7.39859 9.75363 7.48998 9.65489L7.49998 9.65503Z";
  const IconPathWarning = "M8.00535 5.2551C7.72535 5.2551 7.50535 5.4751 7.50535 5.7551V8.7551C7.50535 9.0251 7.72535 9.2551 8.00535 9.2551C8.28535 9.2551 8.50535 9.0251 8.50535 8.7551V5.7551C8.50535 5.4751 8.28535 5.2551 8.00535 5.2551ZM14.9554 10.9951L9.70535 2.5451C8.92535 1.2851 7.08535 1.2851 6.30535 2.5451L1.05535 11.0051C0.225351 12.3351 1.18535 14.0651 2.75535 14.0651H13.2554C14.8254 14.0651 15.7854 12.3351 14.9554 11.0051V10.9951ZM13.2554 13.0551H2.75535C1.96535 13.0551 1.48535 12.1951 1.90535 11.5251L7.15535 3.0651C7.54535 2.4351 8.46535 2.4351 8.85535 3.0651L14.1054 11.5251C14.5254 12.1951 14.0454 13.0551 13.2554 13.0551ZM8.00535 9.2551C8.28535 9.2551 8.50535 9.0251 8.50535 8.7551V5.7551C8.50535 5.4751 8.28535 5.2551 8.00535 5.2551C7.72535 5.2551 7.50535 5.4751 7.50535 5.7551V8.7551C7.50535 9.0251 7.72535 9.2551 8.00535 9.2551ZM8.00535 10.0551C7.64535 10.0551 7.35535 10.3451 7.35535 10.7051C7.35535 11.0651 7.64535 11.3551 8.00535 11.3551C8.36535 11.3551 8.65535 11.0651 8.65535 10.7051C8.65535 10.3451 8.36535 10.0551 8.00535 10.0551ZM8.00535 9.2551C8.28535 9.2551 8.50535 9.0251 8.50535 8.7551V5.7551C8.50535 5.4751 8.28535 5.2551 8.00535 5.2551C7.72535 5.2551 7.50535 5.4751 7.50535 5.7551V8.7551C7.50535 9.0251 7.72535 9.2551 8.00535 9.2551ZM8.00535 10.0551C7.64535 10.0551 7.35535 10.3451 7.35535 10.7051C7.35535 11.0651 7.64535 11.3551 8.00535 11.3551C8.36535 11.3551 8.65535 11.0651 8.65535 10.7051C8.65535 10.3451 8.36535 10.0551 8.00535 10.0551ZM8.00535 10.0551C7.64535 10.0551 7.35535 10.3451 7.35535 10.7051C7.35535 11.0651 7.64535 11.3551 8.00535 11.3551C8.36535 11.3551 8.65535 11.0651 8.65535 10.7051C8.65535 10.3451 8.36535 10.0551 8.00535 10.0551Z";
  const IconPathWeatherCloudy = "M4.16699 6.5C4.16699 4.84386 5.51085 3.5 7.16699 3.5C8.47355 3.5 9.58539 4.3353 9.99646 5.5H10.8337C12.4905 5.5 13.8337 6.84315 13.8337 8.5C13.8337 10.1569 12.4905 11.5 10.8337 11.5H4.41699C3.17085 11.5 2.16699 10.4961 2.16699 9.25C2.16699 8.08839 3.03928 7.1373 4.16699 7.01362V6.5ZM7.16699 4.5C6.06313 4.5 5.16699 5.39614 5.16699 6.5V8H4.41699C3.72313 8 3.16699 8.55614 3.16699 9.25C3.16699 9.94386 3.72313 10.5 4.41699 10.5H10.8337C11.9382 10.5 12.8337 9.60457 12.8337 8.5C12.8337 7.39543 11.9382 6.5 10.8337 6.5H9.20779L9.12687 6.09888C8.94311 5.18807 8.13477 4.5 7.16699 4.5Z";
  const IconPathWeatherCloudyPartly = "M10.09 2.5C10.3661 2.5 10.59 2.72386 10.59 3V4C10.59 4.27614 10.3661 4.5 10.09 4.5C9.81386 4.5 9.59 4.27614 9.59 4V3C9.59 2.72386 9.81386 2.5 10.09 2.5ZM7.10395 3.85896C7.29782 3.66232 7.6144 3.66008 7.81104 3.85395L8.52104 4.55395C8.71768 4.74782 8.71992 5.0644 8.52605 5.26104C8.33218 5.45768 8.0156 5.45992 7.81896 5.26605L7.10896 4.56605C6.91232 4.37218 6.91008 4.0556 7.10395 3.85896ZM13.4761 3.85896C13.6699 4.05561 13.6677 4.37218 13.471 4.56605L12.761 5.26605C12.5644 5.45992 12.2478 5.45768 12.0539 5.26104C11.8601 5.0644 11.8623 4.74782 12.059 4.55395L12.769 3.85395C12.9656 3.66008 13.2822 3.66232 13.4761 3.85896ZM10.9934 6.32052C10.611 5.93151 9.97998 5.92713 9.58355 6.32355C9.38829 6.51882 9.07171 6.51882 8.87645 6.32355C8.68118 6.12829 8.68118 5.81171 8.87645 5.61645C9.66002 4.83287 10.929 4.82849 11.7066 5.61948C12.4723 6.39842 12.4953 7.66522 11.7005 8.44656C11.5036 8.64015 11.187 8.63744 10.9934 8.44052C10.7999 8.2436 10.8026 7.92702 10.9995 7.73344C11.3847 7.35478 11.3877 6.72158 10.9934 6.32052ZM2.92 8.29C2.92 7.02937 3.92838 6 5.19 6C6.14548 6 6.96668 6.58799 7.302 7.43H7.8966C9.15108 7.43 10.171 8.44136 10.1815 9.6958C10.1922 10.9652 9.16608 12 7.8966 12H3.24C2.26863 12 1.5 11.2109 1.5 10.25C1.5 9.39629 2.11332 8.68157 2.92 8.52975V8.29ZM5.19 7C4.49162 7 3.92 7.57063 3.92 8.29V9.5H3.24C2.83875 9.5 2.5 9.83353 2.5 10.25C2.5 10.6691 2.83137 11 3.24 11H7.8966C8.61051 11 9.18756 10.4181 9.18156 9.7042C9.17563 8.99875 8.60208 8.43 7.8966 8.43H6.51813L6.43925 8.02575C6.32452 7.43776 5.80794 7 5.19 7ZM12.75 7.16C12.75 6.88386 12.9739 6.66 13.25 6.66H14.25C14.5261 6.66 14.75 6.88386 14.75 7.16C14.75 7.43614 14.5261 7.66 14.25 7.66H13.25C12.9739 7.66 12.75 7.43614 12.75 7.16ZM12.0539 8.80896C12.2478 8.61232 12.5644 8.61008 12.761 8.80395L13.471 9.50395C13.6677 9.69782 13.6699 10.0144 13.4761 10.211C13.2822 10.4077 12.9656 10.4099 12.769 10.2161L12.059 9.51605C11.8623 9.32218 11.8601 9.00561 12.0539 8.80896Z";
  const IconPathWeatherFrozen = "M8.00195 1.5C8.2781 1.5 8.50195 1.72386 8.50195 2V4.49914L9.69987 3.6001C9.92073 3.43434 10.2341 3.47901 10.3999 3.69987C10.5657 3.92073 10.521 4.23415 10.3001 4.3999L8.50195 5.74944V7.50195H10.2503L11.5998 5.70025C11.7654 5.47923 12.0787 5.43427 12.2998 5.59982C12.5208 5.76537 12.5657 6.07874 12.4002 6.29975L11.4997 7.50195L14 7.50195C14.2761 7.50195 14.5 7.72581 14.5 8.00195C14.5 8.2781 14.2761 8.50195 14 8.50195L11.5009 8.50195L12.3999 9.69987C12.5657 9.92073 12.521 10.2341 12.3001 10.3999C12.0793 10.5657 11.7659 10.521 11.6001 10.3001L10.2506 8.50195H8.50195V10.2492L10.3003 11.6002C10.5211 11.7661 10.5656 12.0795 10.3998 12.3003C10.2339 12.5211 9.92047 12.5656 9.69968 12.3998L8.50195 11.5V14C8.50195 14.2761 8.2781 14.5 8.00195 14.5C7.72581 14.5 7.50195 14.2761 7.50195 14V11.5L6.29968 12.4002C6.07864 12.5657 5.76527 12.5207 5.59976 12.2997C5.43425 12.0786 5.47927 11.7653 5.70032 11.5998L7.50195 10.2508V8.50195H5.75076L4.39976 10.3003C4.2339 10.5211 3.92047 10.5656 3.69968 10.3998C3.4789 10.2339 3.43438 9.92047 3.60024 9.69968L4.50002 8.50195L2 8.50195C1.72386 8.50195 1.5 8.2781 1.5 8.00195C1.5 7.72581 1.72386 7.50195 2 7.50195L4.49998 7.50195L3.59976 6.29968C3.43425 6.07864 3.47927 5.76527 3.70032 5.59976C3.92136 5.43425 4.23473 5.47927 4.40024 5.70032L5.74924 7.50195H7.50195V5.74974L5.70025 4.40018C5.47923 4.23463 5.43427 3.92126 5.59982 3.70025C5.76536 3.47923 6.07874 3.43427 6.29975 3.59982L7.50195 4.50031V2C7.50195 1.72386 7.72581 1.5 8.00195 1.5Z";
  const IconPathWeatherRainy = "M3.5 5.16669C3.5 3.51054 4.84386 2.16669 6.5 2.16669C7.80656 2.16669 8.9184 3.00199 9.32947 4.16669H11.1667C12.8235 4.16669 14.1667 5.50983 14.1667 7.16669C14.1667 8.36303 13.4664 9.39582 12.4534 9.87751C12.4514 9.88179 12.4493 9.88605 12.4472 9.89029L11.9472 10.8903C11.8237 11.1373 11.5234 11.2374 11.2764 11.1139C11.0294 10.9904 10.9293 10.6901 11.0528 10.4431L11.191 10.1666C11.1829 10.1667 11.1748 10.1667 11.1667 10.1667H8.30902L7.94721 10.8903C7.82372 11.1373 7.52338 11.2374 7.27639 11.1139C7.0294 10.9904 6.92929 10.6901 7.05279 10.4431L7.19098 10.1667H4.30902L3.94721 10.8903C3.82372 11.1373 3.52338 11.2374 3.27639 11.1139C3.0294 10.9904 2.92929 10.6901 3.05279 10.4431L3.22191 10.1048C2.23206 9.86831 1.5 8.98084 1.5 7.91669C1.5 6.75507 2.37229 5.80399 3.5 5.68031V5.16669ZM4.01081 9.16669C4.00385 9.16654 3.9969 9.16654 3.98996 9.16669H3.75C3.05614 9.16669 2.5 8.61054 2.5 7.91669C2.5 7.22283 3.05614 6.66669 3.75 6.66669H4.5V5.16669C4.5 4.06283 5.39614 3.16669 6.5 3.16669C7.46778 3.16669 8.27611 3.85475 8.45988 4.76557L8.5408 5.16669H11.1667C12.2712 5.16669 13.1667 6.06212 13.1667 7.16669C13.1667 8.27126 12.2712 9.16669 11.1667 9.16669H8.01081C8.00385 9.16654 7.9969 9.16654 7.98996 9.16669H4.01081ZM5.72361 11.2195C5.9706 11.343 6.07071 11.6433 5.94721 11.8903L5.44721 12.8903C5.32372 13.1373 5.02338 13.2374 4.77639 13.1139C4.5294 12.9904 4.42929 12.6901 4.55279 12.4431L5.05279 11.4431C5.17628 11.1961 5.47662 11.096 5.72361 11.2195ZM9.72361 11.2195C9.9706 11.343 10.0707 11.6433 9.94721 11.8903L9.44721 12.8903C9.32372 13.1373 9.02338 13.2374 8.77639 13.1139C8.5294 12.9904 8.42929 12.6901 8.55279 12.4431L9.05279 11.4431C9.17628 11.1961 9.47662 11.096 9.72361 11.2195Z";
  const IconPathWeatherSnowy = "M3.5 5.16669C3.5 3.51054 4.84386 2.16669 6.5 2.16669C7.80656 2.16669 8.9184 3.00199 9.32947 4.16669H11.1667C12.8235 4.16669 14.1667 5.50983 14.1667 7.16669C14.1667 8.82354 12.8235 10.1667 11.1667 10.1667H10.2071L10.3536 10.3131C10.5488 10.5084 10.5488 10.825 10.3536 11.0202C10.1583 11.2155 9.84171 11.2155 9.64645 11.0202L9.5 10.8738L9.35355 11.0202C9.15829 11.2155 8.84171 11.2155 8.64645 11.0202C8.45118 10.825 8.45118 10.5084 8.64645 10.3131L8.79289 10.1667H3.75C2.50386 10.1667 1.5 9.16283 1.5 7.91669C1.5 6.75507 2.37229 5.80399 3.5 5.68031V5.16669ZM6.5 3.16669C5.39614 3.16669 4.5 4.06283 4.5 5.16669V6.66669H3.75C3.05614 6.66669 2.5 7.22283 2.5 7.91669C2.5 8.61054 3.05614 9.16669 3.75 9.16669H11.1667C12.2712 9.16669 13.1667 8.27126 13.1667 7.16669C13.1667 6.06212 12.2712 5.16669 11.1667 5.16669H8.5408L8.45988 4.76557C8.27611 3.85475 7.46778 3.16669 6.5 3.16669ZM2.64645 11.3131C2.84171 11.1179 3.15829 11.1179 3.35355 11.3131L3.5 11.4596L3.64645 11.3131C3.84171 11.1179 4.15829 11.1179 4.35355 11.3131C4.54882 11.5084 4.54882 11.825 4.35355 12.0202L4.20711 12.1667L4.35355 12.3131C4.54882 12.5084 4.54882 12.825 4.35355 13.0202C4.15829 13.2155 3.84171 13.2155 3.64645 13.0202L3.5 12.8738L3.35355 13.0202C3.15829 13.2155 2.84171 13.2155 2.64645 13.0202C2.45118 12.825 2.45118 12.5084 2.64645 12.3131L2.79289 12.1667L2.64645 12.0202C2.45118 11.825 2.45118 11.5084 2.64645 11.3131ZM10.6464 12.3131C10.8417 12.1179 11.1583 12.1179 11.3536 12.3131L11.5 12.4596L11.6464 12.3131C11.8417 12.1179 12.1583 12.1179 12.3536 12.3131C12.5488 12.5084 12.5488 12.825 12.3536 13.0202L12.2071 13.1667L12.3536 13.3131C12.5488 13.5084 12.5488 13.825 12.3536 14.0202C12.1583 14.2155 11.8417 14.2155 11.6464 14.0202L11.5 13.8738L11.3536 14.0202C11.1583 14.2155 10.8417 14.2155 10.6464 14.0202C10.4512 13.825 10.4512 13.5084 10.6464 13.3131L10.7929 13.1667L10.6464 13.0202C10.4512 12.825 10.4512 12.5084 10.6464 12.3131ZM6.64645 13.3131C6.84171 13.1179 7.15829 13.1179 7.35355 13.3131L7.5 13.4596L7.64645 13.3131C7.84171 13.1179 8.15829 13.1179 8.35355 13.3131C8.54882 13.5084 8.54882 13.825 8.35355 14.0202L8.20711 14.1667L8.35355 14.3131C8.54882 14.5084 8.54882 14.825 8.35355 15.0202C8.15829 15.2155 7.84171 15.2155 7.64645 15.0202L7.5 14.8738L7.35355 15.0202C7.15829 15.2155 6.84171 15.2155 6.64645 15.0202C6.45118 14.825 6.45118 14.5084 6.64645 14.3131L6.79289 14.1667L6.64645 14.0202C6.45118 13.825 6.45118 13.5084 6.64645 13.3131Z";
  const IconPathWeatherStormy = "M3.5 5.16663C3.5 3.51048 4.84386 2.16663 6.5 2.16663C7.80656 2.16663 8.9184 3.00193 9.32947 4.16663H11.1667C12.8235 4.16663 14.1667 5.50977 14.1667 7.16663C14.1667 8.82348 12.8235 10.1666 11.1667 10.1666H8.30902L7.80902 11.1666H9.80902L8.44721 13.8902C8.32372 14.1372 8.02338 14.2373 7.77639 14.1138C7.5294 13.9903 7.42929 13.69 7.55279 13.443L8.19098 12.1666H6.19098L7.19098 10.1666H4.30902L3.94721 10.8902C3.82372 11.1372 3.52338 11.2373 3.27639 11.1138C3.0294 10.9903 2.92929 10.69 3.05279 10.443L3.22191 10.1048C2.23206 9.86825 1.5 8.98078 1.5 7.91663C1.5 6.75501 2.37229 5.80393 3.5 5.68024V5.16663ZM4.01081 9.16663C4.00385 9.16648 3.9969 9.16648 3.98996 9.16663H3.75C3.05614 9.16663 2.5 8.61048 2.5 7.91663C2.5 7.22277 3.05614 6.66663 3.75 6.66663H4.5V5.16663C4.5 4.06277 5.39614 3.16663 6.5 3.16663C7.46778 3.16663 8.27611 3.85469 8.45988 4.76551L8.5408 5.16663H11.1667C12.2712 5.16663 13.1667 6.06206 13.1667 7.16663C13.1667 8.2712 12.2712 9.16663 11.1667 9.16663H8.01081C8.00385 9.16648 7.9969 9.16648 7.98996 9.16663H4.01081ZM12.4736 11.7194C12.7206 11.8429 12.8207 12.1432 12.6972 12.3902L12.1972 13.3902C12.0737 13.6372 11.7734 13.7373 11.5264 13.6138C11.2794 13.4903 11.1793 13.19 11.3028 12.943L11.8028 11.943C11.9263 11.696 12.2266 11.5959 12.4736 11.7194ZM4.22361 12.2194C4.4706 12.3429 4.57071 12.6432 4.44721 12.8902L3.94721 13.8902C3.82372 14.1372 3.52338 14.2373 3.27639 14.1138C3.0294 13.9903 2.92929 13.69 3.05279 13.443L3.55279 12.443C3.67628 12.196 3.97662 12.0959 4.22361 12.2194Z";
  const IconPathWeatherSunny = "M8.0201 0.850098C8.3001 0.850098 8.5201 1.0701 8.5201 1.3501V2.6801C8.5201 2.9601 8.3001 3.1801 8.0201 3.1801C7.7401 3.1801 7.5201 2.9601 7.5201 2.6801V1.3501C7.5201 1.0701 7.7401 0.850098 8.0201 0.850098ZM13.0901 2.9501C13.2901 3.1501 13.2901 3.4601 13.0901 3.6601L12.1501 4.6001C11.9501 4.8001 11.6401 4.8001 11.4401 4.6001C11.2401 4.4001 11.2401 4.0901 11.4401 3.8901L12.3801 2.9501C12.5801 2.7501 12.8901 2.7501 13.0901 2.9501ZM2.9501 2.9501C3.1501 2.7501 3.4601 2.7501 3.6601 2.9501L4.6001 3.8901C4.8001 4.0901 4.8001 4.4001 4.6001 4.6001C4.4001 4.8001 4.0901 4.8001 3.8901 4.6001L2.9501 3.6601C2.7501 3.4601 2.7501 3.1501 2.9501 2.9501ZM8.0201 5.1801C6.4601 5.1801 5.1901 6.4501 5.1901 8.0101C5.1901 9.5701 6.4601 10.8401 8.0201 10.8401C9.5801 10.8401 10.8501 9.5701 10.8501 8.0101C10.8501 6.4501 9.5801 5.1801 8.0201 5.1801ZM4.1901 8.0101C4.1901 5.8901 5.9101 4.1801 8.0201 4.1801C10.1301 4.1801 11.8501 5.9001 11.8501 8.0101C11.8501 10.1201 10.1301 11.8401 8.0201 11.8401C5.9101 11.8401 4.1901 10.1201 4.1901 8.0101ZM0.860098 8.0101C0.860098 7.7301 1.0801 7.5101 1.3601 7.5101H2.6901C2.9701 7.5101 3.1901 7.7301 3.1901 8.0101C3.1901 8.2901 2.9701 8.5101 2.6901 8.5101H1.3501C1.0701 8.5101 0.850098 8.2901 0.850098 8.0101H0.860098ZM12.8601 8.0101C12.8601 7.7301 13.0801 7.5101 13.3601 7.5101H14.6901C14.9701 7.5101 15.1901 7.7301 15.1901 8.0101C15.1901 8.2901 14.9701 8.5101 14.6901 8.5101H13.3601C13.0801 8.5101 12.8601 8.2901 12.8601 8.0101ZM4.6101 11.4301C4.8101 11.6301 4.8101 11.9401 4.6101 12.1401L3.6701 13.0801C3.4701 13.2801 3.1601 13.2801 2.9601 13.0801C2.7601 12.8801 2.7601 12.5701 2.9601 12.3701L3.9001 11.4301C4.1001 11.2301 4.4101 11.2301 4.6101 11.4301ZM11.4501 11.4301C11.6501 11.2301 11.9601 11.2301 12.1601 11.4301L13.1001 12.3701C13.3001 12.5701 13.3001 12.8801 13.1001 13.0801C12.9001 13.2801 12.5901 13.2801 12.3901 13.0801L11.4501 12.1401C11.2501 11.9401 11.2501 11.6301 11.4501 11.4301ZM8.0301 12.8501C8.3101 12.8501 8.5301 13.0701 8.5301 13.3501V14.6801C8.5301 14.9601 8.3101 15.1801 8.0301 15.1801C7.7501 15.1801 7.5301 14.9601 7.5301 14.6801V13.3501C7.5301 13.0701 7.7501 12.8501 8.0301 12.8501Z";
  const IconPathWeatherWindy = "M11.0017 2.5C11.0017 2.22386 11.2256 2 11.5017 2C12.8773 2 14 3.12427 14 4.5C14 5.87573 12.8773 7 11.5017 7H7.99479C7.71864 7 7.49479 6.77614 7.49479 6.5C7.49479 6.22386 7.71864 6 7.99479 6H11.5017C12.3242 6 13 5.32427 13 4.5C13 3.67573 12.3242 3 11.5017 3C11.2256 3 11.0017 2.77614 11.0017 2.5ZM2.49913 6.5C2.49913 6.22386 2.72299 6 2.99913 6H5.99652C6.27267 6 6.49652 6.22386 6.49652 6.5C6.49652 6.77614 6.27267 7 5.99652 7H2.99913C2.72299 7 2.49913 6.77614 2.49913 6.5ZM1.5 8.5C1.5 8.22386 1.72386 8 2 8H3.99826C4.27441 8 4.49826 8.22386 4.49826 8.5C4.49826 8.77614 4.27441 9 3.99826 9H2C1.72386 9 1.5 8.77614 1.5 8.5ZM5.49652 8.5C5.49652 8.22386 5.72038 8 5.99652 8H12.2911C12.5672 8 12.7911 8.22386 12.7911 8.5C12.7911 8.77614 12.5672 9 12.2911 9H5.99652C5.72038 9 5.49652 8.77614 5.49652 8.5ZM2.49913 10.5C2.49913 10.2239 2.72299 10 2.99913 10H4.99739C5.27354 10 5.49739 10.2239 5.49739 10.5C5.49739 10.7761 5.27354 11 4.99739 11H2.99913C2.72299 11 2.49913 10.7761 2.49913 10.5ZM6.49566 10.5C6.49566 10.2239 6.71951 10 6.99566 10H10.7424C11.7084 10 12.4913 10.7843 12.4913 11.75C12.4913 12.7157 11.7084 13.5 10.7424 13.5H9.99305C9.71691 13.5 9.49305 13.2761 9.49305 13C9.49305 12.7239 9.71691 12.5 9.99305 12.5H10.7424C11.1552 12.5 11.4913 12.1643 11.4913 11.75C11.4913 11.3357 11.1552 11 10.7424 11H6.99566C6.71951 11 6.49566 10.7761 6.49566 10.5Z";
  const IconPathWork = "M8.00002 2.9231C7.59581 2.9231 7.21198 3.07747 6.93207 3.34617C6.65791 3.60936 6.50557 3.96031 6.50017 4.3231H9.49987C9.49446 3.96033 9.34212 3.60937 9.06795 3.34617C8.78806 3.07748 8.40423 2.9231 8.00002 2.9231ZM10.4999 4.3231C10.4945 3.68183 10.2266 3.07224 9.76049 2.62479C9.29024 2.17335 8.65661 1.9231 8.00002 1.9231C7.34343 1.9231 6.7098 2.17335 6.23955 2.62478C5.77344 3.07224 5.50556 3.68184 5.5001 4.3231H3.00002C2.19102 4.3231 1.50002 4.95772 1.50002 5.7831V7.21846C1.49999 7.22133 1.49999 7.2242 1.50002 7.22707V12.0231C1.50002 12.8484 2.19102 13.4831 3.00002 13.4831H13C13.809 13.4831 14.5 12.8484 14.5 12.0231V7.2271C14.5 7.22421 14.5 7.22132 14.5 7.21843V5.7831C14.5 4.95771 13.809 4.3231 13 4.3231H10.4999ZM3.00002 5.3231C2.70444 5.3231 2.50002 5.54808 2.50002 5.7831V6.97866C4.06294 8.16129 5.99984 8.80846 8.00002 8.80846C10.0002 8.80846 11.9371 8.16129 13.5 6.97866V5.7831C13.5 5.54809 13.2956 5.3231 13 5.3231H3.00002ZM13.5 8.19819C11.8786 9.24463 9.96486 9.80846 8.00002 9.80846C6.03518 9.80846 4.12145 9.24463 2.50002 8.19819V12.0231C2.50002 12.2581 2.70445 12.4831 3.00002 12.4831H13C13.2956 12.4831 13.5 12.2581 13.5 12.0231V8.19819ZM9.50002 7.22308C9.50002 7.49923 9.27616 7.72308 9.00002 7.72308H7.00002C6.72388 7.72308 6.50002 7.49923 6.50002 7.22308C6.50002 6.94694 6.72388 6.72308 7.00002 6.72308H9.00002C9.27616 6.72308 9.50002 6.94694 9.50002 7.22308Z";
  const IconPathZoomIn = "M1.4707 6.50012C1.4707 3.72244 3.72244 1.4707 6.5001 1.4707C9.27775 1.4707 11.5295 3.72244 11.5295 6.50012C11.5295 7.66843 11.1311 8.7437 10.4628 9.59751L13.8667 12.8653C14.0776 13.0677 14.0845 13.4029 13.882 13.6138C13.6795 13.8247 13.3444 13.8315 13.1335 13.6291L9.72651 10.3584C8.85323 11.0894 7.72806 11.5295 6.5001 11.5295C3.72244 11.5295 1.4707 9.27776 1.4707 6.50012ZM6.5001 2.5295C4.3072 2.5295 2.5295 4.3072 2.5295 6.50012C2.5295 8.693 4.3072 10.4707 6.5001 10.4707C8.69299 10.4707 10.4707 8.69299 10.4707 6.50012C10.4707 4.3072 8.69299 2.5295 6.5001 2.5295ZM6.5001 3.97078C6.79248 3.97078 7.0295 4.2078 7.0295 4.50018V5.97086H8.5001C8.79248 5.97086 9.0295 6.20788 9.0295 6.50026C9.0295 6.79264 8.79248 7.02966 8.5001 7.02966H7.0295V8.50018C7.0295 8.79256 6.79248 9.02958 6.5001 9.02958C6.20772 9.02958 5.9707 8.79256 5.9707 8.50018V7.02966H4.5001C4.20772 7.02966 3.9707 6.79264 3.9707 6.50026C3.9707 6.20788 4.20772 5.97086 4.5001 5.97086H5.9707V4.50018C5.9707 4.2078 6.20772 3.97078 6.5001 3.97078Z";
  const IconPathZoomOut = "M1.4707 6.50012C1.4707 3.72244 3.72244 1.4707 6.5001 1.4707C9.27775 1.4707 11.5295 3.72244 11.5295 6.50012C11.5295 7.66843 11.1311 8.7437 10.4628 9.59751L13.8667 12.8653C14.0776 13.0677 14.0845 13.4029 13.882 13.6138C13.6795 13.8247 13.3444 13.8315 13.1335 13.6291L9.72651 10.3584C8.85323 11.0894 7.72806 11.5295 6.5001 11.5295C3.72244 11.5295 1.4707 9.27776 1.4707 6.50012ZM6.5001 2.5295C4.3072 2.5295 2.5295 4.3072 2.5295 6.50012C2.5295 8.693 4.3072 10.4707 6.5001 10.4707C8.69299 10.4707 10.4707 8.69299 10.4707 6.50012C10.4707 4.3072 8.69299 2.5295 6.5001 2.5295ZM3.9707 6.50026C3.9707 6.20788 4.20772 5.97086 4.5001 5.97086H8.5001C8.79248 5.97086 9.0295 6.20788 9.0295 6.50026C9.0295 6.79264 8.79248 7.02966 8.5001 7.02966H4.5001C4.20772 7.02966 3.9707 6.79264 3.9707 6.50026Z";
  const IconPathBoostCharging = "M7 2.5C6.72386 2.5 6.5 2.72386 6.5 3C6.5 3.27614 6.72386 3.5 7 3.5H12C12.2739 3.5 12.5 3.72614 12.5 4V12C12.5 12.2739 12.2739 12.5 12 12.5H5C4.72386 12.5 4.5 12.7239 4.5 13C4.5 13.2761 4.72386 13.5 5 13.5H12C12.8261 13.5 13.5 12.8261 13.5 12V11H14.5C15.0561 11 15.5 10.5561 15.5 10V6C15.5 5.44386 15.0561 5 14.5 5H13.5V4C13.5 3.17386 12.8261 2.5 12 2.5H7ZM13.5 6V10H14.5V6H13.5ZM9.96424 5.6857C10.0668 5.4293 9.94209 5.13832 9.6857 5.03576C9.4293 4.9332 9.13832 5.05791 9.03576 5.3143L7.76148 8.5H9.76148L9.03576 10.3143C8.93321 10.5707 9.05791 10.8617 9.3143 10.9642C9.5707 11.0668 9.86168 10.9421 9.96424 10.6857L11.2385 7.5H9.23852L9.96424 5.6857ZM3 5.5C3 5.22386 3.22386 5 3.5 5H7C7.27614 5 7.5 5.22386 7.5 5.5C7.5 5.77614 7.27614 6 7 6H3.5C3.22386 6 3 5.77614 3 5.5ZM2 7.5C1.72386 7.5 1.5 7.72386 1.5 8C1.5 8.27614 1.72386 8.5 2 8.5H6C6.27614 8.5 6.5 8.27614 6.5 8C6.5 7.72386 6.27614 7.5 6 7.5H2ZM3.5 10.5C3.5 10.2239 3.72386 10 4 10H7C7.27614 10 7.5 10.2239 7.5 10.5C7.5 10.7761 7.27614 11 7 11H4C3.72386 11 3.5 10.7761 3.5 10.5Z";
  const IconPathCreditCardTerminal = "M3.5 2.5C3.22386 2.5 3 2.72386 3 3V4.5H14V3C14 2.72386 13.7761 2.5 13.5 2.5H3.5ZM3 9V5.5H14V9C14 9.27614 13.7761 9.5 13.5 9.5H3.5C3.22386 9.5 3 9.27614 3 9ZM9 10.5H13.5C14.3284 10.5 15 9.82843 15 9V3C15 2.17157 14.3284 1.5 13.5 1.5H3.5C2.67157 1.5 2 2.17157 2 3V9C2 9.82843 2.67157 10.5 3.5 10.5H8V13.5H6.5C6.22386 13.5 6 13.7239 6 14C6 14.2761 6.22386 14.5 6.5 14.5H10.5C10.7761 14.5 11 14.2761 11 14C11 13.7239 10.7761 13.5 10.5 13.5H9V10.5ZM4.5 7.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H6.5C6.77614 8.5 7 8.27614 7 8C7 7.72386 6.77614 7.5 6.5 7.5H4.5Z";
  const IconPathSolarThreshold = "M14.5 1.5C13.8012 1.5 13.2196 1.73063 12.7495 2.13759C12.2905 2.53488 11.9599 3.08046 11.7096 3.68328C11.2136 4.87804 10.9769 6.44459 10.7683 7.93049L10.7245 8.24358C10.5281 9.6506 10.3442 10.9677 10.0011 11.9619C9.81826 12.4919 9.60503 12.8823 9.35831 13.1353C9.12629 13.3733 8.85656 13.5 8.5 13.5C8.10175 13.5 7.83231 13.3911 7.63047 13.2261C7.41909 13.0534 7.24296 12.787 7.09594 12.4115C6.83753 11.7515 6.71703 10.8968 6.58176 9.93742C6.55823 9.77055 6.53425 9.60049 6.50903 9.42775C6.34612 8.31221 6.1302 7.09129 5.57081 6.15068C5.28453 5.6693 4.90232 5.24946 4.38442 4.95284C3.8666 4.65627 3.24299 4.5 2.5 4.5C2.22386 4.5 2 4.72386 2 5C2 5.27614 2.22386 5.5 2.5 5.5C3.09986 5.5 3.54589 5.62498 3.88743 5.8206C4.22891 6.01617 4.4958 6.29945 4.71131 6.66182C5.15549 7.40871 5.35385 8.43779 5.51952 9.57225C5.54262 9.7304 5.5651 9.89117 5.58777 10.0533C5.72049 11.0023 5.85953 11.9965 6.16477 12.776C6.34811 13.2443 6.6068 13.681 6.99765 14.0004C7.39804 14.3277 7.89825 14.5 8.5 14.5C9.14344 14.5 9.66649 14.2517 10.0743 13.8334C10.4674 13.4302 10.7411 12.8831 10.9464 12.2881C11.323 11.1968 11.5198 9.78369 11.7108 8.4118L11.7586 8.06951C11.9711 6.55541 12.1951 5.12196 12.6332 4.06672C12.85 3.54454 13.1048 3.15262 13.4039 2.89366C13.6919 2.64437 14.0411 2.5 14.5 2.5C14.7761 2.5 15 2.27614 15 2C15 1.72386 14.7761 1.5 14.5 1.5ZM2.5 7.5C2.22386 7.5 2 7.72386 2 8C2 8.27614 2.22386 8.5 2.5 8.5H3.5C3.77614 8.5 4 8.27614 4 8C4 7.72386 3.77614 7.5 3.5 7.5H2.5ZM7.5 8C7.5 7.72386 7.72386 7.5 8 7.5H9C9.27614 7.5 9.5 7.72386 9.5 8C9.5 8.27614 9.27614 8.5 9 8.5H8C7.72386 8.5 7.5 8.27614 7.5 8ZM13.5 7.5C13.2239 7.5 13 7.72386 13 8C13 8.27614 13.2239 8.5 13.5 8.5H14.5C14.7761 8.5 15 8.27614 15 8C15 7.72386 14.7761 7.5 14.5 7.5H13.5Z";
  const IconPathStatusAvailable = "M8.5 14C11.8137 14 14.5 11.3137 14.5 8C14.5 4.68629 11.8137 2 8.5 2C5.18629 2 2.5 4.68629 2.5 8C2.5 11.3137 5.18629 14 8.5 14Z";
  const IconPathStatusUnavailable = "M8.5 11C10.1569 11 11.5 9.65685 11.5 8C11.5 6.34315 10.1569 5 8.5 5C6.84315 5 5.5 6.34315 5.5 8C5.5 9.65685 6.84315 11 8.5 11ZM14.5 8C14.5 11.3137 11.8137 14 8.5 14C5.18629 14 2.5 11.3137 2.5 8C2.5 4.68629 5.18629 2 8.5 2C11.8137 2 14.5 4.68629 14.5 8Z";
  const IconIllustrativeSize = "56px";
  const IconTokens = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    IconIllustrativeSize,
    IconPathAccept,
    IconPathAccessPrivate,
    IconPathAccessPublic,
    IconPathAccessfree,
    IconPathAccount,
    IconPathAdd,
    IconPathAddCircle,
    IconPathAddCircleFilled,
    IconPathAlert,
    IconPathAssign,
    IconPathBatteryCharging,
    IconPathBatteryConsumption,
    IconPathBatteryHorizontal,
    IconPathBatteryVertical,
    IconPathBlock,
    IconPathBoostCharging,
    IconPathCancel,
    IconPathCancelCircle,
    IconPathCancelCircleFilled,
    IconPathCar,
    IconPathCard,
    IconPathCardAdd,
    IconPathCardGroup,
    IconPathChargerElvi,
    IconPathChargerId,
    IconPathChart,
    IconPathCheck,
    IconPathCheckCircleFilled,
    IconPathCheckboxChecked,
    IconPathCheckboxIndeterminate,
    IconPathCheckboxUnchecked,
    IconPathClose,
    IconPathCloseCircle,
    IconPathCloseCircleFilled,
    IconPathConnection,
    IconPathConnectionLost,
    IconPathContactless,
    IconPathContactlessCircle,
    IconPathCookies,
    IconPathCopy,
    IconPathCreditCardTerminal,
    IconPathCreditcard,
    IconPathCreditcardAdd,
    IconPathCreditcardInactive,
    IconPathDashboard,
    IconPathDate,
    IconPathDateAndTime,
    IconPathDayNight,
    IconPathDelete,
    IconPathDesktop,
    IconPathDirection,
    IconPathDirectionEast,
    IconPathDirectionNorth,
    IconPathDirectionNorthEast,
    IconPathDirectionNorthWest,
    IconPathDirectionSouth,
    IconPathDirectionSouthEast,
    IconPathDirectionSouthWest,
    IconPathDirectionWest,
    IconPathDiscount,
    IconPathDownload,
    IconPathDrag,
    IconPathDuration,
    IconPathEcoSystem,
    IconPathEdit,
    IconPathElliFlash,
    IconPathEmail,
    IconPathEnergy,
    IconPathEnergyNonRenewable,
    IconPathEnergyRenewable,
    IconPathEnergySolar,
    IconPathExpandAll,
    IconPathExpandLeft,
    IconPathExpandLeftCircleFilled,
    IconPathExpandLess,
    IconPathExpandLessCircleFilled,
    IconPathExpandMore,
    IconPathExpandMoreCircleFilled,
    IconPathExpandRight,
    IconPathExpandRightCircleFilled,
    IconPathFavorite,
    IconPathFeedback,
    IconPathFile,
    IconPathFileCode,
    IconPathFilter,
    IconPathFlashlight,
    IconPathFolder,
    IconPathGrid,
    IconPathGroup,
    IconPathGroupAuthorisation,
    IconPathGroupLoadmanagement,
    IconPathGroupWork,
    IconPathHeater,
    IconPathHelp,
    IconPathInfo,
    IconPathLabel,
    IconPathLanguage,
    IconPathLaunch,
    IconPathLayers,
    IconPathLight,
    IconPathLink,
    IconPathList,
    IconPathListInfo,
    IconPathListOutlined,
    IconPathLoading,
    IconPathLocation,
    IconPathLocked,
    IconPathLogin,
    IconPathMachineAirCon,
    IconPathMachineDish,
    IconPathMachineDryer,
    IconPathMachineWaching,
    IconPathMail,
    IconPathMailResend,
    IconPathMaintainance,
    IconPathMap,
    IconPathMenu,
    IconPathModeLight,
    IconPathMoreHorizontal,
    IconPathMoreVertical,
    IconPathMyLocation,
    IconPathNavigateBack,
    IconPathNavigateDown,
    IconPathNavigateLeft,
    IconPathNavigateRight,
    IconPathNavigateUp,
    IconPathNotifications,
    IconPathOpenInFull,
    IconPathOpenInNew,
    IconPathOrder,
    IconPathOrganization,
    IconPathOutletCee16A,
    IconPathOutletCee32A,
    IconPathOutletChAdeMo1,
    IconPathOutletCombo1,
    IconPathOutletCombo2,
    IconPathOutletSchuko,
    IconPathOutletType1,
    IconPathOutletType2,
    IconPathParkingDriveway,
    IconPathParkingGarage,
    IconPathParkingLot,
    IconPathParkingMotorway,
    IconPathParkingStreet,
    IconPathParkingUnderground,
    IconPathPayment,
    IconPathPhone,
    IconPathPhoneSignal,
    IconPathPin,
    IconPathPlug,
    IconPathPlugAndCharge,
    IconPathPointer,
    IconPathPower,
    IconPathPriceFixed,
    IconPathPrint,
    IconPathPriority,
    IconPathPriorityHigh,
    IconPathPrivacy,
    IconPathPrivatePublic,
    IconPathRadioChecked,
    IconPathRadioUnchecked,
    IconPathRebootHard,
    IconPathRebootSoft,
    IconPathRefresh,
    IconPathRemove,
    IconPathRemoveCircle,
    IconPathRemoveCircleFilled,
    IconPathRestore,
    IconPathRestoreWarning,
    IconPathRoute,
    IconPathSave,
    IconPathScooter,
    IconPathScooterElectric,
    IconPathSearch,
    IconPathSelectedPartners,
    IconPathSettings,
    IconPathSolarPanel,
    IconPathSolarRoof,
    IconPathSolarShade,
    IconPathSolarSun,
    IconPathSolarThreshold,
    IconPathSort,
    IconPathSpeed,
    IconPathSpeedHigh,
    IconPathSpeedLow,
    IconPathStation,
    IconPathStationGroup,
    IconPathStationLarge,
    IconPathStatusAvailable,
    IconPathStatusUnavailable,
    IconPathSticker,
    IconPathStopCircle,
    IconPathSwitch,
    IconPathTime,
    IconPathUnlink,
    IconPathUnlocked,
    IconPathUpdate,
    IconPathUpload,
    IconPathUploadCloud,
    IconPathVisibilityOff,
    IconPathVisibilityOn,
    IconPathVoucher,
    IconPathWarning,
    IconPathWeatherCloudy,
    IconPathWeatherCloudyPartly,
    IconPathWeatherFrozen,
    IconPathWeatherRainy,
    IconPathWeatherSnowy,
    IconPathWeatherStormy,
    IconPathWeatherSunny,
    IconPathWeatherWindy,
    IconPathWork,
    IconPathZoomIn,
    IconPathZoomOut,
    IconSizeL,
    IconSizeM,
    IconSizeS
  }, Symbol.toStringTag, { value: "Module" }));
  const ColorSurfaceBrandBoldDefault = "#6633cc";
  const ColorSurfaceBrandBoldHover = "#4d26bd";
  const ColorSurfaceBrandBoldActive = "#1f11ab";
  const ColorSurfaceBrandBoldOn = "#ffffff";
  const ColorSurfaceBrandSoftDefault = "#efedf9";
  const ColorSurfaceBrandSoftHover = "#e8e4f7";
  const ColorSurfaceBrandSoftActive = "#d8d2f0";
  const ColorSurfaceBrandSoftOn = "#000000";
  const ColorSurfaceBrandSoftOnHighlight = "#6633cc";
  const ColorSurfaceBrandSoftRippleLayerOne = "#3d20b614";
  const ColorSurfaceBrandSoftRippleLayerTwo = "#3d20b61f";
  const ColorSurfaceAccentBoldDefault = "#00ff99";
  const ColorSurfaceAccentBoldHover = "#00e58a";
  const ColorSurfaceAccentBoldActive = "#00cc7a";
  const ColorSurfaceAccentBoldOn = "#000000";
  const ColorSurfaceAccentSoftDefault = "#ebfff7";
  const ColorSurfaceAccentSoftHover = "#e0fff3";
  const ColorSurfaceAccentSoftActive = "#ccffeb";
  const ColorSurfaceAccentSoftOn = "#000000";
  const ColorSurfaceAccentSoftOnHighlight = "#00804d";
  const ColorSurfaceAccentSoftRippleLayerOne = "#00ff9914";
  const ColorSurfaceAccentSoftRippleLayerTwo = "#00ff991f";
  const ColorSurfaceAlertBoldDefault = "#c9005c";
  const ColorSurfaceAlertBoldHover = "#b40059";
  const ColorSurfaceAlertBoldActive = "#8f0052";
  const ColorSurfaceAlertBoldOn = "#ffffff";
  const ColorSurfaceAlertSoftDefault = "#feebf3";
  const ColorSurfaceAlertSoftHover = "#fde0ed";
  const ColorSurfaceAlertSoftActive = "#fccce0";
  const ColorSurfaceAlertSoftOn = "#000000";
  const ColorSurfaceAlertSoftOnHighlight = "#c9005c";
  const ColorSurfaceAlertSoftRippleLayerOne = "#f0006614";
  const ColorSurfaceAlertSoftRippleLayerTwo = "#f000661f";
  const ColorSurfaceWarningBoldDefault = "#ffa726";
  const ColorSurfaceWarningBoldHover = "#ff9800";
  const ColorSurfaceWarningBoldActive = "#ff8c00";
  const ColorSurfaceWarningBoldOn = "#000000";
  const ColorSurfaceWarningSoftDefault = "#fff8ee";
  const ColorSurfaceWarningSoftHover = "#fff4e5";
  const ColorSurfaceWarningSoftActive = "#ffedd4";
  const ColorSurfaceWarningSoftOn = "#000000";
  const ColorSurfaceWarningSoftOnHighlight = "#cc360b";
  const ColorSurfaceWarningSoftRippleLayerOne = "#ffa72614";
  const ColorSurfaceWarningSoftRippleLayerTwo = "#ffa7261f";
  const ColorSurfaceSuccessBoldDefault = "#00ff99";
  const ColorSurfaceSuccessBoldHover = "#00e58a";
  const ColorSurfaceSuccessBoldActive = "#00cc7a";
  const ColorSurfaceSuccessBoldOn = "#000000";
  const ColorSurfaceSuccessSoftDefault = "#ebfff7";
  const ColorSurfaceSuccessSoftHover = "#e0fff3";
  const ColorSurfaceSuccessSoftActive = "#ccffeb";
  const ColorSurfaceSuccessSoftOn = "#000000";
  const ColorSurfaceSuccessSoftOnHighlight = "#00804d";
  const ColorSurfaceSuccessSoftRippleLayerOne = "#00ff9914";
  const ColorSurfaceSuccessSoftRippleLayerTwo = "#00ff991f";
  const ColorSurfaceInfoBoldDefault = "#6633cc";
  const ColorSurfaceInfoBoldHover = "#4d26bd";
  const ColorSurfaceInfoBoldActive = "#1f11ab";
  const ColorSurfaceInfoBoldOn = "#ffffff";
  const ColorSurfaceInfoSoftDefault = "#efedf9";
  const ColorSurfaceInfoSoftHover = "#e8e4f7";
  const ColorSurfaceInfoSoftActive = "#d8d2f0";
  const ColorSurfaceInfoSoftOn = "#000000";
  const ColorSurfaceInfoSoftOnHighlight = "#6633cc";
  const ColorSurfaceInfoSoftRippleLayerOne = "#3d20b614";
  const ColorSurfaceInfoSoftRippleLayerTwo = "#3d20b61f";
  const ColorSurfaceNeutralBoldDefault = "#7c8388";
  const ColorSurfaceNeutralBoldHover = "#5a5e63";
  const ColorSurfaceNeutralBoldActive = "#3b3f42";
  const ColorSurfaceNeutralBoldOn = "#ffffff";
  const ColorSurfaceNeutralSoftDefault = "#eff0f0";
  const ColorSurfaceNeutralSoftHover = "#e7e8e8";
  const ColorSurfaceNeutralSoftActive = "#d8d9d9";
  const ColorSurfaceNeutralSoftOn = "#000000";
  const ColorSurfaceNeutralSoftOnHighlight = "#5a5e63";
  const ColorSurfaceNeutralSoftRippleLayerOne = "#3b3f4214";
  const ColorSurfaceNeutralSoftRippleLayerTwo = "#3b3f421f";
  const ColorSurfaceInvertedBoldDefault = "#ffffff";
  const ColorSurfaceInvertedBoldHover = "#ffffffe0";
  const ColorSurfaceInvertedBoldActive = "#ffffffcc";
  const ColorSurfaceInvertedBoldOn = "#000000";
  const ColorSurfaceInvertedSoftDefault = "#ffffff14";
  const ColorSurfaceInvertedSoftHover = "#ffffff1f";
  const ColorSurfaceInvertedSoftActive = "#ffffff33";
  const ColorSurfaceInvertedSoftOn = "#ffffff";
  const ColorSurfaceDisabledDefault = "#e8eaed";
  const ColorSurfaceDisabledOn = "#9aa0a6";
  const ColorSurfaceUtilityBoldDefault = "#0f62fe";
  const ColorSurfaceUtilityBoldHover = "#0c4ecb";
  const ColorSurfaceUtilityBoldActive = "#093b98";
  const ColorSurfaceUtilityBoldOn = "#ffffff";
  const ColorSurfaceUtilitySoftDefault = "#ecf2ff";
  const ColorSurfaceUtilitySoftHover = "#e2ecff";
  const ColorSurfaceUtilitySoftActive = "#cfdfff";
  const ColorSurfaceUtilitySoftOn = "#000000";
  const ColorSurfaceUtilitySoftOnHighlight = "#0c4ecb";
  const ColorLinkPrimaryDefault = "#6633cc";
  const ColorLinkPrimaryHover = "#7f53d4";
  const ColorLinkPrimaryActive = "#9772dc";
  const ColorLinkPrimaryVisited = "#1f11ab";
  const ColorLinkSecondaryDefault = "#5a5e63";
  const ColorLinkSecondaryHover = "#7c8388";
  const ColorLinkSecondaryActive = "#9aa0a6";
  const ColorLinkSecondaryVisited = "#1c1c1e";
  const ColorLinkAlertDefault = "#c9005c";
  const ColorLinkAlertHover = "#df0061";
  const ColorLinkAlertActive = "#f00066";
  const ColorLinkAlertVisited = "#8f0052";
  const ColorLinkWarningDefault = "#cc360b";
  const ColorLinkWarningHover = "#ea5001";
  const ColorLinkWarningActive = "#f36c01";
  const ColorLinkWarningVisited = "#ff8c00";
  const ColorLinkSuccessDefault = "#00804d";
  const ColorLinkSuccessHover = "#00995c";
  const ColorLinkSuccessActive = "#00b36b";
  const ColorLinkSuccessVisited = "#00663d";
  const ColorLinkInfoDefault = "#6633cc";
  const ColorLinkInfoHover = "#7f53d4";
  const ColorLinkInfoActive = "#9772dc";
  const ColorLinkInfoVisited = "#1f11ab";
  const ColorLinkInvertedDefault = "#ffffff";
  const ColorLinkInvertedHover = "#ffffffe0";
  const ColorLinkInvertedActive = "#ffffffcc";
  const ColorLinkInvertedVisited = "#ffffffcc";
  const ColorLinkInvertedDisabled = "#ffffff80";
  const ColorLinkDisabled = "#9aa0a6";
  const ColorTextPrimary = "#000000";
  const ColorTextSecondary = "#5a5e63";
  const ColorTextDisabled = "#9aa0a6";
  const ColorTextBrand = "#6633cc";
  const ColorTextAlert = "#c9005c";
  const ColorTextWarning = "#cc360b";
  const ColorTextSuccess = "#00804d";
  const ColorTextInfo = "#6633cc";
  const ColorTextInverted = "#ffffff";
  const ColorBorderDefault = "#bdc1c6";
  const ColorBorderHover = "#000000";
  const ColorBorderFocused = "#0f62fe";
  const ColorBorderFocusedInverted = "#3f81fe";
  const ColorBorderDisabled = "#e8eaed";
  const ColorBorderSubtle = "#dadce0";
  const ColorBorderBrand = "#6633cc";
  const ColorBorderAlert = "#c9005c";
  const ColorBorderWarning = "#ffa726";
  const ColorBorderSuccess = "#00ff99";
  const ColorBorderInfo = "#6633cc";
  const ColorBorderInverted = "#ffffff";
  const ColorBackgroundPrimary = "#ffffff";
  const ColorBackgroundSecondary = "#f1f3f4";
  const ColorBackgroundTertiary = "#dadce0";
  const ColorBrandLogo = "#6633cc";
  const BorderWidthNone = "0px";
  const BorderWidthDefault = "1px";
  const BorderWidthStrong = "2px";
  const BorderRadiusNone = "0px";
  const BorderRadiusS = "2px";
  const BorderRadiusM = "4px";
  const BorderRadiusRound = "10000px";
  const FocusedOutlineWidth = "2px";
  const FocusedOutlineOffset = "2px";
  const FocusedDefaultColor = "#0f62fe";
  const FocusedDefaultWidth = "2px";
  const FocusedDefaultStyle = "solid";
  const FocusedInvertedColor = "#3f81fe";
  const FocusedInvertedWidth = "2px";
  const FocusedInvertedStyle = "solid";
  const Common_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    BorderRadiusM,
    BorderRadiusNone,
    BorderRadiusRound,
    BorderRadiusS,
    BorderWidthDefault,
    BorderWidthNone,
    BorderWidthStrong,
    ColorBackgroundPrimary,
    ColorBackgroundSecondary,
    ColorBackgroundTertiary,
    ColorBorderAlert,
    ColorBorderBrand,
    ColorBorderDefault,
    ColorBorderDisabled,
    ColorBorderFocused,
    ColorBorderFocusedInverted,
    ColorBorderHover,
    ColorBorderInfo,
    ColorBorderInverted,
    ColorBorderSubtle,
    ColorBorderSuccess,
    ColorBorderWarning,
    ColorBrandLogo,
    ColorLinkAlertActive,
    ColorLinkAlertDefault,
    ColorLinkAlertHover,
    ColorLinkAlertVisited,
    ColorLinkDisabled,
    ColorLinkInfoActive,
    ColorLinkInfoDefault,
    ColorLinkInfoHover,
    ColorLinkInfoVisited,
    ColorLinkInvertedActive,
    ColorLinkInvertedDefault,
    ColorLinkInvertedDisabled,
    ColorLinkInvertedHover,
    ColorLinkInvertedVisited,
    ColorLinkPrimaryActive,
    ColorLinkPrimaryDefault,
    ColorLinkPrimaryHover,
    ColorLinkPrimaryVisited,
    ColorLinkSecondaryActive,
    ColorLinkSecondaryDefault,
    ColorLinkSecondaryHover,
    ColorLinkSecondaryVisited,
    ColorLinkSuccessActive,
    ColorLinkSuccessDefault,
    ColorLinkSuccessHover,
    ColorLinkSuccessVisited,
    ColorLinkWarningActive,
    ColorLinkWarningDefault,
    ColorLinkWarningHover,
    ColorLinkWarningVisited,
    ColorSurfaceAccentBoldActive,
    ColorSurfaceAccentBoldDefault,
    ColorSurfaceAccentBoldHover,
    ColorSurfaceAccentBoldOn,
    ColorSurfaceAccentSoftActive,
    ColorSurfaceAccentSoftDefault,
    ColorSurfaceAccentSoftHover,
    ColorSurfaceAccentSoftOn,
    ColorSurfaceAccentSoftOnHighlight,
    ColorSurfaceAccentSoftRippleLayerOne,
    ColorSurfaceAccentSoftRippleLayerTwo,
    ColorSurfaceAlertBoldActive,
    ColorSurfaceAlertBoldDefault,
    ColorSurfaceAlertBoldHover,
    ColorSurfaceAlertBoldOn,
    ColorSurfaceAlertSoftActive,
    ColorSurfaceAlertSoftDefault,
    ColorSurfaceAlertSoftHover,
    ColorSurfaceAlertSoftOn,
    ColorSurfaceAlertSoftOnHighlight,
    ColorSurfaceAlertSoftRippleLayerOne,
    ColorSurfaceAlertSoftRippleLayerTwo,
    ColorSurfaceBrandBoldActive,
    ColorSurfaceBrandBoldDefault,
    ColorSurfaceBrandBoldHover,
    ColorSurfaceBrandBoldOn,
    ColorSurfaceBrandSoftActive,
    ColorSurfaceBrandSoftDefault,
    ColorSurfaceBrandSoftHover,
    ColorSurfaceBrandSoftOn,
    ColorSurfaceBrandSoftOnHighlight,
    ColorSurfaceBrandSoftRippleLayerOne,
    ColorSurfaceBrandSoftRippleLayerTwo,
    ColorSurfaceDisabledDefault,
    ColorSurfaceDisabledOn,
    ColorSurfaceInfoBoldActive,
    ColorSurfaceInfoBoldDefault,
    ColorSurfaceInfoBoldHover,
    ColorSurfaceInfoBoldOn,
    ColorSurfaceInfoSoftActive,
    ColorSurfaceInfoSoftDefault,
    ColorSurfaceInfoSoftHover,
    ColorSurfaceInfoSoftOn,
    ColorSurfaceInfoSoftOnHighlight,
    ColorSurfaceInfoSoftRippleLayerOne,
    ColorSurfaceInfoSoftRippleLayerTwo,
    ColorSurfaceInvertedBoldActive,
    ColorSurfaceInvertedBoldDefault,
    ColorSurfaceInvertedBoldHover,
    ColorSurfaceInvertedBoldOn,
    ColorSurfaceInvertedSoftActive,
    ColorSurfaceInvertedSoftDefault,
    ColorSurfaceInvertedSoftHover,
    ColorSurfaceInvertedSoftOn,
    ColorSurfaceNeutralBoldActive,
    ColorSurfaceNeutralBoldDefault,
    ColorSurfaceNeutralBoldHover,
    ColorSurfaceNeutralBoldOn,
    ColorSurfaceNeutralSoftActive,
    ColorSurfaceNeutralSoftDefault,
    ColorSurfaceNeutralSoftHover,
    ColorSurfaceNeutralSoftOn,
    ColorSurfaceNeutralSoftOnHighlight,
    ColorSurfaceNeutralSoftRippleLayerOne,
    ColorSurfaceNeutralSoftRippleLayerTwo,
    ColorSurfaceSuccessBoldActive,
    ColorSurfaceSuccessBoldDefault,
    ColorSurfaceSuccessBoldHover,
    ColorSurfaceSuccessBoldOn,
    ColorSurfaceSuccessSoftActive,
    ColorSurfaceSuccessSoftDefault,
    ColorSurfaceSuccessSoftHover,
    ColorSurfaceSuccessSoftOn,
    ColorSurfaceSuccessSoftOnHighlight,
    ColorSurfaceSuccessSoftRippleLayerOne,
    ColorSurfaceSuccessSoftRippleLayerTwo,
    ColorSurfaceUtilityBoldActive,
    ColorSurfaceUtilityBoldDefault,
    ColorSurfaceUtilityBoldHover,
    ColorSurfaceUtilityBoldOn,
    ColorSurfaceUtilitySoftActive,
    ColorSurfaceUtilitySoftDefault,
    ColorSurfaceUtilitySoftHover,
    ColorSurfaceUtilitySoftOn,
    ColorSurfaceUtilitySoftOnHighlight,
    ColorSurfaceWarningBoldActive,
    ColorSurfaceWarningBoldDefault,
    ColorSurfaceWarningBoldHover,
    ColorSurfaceWarningBoldOn,
    ColorSurfaceWarningSoftActive,
    ColorSurfaceWarningSoftDefault,
    ColorSurfaceWarningSoftHover,
    ColorSurfaceWarningSoftOn,
    ColorSurfaceWarningSoftOnHighlight,
    ColorSurfaceWarningSoftRippleLayerOne,
    ColorSurfaceWarningSoftRippleLayerTwo,
    ColorTextAlert,
    ColorTextBrand,
    ColorTextDisabled,
    ColorTextInfo,
    ColorTextInverted,
    ColorTextPrimary,
    ColorTextSecondary,
    ColorTextSuccess,
    ColorTextWarning,
    FocusedDefaultColor,
    FocusedDefaultStyle,
    FocusedDefaultWidth,
    FocusedInvertedColor,
    FocusedInvertedStyle,
    FocusedInvertedWidth,
    FocusedOutlineOffset,
    FocusedOutlineWidth
  }, Symbol.toStringTag, { value: "Module" }));
  const ElliLight = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    badgeInfo: BadgeInfo_es,
    badgeInteractive: BadgeInteractive_es,
    badgeNotify: BadgeNotify_es,
    button: Button_es,
    common: Common_es,
    connectorStatus: ConnectorStatus_es,
    formControl: FormControl_es,
    icon: IconTokens,
    link: Link_es,
    typography: Typography_es
  }, Symbol.toStringTag, { value: "Module" }));
  const shouldForwardProp = (prop) => typeof prop === "string" ? !prop.startsWith("$") && !["as"].includes(prop) : true;
  const styled = (component, options) => (
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    material.styled(component, {
      shouldForwardProp,
      ...options
    })
  );
  const VariantMapping = {
    body: "p",
    bodyHighlight: "p",
    bodySmall: "p",
    bodySmallHighlight: "p",
    caption: "p",
    display1: "h1",
    headline: "h6",
    title1: "h1",
    title2: "h2"
  };
  const TypographyBuilder = (variant) => {
    const func = React.forwardRef(({ children, ...rest }, ref) => {
      return /* @__PURE__ */ jsxRuntime.jsx(material.Typography, { variant, ...rest, ref, variantMapping: VariantMapping, children });
    });
    func.displayName = variant ? variant[0].toUpperCase() + variant.slice(1) : "Typography";
    return func;
  };
  const Display1 = TypographyBuilder("display1");
  const Title1 = TypographyBuilder("title1");
  const Title2 = TypographyBuilder("title2");
  const Headline = TypographyBuilder("headline");
  const Body$1 = TypographyBuilder("body");
  const BodyHighlight = TypographyBuilder("bodyHighlight");
  const BodyLink = TypographyBuilder("bodyLink");
  const BodySmall = TypographyBuilder("bodySmall");
  const BodySmallHighlight = TypographyBuilder("bodySmallHighlight");
  const BodySmallLink = TypographyBuilder("bodySmallLink");
  const Label$1 = TypographyBuilder("label");
  const LabelSmall = TypographyBuilder("labelSmall");
  const LabelMedium = TypographyBuilder("labelMedium");
  const Caption = TypographyBuilder("caption");
  const IconPathRegex = /IconPath([a-zA-Z].*)/;
  const iconNamesList = Object.keys(IconTokens).map((tokenKey) => {
    const matches = tokenKey.match(IconPathRegex);
    return (matches == null ? void 0 : matches[1]) ?? void 0;
  }).filter((iconName) => iconName !== void 0);
  const getIconTokens = (theme2) => theme2.tokens.icon;
  const Root$8 = styled("svg", { name: "Icon", slot: "Svg" })((props) => {
    const { size, fill, theme: theme2 } = props;
    const iconTokens = getIconTokens(theme2);
    return material.css`
    width: ${iconTokens[`IconSize${upper(size)}`]};
    height: ${iconTokens[`IconSize${upper(size)}`]};
    fill: ${fill};
  `;
  });
  function Icon$2({ color, size = "m", name, ariaLabel, role = "img", ...props }) {
    const viewBoxXYDefault = 0;
    const viewBoxSizeDefault = 16;
    const tokens = material.useTheme().tokens;
    const iconPathTokenKey = `IconPath${name}`;
    return /* @__PURE__ */ jsxRuntime.jsx(
      Root$8,
      {
        "aria-label": ariaLabel ?? name,
        fill: color ?? "currentColor",
        role,
        size,
        viewBox: `${viewBoxXYDefault} ${viewBoxXYDefault} ${viewBoxSizeDefault} ${viewBoxSizeDefault}`,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /* @__PURE__ */ jsxRuntime.jsx("path", { clipRule: "evenodd", d: tokens.icon[iconPathTokenKey], fillRule: "evenodd" })
      }
    );
  }
  Icon$2.displayName = "Icon";
  const IconContainer$1 = styled("div")(
    () => material.css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    width: 160px;
    overflow-wrap: anywhere;
    border-radius: 8px;
    border: 1px solid #9aa0a6;
    padding: 16px 0px;
  `
  );
  const IconSwatch = ({ iconName, ...props }) => /* @__PURE__ */ jsxRuntime.jsxs(IconContainer$1, { ...props, children: [
    /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { name: iconName }),
    /* @__PURE__ */ jsxRuntime.jsx(LabelSmall, { sx: { color: "black" }, children: iconName })
  ] });
  const RootOptions$7 = {
    name: "LinkStandalone",
    slot: "Root"
  };
  const Root$7 = material.styled(
    material.Link,
    RootOptions$7
  )((props) => {
    const {
      size,
      theme: {
        tokens: { link, common: common2 }
      }
    } = props;
    const getLinkStylesByState = (state) => material.css`
    &.MuiLink-root {
      color: ${link[`LinkColor${upper(state)}Text`]};
      text-decoration: ${link[`LinkStandaloneUnderline${upper(state)}`]};
      font-size: ${link[`LinkStandaloneSize${upper(size)}TypographyFontSize`]};
      line-height: ${link[`LinkStandaloneSize${upper(size)}TypographyLineHeight`]};
      font-weight: ${link[`LinkStandaloneSize${upper(size)}TypographyFontWeight`]};
      outline: none;
      cursor: pointer;
      &.Mui-focusVisible {
        outline: ${state === "disabled" ? "none" : `${common2.FocusedDefaultWidth} ${common2.FocusedDefaultColor} ${common2.FocusedDefaultStyle}`};
        outline-offset: ${link.LinkStandaloneFocusedOffset};
      }
    }
  `;
    return material.css`
    display: flex;
    gap: ${link[`LinkStandaloneSize${upper(size)}Gap`]};
    width: fit-content;
    &.disabled {
      ${getLinkStylesByState("disabled")};
      pointer-events: none;
    }
    :not(.disabled) {
      :link {
        ${getLinkStylesByState("default")};
      }
      :visited {
        ${getLinkStylesByState("visited")};
      }
      :hover {
        ${getLinkStylesByState("hover")};
      }
      :active {
        ${getLinkStylesByState("active")};
      }
    }
  `;
  });
  const LinkStandalone = ({
    size = "m",
    disabled = false,
    icon = "NavigateRight",
    iconPosition = "right",
    children,
    className,
    ...muiLinkProps
  }) => {
    const iconSize = size === "m" ? size : "s";
    return /* @__PURE__ */ jsxRuntime.jsxs(Root$7, { ...muiLinkProps, className: clsx(disabled ? "disabled" : void 0, className), size, underline: "none", children: [
      icon && iconPosition === "left" && /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { name: icon, size: iconSize }),
      children,
      icon && iconPosition === "right" && /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { name: icon, size: iconSize })
    ] });
  };
  const CardStyled = styled(material.Card)`
  position: relative;
`;
  const Card = ({ children, className }) => {
    return /* @__PURE__ */ jsxRuntime.jsx(CardStyled, { className, children });
  };
  const RootContainer = styled("div")`
  align-items: baseline;
  padding: 24px 24px 0 24px;
  display: flex;
  justify-content: space-between;
`;
  const StyledHeadlineContainerWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 4px;
`;
  const StyledHeadlineContainer = styled("div")`
  align-items: center;
  display: flex;
  gap: 12px;
`;
  const CardHeader = ({
    cardButton,
    text,
    subText,
    headlineButton,
    className
  }) => {
    const theme2 = material.useTheme();
    return /* @__PURE__ */ jsxRuntime.jsxs(RootContainer, { className, children: [
      /* @__PURE__ */ jsxRuntime.jsxs(StyledHeadlineContainerWrapper, { children: [
        /* @__PURE__ */ jsxRuntime.jsxs(StyledHeadlineContainer, { children: [
          /* @__PURE__ */ jsxRuntime.jsx(Headline, { children: text }),
          headlineButton
        ] }),
        /* @__PURE__ */ jsxRuntime.jsx("div", { children: subText && /* @__PURE__ */ jsxRuntime.jsx(Caption, { color: theme2.textSecondary, children: subText }) })
      ] }),
      cardButton
    ] });
  };
  const CardContentContainer = styled("div")`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  padding: 24px;
`;
  const CardContent = ({ children, className }) => {
    return /* @__PURE__ */ jsxRuntime.jsx(CardContentContainer, { className, children });
  };
  const LayoutItemWrapper = styled("div")`
  width: 320px;
`;
  const CardItem = ({ children, className }) => {
    return /* @__PURE__ */ jsxRuntime.jsx(LayoutItemWrapper, { className, children });
  };
  const variantMappings$2 = {
    filled: {
      color: "secondary",
      variant: "contained"
    },
    text: {
      color: "primary",
      variant: "text"
    },
    outlined: {
      color: "primary",
      variant: "outlined"
    },
    alert: {
      color: "error",
      variant: "contained"
    }
  };
  const IconSpinner = styled(material.CircularProgress, { name: "Button", slot: "IconSpinner" })`
  margin: 2px;
`;
  const Spinner = styled(material.CircularProgress, { name: "Button", slot: "Spinner" })`
  position: absolute;
`;
  const LoadingWrapper = styled("span", { name: "Button", slot: "LoadingWrapper" })`
  visibility: ${({ $hidden }) => $hidden ? "hidden" : "unset"};
`;
  const Button = React.forwardRef(
    ({ variant, isLoading, children, icon, ...props }, ref) => {
      const isBaseButton = isLoading === void 0;
      const variantProps = { ...props, ...variantMappings$2[variant] };
      const iconToUse = isLoading ? /* @__PURE__ */ jsxRuntime.jsx(IconSpinner, { "aria-label": "loading spinner", color: "inherit", size: "20px" }) : icon;
      const hasIcon = ["iconLeft", "iconRight"].includes(variant);
      const isLoadingButtonChildren = /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [
        isLoading && !hasIcon && /* @__PURE__ */ jsxRuntime.jsx(Spinner, { "aria-label": "loading spinner", color: "inherit", size: "16px" }),
        /* @__PURE__ */ jsxRuntime.jsx(LoadingWrapper, { hidden: isLoading && !hasIcon, children })
      ] });
      return /* @__PURE__ */ jsxRuntime.jsx(
        material.Button,
        {
          ...variantProps,
          className: clsx(variantProps.className, { loading: isLoading, disabled: variantProps.disabled }),
          disabled: variantProps.disabled || isLoading,
          endIcon: variant === "iconRight" && iconToUse,
          ref,
          startIcon: variant === "iconLeft" && iconToUse,
          children: isBaseButton ? children : isLoadingButtonChildren
        }
      );
    }
  );
  Button.displayName = "Button";
  const RootOptions$6 = {
    name: "BlitzButtonBase",
    slot: "Root"
  };
  const btn$2 = ({ theme: theme2 }) => {
    return theme2.tokens.button;
  };
  const enterKeyframe = material.keyframes`
    0% {
      transform: scale(0);
      opacity: 0.1;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  `;
  const getStateStyle$1 = (props, state) => {
    const prefix = `ButtonVariant${upper(props.$variant)}${upper(state)}`;
    return material.css`
    /* We need to remove invisible borders from the button to make sure, the ripple effect extends to the edge of the button. 
       * To achieve that and be sure we can handle borders / non border in different states such as hover, we use the css 
       * variables. 
       */
    --has-no-border: ${["#ffffff00", "rgba(100%, 100%, 100%, 0)"].includes(btn$2(props)[`${prefix}BorderColor`]) ? 1 : 0};
    background-color: ${btn$2(props)[`${prefix}BackgroundColor`]};
    border-color: ${btn$2(props)[`${prefix}BorderColor`]};
    color: ${btn$2(props)[`${prefix}Color`]};
  `;
  };
  const getSizeStyle$1 = (props) => {
    const prefix = `ButtonSize${upper(props.$size)}`;
    return material.css`
    --has-border: calc(1 - var(--has-no-border));
    padding: calc(
        ${btn$2(props)[`${prefix}PaddingTopBottom`]} + ${btn$2(props)[`${prefix}BorderWidth`]} * var(--has-no-border)
      )
      calc(${btn$2(props)[`${prefix}PaddingLeftRight`]} + ${btn$2(props)[`${prefix}BorderWidth`]} * var(--has-no-border));
    border: calc(${btn$2(props)[`${prefix}BorderWidth`]} * var(--has-border)) solid;
    border-radius: ${btn$2(props)[`${prefix}BorderRadius`]};
    font-family: ${btn$2(props)[`${prefix}TypographyFontFamily`]};
    font-weight: ${btn$2(props)[`${prefix}TypographyFontWeight`]};
    line-height: ${btn$2(props)[`${prefix}TypographyLineHeight`]};
    font-size: ${btn$2(props)[`${prefix}TypographyFontSize`]};
  `;
  };
  const getGapStyle = (props) => {
    const prefix = `ButtonSize${upper(props.$size)}`;
    return material.css`
    gap: ${btn$2(props)[`${prefix}Gap`]};
  `;
  };
  const Root$6 = styled(material.ButtonBase, RootOptions$6)`
  // sizes
  ${(props) => getSizeStyle$1(props)}

  // base props
    ${(props) => props.$fullWidth && material.css`
      width: 100%;
    `}
    display: inline-flex;

  // types
  ${(props) => getStateStyle$1(props, "default")}

  &:hover {
    ${(props) => getStateStyle$1(props, "hover")}
  }

  &:active {
    ${(props) => getStateStyle$1(props, "active")}
  }

  &.${material.buttonBaseClasses.disabled} {
    ${(props) => getStateStyle$1(props, "disabled")}
  }

  & .${material.touchRippleClasses.root} {
    color: ${(props) => btn$2(props)[`ButtonVariant${upper(props.$variant)}ActiveRipple`]};
  }

  & .${material.touchRippleClasses.child} {
    color: ${(props) => btn$2(props)[`ButtonVariant${upper(props.$variant)}ActiveRipple`]};
    background-color: ${(props) => btn$2(props)[`ButtonVariant${upper(props.$variant)}ActiveRipple`]};
  }

  & .${material.touchRippleClasses.rippleVisible} {
    animation-name: ${enterKeyframe};
    opacity: 1;
  }

  &:focus-visible {
    outline-color: ${(props) => props.theme.tokens.common.FocusedDefaultColor};
    outline-style: ${(props) => props.theme.tokens.common.FocusedDefaultStyle};
    outline-width: ${(props) => props.theme.tokens.common.FocusedDefaultWidth};
    outline-offset: ${(props) => props.theme.tokens.common.FocusedOutlineOffset};
  }
`;
  const Children = styled("div", { name: "BlitzButtonBase", slot: "Children" })(
    (props) => material.css`
    display: flex;
    ${getGapStyle(props)};
    z-index: 1;
    justify-content: center;
  `
  );
  const BlitzButtonBase = React.forwardRef(
    function BlitzButtonBase2(props, ref) {
      const {
        variant,
        className,
        children,
        disabled,
        isLoading = false,
        fullWidth = false,
        size = "m",
        ...otherProps
      } = props;
      const defaultProps = {
        $fullWidth: fullWidth,
        $size: size,
        $variant: variant
      };
      return /* @__PURE__ */ jsxRuntime.jsx(Root$6, { ...defaultProps, className, ...otherProps, disabled: disabled || isLoading, ref, children: /* @__PURE__ */ jsxRuntime.jsx(Children, { ...defaultProps, children }) });
    }
  );
  const IconRootOptions = {
    name: "BlitzButton",
    slot: "IconRoot"
  };
  const btn$1 = ({ theme: theme2 }) => {
    return theme2.tokens.button;
  };
  const getSizeStyle = (props) => {
    const prefix = `ButtonSize${upper(props.$size)}Icon`;
    return material.css`
    padding: ${btn$1(props)[`${prefix}ButtonPadding`]};
    border-radius: ${btn$1(props)[`${prefix}ButtonBorderRadius`]};
  `;
  };
  const getStateStyle = (state) => (props) => material.css`
    color: ${btn$1(props)[`ButtonVariant${upper(props.$variant)}${upper(state)}IconColor`]};
  `;
  const BlitzIconRoot = styled(BlitzButtonBase, IconRootOptions)`
  ${getSizeStyle};
  height: fit-content;

  ${getStateStyle("default")}

  &:hover {
    ${getStateStyle("hover")}
  }

  &:active {
    ${getStateStyle("active")}
  }

  &:disabled {
    ${getStateStyle("disabled")}
  }
`;
  const BlitzIconButton = React.forwardRef(function BlitzIconButton2(props, ref) {
    const { icon, variant } = {
      ...props
    };
    const size = props.size ?? "m";
    const children = getSpinnerOrIcon({ icon, size, isLoading: props.isLoading });
    return /* @__PURE__ */ jsxRuntime.jsx(BlitzIconRoot, { $size: size, $variant: variant, ...props, fullWidth: false, ref, children });
  });
  const btn = ({ theme: theme2 }) => {
    return theme2.tokens.button;
  };
  const LoadingSpinner = styled(material.CircularProgress, { name: "BlitzButton", slot: "Spinner" })(
    (props) => material.css`
    height: ${btn(props)[`ButtonSize${upper(props.size)}IconHeight`]};
    width: ${btn(props)[`ButtonSize${upper(props.size)}IconWidth`]};
    position: ${props.icon !== void 0 ? "relative" : "absolute"};
  `
  );
  const getSpinnerOrIcon = ({
    icon,
    size,
    isLoading
  }) => {
    return isLoading ? /* @__PURE__ */ jsxRuntime.jsx(LoadingSpinner, { "aria-label": "Loading Spinner", color: "inherit", icon, size }) : icon && /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { name: icon, size: size === "s" ? "s" : "m" });
  };
  const BlitzButton = React.forwardRef(
    function BlitzButton2(props, ref) {
      const { children, icon, isLoading = false, iconPosition = "left", size = "m", ...otherProps } = props;
      if (icon !== void 0 && !children) {
        return /* @__PURE__ */ jsxRuntime.jsx(BlitzIconButton, { ...props, icon, ref });
      }
      const renderedIcon = getSpinnerOrIcon({ icon, size, isLoading });
      return /* @__PURE__ */ jsxRuntime.jsx(BlitzButtonBase, { ...otherProps, isLoading, ref, size, children: icon ? /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [
        iconPosition === "left" && renderedIcon,
        children,
        iconPosition === "right" && renderedIcon
      ] }) : /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [
        renderedIcon,
        /* @__PURE__ */ jsxRuntime.jsx("span", { style: { opacity: isLoading ? 0 : 1, display: "inline-flex" }, children })
      ] }) });
    }
  );
  const BlitzButtonCompat = React.forwardRef((props, ref) => {
    const { variant, size: propsSize, icon, children, disabled, ...otherProps } = props;
    const isLoading = "isLoading" in otherProps ? otherProps.isLoading ?? false : false;
    const size = (isMuiSize(propsSize) ? MuiSizeMap[propsSize] : propsSize) ?? "m";
    if ("isLoading" in otherProps) {
      delete otherProps.isLoading;
    }
    return /* @__PURE__ */ jsxRuntime.jsx(
      BlitzButton,
      {
        ...otherProps,
        disabled: disabled || isLoading,
        icon: isIconName(icon) ? icon : void 0,
        iconPosition: getIconPosition(props),
        isLoading,
        ref,
        size,
        variant: isButtonVariant(variant) ? VariantMap[variant] : variant,
        children
      }
    );
  });
  BlitzButtonCompat.displayName = "BlitzButtonCompat";
  function isIconName(icon) {
    return iconNamesList == null ? void 0 : iconNamesList.includes(icon);
  }
  const getIconPosition = (props) => {
    if (props.variant === "iconLeft") {
      return "left";
    }
    if (props.variant === "iconRight") {
      return "right";
    }
    if ("iconPosition" in props) {
      return props.iconPosition;
    }
    return void 0;
  };
  function isButtonVariant(variant) {
    return variant in VariantMap;
  }
  const VariantMap = {
    alert: "alert",
    filled: "primary",
    iconLeft: "tertiary",
    iconRight: "tertiary",
    outlined: "ghost",
    text: "tertiary"
  };
  function isMuiSize(size) {
    if (typeof size === "undefined") {
      return false;
    }
    return size in MuiSizeMap;
  }
  const MuiSizeMap = {
    large: "l",
    medium: "m",
    small: "s"
  };
  const RootOptions$5 = {
    name: "Chip",
    slot: "Root"
  };
  const Root$5 = styled("div", RootOptions$5)`
  padding-left: 4px;
  padding-right: 4px;
  padding-top: ${(props) => props.$size === "small" ? 0 : 4}px;
  padding: ${(props) => props.$size === "small" ? 0 : 4}px 4px;

  background-color: ${(props) => ({
    default: system.alpha(props.theme.palette.shades.grey[700], 0.1),
    error: system.alpha(props.theme.palette.shades.pink[500], 0.08),
    primary: system.alpha(props.theme.palette.shades.purple[500], 0.08),
    success: system.alpha(props.theme.palette.shades.lime[300], 0.08),
    warning: system.alpha(props.theme.palette.shades.orange[400], 0.1)
  })[props.$color ?? "default"]};

  color: ${(props) => ({
    default: props.theme.textPrimary,
    error: props.theme.palette.shades.pink[700],
    primary: props.theme.palette.shades.purple[500],
    success: props.theme.textSuccess,
    warning: props.theme.palette.shades.orange[950]
  })[props.$color ?? "default"]};

  border-radius: 4px;
  width: fit-content;
`;
  const TextOptions = {
    name: "Chip",
    slot: "Text"
  };
  const Text = styled(BodySmall, TextOptions)`
  padding: 2px 6px;
`;
  const IconOptions = {
    name: "Chip",
    slot: "Icon"
  };
  const Icon$1 = styled("div", IconOptions)`
  width: 24px;
  height: 24px;
`;
  const Chip = ({ children, className, icon, size, color }) => {
    return /* @__PURE__ */ jsxRuntime.jsxs(Root$5, { $color: color, $size: size, className, children: [
      icon && /* @__PURE__ */ jsxRuntime.jsx(Icon$1, { children: icon }),
      /* @__PURE__ */ jsxRuntime.jsx(Text, { children })
    ] });
  };
  const RootOptions$4 = {
    name: "Badge",
    slot: "Root"
  };
  const Root$4 = styled(Caption, RootOptions$4)`
  background-color: ${({ theme: theme2, $color }) => ({
    primary: theme2.palette.shades.purple[500],
    success: theme2.colorAccent
  })[$color]};
  color: ${({ theme: theme2, $color }) => ({
    primary: theme2.palette.background.paper,
    success: theme2.textPrimary
  })[$color]};
  padding: 4px 8px;
  font-weight: ${({ theme: theme2 }) => theme2.typography.fontWeightSemiBold};
  text-transform: uppercase;
  width: fit-content;
`;
  const Badge = ({ children, className, color }) => {
    return /* @__PURE__ */ jsxRuntime.jsx(Root$4, { $color: color, className, children });
  };
  const RootOptions$3 = {
    name: "BadgeInfo",
    slot: "Root"
  };
  const getBadgeInfoTokens = (theme2) => {
    return theme2.tokens.badgeInfo;
  };
  const BadgeInfoLabel = styled(Label$1, { name: "BadgeInfo", slot: "Label" })((props) => {
    const badgeTokens = getBadgeInfoTokens(props.theme);
    return material.css`
    max-width: ${badgeTokens.BadgeInfoLabelMaxWidth};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
  });
  const Root$3 = styled(
    "div",
    RootOptions$3
  )((props) => {
    const { $color, $variant, theme: theme2 } = props;
    const badgeTokens = getBadgeInfoTokens(theme2);
    const colorTokenPrefix = `BadgeInfoColor${upper($color)}${upper($variant)}`;
    const padding = `${badgeTokens.BadgeInfoPaddingTopBottom} ${badgeTokens.BadgeInfoPaddingLeftRight}`;
    return material.css`
    background-color: ${badgeTokens[`${colorTokenPrefix}BackgroundColor`]};
    border-radius: ${badgeTokens.BadgeInfoBorderRadius};
    color: ${badgeTokens[`${colorTokenPrefix}TextColor`]};
    display: inline-flex;
    gap: ${badgeTokens.BadgeInfoGap};
    padding: ${padding};
    width: fit-content;
  `;
  });
  const BadgeInfo = React.forwardRef(
    ({ children, color = "info", icon, variant = "soft", ...rest }, ref) => /* @__PURE__ */ jsxRuntime.jsxs(Root$3, { $color: color, $variant: variant, ...rest, ref, children: [
      icon && /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { name: icon, size: "s" }),
      /* @__PURE__ */ jsxRuntime.jsx(BadgeInfoLabel, { children })
    ] })
  );
  BadgeInfo.displayName = "BadgeInfo";
  const terms = {
    general: {
      add: "componentLibrary.general.add",
      cancel: "componentLibrary.general.cancel",
      clear: "componentLibrary.general.clear",
      close: "componentLibrary.general.close",
      delete: "componentLibrary.general.delete",
      edit: "componentLibrary.general.edit",
      save: "componentLibrary.general.save"
    }
  };
  const useTypedTranslation = () => {
    const orig = reactI18next.useTranslation();
    return { ...orig, terms };
  };
  const RootOptions$2 = {
    name: "BadgeInteractive",
    slot: "Root"
  };
  const Root$2 = styled(
    material.Chip,
    RootOptions$2
  )(({ $color, $size, theme: theme2 }) => {
    const {
      tokens: { badgeInteractive, common: common2 }
    } = theme2;
    const badgeColorPrefix = `BadgeInteractiveColor${upper($color)}`;
    const badgeSizePrefix = `BadgeInteractiveSize${upper($size)}`;
    return material.css`
    // Replacing the default MUI deleteIcon with a custom one breaks the automatic
    // resizing of this icon, so we need to set the width explicitly.
    .MuiChip-deleteIcon {
      :hover {
        color: ${badgeInteractive[`${badgeColorPrefix}HoverIconInteractiveColor`]};
      }

      :active {
        color: ${badgeInteractive[`${badgeColorPrefix}ActiveIconInteractiveColor`]};
      }

      color: ${badgeInteractive[`${badgeColorPrefix}DefaultIconInteractiveColor`]};
      margin: 0;
    }

    .MuiChip-label {
      padding: 0;
    }

    && {
      :hover {
        background-color: ${badgeInteractive[`${badgeColorPrefix}HoverBackgroundColor`]};
      }

      :active {
        background-color: ${badgeInteractive[`${badgeColorPrefix}ActiveBackgroundColor`]};
      }

      background-color: ${badgeInteractive[`${badgeColorPrefix}DefaultBackgroundColor`]};
      color: ${badgeInteractive[`${badgeColorPrefix}DefaultTextColor`]};
      box-shadow: none;

      border-color: ${badgeInteractive[`${badgeColorPrefix}DefaultBorderColor`]};
      border-radius: ${badgeInteractive[`${badgeSizePrefix}BorderRadius`]};
      border-width: ${badgeInteractive[`${badgeSizePrefix}BorderWidth`]};

      gap: ${badgeInteractive[`${badgeSizePrefix}Gap`]};
      padding: ${badgeInteractive[`${badgeSizePrefix}PaddingTopBottom`]}
        ${badgeInteractive[`${badgeSizePrefix}PaddingLeftRight`]};
      height: fit-content;

      :focus-visible {
        outline: ${common2.FocusedDefaultWidth} ${common2.FocusedDefaultColor} ${common2.FocusedDefaultStyle};
        outline-offset: ${common2.FocusedOutlineOffset};
      }
    }
  `;
  });
  const BadgeInteractive = React.forwardRef(
    ({ color = "primary", size = "medium", label, ...otherProps }, ref) => {
      const { t, terms: terms2 } = useTypedTranslation();
      const defaultDeleteIcon = size === "small" ? /* @__PURE__ */ jsxRuntime.jsx(
        Icon$2,
        {
          ariaLabel: t(terms2.general.delete),
          "data-testid": "CancelIcon",
          name: "CancelCircleFilled",
          role: "button",
          size: "s"
        }
      ) : /* @__PURE__ */ jsxRuntime.jsx(
        Icon$2,
        {
          ariaLabel: t(terms2.general.delete),
          "data-testid": "CancelIcon",
          name: "CancelCircleFilled",
          role: "button",
          size: "m"
        }
      );
      const labelTypography = size === "small" ? /* @__PURE__ */ jsxRuntime.jsx(LabelSmall, { children: label }) : /* @__PURE__ */ jsxRuntime.jsx(LabelMedium, { children: label });
      return /* @__PURE__ */ jsxRuntime.jsx(
        Root$2,
        {
          $color: color,
          $size: size,
          deleteIcon: defaultDeleteIcon,
          label: labelTypography,
          ref,
          variant: "outlined",
          ...otherProps
        }
      );
    }
  );
  BadgeInteractive.displayName = "BadgeInteractive";
  const getConnectorStatusTokens = (theme2) => {
    return theme2.tokens.connectorStatus;
  };
  const StatusIcon = styled("div", { name: "ConnectorStatus", slot: "StatusIcon" })((props) => {
    const { $variant, theme: theme2 } = props;
    const connectorStatusTokens = getConnectorStatusTokens(theme2);
    const statusIconColor = `ConnectorStatusVariant${upper($variant)}IconColor`;
    return material.css`
    background-color: ${connectorStatusTokens[statusIconColor]};
    border-radius: ${connectorStatusTokens.ConnectorStatusIconBorderRadius};
    height: ${connectorStatusTokens.ConnectorStatusIconSize};
    width: ${connectorStatusTokens.ConnectorStatusIconSize};
  `;
  });
  const StatusLabel = styled(BodySmall, { name: "ConnectorStatus", slot: "StatusLabel" })((props) => {
    const connectorStatusTokens = getConnectorStatusTokens(props.theme);
    return material.css`
    max-width: ${connectorStatusTokens.ConnectorStatusLabelMaxWidth};
    color: ${connectorStatusTokens.ConnectorStatusLabelColor};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
  });
  const Root$1 = styled("div", {
    name: "ConnectorStatus",
    slot: "Root"
  })((props) => {
    const connectorStatusTokens = getConnectorStatusTokens(props.theme);
    return material.css`
    align-items: center;
    display: flex;
    gap: ${connectorStatusTokens.ConnectorStatusGap};
    justify-content: center;
    width: fit-content;
  `;
  });
  function ConnectorStatus({
    variant = "success",
    children,
    ...otherProps
  }) {
    return /* @__PURE__ */ jsxRuntime.jsxs(Root$1, { ...otherProps, "data-testid": "connector-status", children: [
      /* @__PURE__ */ jsxRuntime.jsx(StatusIcon, { $variant: variant, ...otherProps, "data-testid": "status-icon" }),
      /* @__PURE__ */ jsxRuntime.jsx(StatusLabel, { ...otherProps, children })
    ] });
  }
  const RootOptions$1 = {
    name: "BadgeNotify",
    slot: "Root"
  };
  const getBadgeNotifyTokens = (theme2) => {
    return theme2.tokens.badgeNotify;
  };
  const Root = styled(
    material.Badge,
    RootOptions$1
  )((props) => {
    const badgeTokens = getBadgeNotifyTokens(props.theme);
    return material.css`
    .MuiBadge-badge {
      background-color: ${badgeTokens.BadgeNotifyBackgroundColor};
      color: ${badgeTokens.BadgeNotifyTextColor};
      border-radius: ${badgeTokens.BadgeNotifyBorderRadius};
    }
    .MuiBadge-dot {
      min-width: ${badgeTokens.BadgeNotifyVariantDotMinWidth};
      height: ${badgeTokens.BadgeNotifyVariantDotHeight};
    }
    .MuiBadge-standard {
      height: ${badgeTokens.BadgeNotifyVariantStandardHeight};
      min-width: ${badgeTokens.BadgeNotifyVariantStandardMinWidth};
      padding-left: ${badgeTokens.BadgeNotifyVariantStandardPaddingLeftRight};
      padding-right: ${badgeTokens.BadgeNotifyVariantStandardPaddingLeftRight};
  `;
  });
  const BadgeNotify = React.forwardRef((props, ref) => /* @__PURE__ */ jsxRuntime.jsx(Root, { "data-testid": "badge-notify", ref, role: "status", ...props }));
  BadgeNotify.displayName = "BadgeNotify";
  function Checkbox({ color = "primary", ...props }) {
    return /* @__PURE__ */ jsxRuntime.jsx(
      material.Checkbox,
      {
        color,
        ...props,
        checkedIcon: /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { name: "CheckboxChecked" }),
        icon: /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { name: "CheckboxUnchecked" }),
        indeterminateIcon: /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { name: "CheckboxIndeterminate" })
      }
    );
  }
  Checkbox.displayName = "Checkbox";
  function Radio({ color = "primary", ...props }) {
    return /* @__PURE__ */ jsxRuntime.jsx(
      material.Radio,
      {
        color,
        ...props,
        checkedIcon: /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { name: "RadioChecked" }),
        icon: /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { name: "RadioUnchecked" })
      }
    );
  }
  Radio.displayName = "Radio";
  const RootOptions = {
    name: "Accordion",
    slot: "Root"
  };
  const border = 1;
  const disabledForeground = "#9aa0a6";
  const sizes = {
    S: {
      collapsedHeightWithoutBorder: `${44 - 2 * border}px`,
      HeadingComponent: BodySmallHighlight,
      SubheadingComponent: BodySmall
    },
    M: { collapsedHeightWithoutBorder: `${64 - 2 * border}px`, HeadingComponent: Body$1, SubheadingComponent: BodySmall },
    L: { collapsedHeightWithoutBorder: `${76 - 2 * border}px`, HeadingComponent: Headline, SubheadingComponent: Body$1 }
  };
  const StyledHeading = styled(material.Typography, { ...RootOptions, slot: "Heading" })`
  ${(props) => props.$hasSubheading ? "width: 33%;" : ""}
  ${(props) => props.$hasSubheading ? "max-width: 33%;" : ""}
`;
  const StyledSubheading = styled(material.Typography, { ...RootOptions, slot: "Heading" })`
  color: ${({ theme: theme2, disabled }) => disabled ? "inherit" : theme2.textSecondary};
`;
  const chevronStyles = {
    left: {
      expanded: "90deg",
      collapsed: "0deg"
    },
    right: {
      expanded: "270deg",
      collapsed: "90deg"
    }
  };
  const ElliAccordionSummary = styled(material.AccordionSummary)`
  &.Mui-disabled {
    // overrides MUIs opacity-based disabling as opacity may look weird on different backgrounds
    opacity: 1;
  }
  .MuiAccordionSummary-expandIconWrapper {
    transform: ${({ chevron }) => `rotate(${chevronStyles[chevron].collapsed})`};
    color: inherit;
    * {
      color: inherit;
    }
  }
  .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
    transform: ${({ chevron }) => `rotate(${chevronStyles[chevron].expanded})`};
  }
  flex-direction: ${({ chevron }) => chevron === "left" ? "row-reverse" : "row"};
  gap: 8px;
  .MuiAccordionSummary-content {
    gap: inherit;
  }
  height: ${({ size }) => sizes[size].collapsedHeightWithoutBorder};
  min-height: ${({ size }) => sizes[size].collapsedHeightWithoutBorder};
`;
  const ElliAccordion = styled(material.Accordion)`
  &.Mui-disabled {
    background-color: ${({ theme: theme2 }) => theme2.surfaceSecondary};
    color: ${disabledForeground};
    // overrides MUIs opacity-based disabling as opacity may look weird on different backgrounds
    opacity: 1;
  }
  ${({ disabled, theme: theme2 }) => !disabled && `
    &:hover {
      box-shadow: ${theme2.shadows[1]};
    }
  `}
  border: ${border}px solid;
  border-color: ${({ disabled, theme: theme2 }) => disabled ? theme2.surfaceSecondary : theme2.surfaceTertiary};
  box-shadow: ${({ theme: theme2 }) => theme2.shadows[0]};
`;
  const Accordion = ({
    children,
    heading,
    subheading,
    size,
    chevronPosition = "right",
    disabled = false,
    defaultExpanded = false,
    expanded,
    onChange
  }) => {
    return /* @__PURE__ */ jsxRuntime.jsxs(
      ElliAccordion,
      {
        defaultExpanded,
        disabled,
        expanded,
        size,
        disableGutters: true,
        onChange,
        children: [
          /* @__PURE__ */ jsxRuntime.jsxs(
            ElliAccordionSummary,
            {
              chevron: chevronPosition,
              disabled,
              expandIcon: /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { name: "ExpandRight", size: "m" }),
              size,
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(StyledHeading, { $hasSubheading: !!subheading, as: sizes[size].HeadingComponent, children: heading }),
                subheading && /* @__PURE__ */ jsxRuntime.jsx(StyledSubheading, { as: sizes[size].SubheadingComponent, disabled, children: subheading })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntime.jsx(material.AccordionDetails, { children })
        ]
      }
    );
  };
  const variantMappings$1 = (theme2) => ({
    error: {
      hoverBackgroundColor: material.alpha(theme2.colorNegativeTextSoft, 0.06),
      color: theme2.colorNegativeTextSoft
    },
    information: {
      hoverBackgroundColor: material.alpha(theme2.colorPrimary, 0.06),
      color: theme2.colorPrimary
    },
    success: {
      hoverBackgroundColor: material.alpha(theme2.colorAccent, 0.1),
      color: theme2.colorPositiveTextSoft
    },
    warning: {
      hoverBackgroundColor: material.alpha(theme2.colorWarningTextSoft, 0.1),
      color: theme2.colorWarningTextSoft
    }
  });
  const BannerButtonOptions = {
    name: "Banner",
    slot: "Button"
  };
  const BannerButton = styled(
    material.Button,
    BannerButtonOptions
  )`
  color: ${({ theme: theme2, $variant }) => variantMappings$1(theme2)[$variant].color};
  &:hover {
    background-color: ${({ theme: theme2, $variant }) => variantMappings$1(theme2)[$variant].hoverBackgroundColor};
  }
  &:focus {
    background-color: ${({ theme: theme2, $variant }) => variantMappings$1(theme2)[$variant].hoverBackgroundColor};
  }
`;
  const variantMappings = (theme2) => ({
    error: {
      borderColor: theme2.colorNegativeTextSoft,
      background: material.alpha(theme2.colorNegativeTextSoft, 0.03),
      color: theme2.colorNegativeTextSoft
    },
    information: {
      borderColor: theme2.colorPrimary,
      background: material.alpha(theme2.colorPrimary, 0.03),
      color: theme2.colorPrimary
    },
    success: {
      borderColor: "#00992B",
      background: material.alpha(theme2.colorAccent, 0.05),
      color: theme2.colorPositiveTextSoft
    },
    warning: {
      borderColor: theme2.colorWarningTextSoft,
      background: material.alpha(theme2.colorWarningTextSoft, 0.05),
      color: theme2.colorWarningTextSoft
    }
  });
  const BannerRootOptions = {
    name: "Banner",
    slot: "Root"
  };
  const BannerRoot = styled(
    "div",
    BannerRootOptions
  )`
  align-items: start;
  background: ${({ theme: theme2, $variant }) => variantMappings(theme2)[$variant].background};
  border-left: 2px solid ${({ theme: theme2, $variant }) => variantMappings(theme2)[$variant].borderColor};
  color: ${({ theme: theme2, $variant }) => variantMappings(theme2)[$variant].color};
  display: flex;
  gap: 8px;
  padding: 10px 12px;
  width: ${({ $fullWidth }) => $fullWidth ? "unset" : "fit-content"};
`;
  const IconContainer = styled("div", { slot: "Icon" })`
  flex-shrink: 0;
  margin-top: -5px;
`;
  const iconMap = {
    information: "Info",
    warning: "Help",
    error: "Alert",
    success: "Check"
  };
  const StyledBannerContent = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
  text-align: left;
`;
  const Banner = ({ text, variant, icon, fullWidth, action, className, children }) => {
    return /* @__PURE__ */ jsxRuntime.jsxs(BannerRoot, { $fullWidth: fullWidth, $variant: variant, className, children: [
      icon && /* @__PURE__ */ jsxRuntime.jsx(IconContainer, { children: /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { name: iconMap[variant] }) }),
      /* @__PURE__ */ jsxRuntime.jsxs(StyledBannerContent, { children: [
        text && /* @__PURE__ */ jsxRuntime.jsx(Label$1, { children: text }),
        children && /* @__PURE__ */ jsxRuntime.jsx(Label$1, { children }),
        action && // eslint-disable-next-line react/jsx-handler-names
        /* @__PURE__ */ jsxRuntime.jsx(BannerButton, { $variant: variant, variant: "text", onClick: action.onClick, children: /* @__PURE__ */ jsxRuntime.jsx(Label$1, { children: action.text }) })
      ] })
    ] });
  };
  const LabelOptions = { name: "RadioTile", slot: "Root" };
  const Label = styled(
    material.FormControlLabel,
    LabelOptions
  )`
  margin-right: unset;
  flex-direction: ${({ $isVertical }) => $isVertical ? "column-reverse" : "row"};
`;
  const variants = [
    {
      props: { $active: true, $variant: "default" },
      style: ({ theme: theme2 }) => material.css`
      &,
      &:hover {
        background-color: ${theme2.colorPrimary};
        border-color: ${theme2.colorPrimary};
        color: ${theme2.surfacePrimary};
      }
    `
    },
    {
      props: { $active: false, $variant: "light" },
      style: ({ theme: theme2 }) => material.css`
      &,
      &:hover {
        border-color: transparent;
      }
      &:hover .icon {
        color: ${theme2.colorPrimary};
      }
    `
    },
    {
      props: { $active: false, $variant: "default" },
      style: ({ theme: theme2 }) => material.css`
      &:hover .icon {
        color: ${theme2.colorPrimary};
      }
    `
    },
    {
      props: { $active: true, $variant: "light" },
      style: ({ theme: theme2 }) => material.css`
      &,
      &:hover {
        background-color: ${theme2.colorInfoSurfaceSoft};
        border-color: ${theme2.colorPrimary};
        color: ${theme2.colorPrimary};
      }
    `
    },
    {
      props: { disabled: true },
      style: ({ theme: theme2 }) => material.css`
      &,
      &:hover {
        background-color: ${theme2.surfaceSecondary};
        color: ${theme2.textPrimary};
        border-color: transparent;
      }
    `
    }
  ];
  function isUndefinedOrEqual(x, y) {
    return typeof x === "undefined" || x === y;
  }
  const TileOptions = {
    name: "RadioTile",
    slot: "Tile"
  };
  const Tile = styled(material.ButtonBase, TileOptions)`
  &:hover {
    border-color: ${({ theme: theme2 }) => theme2.colorPrimary};
    background-color: ${({ theme: theme2 }) => theme2.colorInfoSurfaceSoft};
    color: ${({ theme: theme2 }) => theme2.colorPrimary};
  }

  background-color: ${({ theme: theme2 }) => theme2.surfacePrimary};
  border: 1px solid;
  border-color: ${({ theme: theme2 }) => theme2.surfaceSecondary};
  border-radius: 4px;

  display: flex;
  flex-grow: 1;
  justify-content: flex-start;
  min-width: 120px;
  padding: 16px;
  position: relative;
  ${({ theme: theme2, $variant, $active, disabled }) => variants.filter(
    ({ props }) => isUndefinedOrEqual(props.$variant, $variant) && isUndefinedOrEqual(props.$active, $active) && isUndefinedOrEqual(props.disabled, disabled)
  ).map(({ style }) => style({ theme: theme2 }))}
`;
  const TileContentOptions = { name: "RadioTile", slot: "TileContent" };
  const TileContent = styled(
    "span",
    TileContentOptions
  )`
  display: flex;
  flex-direction: ${({ $isVertical }) => $isVertical ? "column" : "row"};
  gap: 16px;
  align-items: ${({ $isVertical, $hasBody }) => $hasBody && !$isVertical ? "start" : "center"};

  ${({ $disabled, theme: theme2 }) => $disabled && material.css`
      color: ${theme2.textPrimary};
      opacity: 0.5;
      & > * {
        color: ${theme2.textPrimary};
      }
    `}
`;
  const StyledLabelContent = styled("div")`
  align-items: ${({ $orientation }) => $orientation === "horizontal" ? "start" : "center"};
  display: flex;
  flex-direction: column;
  gap: ${({ $variant }) => $variant === "default" ? "4px" : "0"};
`;
  const LabelComponentBody = ({ $body }) => {
    if (typeof $body === "string") {
      return /* @__PURE__ */ jsxRuntime.jsx(Body$1, { children: $body });
    }
    return $body;
  };
  const LabelComponent = ({ $body, $orientation, $variant, children }) => {
    if ($variant === "light") {
      return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, { children: $body ? /* @__PURE__ */ jsxRuntime.jsxs(StyledLabelContent, { $orientation, $variant, children: [
        /* @__PURE__ */ jsxRuntime.jsx(BodyHighlight, { children }),
        /* @__PURE__ */ jsxRuntime.jsx(LabelComponentBody, { $body })
      ] }) : /* @__PURE__ */ jsxRuntime.jsx(Body$1, { children }) });
    }
    if ($orientation === "horizontal") {
      return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, { children: $body ? /* @__PURE__ */ jsxRuntime.jsxs(StyledLabelContent, { $orientation, $variant, children: [
        /* @__PURE__ */ jsxRuntime.jsx(BodyHighlight, { children }),
        /* @__PURE__ */ jsxRuntime.jsx(LabelComponentBody, { $body })
      ] }) : /* @__PURE__ */ jsxRuntime.jsx(Headline, { children }) });
    }
    return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, { children: $body ? /* @__PURE__ */ jsxRuntime.jsxs(StyledLabelContent, { $orientation, $variant, children: [
      /* @__PURE__ */ jsxRuntime.jsx(Headline, { children }),
      /* @__PURE__ */ jsxRuntime.jsx(LabelComponentBody, { $body })
    ] }) : /* @__PURE__ */ jsxRuntime.jsx(Headline, { children }) });
  };
  const IconWrapper = styled("div", { name: "RadioTile", slot: "IconWrapper" })`
  display: flex;
`;
  const Icon = styled("div", { name: "RadioTile", slot: "Icon" })`
  color: ${({ theme: theme2 }) => theme2.textPrimary};
  ${({ $active, theme: theme2 }) => $active && `color: ${theme2.surfacePrimary};`}
  ${({ $disabled, theme: theme2 }) => $disabled && `color: ${theme2.textPrimary};`}
`;
  const RadioTile = ({
    icon,
    label,
    value,
    className,
    orientation = "horizontal",
    variant = "default",
    disabled = false,
    body
  }) => {
    const radioGroup = material.useRadioGroup();
    const active = value === (radioGroup == null ? void 0 : radioGroup.value);
    const renderedLabel = React.useMemo(
      () => /* @__PURE__ */ jsxRuntime.jsx(Tile, { $active: active, $variant: variant, component: "div", disabled, children: /* @__PURE__ */ jsxRuntime.jsxs(TileContent, { $disabled: disabled, $hasBody: !!body, $isVertical: orientation === "vertical", children: [
        icon && /* @__PURE__ */ jsxRuntime.jsx(IconWrapper, { children: /* @__PURE__ */ jsxRuntime.jsx(Icon, { $active: active, $disabled: disabled, as: icon, className: "icon" }) }),
        /* @__PURE__ */ jsxRuntime.jsx(LabelComponent, { $body: body, $orientation: orientation, $variant: variant, children: label })
      ] }) }),
      [disabled, icon, label, variant, active, orientation, body]
    );
    return /* @__PURE__ */ jsxRuntime.jsx(
      Label,
      {
        $isVertical: orientation === "vertical",
        className,
        control: /* @__PURE__ */ jsxRuntime.jsx(material.Radio, { color: "primary" }),
        disabled,
        label: renderedLabel,
        value,
        disableTypography: true
      }
    );
  };
  var _path$t, _path2$8, _path3$6;
  function _extends$t() {
    return _extends$t = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$t.apply(null, arguments);
  }
  const SvgIc24AlertCircle = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$t || (_path$t = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
  })), _path2$8 || (_path2$8 = /* @__PURE__ */ React__namespace.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 18a.938.938 0 1 1 0-1.876A.938.938 0 0 1 12 18",
    clipRule: "evenodd"
  })), _path3$6 || (_path3$6 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M12 7.5v5.625"
  })));
  var _path$s;
  function _extends$s() {
    return _extends$s = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$s.apply(null, arguments);
  }
  const SvgIcCancel24Px = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    color: "#878c96"
  }, props), _path$s || (_path$s = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m18.75 5.25-13.5 13.5m13.5 0L5.25 5.25"
  })));
  var _path$r;
  function _extends$r() {
    return _extends$r = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$r.apply(null, arguments);
  }
  const SvgIc24Check = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$r || (_path$r = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m5.25 12.75 4.5 4.5 10.5-10.5"
  })));
  var _path$q;
  function _extends$q() {
    return _extends$q = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$q.apply(null, arguments);
  }
  const SvgIcChevronRight24Px = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    color: "#000"
  }, props), _path$q || (_path$q = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M8.25 5.25 15 12l-6.75 6.75"
  })));
  var _path$p;
  function _extends$p() {
    return _extends$p = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$p.apply(null, arguments);
  }
  const SvgIcDropdown24Px = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    color: "currentColor"
  }, props), _path$p || (_path$p = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M6.75 9.75 12 15l5.25-5.25"
  })));
  var _path$o, _path2$7, _path3$5;
  function _extends$o() {
    return _extends$o = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$o.apply(null, arguments);
  }
  const SvgIc24HelpCircle = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$o || (_path$o = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
  })), _path2$7 || (_path2$7 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M12 13.757c0-.956.531-1.784 1.297-2.357a2.17 2.17 0 0 0 .794-2.31 2.14 2.14 0 0 0-1.514-1.515 2.17 2.17 0 0 0-2.743 2.091"
  })), _path3$5 || (_path3$5 = /* @__PURE__ */ React__namespace.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 18a.938.938 0 1 1 0-1.876A.938.938 0 0 1 12 18",
    clipRule: "evenodd"
  })));
  var _path$n, _path2$6, _path3$4;
  function _extends$n() {
    return _extends$n = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$n.apply(null, arguments);
  }
  const SvgIc24InfoCircle = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$n || (_path$n = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
  })), _path2$6 || (_path2$6 = /* @__PURE__ */ React__namespace.createElement("path", {
    fill: "currentColor",
    d: "M12 8.55a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8"
  })), _path3$4 || (_path3$4 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M10.5 12H12v4.5"
  })));
  var _path$m, _path2$5;
  function _extends$m() {
    return _extends$m = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$m.apply(null, arguments);
  }
  const SvgIcWorld24Px = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$m || (_path$m = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 21a9 9 0 1 0-.001-18.001A9 9 0 0 0 12 21"
  })), _path2$5 || (_path2$5 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 21c2.071 0 3.75-4.03 3.75-9S14.071 3 12 3s-3.75 4.03-3.75 9 1.679 9 3.75 9M4 9h16M4 15.75h16"
  })));
  var _path$l;
  function _extends$l() {
    return _extends$l = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$l.apply(null, arguments);
  }
  const SvgIcCheckboxUnchecked24Px = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$l || (_path$l = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M19.364 21H4.636C3.736 21 3 20.264 3 19.364V4.636C3 3.736 3.736 3 4.636 3h14.728c.9 0 1.636.736 1.636 1.636v14.728c0 .9-.736 1.636-1.636 1.636Z"
  })));
  var _path$k;
  function _extends$k() {
    return _extends$k = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$k.apply(null, arguments);
  }
  const SvgIcCheckboxChecked24Px = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$k || (_path$k = /* @__PURE__ */ React__namespace.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.636 21h14.728c.9 0 1.636-.736 1.636-1.636V4.636C21 3.736 20.264 3 19.364 3H4.636C3.736 3 3 3.736 3 4.636v14.728c0 .9.736 1.636 1.636 1.636M18.672 9.74a1 1 0 1 0-1.344-1.48l-7.042 6.39-3.614-3.28a1 1 0 1 0-1.344 1.482l4.286 3.889.672.61.672-.61z",
    clipRule: "evenodd"
  })));
  var _path$j;
  function _extends$j() {
    return _extends$j = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$j.apply(null, arguments);
  }
  const SvgIcCheckboxIndeterminate24Px = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$j || (_path$j = /* @__PURE__ */ React__namespace.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.636 21h14.728c.9 0 1.636-.736 1.636-1.636V4.636C21 3.736 20.264 3 19.364 3H4.636C3.736 3 3 3.736 3 4.636v14.728c0 .9.736 1.636 1.636 1.636M7 11a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })));
  var _path$i;
  function _extends$i() {
    return _extends$i = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$i.apply(null, arguments);
  }
  const SvgIcRadiobuttonUnchecked24Px = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$i || (_path$i = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
  })));
  var _path$h;
  function _extends$h() {
    return _extends$h = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$h.apply(null, arguments);
  }
  const SvgIcRadiobuttonChecked24Px = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$h || (_path$h = /* @__PURE__ */ React__namespace.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m5.25 10a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0",
    clipRule: "evenodd"
  })));
  var _path$g;
  function _extends$g() {
    return _extends$g = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$g.apply(null, arguments);
  }
  const SvgIc24OpenInNew = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    "aria-label": "open in new"
  }, props), _path$g || (_path$g = /* @__PURE__ */ React__namespace.createElement("path", {
    d: "M21 13.379a.75.75 0 0 0-1.5 0zM10.95 5.2a.75.75 0 0 0 0-1.5zm3.675-1.5a.75.75 0 0 0 0 1.5zm5.625.75H21V3.7h-.75zm-.75 5.4a.75.75 0 0 0 1.5 0zM9.23 13.99a.75.75 0 1 0 1.04 1.082zm10.27-.611v5.472H21v-5.472zm0 5.472c0 .349-.31.69-.75.69v1.5c1.21 0 2.25-.956 2.25-2.19zm-.75.69H5.25v1.5h13.5zm-13.5 0c-.44 0-.75-.341-.75-.69H3c0 1.234 1.04 2.19 2.25 2.19zm-.75-.69V5.89H3v12.96zm0-12.96c0-.35.31-.69.75-.69V3.7C4.04 3.7 3 4.656 3 5.89zm.75-.69h5.7V3.7h-5.7zm9.375 0h5.625V3.7h-5.625zm4.875-.75v5.4H21v-5.4zm.23-.541L9.23 13.99l1.04 1.082 10.5-10.08z"
  })));
  var _path$f;
  function _extends$f() {
    return _extends$f = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$f.apply(null, arguments);
  }
  const SvgIc24OpenInFull = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "open in full"
  }, props), _path$f || (_path$f = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M14.625 4.45h5.625m0 0v5.4m0-5.4L3.75 20.29m5.625 0H3.75m0 0v-5.4"
  })));
  var _path$e;
  function _extends$e() {
    return _extends$e = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$e.apply(null, arguments);
  }
  const SvgIc24Download = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "download"
  }, props), _path$e || (_path$e = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M6.75 19.5h10.5M12 15V4.5M8.25 12 12 15.75 15.75 12"
  })));
  var _path$d;
  function _extends$d() {
    return _extends$d = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$d.apply(null, arguments);
  }
  const SvgIc24ArrowRight = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$d || (_path$d = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M5 12.5h13.5m0 0L11.75 19m6.75-6.5L11.75 6"
  })));
  var _path$c, _path2$4, _path3$3, _path4$1;
  function _extends$c() {
    return _extends$c = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$c.apply(null, arguments);
  }
  const SvgIcStationbig40Px = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path$c || (_path$c = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m15 12.125-1.5 4.5h3l-1.5 4.5"
  })), _path2$4 || (_path2$4 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M23.75 13.75h2.5c1.375 0 2.5 1.125 2.5 2.5v7.5c0 1.375 1.125 2.5 2.5 2.5s2.5-1.125 2.5-2.5V10m-2.5-3.375V10h5V6.625"
  })), _path3$3 || (_path3$3 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M23.75 33.75H6.25v-25c0-1.375 1.125-2.5 2.5-2.5h12.5c1.375 0 2.5 1.125 2.5 2.5z",
    clipRule: "evenodd"
  })), _path4$1 || (_path4$1 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M3.75 33.75H35"
  })));
  var _rect, _path$b, _defs;
  function _extends$b() {
    return _extends$b = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$b.apply(null, arguments);
  }
  const SvgCardLogpayMsp36Px = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 36,
    fill: "none"
  }, props), _rect || (_rect = /* @__PURE__ */ React__namespace.createElement("rect", {
    width: 60,
    height: 36,
    fill: "url(#card_logpay_msp_36px_svg__a)",
    rx: 4
  })), _path$b || (_path$b = /* @__PURE__ */ React__namespace.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M38.895 11.599c.201-.604.366-1.408.424-2.012C39.406 8.725 38.816 8 37.802 8c-1.12 0-1.617.725-1.905 1.587a10 10 0 0 0-.424 2.012c-.087.862.437 1.587 1.516 1.587 1.121 0 1.619-.725 1.906-1.587m-.589-2.012a10 10 0 0 1-.424 2.012c-.108.315-.353.573-.82.573-.439 0-.61-.257-.575-.573.059-.604.223-1.408.425-2.012a.824.824 0 0 1 .819-.575c.439 0 .61.258.575.575m3.7 1.645c.043 0 .058.029.05.072l-.065.296c-.074.315-.338.574-.85.574-.437 0-.61-.26-.574-.575.058-.604.222-1.408.424-2.012a.83.83 0 0 1 .82-.575c.504 0 .612.258.576.575-.015.1.036.18.172.18h.583c.143 0 .245-.072.265-.216.137-.84-.524-1.551-1.524-1.551-1.1 0-1.617.725-1.905 1.587a10 10 0 0 0-.425 2.012c-.086.862.438 1.587 1.517 1.587 1.042 0 1.711-.676 1.898-1.552l.266-1.228c.015-.08-.036-.144-.115-.144h-1.402a.18.18 0 0 0-.172.144l-.143.683c-.015.08.036.143.115.143zm7.56 1.027c0-.058-.02-.107-.087-.107h-1.128c-.064 0-.1.043-.13.107l-.358.74a.18.18 0 0 1-.159.107h-.79c-.116 0-.144-.079-.116-.143l2.3-4.776a.18.18 0 0 1 .159-.108h.964c.064 0 .115.044.115.108l.258 4.776c0 .064-.056.143-.173.143h-.711c-.065 0-.115-.043-.115-.107zm-.02-1.193V9.343q.002-.029-.03-.028h-.014a.04.04 0 0 0-.043.028l-.727 1.723c-.02.057 0 .08.044.08h.697c.042 0 .07-.023.072-.08M54 8.08c-.065 0-.115.029-.159.108l-1.149 1.989c-.015.02-.022.028-.043.028h-.015c-.021 0-.026-.007-.029-.028l-.309-1.99c-.015-.078-.05-.107-.115-.107h-.72a.168.168 0 0 0-.159.2l.59 3.204-.316 1.48c-.015.08.036.143.115.143h.719a.18.18 0 0 0 .172-.143l.316-1.48 1.957-3.204c.064-.106.022-.2-.072-.2zm-7.653 0H44.38a.186.186 0 0 0-.19.16l-.146.69c-.02.087.047.157.156.156h.282l-.83 3.878c-.014.08.036.143.116.143h.718a.18.18 0 0 0 .172-.143l.33-1.593c.008-.043.051-.072.093-.072h.647c.972 0 1.913-.783 1.913-1.947.002-.668-.566-1.272-1.293-1.272m-.409 2.213h-.647c-.043 0-.057-.028-.05-.071l.23-1.064a.086.086 0 0 1 .086-.072h.647c.287 0 .402.238.402.474.002.315-.33.733-.668.733m-12.276 1.809h1.403c.08 0 .128.064.115.145l-.158.718a.18.18 0 0 1-.172.144h-2.34c-.078 0-.122-.064-.107-.144l.824-3.88h-.28c-.109.002-.175-.07-.155-.154l.146-.69a.186.186 0 0 1 .19-.16h1.175c.079 0 .13.063.115.143l-.813 3.806c-.008.043.013.072.057.072m-3.624.96c-2.315-.288-3.757-.733-3.757-1.527 0-.52 1.101-.873 3.742-.873.968 0 1.814.048 2.074.065a.09.09 0 0 0 .096-.072l.185-.868c.009-.063-.029-.1-.1-.105a26 26 0 0 0-1.89-.066c-3.15 0-5.135.553-5.135 1.73 0 1.038 1.603 1.752 4.771 1.752.064 0 .055-.031.014-.037M25.76 9.858c-.435.253-.668.47-.755.76q-.003.006-.001 0c-.031-.36.093-.682.293-.948.553-.731 2.168-1.614 6.06-1.614.322 0 .572.011.711.018l.031.001c.059.003.078.042.07.1l-.173.825c-.016.072-.044.09-.103.087-.31-.018-.63-.036-1.025-.036-2.883 0-4.117.23-5.108.807",
    clipRule: "evenodd"
  })), _defs || (_defs = /* @__PURE__ */ React__namespace.createElement("defs", null, /* @__PURE__ */ React__namespace.createElement("linearGradient", {
    id: "card_logpay_msp_36px_svg__a",
    x1: 36,
    x2: 20.014,
    y1: 7,
    y2: 44.526,
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React__namespace.createElement("stop", {
    stopColor: "#007392"
  }), /* @__PURE__ */ React__namespace.createElement("stop", {
    offset: 1,
    stopColor: "#003B58"
  })))));
  var _path$a;
  function _extends$a() {
    return _extends$a = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$a.apply(null, arguments);
  }
  const SvgIc24CancelCircleFilled = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$a || (_path$a = /* @__PURE__ */ React__namespace.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M7.72 7.72a.75.75 0 0 1 1.06 0L12 10.94l3.22-3.22a.75.75 0 1 1 1.06 1.06L13.06 12l3.22 3.22a.75.75 0 1 1-1.06 1.06L12 13.06l-3.22 3.22a.75.75 0 0 1-1.06-1.06L10.94 12 7.72 8.78a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  })));
  var _path$9;
  function _extends$9() {
    return _extends$9 = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$9.apply(null, arguments);
  }
  const SvgIcFavorite16Px = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path$9 || (_path$9 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m12 19.5-1.2-1.05c-4.275-3.825-7.05-6.3-7.05-9.375 0-1.5.75-2.925 2.025-3.75 2.175-1.425 4.8-.75 6.225.9 1.425-1.65 4.05-2.325 6.225-.9a4.47 4.47 0 0 1 2.025 3.75c0 3.075-2.775 5.625-7.05 9.45z"
  })));
  var _path$8, _path2$3, _path3$2;
  function _extends$8() {
    return _extends$8 = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$8.apply(null, arguments);
  }
  const SvgIcAlertCircle16 = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8 || (_path$8 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Z"
  })), _path2$3 || (_path2$3 = /* @__PURE__ */ React__namespace.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 12a.625.625 0 1 1 0-1.25A.625.625 0 0 1 8 12",
    clipRule: "evenodd"
  })), _path3$2 || (_path3$2 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M8 5v3.75"
  })));
  var _path$7, _path2$2;
  function _extends$7() {
    return _extends$7 = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$7.apply(null, arguments);
  }
  const SvgIcCheckCircle16 = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7 || (_path$7 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12"
  })), _path2$2 || (_path2$2 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m5.25 8 2 2 3.5-3.5"
  })));
  var _path$6, _path2$1, _path3$1;
  function _extends$6() {
    return _extends$6 = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$6.apply(null, arguments);
  }
  const SvgIcInfoCircle16 = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6 || (_path$6 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Z"
  })), _path2$1 || (_path2$1 = /* @__PURE__ */ React__namespace.createElement("path", {
    fill: "currentColor",
    d: "M8 5.7a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2"
  })), _path3$1 || (_path3$1 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M7 8h1v3"
  })));
  var _path$5;
  function _extends$5() {
    return _extends$5 = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$5.apply(null, arguments);
  }
  const SvgIc16CancelCircleFilled = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5 || (_path$5 = /* @__PURE__ */ React__namespace.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0m4.354-2.854a.5.5 0 1 0-.708.708L7.293 8l-2.147 2.146a.5.5 0 0 0 .708.708L8 8.707l2.146 2.147a.5.5 0 0 0 .708-.708L8.707 8l2.147-2.146a.5.5 0 0 0-.708-.708L8 7.293z",
    clipRule: "evenodd"
  })));
  var _path$4;
  function _extends$4() {
    return _extends$4 = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$4.apply(null, arguments);
  }
  const SvgIc16OpenInNew = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    "aria-label": "open in new tab"
  }, props), _path$4 || (_path$4 = /* @__PURE__ */ React__namespace.createElement("path", {
    d: "M14 8.919a.5.5 0 0 0-1 0zM7.3 3.467a.5.5 0 0 0 0-1zm2.45-1a.5.5 0 0 0 0 1zm3.75.5h.5v-.5h-.5zm-.5 3.6a.5.5 0 0 0 1 0zm-6.846 2.76a.5.5 0 0 0 .692.72zM13 8.918v3.648h1V8.919zm0 3.648c0 .233-.207.46-.5.46v1c.807 0 1.5-.637 1.5-1.46zm-.5.46h-9v1h9zm-9 0c-.293 0-.5-.227-.5-.46H2c0 .823.693 1.46 1.5 1.46zm-.5-.46v-8.64H2v8.64zm0-8.64c0-.233.207-.46.5-.46v-1c-.807 0-1.5.637-1.5 1.46zm.5-.46h3.8v-1H3.5zm6.25 0h3.75v-1H9.75zm3.25-.5v3.6h1v-3.6zm.154-.36-7 6.72.692.72 7-6.72z"
  })));
  var _path$3;
  function _extends$3() {
    return _extends$3 = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$3.apply(null, arguments);
  }
  const SvgIc16OpenInFull = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    "aria-label": "open in full"
  }, props), _path$3 || (_path$3 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M9.75 2.967h3.75m0 0v3.6m0-3.6-11 10.56m3.75 0H2.5m0 0v-3.6"
  })));
  var _path$2;
  function _extends$2() {
    return _extends$2 = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$2.apply(null, arguments);
  }
  const SvgIc16Download = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    "aria-label": "download"
  }, props), _path$2 || (_path$2 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M4.5 13h7M8 10V3M5.5 8 8 10.5 10.5 8"
  })));
  var _path$1;
  function _extends$1() {
    return _extends$1 = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends$1.apply(null, arguments);
  }
  const SvgIc16ArrowRight = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$1 || (_path$1 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M3.333 8.333h9m0 0-4.5 4.334m4.5-4.334L7.833 4"
  })));
  var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
  function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
      }
      return n;
    }, _extends.apply(null, arguments);
  }
  const SvgIcCardOrder96Px = (props) => /* @__PURE__ */ React__namespace.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 97,
    fill: "none"
  }, props), _path || (_path = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "#0F9",
    strokeWidth: 2,
    d: "M95 48.5c0 25.957-21.043 47-47 47S1 74.457 1 48.5s21.043-47 47-47 47 21.043 47 47Z"
  })), _path2 || (_path2 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "#63C",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M27.939 46.707h-4.972M24.956 50.671H17"
  })), _path3 || (_path3 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "#63C",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M72.192 44.032 51.11 64.942c-1.194 1.189-3.083 1.189-4.177 0L33.41 51.562c-1.194-1.19-1.194-3.072 0-4.162L54.49 26.39c1.193-1.188 3.083-1.188 4.176 0l13.426 13.38a3.077 3.077 0 0 1 .099 4.26Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /* @__PURE__ */ React__namespace.createElement("path", {
    fill: "#63C",
    d: "M49.022 57.509c-.697 0-1.194.595-1.194 1.19 0 .693.597 1.188 1.194 1.188.596 0 1.193-.594 1.193-1.189 0-.594-.497-1.189-1.194-1.189"
  })), _path5 || (_path5 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "#63C",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M41.463 51.266c.994-.991 2.088-1.784 3.381-2.28a11.6 11.6 0 0 1 4.177-.792c1.491 0 2.883.297 4.176.793 1.293.495 2.486 1.288 3.381 2.279M45.242 55.031a6.5 6.5 0 0 1 1.69-1.189c.597-.297 1.393-.396 2.09-.396.695 0 1.49.198 2.087.396s1.194.694 1.69 1.19"
  })), _path6 || (_path6 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "#63C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M57.773 58.6c3.082 3.071 3.082 7.828 0 10.9h5.966M39.872 58.4c-3.083 2.181-7.16 1.983-9.944-.891v5.946"
  })), _path7 || (_path7 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "#63C",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M27.939 46.707h-4.972M24.956 50.671H17"
  })), _path8 || (_path8 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "#63C",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M72.192 44.032 51.11 64.942c-1.194 1.189-3.083 1.189-4.177 0L33.41 51.562c-1.194-1.19-1.194-3.072 0-4.162L54.49 26.39c1.193-1.188 3.083-1.188 4.176 0l13.426 13.38a3.077 3.077 0 0 1 .099 4.26Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /* @__PURE__ */ React__namespace.createElement("path", {
    fill: "#63C",
    d: "M49.022 57.509c-.697 0-1.194.595-1.194 1.19 0 .693.597 1.188 1.194 1.188.596 0 1.193-.594 1.193-1.189 0-.594-.497-1.189-1.194-1.189"
  })), _path10 || (_path10 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "#63C",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M41.463 51.266c.994-.991 2.088-1.784 3.381-2.28a11.6 11.6 0 0 1 4.177-.792c1.491 0 2.883.297 4.176.793 1.293.495 2.486 1.288 3.381 2.279M45.242 55.031a6.5 6.5 0 0 1 1.69-1.189c.597-.297 1.393-.396 2.09-.396.695 0 1.49.198 2.087.396s1.194.694 1.69 1.19"
  })), _path11 || (_path11 = /* @__PURE__ */ React__namespace.createElement("path", {
    stroke: "#63C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M57.773 58.6c3.082 3.071 3.082 7.828 0 10.9h5.966M39.872 58.4c-3.083 2.181-7.16 1.983-9.944-.891v5.946"
  })));
  const getEffectSize = (props) => {
    const effectPadding = 12;
    return `${props.$effectSize ?? props.$iconSize + 2 * effectPadding}px`;
  };
  const StyledIconButtonOptions = {
    name: "IconButton",
    slot: "Root"
  };
  const StyledIconButton = styled(material.IconButton, StyledIconButtonOptions)`
  & .MuiTouchRipple-root {
    bottom: auto;
    height: ${getEffectSize};
    left: auto;
    right: auto;
    top: auto;
    width: ${getEffectSize};
  }

  background: none !important; // Removing the standard hover effect
  padding: 0 12px;
`;
  const HoverEffectOptions = {
    name: "IconButton",
    slot: "HoverEffect"
  };
  const HoverEffect = styled("span", HoverEffectOptions)`
  &:hover {
    background: rgba(0, 0, 0, 0.08);
  }
  border-radius: 50%;
  height: ${getEffectSize};
  position: absolute;
  width: ${getEffectSize};
`;
  const IconButton = React.forwardRef(
    ({ className, iconSize = 24, effectSize, children, ...rest }, ref) => {
      return /* @__PURE__ */ jsxRuntime.jsxs(
        StyledIconButton,
        {
          $effectSize: effectSize,
          $iconSize: iconSize,
          className,
          ref,
          ...rest,
          size: "large",
          children: [
            children,
            /* @__PURE__ */ jsxRuntime.jsx(HoverEffect, { $effectSize: effectSize, $iconSize: iconSize })
          ]
        }
      );
    }
  );
  const CloseIcon = styled("div")`
  position: absolute;
  right: 5px;
  top: 17px;
`;
  const CloseButton = ({ onClose, ariaLabel }) => {
    return /* @__PURE__ */ jsxRuntime.jsx(CloseIcon, { children: /* @__PURE__ */ jsxRuntime.jsx(IconButton, { "aria-label": ariaLabel, onClick: onClose, children: /* @__PURE__ */ jsxRuntime.jsx(SvgIcCancel24Px, {}) }) });
  };
  const StyledDialogOptions = {
    name: "Dialog",
    slot: "Root"
  };
  const StyledDialog = styled(material.Dialog, StyledDialogOptions)`
  & .MuiDialog-paper {
    &:not(.dialog-XL) {
      max-height: min(800px, calc(100% - 64px));
    }

    box-sizing: border-box;
    max-width: ${(props) => props.$maxWidth};
    padding: 56px 0 40px; // 16px added to bottom padding via footer margin (or body padding if no footer)
    text-align: center;
  }

  ${(props) => props.$dynamicHeight ? material.css`
          && .MuiDialog-paper {
            height: auto;
            max-height: 100%;
          }

          & .MuiDialog-container {
            align-items: flex-start;
          }
        ` : void 0}
`;
  const Dialog = ({
    open,
    size = "M",
    onClose,
    closeButtonAriaLabel = "close",
    children,
    title
  }) => {
    const { maxWidth, fullScreen } = useGetSizeBasedProps(size);
    return /* @__PURE__ */ jsxRuntime.jsxs(
      StyledDialog,
      {
        $dynamicHeight: fullScreen && size !== "XL",
        $maxWidth: fullScreen ? "unset" : maxWidth,
        PaperProps: {
          title
        },
        classes: {
          paper: `dialog-${size}`
        },
        fullScreen,
        fullWidth: true,
        open,
        onClose,
        children: [
          onClose ? /* @__PURE__ */ jsxRuntime.jsx(CloseButton, { ariaLabel: closeButtonAriaLabel, onClose }) : null,
          children
        ]
      }
    );
  };
  const useGetSizeBasedProps = (size) => {
    const sizeToProps = {
      S: { maxWidth: "444px", fullScreenBelow: "sm" },
      M: { maxWidth: "600px", fullScreenBelow: "md" },
      L: { maxWidth: "960px", fullScreenBelow: "md" },
      XL: { maxWidth: void 0, fullScreenBelow: 1e6 }
    };
    const theme2 = material.useTheme();
    const mInsteadOfL = material.useMediaQuery(theme2.breakpoints.down("lg")) && size === "L";
    const { maxWidth, fullScreenBelow } = sizeToProps[mInsteadOfL ? "M" : size] ?? sizeToProps["M"];
    const fullScreen = material.useMediaQuery(theme2.breakpoints.down(fullScreenBelow));
    return React.useMemo(() => ({ maxWidth, fullScreen }), [maxWidth, fullScreen]);
  };
  const refCallbackPairs = [];
  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      const pair = refCallbackPairs.find((somePair) => somePair.ref.current === entry.target);
      if (!pair) {
        return;
      }
      pair.callback(entry);
    });
  });
  function useResizeObserver(ref, callback) {
    React.useEffect(() => {
      const current = ref.current;
      if (!current) {
        return void 0;
      }
      const addedPair = { ref, callback };
      refCallbackPairs.push(addedPair);
      resizeObserver.observe(current);
      return () => {
        const foundIndex = refCallbackPairs.findIndex((pair) => addedPair === pair);
        refCallbackPairs.splice(foundIndex, 1);
        resizeObserver.unobserve(current);
      };
    }, [callback, ref]);
  }
  const BodyOptions = {
    name: "DialogBody",
    slot: "Root"
  };
  const Body = styled("div", BodyOptions)`
  .dialog-XL & {
    flex-grow: 1;
  }
  box-sizing: border-box;
  margin-bottom: 0; // margin to footer defined as marginTop on the footer as the footer is optional
  margin-right: 56px;
  margin-top: 8px; // 24px whitespace including the padding
  min-height: 4em;
  overflow-y: auto;
  padding: 16px 0; // padding necessary for the mask / scroll-fade effect
  // we use padding on the left and margin on the right so that elements with a negative margin (notably the ripple-effect
  // of the radio button) are display correctly and so that the scrollbar on the right sits close to the content
  padding-left: 56px;

  ${(props) => props.$isMasked ? material.css`
          mask-image: linear-gradient(transparent 0, white 25px, white calc(100% - 25px), transparent 100%);
        ` : void 0}
`;
  const DialogBody = ({ children }) => {
    const ref = React.useRef(null);
    const [isMasked, setIsMasked] = React.useState(false);
    const handleResize = React.useCallback((entry) => {
      if (entry.target.scrollHeight > entry.target.clientHeight) {
        setIsMasked(true);
      } else {
        setIsMasked(false);
      }
    }, []);
    useResizeObserver(ref, handleResize);
    return /* @__PURE__ */ jsxRuntime.jsx(Body, { $isMasked: isMasked, ref, children });
  };
  const FooterOptions = {
    name: "Footer",
    slot: "Root"
  };
  const Footer = styled("div", FooterOptions)`
  ${({ theme: theme2, $autoLayout }) => $autoLayout && material.css`
      & button {
        &:only-child {
          margin: auto;
        }
        min-width: 170px;
      }
      align-items: center;
      display: flex;
      flex-direction: row;
      gap: 24px;
      justify-content: center;

      ${theme2.breakpoints.down("sm")},
      .dialog-S & {
        & button {
          width: 100%;
          order: -1; // show below any non-button component
        }
        flex-direction: column-reverse;
      }
    `}

  ${({ theme: theme2, $withProgressBar }) => $withProgressBar && material.css`
      ${theme2.breakpoints.between("sm", "md")},
      ${theme2.breakpoints.between("md", "lg")}.dialog-L & {
        & button {
          order: -1;
        }
        & > :not(button) {
          margin: 0 80px; // make sure the progressbar causes wrapping when used with two 170px buttons
        }
        justify-content: center;
        flex-wrap: wrap-reverse;
      }
      justify-content: space-between;
    `}

  margin-top: 40px; // 56px whitespace including DialogBody's padding
  margin-bottom: 16px;
  padding: 0 56px;
`;
  const DialogFooter = ({ autoLayout = true, children }) => {
    const numberOfChildren = React.Children.toArray(children).filter(Boolean).length;
    if (autoLayout && process.env.NODE_ENV === "development" && (numberOfChildren < 1 || numberOfChildren > 3)) {
      console.warn(
        "DialogFooter with autoLayout=true expects 1-3 children (1 button, 2 buttons or 2 buttons + progress bar) for the auto-layouting to work properly."
      );
    }
    return /* @__PURE__ */ jsxRuntime.jsx(
      Footer,
      {
        $autoLayout: autoLayout,
        $withProgressBar: autoLayout && numberOfChildren === 3,
        className: clsx({ withProgressBar: autoLayout && numberOfChildren === 3 }),
        children
      }
    );
  };
  const HeaderOptions = {
    name: "DialogHeader",
    slot: "Root"
  };
  const Header = styled("div", HeaderOptions)`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 56px;
`;
  const DialogHeader = ({ children, icon }) => {
    return /* @__PURE__ */ jsxRuntime.jsxs(Header, { children: [
      icon,
      /* @__PURE__ */ jsxRuntime.jsx(Title1, { children })
    ] });
  };
  const ButtonText = material.styled(BodyHighlight, { name: "LanguageDropdown", slot: "ButtonText" })`
  margin-right: 8px;
`;
  const LanguageButton = material.styled(material.Button, { name: "LanguageDropdown", slot: "Button" })`
  align-items: center;
  color: ${({ theme: theme2 }) => theme2.colorPrimary};
  display: flex;
  padding-right: 14px;
`;
  const Container$1 = material.styled("div", { name: "LanguageDropdown", slot: "Root" })`
  display: inline-block;
`;
  const StyledMenu = material.styled(material.Menu, { name: "LanguageDropdown", slot: "Menu" })`
  margin-top: 7px;
`;
  const StyledMenuItemOptions = { name: "LanguageDropdown", slot: "MenuItem" };
  const StyledMenuItem = material.styled(material.MenuItem, StyledMenuItemOptions)`
  &&&:hover {
    background-color: ${({ theme: theme2 }) => theme2.surfaceLightPurplePink};
    color: ${({ theme: theme2 }) => theme2.palette.primary.contrastText};
  }

  &.Mui-selected {
    background-color: ${({ theme: theme2 }) => theme2.colorPrimary};
    color: ${({ theme: theme2 }) => theme2.palette.primary.contrastText};
  }

  color: ${({ theme: theme2 }) => theme2.colorPrimary};
  height: 48px;
  justify-content: flex-end;
  padding-left: 24px;
  padding-right: 24px;
`;
  const LanguageDropdown = ({
    selectedLanguageCode,
    allLanguages,
    onSelectLanguage,
    className,
    menuClassName
  }) => {
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);
    const menuAnchorRef = React.useRef(null);
    const handleSelectLanguage = (language) => {
      onSelectLanguage(language);
    };
    const handleOpen = () => {
      setIsMenuOpen(true);
    };
    const handleClose = () => {
      setIsMenuOpen(false);
    };
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [
      /* @__PURE__ */ jsxRuntime.jsx(Container$1, { className, ref: menuAnchorRef, children: /* @__PURE__ */ jsxRuntime.jsxs(LanguageButton, { onClick: handleOpen, children: [
        /* @__PURE__ */ jsxRuntime.jsx(ButtonText, { children: selectedLanguageCode.toUpperCase() }),
        /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { name: "Language" })
      ] }) }),
      /* @__PURE__ */ jsxRuntime.jsx(
        StyledMenu,
        {
          anchorEl: menuAnchorRef.current,
          anchorOrigin: { vertical: "bottom", horizontal: "center" },
          className: menuClassName,
          marginThreshold: 0,
          open: isMenuOpen,
          transformOrigin: { vertical: "top", horizontal: "center" },
          keepMounted: true,
          onClose: handleClose,
          children: allLanguages.map((language) => /* @__PURE__ */ jsxRuntime.jsx(
            StyledMenuItem,
            {
              selected: language.code === selectedLanguageCode,
              onClick: () => handleSelectLanguage(language),
              onMouseUp: handleClose,
              children: language.label
            },
            language.code
          ))
        }
      )
    ] });
  };
  const Progress = material.styled(material.LinearProgress, { name: "Progress", slot: "Progress" })`
  width: 100%;
`;
  const Container = material.styled(Caption, { name: "Progress", slot: "Root" })`
  align-items: center;
  color: ${({ theme: theme2 }) => theme2.textSecondary};
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  max-width: 100%;
  min-height: 1em;
  width: 240px;
`;
  const ProgressBar = ({ numberOfSteps, currentStep, className, children }) => {
    const progress = Math.min(currentStep / numberOfSteps, 1) * 100;
    return /* @__PURE__ */ jsxRuntime.jsxs(Container, { className, component: "div", children: [
      /* @__PURE__ */ jsxRuntime.jsx(Progress, { "aria-label": "progress bar", color: "primary", value: progress, variant: "determinate" }),
      children ? /* @__PURE__ */ jsxRuntime.jsx("div", { children }) : null
    ] });
  };
  const shades = {
    blue: {
      /** #34bcd4 */
      400: "#34bcd4",
      /** #116d7c */
      800: "#116d7c"
    },
    cobalt: {
      /** #0f62fe */
      600: "#0f62fe"
    },
    purple: {
      /** #f7f5fc */
      25: "#f7f5fc",
      /** #eee7f9 */
      50: "#eee7f9",
      /** #d2c3ef */
      100: "#d2c3ef",
      /** #b59ce6 */
      200: "#b59ce6",
      /** #9772dc */
      300: "#9772dc",
      /** #7f53d4 */
      400: "#7f53d4",
      /** #6633cc */
      500: "#6633cc",
      /** #5c2ec6 */
      600: "#5c2ec6",
      /** #4d26bd */
      700: "#4d26bd",
      /** #3d20b6 */
      800: "#3d20b6",
      /** #1f11ab */
      900: "#1f11ab"
    },
    lime: {
      /** #f2fffa */
      25: "#f2fffa",
      /** #e3ffee */
      50: "#e3ffee",
      /** #baffd5 */
      100: "#baffd5",
      /** #84ffb9 */
      200: "#84ffb9",
      /** #00ff99 */
      300: "#00ff99",
      /** #00fb7d */
      400: "#00fb7d",
      /** #00f568 */
      500: "#00f568",
      /** #00e35c */
      600: "#00e35c",
      /** #00ce4e */
      700: "#00ce4e",
      /** #00bb41 */
      800: "#00bb41",
      /** #00992b */
      900: "#00992b",
      /** #11881a */
      950: "#11881a"
    },
    pink: {
      /** #fef2f7 */
      25: "#fef2f7",
      /** #fde4ec */
      50: "#fde4ec",
      /** #fabad1 */
      100: "#fabad1",
      /** #f78eb3 */
      200: "#f78eb3",
      /** #f55e94 */
      300: "#f55e94",
      /** #f2387c */
      400: "#f2387c",
      /** #f00066 */
      500: "#f00066",
      /** #df0061 */
      600: "#df0061",
      /** #c9005c */
      700: "#c9005c",
      /** #b40059 */
      800: "#b40059",
      /** #8f0052 */
      900: "#8f0052"
    },
    orange: {
      /** #fffbf4 */
      25: "#fffbf4",
      /** #fff3e0 */
      50: "#fff3e0",
      /** #ffe0b2 */
      100: "#ffe0b2",
      /** #ffcc80 */
      200: "#ffcc80",
      /** #ffb84d */
      300: "#ffb84d",
      /** #ffa726 */
      400: "#ffa726",
      /** #ff9800 */
      500: "#ff9800",
      /** #ff8c00 */
      600: "#ff8c00",
      /** #f97c01 */
      700: "#f97c01",
      /** #f36c01 */
      800: "#f36c01",
      /** #ea5001 */
      900: "#ea5001",
      /** #d2380b */
      950: "#d2380b"
    },
    grey: {
      /** #f1f3f4 */
      50: "#f1f3f4",
      /** #e8eaed */
      100: "#e8eaed",
      /** #dadce0 */
      200: "#dadce0",
      /** #bdc1c6 */
      300: "#bdc1c6",
      /** #9aa0a6 */
      400: "#9aa0a6",
      /** #7c8388 */
      500: "#7c8388",
      /** #5a5e63 */
      600: "#5a5e63",
      /** #3b3f42 */
      700: "#3b3f42",
      /** #292a2e */
      800: "#292a2e",
      /** #1c1c1e */
      900: "#1c1c1e"
    }
  };
  const colors = {
    black: "#000000",
    white: "#ffffff",
    defaultMUIFrameColor: "rgba(0,0,0,0.23)",
    ...shades
  };
  const createColorNamesFromSystemTokens = (tokens) => ({
    background: {
      primary: tokens.backgroundPrimary,
      secondary: tokens.backgroundSecondary,
      tertiary: tokens.backgroundTertiary
    },
    border: {
      default: tokens.borderDefault,
      disabled: tokens.borderDisabled,
      error: tokens.borderError,
      focus: tokens.borderFocus,
      hover: tokens.borderHover,
      interactive: tokens.borderInteractive,
      inverse: tokens.borderInverse
    },
    surfaceSoft: {
      disabled: tokens.surfaceSoftDisabled,
      error: {
        default: tokens.surfaceSoftErrorDefault,
        hover: tokens.surfaceSoftErrorHover,
        pressed: tokens.surfaceSoftErrorPressed
      },
      neutral: {
        default: tokens.surfaceSoftNeutralDefault,
        hover: tokens.surfaceSoftNeutralHover,
        pressed: tokens.surfaceSoftNeutralPressed
      },
      primary: {
        default: tokens.surfaceSoftPrimaryDefault,
        hover: tokens.surfaceSoftPrimaryHover,
        pressed: tokens.surfaceSoftPrimaryPressed
      },
      success: {
        default: tokens.surfaceSoftSuccessDefault,
        hover: tokens.surfaceSoftSuccessHover,
        pressed: tokens.surfaceSoftSuccessPressed
      },
      warning: {
        default: tokens.surfaceSoftWarningDefault,
        hover: tokens.surfaceSoftWarningHover,
        pressed: tokens.surfaceSoftWarningPressed
      }
    },
    surfaceSolid: {
      errorDefault: tokens.surfaceSolidErrorDefault,
      infoDefault: tokens.surfaceSolidInfoDefault,
      primaryDefault: tokens.surfaceSolidPrimaryDefault,
      succcessDefault: tokens.surfaceSolidSucccessDefault,
      warningDefault: tokens.surfaceSolidWarningDefault
    },
    text: {
      disabled: tokens.textDisabled,
      error: tokens.textError,
      info: tokens.textInfo,
      interactive: tokens.textInteractive,
      inverse: tokens.textInverse,
      inverseDisabled: tokens.textInverseDisabled,
      onColorDisabled: tokens.textOnColorDisabled,
      primary: tokens.textPrimary,
      secondary: tokens.textSecondary,
      success: tokens.textSuccess,
      warning: tokens.textWarning
    }
  });
  const alphaValues = {
    8: 0.08,
    10: 0.1,
    12: 0.12,
    14: 0.14,
    18: 0.18,
    20: 0.2,
    50: 0.5
  };
  const { common } = ElliLight;
  const systemTokens = {
    backgroundPrimary: common.ColorBackgroundPrimary,
    backgroundSecondary: common.ColorBackgroundSecondary,
    backgroundTertiary: common.ColorBackgroundTertiary,
    borderDefault: common.ColorBorderDefault,
    borderDisabled: common.ColorBorderDisabled,
    borderError: common.ColorBorderAlert,
    borderFocus: common.ColorBorderFocused,
    borderHover: common.ColorBorderHover,
    borderInteractive: common.ColorBorderBrand,
    borderInverse: common.ColorBorderInverted,
    surfaceSoftDisabled: common.ColorSurfaceDisabledDefault,
    surfaceSoftErrorDefault: common.ColorSurfaceAlertSoftDefault,
    surfaceSoftErrorHover: common.ColorSurfaceAlertSoftHover,
    surfaceSoftErrorPressed: common.ColorSurfaceAlertSoftActive,
    surfaceSoftNeutralDefault: common.ColorSurfaceNeutralSoftDefault,
    surfaceSoftNeutralHover: common.ColorSurfaceNeutralSoftHover,
    surfaceSoftNeutralPressed: common.ColorSurfaceNeutralSoftActive,
    surfaceSoftPrimaryDefault: common.ColorSurfaceBrandSoftDefault,
    surfaceSoftPrimaryHover: common.ColorSurfaceBrandSoftHover,
    surfaceSoftPrimaryPressed: common.ColorSurfaceBrandSoftActive,
    surfaceSoftSuccessDefault: common.ColorSurfaceSuccessSoftDefault,
    surfaceSoftSuccessHover: common.ColorSurfaceSuccessSoftHover,
    surfaceSoftSuccessPressed: common.ColorSurfaceSuccessSoftActive,
    surfaceSoftWarningDefault: common.ColorSurfaceWarningSoftDefault,
    surfaceSoftWarningHover: common.ColorSurfaceWarningSoftHover,
    surfaceSoftWarningPressed: common.ColorSurfaceWarningSoftActive,
    surfaceSolidErrorDefault: common.ColorSurfaceAlertBoldDefault,
    surfaceSolidInfoDefault: common.ColorSurfaceInfoBoldDefault,
    surfaceSolidPrimaryDefault: common.ColorSurfaceBrandBoldDefault,
    surfaceSolidSucccessDefault: common.ColorSurfaceSuccessBoldDefault,
    surfaceSolidWarningDefault: common.ColorSurfaceWarningBoldDefault,
    textDisabled: common.ColorTextDisabled,
    textError: common.ColorTextAlert,
    textInfo: common.ColorTextInfo,
    textInteractive: common.ColorTextBrand,
    textInverse: common.ColorTextInverted,
    textInverseDisabled: material.alpha(common.ColorTextInverted, alphaValues[50]),
    textOnColorDisabled: common.ColorTextDisabled,
    textPrimary: common.ColorTextPrimary,
    textSecondary: common.ColorTextSecondary,
    textSuccess: common.ColorTextSuccess,
    textWarning: common.ColorTextWarning
  };
  const LightColors = createColorNamesFromSystemTokens(systemTokens);
  const muiVariants = [
    { color: "error", variant: "contained" },
    { color: "secondary", variant: "contained" },
    { color: "primary", variant: "outlined" },
    { color: "primary", variant: "text" }
  ];
  function muiToBlitzButtonVariant(muiColorVariant) {
    const { color, variant } = muiColorVariant;
    switch (color) {
      case "error":
        return "Alert";
      case "primary":
        return variant === "outlined" ? "Ghost" : "Tertiary";
      case "secondary":
        return "Primary";
      default:
        return "Primary";
    }
  }
  function muiToBlitzButtonVariants(tokens) {
    const { common: common2, button } = tokens;
    return muiVariants.map((muiVariant) => {
      const blitzVariant = muiToBlitzButtonVariant(muiVariant);
      return {
        props: muiVariant,
        style: {
          "&&": {
            " .MuiTouchRipple-child": {
              color: button[`ButtonVariant${blitzVariant}ActiveBackgroundColor`],
              backgroundColor: button[`ButtonVariant${blitzVariant}ActiveBackgroundColor`]
            },
            " .MuiTouchRipple-rippleVisible": {
              animationName: enterKeyframe,
              opacity: 1
            },
            " .MuiTouchRipple-root": {
              color: button[`ButtonVariant${blitzVariant}ActiveBackgroundColor`],
              zIndex: -1
            },
            ":active": {
              color: button[`ButtonVariant${blitzVariant}ActiveColor`],
              borderColor: button[`ButtonVariant${blitzVariant}ActiveBorderColor`]
            },
            ":disabled": {
              "&.loading:not(.disabled)": {
                opacity: "unset"
              },
              backgroundColor: button[`ButtonVariant${blitzVariant}DisabledBackgroundColor`],
              borderColor: button[`ButtonVariant${blitzVariant}DisabledBorderColor`],
              color: button[`ButtonVariant${blitzVariant}DisabledColor`]
            },
            ":focus": { boxShadow: "none" },
            ":focus-visible": {
              outlineColor: common2.FocusedDefaultColor,
              outlineStyle: common2.FocusedDefaultStyle,
              outlineWidth: common2.FocusedDefaultWidth,
              outlineOffset: common2.FocusedOutlineOffset
            },
            ":hover": {
              backgroundColor: button[`ButtonVariant${blitzVariant}HoverBackgroundColor`],
              borderColor: button[`ButtonVariant${blitzVariant}HoverBorderColor`],
              boxShadow: "none",
              color: button[`ButtonVariant${blitzVariant}HoverColor`]
            },
            backgroundColor: button[`ButtonVariant${blitzVariant}DefaultBackgroundColor`],
            borderColor: button[`ButtonVariant${blitzVariant}DefaultBorderColor`],
            borderWidth: button.ButtonSizeMBorderWidth,
            boxShadow: "none",
            color: button[`ButtonVariant${blitzVariant}DefaultColor`],
            height: "40px",
            padding: `${button.ButtonSizeMPaddingTopBottom} ${button.ButtonSizeMPaddingLeftRight}`,
            zIndex: 0
          }
        }
      };
    });
  }
  function createTypography(typography) {
    return {
      body: {
        // dictates body1
        fontWeight: typography.TypographyFontWeightRegular,
        fontSize: "16px",
        // eslint-disable-next-line sonarjs/no-duplicate-string
        lineHeight: "calc(24 / 16)"
      },
      bodyHighlight: {
        // dictates button
        fontWeight: typography.TypographyFontWeightSemibold,
        fontSize: "16px",
        lineHeight: "calc(24 / 16)"
      },
      bodyLink: {
        fontWeight: typography.TypographyFontWeightRegular,
        fontSize: "16px",
        lineHeight: "calc(24 / 16)",
        textDecorationLine: "underline"
      },
      bodySmall: {
        // dictates body2
        fontWeight: typography.TypographyFontWeightRegular,
        fontSize: "14px",
        // eslint-disable-next-line sonarjs/no-duplicate-string
        lineHeight: "calc(20 / 14)"
      },
      bodySmallHighlight: {
        fontWeight: typography.TypographyFontWeightSemibold,
        fontSize: "14px",
        lineHeight: "calc(20 / 14)"
      },
      bodySmallLink: {
        fontWeight: typography.TypographyFontWeightRegular,
        fontSize: "14px",
        lineHeight: "calc(20 / 14)",
        textDecorationLine: "underline"
      },
      caption: {
        fontSize: "12px",
        fontWeight: typography.TypographyFontWeightRegular,
        letterSpacing: "-0.000427656px",
        lineHeight: "calc(16 / 12)",
        weight: typography.TypographyFontWeightRegular
      },
      display1: {
        fontWeight: typography.TypographyFontWeightBlack,
        fontSize: "44px",
        lineHeight: "calc(56 / 44)"
      },
      headline: {
        fontWeight: typography.TypographyFontWeightExtrabold,
        fontSize: "18px",
        lineHeight: "calc(28 / 18)"
      },
      label: {
        fontWeight: typography.TypographyFontWeightMedium,
        fontSize: "12px",
        lineHeight: "calc(16 / 12)"
      },
      labelMedium: {
        fontWeight: typography.TypographyFontWeightMedium,
        fontSize: "14px",
        lineHeight: "20px"
      },
      labelSmall: {
        fontWeight: typography.TypographyFontWeightMedium,
        fontSize: "12px"
      },
      title1: {
        fontWeight: typography.TypographyFontWeightExtrabold,
        fontSize: "26px",
        lineHeight: "calc(32 / 26)"
      },
      title2: {
        fontWeight: typography.TypographyFontWeightExtrabold,
        fontSize: "22px",
        lineHeight: "calc(32 / 22)"
      }
    };
  }
  const boxShadowElevation3NoColor = "0 16px 32px 0";
  const shadows = {
    elevation1: "0 2px 8px 0 rgba(0, 0, 0, 0.08)",
    elevation2: "0px 4px 20px 0 rgba(0, 0, 0, 0.12)",
    elevation3: `${boxShadowElevation3NoColor} rgba(0, 0, 0, 0.12)`,
    // easily recognizable locally in case an unconfigured elevation is used
    unconfigured: process.env.NODE_ENV === "development" ? `10px 10px 5px 0px ${colors.pink["700"]};` : "none"
  };
  const createMainTheme = (options) => {
    const tokens = (options == null ? void 0 : options.tokens) ?? ElliLight;
    const { common: common2, typography, formControl } = tokens;
    const customTypography = createTypography(typography);
    const theme2 = material.createTheme({
      colorAccent: common2.ColorSurfaceAccentBoldDefault,
      colorAlertPrimary: common2.ColorSurfaceAlertBoldDefault,
      colorAlertSecondary: common2.ColorSurfaceWarningBoldDefault,
      colorAlertSecondaryDark: common2.ColorSurfaceWarningBoldActive,
      colorConfirmation: common2.ColorSurfaceSuccessSoftOnHighlight,
      colorInfoSurfaceSoft: common2.ColorSurfaceInfoSoftDefault,
      colorNegativeTextSoft: common2.ColorTextAlert,
      colorPositiveTextSoft: common2.ColorTextSuccess,
      colorPrimary: common2.ColorSurfaceBrandBoldDefault,
      colorPrimaryDark: common2.ColorSurfaceBrandBoldActive,
      colorWarningTextSoft: common2.ColorTextWarning,
      components: {
        MuiAutocomplete: {
          defaultProps: {
            popupIcon: /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { ariaLabel: "dropDown", name: "ExpandMore" })
          },
          styleOverrides: {
            popupIndicator: {
              "&&&:hover": {
                background: "unset"
              }
            }
          }
        },
        MuiButton: {
          variants: muiToBlitzButtonVariants(tokens)
        },
        MuiCheckbox: {
          defaultProps: {
            checkedIcon: /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { name: "CheckboxChecked" }),
            icon: /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { name: "CheckboxUnchecked" }),
            indeterminateIcon: /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { name: "CheckboxIndeterminate" })
          },
          styleOverrides: {
            root: getCheckboxRadioStyles("checkbox", tokens)
          }
        },
        MuiFormHelperText: {
          styleOverrides: {
            root: {
              marginTop: formControl.FormControlHelperTextTopMargin
            }
          }
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontSize: "16px",
              fontWeight: 400
            }
          }
        },
        MuiIconButton: {
          styleOverrides: {
            root: {
              minWidth: "24px",
              "&&&:hover": {
                background: "rgba(0, 0, 0, 0.08)"
              }
            }
          }
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              fontSize: "16px",
              fontWeight: 400,
              letterSpacing: "normal"
            }
          }
        },
        MuiLink: {
          styleOverrides: {
            underlineAlways: {
              textDecoration: "underline"
            },
            root: getLinkStyles(tokens)
          }
        },
        MuiListItem: {
          styleOverrides: {
            root: {
              "&$disabled": {
                color: common2.ColorBackgroundTertiary,
                opacity: 1
              }
            }
          }
        },
        MuiRadio: {
          defaultProps: {
            checkedIcon: /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { name: "RadioChecked" }),
            icon: /* @__PURE__ */ jsxRuntime.jsx(Icon$2, { name: "RadioUnchecked" })
          },
          styleOverrides: {
            root: getCheckboxRadioStyles("radio", tokens)
          }
        },
        MuiSelect: {
          defaultProps: {
            IconComponent: SvgIcDropdown24Px
          },
          styleOverrides: {
            icon: {
              top: "calc(50% - 12px)"
            }
          }
        },
        MuiSvgIcon: {
          styleOverrides: {
            root: {
              fontSize: void 0
            }
          }
        },
        MuiTab: {
          styleOverrides: {
            textColorPrimary: {
              color: common2.ColorTextPrimary,
              fontWeight: typography.TypographyFontWeightSemibold
            }
          }
        },
        MuiTableRow: {
          styleOverrides: {
            hover: {
              "&$hover:hover": {
                backgroundColor: colors.grey["50"]
              }
            }
          }
        },
        MuiTouchRipple: {
          styleOverrides: {
            // The opacity is added to the hover state darkening
            // @ts-expect-error The types are insufficient here, this style exists
            "@keyframes enter": {
              "0%": {
                transform: "scale(0)",
                opacity: 0.08
              },
              "100%": {
                transform: "scale(1)",
                opacity: 0.08
              }
            },
            rippleVisible: {
              opacity: 0.08
            }
          }
        }
      },
      materialFrameColor: colors.defaultMUIFrameColor,
      palette: {
        background: {
          default: common2.ColorBackgroundPrimary
        },
        colors: LightColors,
        error: {
          contrastText: common2.ColorTextPrimary,
          main: common2.ColorSurfaceAlertBoldDefault
        },
        primary: {
          contrastText: common2.ColorSurfaceBrandBoldOn,
          main: common2.ColorSurfaceBrandBoldDefault
        },
        secondary: {
          contrastText: common2.ColorSurfaceAccentBoldOn,
          main: common2.ColorSurfaceAccentBoldDefault
        },
        shades
      },
      portalPadding: "36px",
      shadows: [
        "none",
        shadows.elevation1,
        // MUI default elevation for paper
        shadows.elevation2,
        shadows.elevation3,
        shadows.elevation1,
        // MUI default elevation for Topbar
        shadows.unconfigured,
        shadows.elevation2,
        // MUI default for buttons with visible focus
        shadows.unconfigured,
        shadows.elevation3,
        // MUI default elevation for popup menus, selects
        shadows.unconfigured,
        shadows.unconfigured,
        shadows.unconfigured,
        shadows.unconfigured,
        shadows.unconfigured,
        shadows.unconfigured,
        shadows.unconfigured,
        shadows.unconfigured,
        shadows.unconfigured,
        shadows.unconfigured,
        shadows.unconfigured,
        shadows.unconfigured,
        shadows.unconfigured,
        shadows.unconfigured,
        shadows.unconfigured,
        shadows.elevation3
        // MUI default elevation for dialogs
      ],
      surfaceLightPurplePink: common2.ColorSurfaceBrandBoldHover,
      surfacePrimary: common2.ColorBackgroundPrimary,
      surfaceSecondary: common2.ColorBackgroundSecondary,
      surfaceTertiary: common2.ColorBackgroundTertiary,
      textPrimary: common2.ColorTextPrimary,
      textSecondary: common2.ColorTextSecondary,
      textSuccess: common2.ColorTextSuccess,
      tokens,
      typography: {
        ...customTypography,
        body1: {
          ...customTypography.body,
          lineHeight: 1.38
        },
        button: {
          ...customTypography.bodyHighlight,
          textTransform: "none"
        },
        fontFamily: "Inter, Futura, Helvetica, Verdana, sans-serif",
        fontWeightBold: typography.TypographyFontWeightBold,
        fontWeightLight: typography.TypographyFontWeightLight,
        fontWeightMedium: typography.TypographyFontWeightMedium,
        fontWeightRegular: typography.TypographyFontWeightRegular,
        fontWeightSemiBold: typography.TypographyFontWeightSemibold,
        // Below are default MUI Typography variants:
        // (see https://mui.com/material-ui/customization/typography/#variants):
        h1: customTypography.title1,
        h2: customTypography.title2,
        h3: customTypography.headline,
        h4: customTypography.headline,
        h6: customTypography.caption
      }
    });
    theme2.palette.text.primary = theme2.textPrimary;
    theme2.palette.text.secondary = theme2.textSecondary;
    theme2.shape.borderRadius = 0;
    theme2.components = {
      ...theme2.components,
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontSize: "16px",
            fontWeight: 400,
            paddingBottom: "4px",
            paddingTop: "4px",
            [theme2.breakpoints.up("sm")]: {
              minHeight: "48px"
            }
          }
        }
      }
    };
    return theme2;
  };
  const mainTheme = createMainTheme();
  const Provider = ({ children, tokens }) => {
    const theme2 = React.useMemo(() => createMainTheme({ tokens }), [tokens]);
    return /* @__PURE__ */ jsxRuntime.jsx(material.StyledEngineProvider, { injectFirst: true, children: /* @__PURE__ */ jsxRuntime.jsx(material.ThemeProvider, { theme: theme2, children }) });
  };
  const theme = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    Provider,
    boxShadowElevation3NoColor,
    createMainTheme,
    mainTheme
  }, Symbol.toStringTag, { value: "Module" }));
  const consoleLogger = {
    type: "logger",
    log(args) {
      this.output("log", args);
    },
    warn(args) {
      this.output("warn", args);
    },
    error(args) {
      this.output("error", args);
    },
    output(type, args) {
      if (console && console[type]) console[type].apply(console, args);
    }
  };
  class Logger {
    constructor(concreteLogger) {
      let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.init(concreteLogger, options);
    }
    init(concreteLogger) {
      let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.prefix = options.prefix || "i18next:";
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
    log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return this.forward(args, "log", "", true);
    }
    warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return this.forward(args, "warn", "", true);
    }
    error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return this.forward(args, "error", "");
    }
    deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
    }
    forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === "string") args[0] = `${prefix}${this.prefix} ${args[0]}`;
      return this.logger[lvl](args);
    }
    create(moduleName) {
      return new Logger(this.logger, {
        ...{
          prefix: `${this.prefix}:${moduleName}:`
        },
        ...this.options
      });
    }
    clone(options) {
      options = options || this.options;
      options.prefix = options.prefix || this.prefix;
      return new Logger(this.logger, options);
    }
  }
  var baseLogger = new Logger();
  class EventEmitter {
    constructor() {
      this.observers = {};
    }
    on(events, listener) {
      events.split(" ").forEach((event) => {
        if (!this.observers[event]) this.observers[event] = /* @__PURE__ */ new Map();
        const numListeners = this.observers[event].get(listener) || 0;
        this.observers[event].set(listener, numListeners + 1);
      });
      return this;
    }
    off(event, listener) {
      if (!this.observers[event]) return;
      if (!listener) {
        delete this.observers[event];
        return;
      }
      this.observers[event].delete(listener);
    }
    emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (this.observers[event]) {
        const cloned = Array.from(this.observers[event].entries());
        cloned.forEach((_ref) => {
          let [observer, numTimesAdded] = _ref;
          for (let i = 0; i < numTimesAdded; i++) {
            observer(...args);
          }
        });
      }
      if (this.observers["*"]) {
        const cloned = Array.from(this.observers["*"].entries());
        cloned.forEach((_ref2) => {
          let [observer, numTimesAdded] = _ref2;
          for (let i = 0; i < numTimesAdded; i++) {
            observer.apply(observer, [event, ...args]);
          }
        });
      }
    }
  }
  const defer = () => {
    let res;
    let rej;
    const promise = new Promise((resolve, reject) => {
      res = resolve;
      rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
  };
  const makeString = (object) => {
    if (object == null) return "";
    return "" + object;
  };
  const copy = (a, s, t) => {
    a.forEach((m) => {
      if (s[m]) t[m] = s[m];
    });
  };
  const lastOfPathSeparatorRegExp = /###/g;
  const cleanKey = (key) => key && key.indexOf("###") > -1 ? key.replace(lastOfPathSeparatorRegExp, ".") : key;
  const canNotTraverseDeeper = (object) => !object || typeof object === "string";
  const getLastOfPath = (object, path, Empty) => {
    const stack = typeof path !== "string" ? path : path.split(".");
    let stackIndex = 0;
    while (stackIndex < stack.length - 1) {
      if (canNotTraverseDeeper(object)) return {};
      const key = cleanKey(stack[stackIndex]);
      if (!object[key] && Empty) object[key] = new Empty();
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        object = object[key];
      } else {
        object = {};
      }
      ++stackIndex;
    }
    if (canNotTraverseDeeper(object)) return {};
    return {
      obj: object,
      k: cleanKey(stack[stackIndex])
    };
  };
  const setPath = (object, path, newValue) => {
    const {
      obj,
      k
    } = getLastOfPath(object, path, Object);
    if (obj !== void 0 || path.length === 1) {
      obj[k] = newValue;
      return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = getLastOfPath(object, p, Object);
    while (last.obj === void 0 && p.length) {
      e = `${p[p.length - 1]}.${e}`;
      p = p.slice(0, p.length - 1);
      last = getLastOfPath(object, p, Object);
      if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== "undefined") {
        last.obj = void 0;
      }
    }
    last.obj[`${last.k}.${e}`] = newValue;
  };
  const pushPath = (object, path, newValue, concat) => {
    const {
      obj,
      k
    } = getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
  };
  const getPath = (object, path) => {
    const {
      obj,
      k
    } = getLastOfPath(object, path);
    if (!obj) return void 0;
    return obj[k];
  };
  const getPathWithDefaults = (data, defaultData, key) => {
    const value = getPath(data, key);
    if (value !== void 0) {
      return value;
    }
    return getPath(defaultData, key);
  };
  const deepExtend = (target, source, overwrite) => {
    for (const prop in source) {
      if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
          if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
            if (overwrite) target[prop] = source[prop];
          } else {
            deepExtend(target[prop], source[prop], overwrite);
          }
        } else {
          target[prop] = source[prop];
        }
      }
    }
    return target;
  };
  const regexEscape = (str) => str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
  var _entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
  };
  const escape = (data) => {
    if (typeof data === "string") {
      return data.replace(/[&<>"'\/]/g, (s) => _entityMap[s]);
    }
    return data;
  };
  class RegExpCache {
    constructor(capacity) {
      this.capacity = capacity;
      this.regExpMap = /* @__PURE__ */ new Map();
      this.regExpQueue = [];
    }
    getRegExp(pattern) {
      const regExpFromCache = this.regExpMap.get(pattern);
      if (regExpFromCache !== void 0) {
        return regExpFromCache;
      }
      const regExpNew = new RegExp(pattern);
      if (this.regExpQueue.length === this.capacity) {
        this.regExpMap.delete(this.regExpQueue.shift());
      }
      this.regExpMap.set(pattern, regExpNew);
      this.regExpQueue.push(pattern);
      return regExpNew;
    }
  }
  const chars = [" ", ",", "?", "!", ";"];
  const looksLikeObjectPathRegExpCache = new RegExpCache(20);
  const looksLikeObjectPath = (key, nsSeparator, keySeparator) => {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    const possibleChars = chars.filter((c) => nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r2 = looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c) => c === "?" ? "\\?" : c).join("|")})`);
    let matched = !r2.test(key);
    if (!matched) {
      const ki = key.indexOf(keySeparator);
      if (ki > 0 && !r2.test(key.substring(0, ki))) {
        matched = true;
      }
    }
    return matched;
  };
  const deepFind = function(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
    if (!obj) return void 0;
    if (obj[path]) return obj[path];
    const tokens = path.split(keySeparator);
    let current = obj;
    for (let i = 0; i < tokens.length; ) {
      if (!current || typeof current !== "object") {
        return void 0;
      }
      let next;
      let nextPath = "";
      for (let j = i; j < tokens.length; ++j) {
        if (j !== i) {
          nextPath += keySeparator;
        }
        nextPath += tokens[j];
        next = current[nextPath];
        if (next !== void 0) {
          if (["string", "number", "boolean"].indexOf(typeof next) > -1 && j < tokens.length - 1) {
            continue;
          }
          i += j - i + 1;
          break;
        }
      }
      current = next;
    }
    return current;
  };
  const getCleanedCode = (code) => {
    if (code && code.indexOf("_") > 0) return code.replace("_", "-");
    return code;
  };
  class ResourceStore extends EventEmitter {
    constructor(data) {
      let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        ns: ["translation"],
        defaultNS: "translation"
      };
      super();
      this.data = data || {};
      this.options = options;
      if (this.options.keySeparator === void 0) {
        this.options.keySeparator = ".";
      }
      if (this.options.ignoreJSONStructure === void 0) {
        this.options.ignoreJSONStructure = true;
      }
    }
    addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
    removeNamespaces(ns) {
      const index = this.options.ns.indexOf(ns);
      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
    getResource(lng, ns, key) {
      let options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      const keySeparator = options.keySeparator !== void 0 ? options.keySeparator : this.options.keySeparator;
      const ignoreJSONStructure = options.ignoreJSONStructure !== void 0 ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      let path;
      if (lng.indexOf(".") > -1) {
        path = lng.split(".");
      } else {
        path = [lng, ns];
        if (key) {
          if (Array.isArray(key)) {
            path.push(...key);
          } else if (typeof key === "string" && keySeparator) {
            path.push(...key.split(keySeparator));
          } else {
            path.push(key);
          }
        }
      }
      const result = getPath(this.data, path);
      if (!result && !ns && !key && lng.indexOf(".") > -1) {
        lng = path[0];
        ns = path[1];
        key = path.slice(2).join(".");
      }
      if (result || !ignoreJSONStructure || typeof key !== "string") return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
      let options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
        silent: false
      };
      const keySeparator = options.keySeparator !== void 0 ? options.keySeparator : this.options.keySeparator;
      let path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf(".") > -1) {
        path = lng.split(".");
        value = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit("added", lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
      let options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        silent: false
      };
      for (const m in resources) {
        if (typeof resources[m] === "string" || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }
      if (!options.silent) this.emit("added", lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
      let options = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
        silent: false,
        skipCopy: false
      };
      let path = [lng, ns];
      if (lng.indexOf(".") > -1) {
        path = lng.split(".");
        deep = resources;
        resources = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      let pack = getPath(this.data, path) || {};
      if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = {
          ...pack,
          ...resources
        };
      }
      setPath(this.data, path, pack);
      if (!options.silent) this.emit("added", lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }
      this.removeNamespaces(ns);
      this.emit("removed", lng, ns);
    }
    hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== void 0;
    }
    getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === "v1") return {
        ...{},
        ...this.getResource(lng, ns)
      };
      return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
      return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
      const data = this.getDataByLanguage(lng);
      const n = data && Object.keys(data) || [];
      return !!n.find((v) => data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
      return this.data;
    }
  }
  var postProcessor = {
    processors: {},
    addPostProcessor(module2) {
      this.processors[module2.name] = module2;
    },
    handle(processors, value, key, options, translator) {
      processors.forEach((processor) => {
        if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
      });
      return value;
    }
  };
  const checkedLoadedFor = {};
  class Translator extends EventEmitter {
    constructor(services) {
      let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      super();
      copy(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], services, this);
      this.options = options;
      if (this.options.keySeparator === void 0) {
        this.options.keySeparator = ".";
      }
      this.logger = baseLogger.create("translator");
    }
    changeLanguage(lng) {
      if (lng) this.language = lng;
    }
    exists(key) {
      let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      };
      if (key === void 0 || key === null) {
        return false;
      }
      const resolved = this.resolve(key, options);
      return resolved && resolved.res !== void 0;
    }
    extractFromKey(key, options) {
      let nsSeparator = options.nsSeparator !== void 0 ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === void 0) nsSeparator = ":";
      const keySeparator = options.keySeparator !== void 0 ? options.keySeparator : this.options.keySeparator;
      let namespaces = options.ns || this.options.defaultNS || [];
      const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        const m = key.match(this.interpolator.nestingRegexp);
        if (m && m.length > 0) {
          return {
            key,
            namespaces
          };
        }
        const parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }
      if (typeof namespaces === "string") namespaces = [namespaces];
      return {
        key,
        namespaces
      };
    }
    translate(keys, options, lastKey) {
      if (typeof options !== "object" && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }
      if (typeof options === "object") options = {
        ...options
      };
      if (!options) options = {};
      if (keys === void 0 || keys === null) return "";
      if (!Array.isArray(keys)) keys = [String(keys)];
      const returnDetails = options.returnDetails !== void 0 ? options.returnDetails : this.options.returnDetails;
      const keySeparator = options.keySeparator !== void 0 ? options.keySeparator : this.options.keySeparator;
      const {
        key,
        namespaces
      } = this.extractFromKey(keys[keys.length - 1], options);
      const namespace = namespaces[namespaces.length - 1];
      const lng = options.lng || this.language;
      const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (lng && lng.toLowerCase() === "cimode") {
        if (appendNamespaceToCIMode) {
          const nsSeparator = options.nsSeparator || this.options.nsSeparator;
          if (returnDetails) {
            return {
              res: `${namespace}${nsSeparator}${key}`,
              usedKey: key,
              exactUsedKey: key,
              usedLng: lng,
              usedNS: namespace,
              usedParams: this.getUsedParamsDetails(options)
            };
          }
          return `${namespace}${nsSeparator}${key}`;
        }
        if (returnDetails) {
          return {
            res: key,
            usedKey: key,
            exactUsedKey: key,
            usedLng: lng,
            usedNS: namespace,
            usedParams: this.getUsedParamsDetails(options)
          };
        }
        return key;
      }
      const resolved = this.resolve(keys, options);
      let res = resolved && resolved.res;
      const resUsedKey = resolved && resolved.usedKey || key;
      const resExactUsedKey = resolved && resolved.exactUsedKey || key;
      const resType = Object.prototype.toString.apply(res);
      const noObject = ["[object Number]", "[object Function]", "[object RegExp]"];
      const joinArrays = options.joinArrays !== void 0 ? options.joinArrays : this.options.joinArrays;
      const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      const handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && Array.isArray(res))) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn("accessing an object - but returnObjects options is not enabled!");
          }
          const r2 = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
            ...options,
            ns: namespaces
          }) : `key '${key} (${this.language})' returned an object instead of string.`;
          if (returnDetails) {
            resolved.res = r2;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
          }
          return r2;
        }
        if (keySeparator) {
          const resTypeIsArray = Array.isArray(res);
          const copy2 = resTypeIsArray ? [] : {};
          const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
          for (const m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              const deepKey = `${newKeyToUse}${keySeparator}${m}`;
              copy2[m] = this.translate(deepKey, {
                ...options,
                ...{
                  joinArrays: false,
                  ns: namespaces
                }
              });
              if (copy2[m] === deepKey) copy2[m] = res[m];
            }
          }
          res = copy2;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && Array.isArray(res)) {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        let usedDefault = false;
        let usedKey = false;
        const needsPluralHandling = options.count !== void 0 && typeof options.count !== "string";
        const hasDefaultValue = Translator.hasDefaultValue(options);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
        const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
          ordinal: false
        }) : "";
        const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
        const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }
        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }
        const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? void 0 : res;
        const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
          if (keySeparator) {
            const fk = this.resolve(key, {
              ...options,
              keySeparator: false
            });
            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
          }
          let lngs = [];
          const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
          if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) {
            for (let i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === "all") {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }
          const send = (l, k, specificDefaultValue) => {
            const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
            if (this.options.missingKeyHandler) {
              this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (this.backendConnector && this.backendConnector.saveMissing) {
              this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }
            this.emit("missingKey", l, namespace, k, res);
          };
          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach((language) => {
                const suffixes = this.pluralResolver.getSuffixes(language, options);
                if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) {
                  suffixes.push(`${this.options.pluralSeparator}zero`);
                }
                suffixes.forEach((suffix) => {
                  send([language], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }
        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== "v1") {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : void 0);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }
      if (returnDetails) {
        resolved.res = res;
        resolved.usedParams = this.getUsedParamsDetails(options);
        return resolved;
      }
      return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
      var _this = this;
      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, {
          ...this.options.interpolation.defaultVariables,
          ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init({
          ...options,
          ...{
            interpolation: {
              ...this.options.interpolation,
              ...options.interpolation
            }
          }
        });
        const skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== void 0 ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        let nestBef;
        if (skipOnVariables) {
          const nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }
        let data = options.replace && typeof options.replace !== "string" ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = {
          ...this.options.interpolation.defaultVariables,
          ...data
        };
        res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
        if (skipOnVariables) {
          const na = res.match(this.interpolator.nestingRegexp);
          const nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }
        if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
        if (options.nest !== false) res = this.interpolator.nest(res, function() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
            return null;
          }
          return _this.translate(...args, key);
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }
      const postProcess = options.postProcess || this.options.postProcess;
      const postProcessorNames = typeof postProcess === "string" ? [postProcess] : postProcess;
      if (res !== void 0 && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
          i18nResolved: {
            ...resolved,
            usedParams: this.getUsedParamsDetails(options)
          },
          ...options
        } : options, this);
      }
      return res;
    }
    resolve(keys) {
      let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      let found;
      let usedKey;
      let exactUsedKey;
      let usedLng;
      let usedNS;
      if (typeof keys === "string") keys = [keys];
      keys.forEach((k) => {
        if (this.isValidLookup(found)) return;
        const extracted = this.extractFromKey(k, options);
        const key = extracted.key;
        usedKey = key;
        let namespaces = extracted.namespaces;
        if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
        const needsPluralHandling = options.count !== void 0 && typeof options.count !== "string";
        const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
        const needsContextHandling = options.context !== void 0 && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
        const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
        namespaces.forEach((ns) => {
          if (this.isValidLookup(found)) return;
          usedNS = ns;
          if (!checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor[`${codes[0]}-${ns}`] = true;
            this.logger.warn(`key "${usedKey}" for languages "${codes.join(", ")}" won't get resolved as namespace "${usedNS}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
          }
          codes.forEach((code) => {
            if (this.isValidLookup(found)) return;
            usedLng = code;
            const finalKeys = [key];
            if (this.i18nFormat && this.i18nFormat.addLookupKeys) {
              this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              let pluralSuffix;
              if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
              const zeroSuffix = `${this.options.pluralSeparator}zero`;
              const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);
                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                  finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                }
                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }
              if (needsContextHandling) {
                const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                finalKeys.push(contextKey);
                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);
                  if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                    finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                  }
                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }
            let possibleKey;
            while (possibleKey = finalKeys.pop()) {
              if (!this.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = this.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey,
        exactUsedKey,
        usedLng,
        usedNS
      };
    }
    isValidLookup(res) {
      return res !== void 0 && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
    }
    getResource(code, ns, key) {
      let options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
      let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      const optionsKeys = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"];
      const useOptionsReplaceForData = options.replace && typeof options.replace !== "string";
      let data = useOptionsReplaceForData ? options.replace : options;
      if (useOptionsReplaceForData && typeof options.count !== "undefined") {
        data.count = options.count;
      }
      if (this.options.interpolation.defaultVariables) {
        data = {
          ...this.options.interpolation.defaultVariables,
          ...data
        };
      }
      if (!useOptionsReplaceForData) {
        data = {
          ...data
        };
        for (const key of optionsKeys) {
          delete data[key];
        }
      }
      return data;
    }
    static hasDefaultValue(options) {
      const prefix = "defaultValue";
      for (const option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && void 0 !== options[option]) {
          return true;
        }
      }
      return false;
    }
  }
  const capitalize = (string) => string.charAt(0).toUpperCase() + string.slice(1);
  class LanguageUtil {
    constructor(options) {
      this.options = options;
      this.supportedLngs = this.options.supportedLngs || false;
      this.logger = baseLogger.create("languageUtils");
    }
    getScriptPartFromCode(code) {
      code = getCleanedCode(code);
      if (!code || code.indexOf("-") < 0) return null;
      const p = code.split("-");
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === "x") return null;
      return this.formatLanguageCode(p.join("-"));
    }
    getLanguagePartFromCode(code) {
      code = getCleanedCode(code);
      if (!code || code.indexOf("-") < 0) return code;
      const p = code.split("-");
      return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
      if (typeof code === "string" && code.indexOf("-") > -1) {
        const specialCases = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
        let p = code.split("-");
        if (this.options.lowerCaseLng) {
          p = p.map((part) => part.toLowerCase());
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }
        return p.join("-");
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
      if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }
      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
      if (!codes) return null;
      let found;
      codes.forEach((code) => {
        if (found) return;
        const cleanedLng = this.formatLanguageCode(code);
        if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });
      if (!found && this.options.supportedLngs) {
        codes.forEach((code) => {
          if (found) return;
          const lngOnly = this.getLanguagePartFromCode(code);
          if (this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = this.options.supportedLngs.find((supportedLng) => {
            if (supportedLng === lngOnly) return supportedLng;
            if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
            if (supportedLng.indexOf("-") > 0 && lngOnly.indexOf("-") < 0 && supportedLng.substring(0, supportedLng.indexOf("-")) === lngOnly) return supportedLng;
            if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
          });
        });
      }
      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
    getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === "function") fallbacks = fallbacks(code);
      if (typeof fallbacks === "string") fallbacks = [fallbacks];
      if (Array.isArray(fallbacks)) return fallbacks;
      if (!code) return fallbacks.default || [];
      let found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks.default;
      return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
      const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      const codes = [];
      const addCode = (c) => {
        if (!c) return;
        if (this.isSupportedCode(c)) {
          codes.push(c);
        } else {
          this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        }
      };
      if (typeof code === "string" && (code.indexOf("-") > -1 || code.indexOf("_") > -1)) {
        if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
        if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === "string") {
        addCode(this.formatLanguageCode(code));
      }
      fallbackCodes.forEach((fc) => {
        if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
      });
      return codes;
    }
  }
  let sets = [{
    lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
    nr: [1, 2],
    fc: 1
  }, {
    lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
    nr: [1, 2],
    fc: 2
  }, {
    lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
    nr: [1],
    fc: 3
  }, {
    lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
    nr: [1, 2, 5],
    fc: 4
  }, {
    lngs: ["ar"],
    nr: [0, 1, 2, 3, 11, 100],
    fc: 5
  }, {
    lngs: ["cs", "sk"],
    nr: [1, 2, 5],
    fc: 6
  }, {
    lngs: ["csb", "pl"],
    nr: [1, 2, 5],
    fc: 7
  }, {
    lngs: ["cy"],
    nr: [1, 2, 3, 8],
    fc: 8
  }, {
    lngs: ["fr"],
    nr: [1, 2],
    fc: 9
  }, {
    lngs: ["ga"],
    nr: [1, 2, 3, 7, 11],
    fc: 10
  }, {
    lngs: ["gd"],
    nr: [1, 2, 3, 20],
    fc: 11
  }, {
    lngs: ["is"],
    nr: [1, 2],
    fc: 12
  }, {
    lngs: ["jv"],
    nr: [0, 1],
    fc: 13
  }, {
    lngs: ["kw"],
    nr: [1, 2, 3, 4],
    fc: 14
  }, {
    lngs: ["lt"],
    nr: [1, 2, 10],
    fc: 15
  }, {
    lngs: ["lv"],
    nr: [1, 2, 0],
    fc: 16
  }, {
    lngs: ["mk"],
    nr: [1, 2],
    fc: 17
  }, {
    lngs: ["mnk"],
    nr: [0, 1, 2],
    fc: 18
  }, {
    lngs: ["mt"],
    nr: [1, 2, 11, 20],
    fc: 19
  }, {
    lngs: ["or"],
    nr: [2, 1],
    fc: 2
  }, {
    lngs: ["ro"],
    nr: [1, 2, 20],
    fc: 20
  }, {
    lngs: ["sl"],
    nr: [5, 1, 2, 3],
    fc: 21
  }, {
    lngs: ["he", "iw"],
    nr: [1, 2, 20, 21],
    fc: 22
  }];
  let _rulesPluralsTypes = {
    1: (n) => Number(n > 1),
    2: (n) => Number(n != 1),
    3: (n) => 0,
    4: (n) => Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    5: (n) => Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5),
    6: (n) => Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2),
    7: (n) => Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    8: (n) => Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3),
    9: (n) => Number(n >= 2),
    10: (n) => Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4),
    11: (n) => Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3),
    12: (n) => Number(n % 10 != 1 || n % 100 == 11),
    13: (n) => Number(n !== 0),
    14: (n) => Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3),
    15: (n) => Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    16: (n) => Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2),
    17: (n) => Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1),
    18: (n) => Number(n == 0 ? 0 : n == 1 ? 1 : 2),
    19: (n) => Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3),
    20: (n) => Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2),
    21: (n) => Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0),
    22: (n) => Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3)
  };
  const nonIntlVersions = ["v1", "v2", "v3"];
  const intlVersions = ["v4"];
  const suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
  };
  const createRules = () => {
    const rules = {};
    sets.forEach((set) => {
      set.lngs.forEach((l) => {
        rules[l] = {
          numbers: set.nr,
          plurals: _rulesPluralsTypes[set.fc]
        };
      });
    });
    return rules;
  };
  class PluralResolver {
    constructor(languageUtils) {
      let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.languageUtils = languageUtils;
      this.options = options;
      this.logger = baseLogger.create("pluralResolver");
      if ((!this.options.compatibilityJSON || intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === "undefined" || !Intl.PluralRules)) {
        this.options.compatibilityJSON = "v3";
        this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
      }
      this.rules = createRules();
      this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
      this.rules[lng] = obj;
    }
    clearCache() {
      this.pluralRulesCache = {};
    }
    getRule(code) {
      let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (this.shouldUseIntlApi()) {
        try {
          const cleanedCode = getCleanedCode(code === "dev" ? "en" : code);
          const type = options.ordinal ? "ordinal" : "cardinal";
          const cacheKey = JSON.stringify({
            cleanedCode,
            type
          });
          if (cacheKey in this.pluralRulesCache) {
            return this.pluralRulesCache[cacheKey];
          }
          const rule = new Intl.PluralRules(cleanedCode, {
            type
          });
          this.pluralRulesCache[cacheKey] = rule;
          return rule;
        } catch (err) {
          return;
        }
      }
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
      let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      const rule = this.getRule(code, options);
      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }
      return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
      let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return this.getSuffixes(code, options).map((suffix) => `${key}${suffix}`);
    }
    getSuffixes(code) {
      let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      const rule = this.getRule(code, options);
      if (!rule) {
        return [];
      }
      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2) => suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2]).map((pluralCategory) => `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${pluralCategory}`);
      }
      return rule.numbers.map((number) => this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
      let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      const rule = this.getRule(code, options);
      if (rule) {
        if (this.shouldUseIntlApi()) {
          return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${rule.select(count)}`;
        }
        return this.getSuffixRetroCompatible(rule, count);
      }
      this.logger.warn(`no plural rule found for: ${code}`);
      return "";
    }
    getSuffixRetroCompatible(rule, count) {
      const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      let suffix = rule.numbers[idx];
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = "plural";
        } else if (suffix === 1) {
          suffix = "";
        }
      }
      const returnSuffix = () => this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
      if (this.options.compatibilityJSON === "v1") {
        if (suffix === 1) return "";
        if (typeof suffix === "number") return `_plural_${suffix.toString()}`;
        return returnSuffix();
      } else if (this.options.compatibilityJSON === "v2") {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
      return !nonIntlVersions.includes(this.options.compatibilityJSON);
    }
  }
  const deepFindWithDefaults = function(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".";
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
    let path = getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
      path = deepFind(data, key, keySeparator);
      if (path === void 0) path = deepFind(defaultData, key, keySeparator);
    }
    return path;
  };
  const regexSafe = (val) => val.replace(/\$/g, "$$$$");
  class Interpolator {
    constructor() {
      let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      this.logger = baseLogger.create("interpolator");
      this.options = options;
      this.format = options.interpolation && options.interpolation.format || ((value) => value);
      this.init(options);
    }
    init() {
      let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      const {
        escape: escape$1,
        escapeValue,
        useRawValueToEscape,
        prefix,
        prefixEscaped,
        suffix,
        suffixEscaped,
        formatSeparator,
        unescapeSuffix,
        unescapePrefix,
        nestingPrefix,
        nestingPrefixEscaped,
        nestingSuffix,
        nestingSuffixEscaped,
        nestingOptionsSeparator,
        maxReplaces,
        alwaysFormat
      } = options.interpolation;
      this.escape = escape$1 !== void 0 ? escape$1 : escape;
      this.escapeValue = escapeValue !== void 0 ? escapeValue : true;
      this.useRawValueToEscape = useRawValueToEscape !== void 0 ? useRawValueToEscape : false;
      this.prefix = prefix ? regexEscape(prefix) : prefixEscaped || "{{";
      this.suffix = suffix ? regexEscape(suffix) : suffixEscaped || "}}";
      this.formatSeparator = formatSeparator || ",";
      this.unescapePrefix = unescapeSuffix ? "" : unescapePrefix || "-";
      this.unescapeSuffix = this.unescapePrefix ? "" : unescapeSuffix || "";
      this.nestingPrefix = nestingPrefix ? regexEscape(nestingPrefix) : nestingPrefixEscaped || regexEscape("$t(");
      this.nestingSuffix = nestingSuffix ? regexEscape(nestingSuffix) : nestingSuffixEscaped || regexEscape(")");
      this.nestingOptionsSeparator = nestingOptionsSeparator || ",";
      this.maxReplaces = maxReplaces || 1e3;
      this.alwaysFormat = alwaysFormat !== void 0 ? alwaysFormat : false;
      this.resetRegExp();
    }
    reset() {
      if (this.options) this.init(this.options);
    }
    resetRegExp() {
      const getOrResetRegExp = (existingRegExp, pattern) => {
        if (existingRegExp && existingRegExp.source === pattern) {
          existingRegExp.lastIndex = 0;
          return existingRegExp;
        }
        return new RegExp(pattern, "g");
      };
      this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
      this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
      this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
      let match;
      let value;
      let replaces;
      const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      const handleFormat = (key) => {
        if (key.indexOf(this.formatSeparator) < 0) {
          const path = deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
          return this.alwaysFormat ? this.format(path, void 0, lng, {
            ...options,
            ...data,
            interpolationkey: key
          }) : path;
        }
        const p = key.split(this.formatSeparator);
        const k = p.shift().trim();
        const f = p.join(this.formatSeparator).trim();
        return this.format(deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
          ...options,
          ...data,
          interpolationkey: k
        });
      };
      this.resetRegExp();
      const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== void 0 ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      const todos = [{
        regex: this.regexpUnescape,
        safeValue: (val) => regexSafe(val)
      }, {
        regex: this.regexp,
        safeValue: (val) => this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
      }];
      todos.forEach((todo) => {
        replaces = 0;
        while (match = todo.regex.exec(str)) {
          const matchedVar = match[1].trim();
          value = handleFormat(matchedVar);
          if (value === void 0) {
            if (typeof missingInterpolationHandler === "function") {
              const temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === "string" ? temp : "";
            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) {
              value = "";
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
              value = "";
            }
          } else if (typeof value !== "string" && !this.useRawValueToEscape) {
            value = makeString(value);
          }
          const safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);
          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }
          replaces++;
          if (replaces >= this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
    nest(str, fc) {
      let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      let match;
      let value;
      let clonedOptions;
      const handleHasOptions = (key, inheritedOptions) => {
        const sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        const c = key.split(new RegExp(`${sep}[ ]*{`));
        let optionsString = `{${c[1]}`;
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        const matchedSingleQuotes = optionsString.match(/'/g);
        const matchedDoubleQuotes = optionsString.match(/"/g);
        if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
          optionsString = optionsString.replace(/'/g, '"');
        }
        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = {
            ...inheritedOptions,
            ...clonedOptions
          };
        } catch (e) {
          this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
          return `${key}${sep}${optionsString}`;
        }
        if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
        return key;
      };
      while (match = this.nestingRegexp.exec(str)) {
        let formatters = [];
        clonedOptions = {
          ...options
        };
        clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
        clonedOptions.applyPostProcessor = false;
        delete clonedOptions.defaultValue;
        let doReduce = false;
        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          const r2 = match[1].split(this.formatSeparator).map((elem) => elem.trim());
          match[1] = r2.shift();
          formatters = r2;
          doReduce = true;
        }
        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== "string") return value;
        if (typeof value !== "string") value = makeString(value);
        if (!value) {
          this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
          value = "";
        }
        if (doReduce) {
          value = formatters.reduce((v, f) => this.format(v, f, options.lng, {
            ...options,
            interpolationkey: match[1].trim()
          }), value.trim());
        }
        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }
      return str;
    }
  }
  const parseFormatStr = (formatStr) => {
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
      const p = formatStr.split("(");
      formatName = p[0].toLowerCase().trim();
      const optStr = p[1].substring(0, p[1].length - 1);
      if (formatName === "currency" && optStr.indexOf(":") < 0) {
        if (!formatOptions.currency) formatOptions.currency = optStr.trim();
      } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
        if (!formatOptions.range) formatOptions.range = optStr.trim();
      } else {
        const opts = optStr.split(";");
        opts.forEach((opt) => {
          if (opt) {
            const [key, ...rest] = opt.split(":");
            const val = rest.join(":").trim().replace(/^'+|'+$/g, "");
            const trimmedKey = key.trim();
            if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
            if (val === "false") formatOptions[trimmedKey] = false;
            if (val === "true") formatOptions[trimmedKey] = true;
            if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
          }
        });
      }
    }
    return {
      formatName,
      formatOptions
    };
  };
  const createCachedFormatter = (fn) => {
    const cache = {};
    return (val, lng, options) => {
      let optForCache = options;
      if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) {
        optForCache = {
          ...optForCache,
          [options.interpolationkey]: void 0
        };
      }
      const key = lng + JSON.stringify(optForCache);
      let formatter = cache[key];
      if (!formatter) {
        formatter = fn(getCleanedCode(lng), options);
        cache[key] = formatter;
      }
      return formatter(val);
    };
  };
  class Formatter {
    constructor() {
      let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      this.logger = baseLogger.create("formatter");
      this.options = options;
      this.formats = {
        number: createCachedFormatter((lng, opt) => {
          const formatter = new Intl.NumberFormat(lng, {
            ...opt
          });
          return (val) => formatter.format(val);
        }),
        currency: createCachedFormatter((lng, opt) => {
          const formatter = new Intl.NumberFormat(lng, {
            ...opt,
            style: "currency"
          });
          return (val) => formatter.format(val);
        }),
        datetime: createCachedFormatter((lng, opt) => {
          const formatter = new Intl.DateTimeFormat(lng, {
            ...opt
          });
          return (val) => formatter.format(val);
        }),
        relativetime: createCachedFormatter((lng, opt) => {
          const formatter = new Intl.RelativeTimeFormat(lng, {
            ...opt
          });
          return (val) => formatter.format(val, opt.range || "day");
        }),
        list: createCachedFormatter((lng, opt) => {
          const formatter = new Intl.ListFormat(lng, {
            ...opt
          });
          return (val) => formatter.format(val);
        })
      };
      this.init(options);
    }
    init(services) {
      let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      };
      const iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
    }
    add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
      this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
    format(value, format, lng) {
      let options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      const formats = format.split(this.formatSeparator);
      if (formats.length > 1 && formats[0].indexOf("(") > 1 && formats[0].indexOf(")") < 0 && formats.find((f) => f.indexOf(")") > -1)) {
        const lastIndex = formats.findIndex((f) => f.indexOf(")") > -1);
        formats[0] = [formats[0], ...formats.splice(1, lastIndex)].join(this.formatSeparator);
      }
      const result = formats.reduce((mem, f) => {
        const {
          formatName,
          formatOptions
        } = parseFormatStr(f);
        if (this.formats[formatName]) {
          let formatted = mem;
          try {
            const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = this.formats[formatName](mem, l, {
              ...formatOptions,
              ...options,
              ...valOptions
            });
          } catch (error) {
            this.logger.warn(error);
          }
          return formatted;
        } else {
          this.logger.warn(`there was no format function for ${formatName}`);
        }
        return mem;
      }, value);
      return result;
    }
  }
  const removePending = (q, name) => {
    if (q.pending[name] !== void 0) {
      delete q.pending[name];
      q.pendingCount--;
    }
  };
  class Connector extends EventEmitter {
    constructor(backend, store, services) {
      let options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      super();
      this.backend = backend;
      this.store = store;
      this.services = services;
      this.languageUtils = services.languageUtils;
      this.options = options;
      this.logger = baseLogger.create("backendConnector");
      this.waitingReads = [];
      this.maxParallelReads = options.maxParallelReads || 10;
      this.readingCalls = 0;
      this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
      this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
      this.state = {};
      this.queue = [];
      if (this.backend && this.backend.init) {
        this.backend.init(services, options.backend, options);
      }
    }
    queueLoad(languages, namespaces, options, callback) {
      const toLoad = {};
      const pending = {};
      const toLoadLanguages = {};
      const toLoadNamespaces = {};
      languages.forEach((lng) => {
        let hasAllNamespaces = true;
        namespaces.forEach((ns) => {
          const name = `${lng}|${ns}`;
          if (!options.reload && this.store.hasResourceBundle(lng, ns)) {
            this.state[name] = 2;
          } else if (this.state[name] < 0) ;
          else if (this.state[name] === 1) {
            if (pending[name] === void 0) pending[name] = true;
          } else {
            this.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === void 0) pending[name] = true;
            if (toLoad[name] === void 0) toLoad[name] = true;
            if (toLoadNamespaces[ns] === void 0) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });
      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback
        });
      }
      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
    loaded(name, err, data) {
      const s = name.split("|");
      const lng = s[0];
      const ns = s[1];
      if (err) this.emit("failedLoading", lng, ns, err);
      if (!err && data) {
        this.store.addResourceBundle(lng, ns, data, void 0, void 0, {
          skipCopy: true
        });
      }
      this.state[name] = err ? -1 : 2;
      if (err && data) this.state[name] = 0;
      const loaded = {};
      this.queue.forEach((q) => {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);
        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach((l) => {
            if (!loaded[l]) loaded[l] = {};
            const loadedKeys = q.loaded[l];
            if (loadedKeys.length) {
              loadedKeys.forEach((n) => {
                if (loaded[l][n] === void 0) loaded[l][n] = true;
              });
            }
          });
          q.done = true;
          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit("loaded", loaded);
      this.queue = this.queue.filter((q) => !q.done);
    }
    read(lng, ns, fcName) {
      let tried = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
      let wait = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout;
      let callback = arguments.length > 5 ? arguments[5] : void 0;
      if (!lng.length) return callback(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng,
          ns,
          fcName,
          tried,
          wait,
          callback
        });
        return;
      }
      this.readingCalls++;
      const resolver = (err, data) => {
        this.readingCalls--;
        if (this.waitingReads.length > 0) {
          const next = this.waitingReads.shift();
          this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }
        if (err && data && tried < this.maxRetries) {
          setTimeout(() => {
            this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }
        callback(err, data);
      };
      const fc = this.backend[fcName].bind(this.backend);
      if (fc.length === 2) {
        try {
          const r2 = fc(lng, ns);
          if (r2 && typeof r2.then === "function") {
            r2.then((data) => resolver(null, data)).catch(resolver);
          } else {
            resolver(null, r2);
          }
        } catch (err) {
          resolver(err);
        }
        return;
      }
      return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
      let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      let callback = arguments.length > 3 ? arguments[3] : void 0;
      if (!this.backend) {
        this.logger.warn("No backend was added via i18next.use. Will not load resources.");
        return callback && callback();
      }
      if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === "string") namespaces = [namespaces];
      const toLoad = this.queueLoad(languages, namespaces, options, callback);
      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }
      toLoad.toLoad.forEach((name) => {
        this.loadOne(name);
      });
    }
    load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
    loadOne(name) {
      let prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      const s = name.split("|");
      const lng = s[0];
      const ns = s[1];
      this.read(lng, ns, "read", void 0, void 0, (err, data) => {
        if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
        if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
        this.loaded(name, err, data);
      });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      let options = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
      let clb = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
      };
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
        return;
      }
      if (key === void 0 || key === null || key === "") return;
      if (this.backend && this.backend.create) {
        const opts = {
          ...options,
          isUpdate
        };
        const fc = this.backend.create.bind(this.backend);
        if (fc.length < 6) {
          try {
            let r2;
            if (fc.length === 5) {
              r2 = fc(languages, namespace, key, fallbackValue, opts);
            } else {
              r2 = fc(languages, namespace, key, fallbackValue);
            }
            if (r2 && typeof r2.then === "function") {
              r2.then((data) => clb(null, data)).catch(clb);
            } else {
              clb(null, r2);
            }
          } catch (err) {
            clb(err);
          }
        } else {
          fc(languages, namespace, key, fallbackValue, clb, opts);
        }
      }
      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }
  const get = () => ({
    debug: false,
    initImmediate: true,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: "all",
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: "fallback",
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: false,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: (args) => {
      let ret = {};
      if (typeof args[1] === "object") ret = args[1];
      if (typeof args[1] === "string") ret.defaultValue = args[1];
      if (typeof args[2] === "string") ret.tDescription = args[2];
      if (typeof args[2] === "object" || typeof args[3] === "object") {
        const options = args[3] || args[2];
        Object.keys(options).forEach((key) => {
          ret[key] = options[key];
        });
      }
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: (value) => value,
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: true
    }
  });
  const transformOptions = (options) => {
    if (typeof options.ns === "string") options.ns = [options.ns];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [options.fallbackLng];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [options.fallbackNS];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) {
      options.supportedLngs = options.supportedLngs.concat(["cimode"]);
    }
    return options;
  };
  const noop = () => {
  };
  const bindMemberFunctions = (inst) => {
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem) => {
      if (typeof inst[mem] === "function") {
        inst[mem] = inst[mem].bind(inst);
      }
    });
  };
  class I18n extends EventEmitter {
    constructor() {
      let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      let callback = arguments.length > 1 ? arguments[1] : void 0;
      super();
      this.options = transformOptions(options);
      this.services = {};
      this.logger = baseLogger;
      this.modules = {
        external: []
      };
      bindMemberFunctions(this);
      if (callback && !this.isInitialized && !options.isClone) {
        if (!this.options.initImmediate) {
          this.init(options, callback);
          return this;
        }
        setTimeout(() => {
          this.init(options, callback);
        }, 0);
      }
    }
    init() {
      var _this = this;
      let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      let callback = arguments.length > 1 ? arguments[1] : void 0;
      this.isInitializing = true;
      if (typeof options === "function") {
        callback = options;
        options = {};
      }
      if (!options.defaultNS && options.defaultNS !== false && options.ns) {
        if (typeof options.ns === "string") {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf("translation") < 0) {
          options.defaultNS = options.ns[0];
        }
      }
      const defOpts = get();
      this.options = {
        ...defOpts,
        ...this.options,
        ...transformOptions(options)
      };
      if (this.options.compatibilityAPI !== "v1") {
        this.options.interpolation = {
          ...defOpts.interpolation,
          ...this.options.interpolation
        };
      }
      if (options.keySeparator !== void 0) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }
      if (options.nsSeparator !== void 0) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }
      const createClassOnDemand = (ClassOrObject) => {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === "function") return new ClassOrObject();
        return ClassOrObject;
      };
      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }
        let formatter;
        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== "undefined") {
          formatter = Formatter;
        }
        const lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        const s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on("*", function(event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          _this.emit(event, ...args);
        });
        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
        }
        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }
        this.translator = new Translator(this.services, this.options);
        this.translator.on("*", function(event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          _this.emit(event, ...args);
        });
        this.modules.external.forEach((m) => {
          if (m.init) m.init(this);
        });
      }
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;
      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
      }
      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn("init: no languageDetector is used and no lng is defined");
      }
      const storeApi = ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"];
      storeApi.forEach((fcName) => {
        this[fcName] = function() {
          return _this.store[fcName](...arguments);
        };
      });
      const storeApiChained = ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"];
      storeApiChained.forEach((fcName) => {
        this[fcName] = function() {
          _this.store[fcName](...arguments);
          return _this;
        };
      });
      const deferred = defer();
      const load = () => {
        const finish = (err, t) => {
          this.isInitializing = false;
          if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn("init: i18next is already initialized. You should call init just once!");
          this.isInitialized = true;
          if (!this.options.isClone) this.logger.log("initialized", this.options);
          this.emit("initialized", this.options);
          deferred.resolve(t);
          callback(err, t);
        };
        if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return finish(null, this.t.bind(this));
        this.changeLanguage(this.options.lng, finish);
      };
      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }
      return deferred;
    }
    loadResources(language) {
      let callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
      let usedCallback = callback;
      const usedLng = typeof language === "string" ? language : this.language;
      if (typeof language === "function") usedCallback = language;
      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
        const toLoad = [];
        const append = (lng) => {
          if (!lng) return;
          if (lng === "cimode") return;
          const lngs = this.services.languageUtils.toResolveHierarchy(lng);
          lngs.forEach((l) => {
            if (l === "cimode") return;
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };
        if (!usedLng) {
          const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach((l) => append(l));
        } else {
          append(usedLng);
        }
        if (this.options.preload) {
          this.options.preload.forEach((l) => append(l));
        }
        this.services.backendConnector.load(toLoad, this.options.ns, (e) => {
          if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
    reloadResources(lngs, ns, callback) {
      const deferred = defer();
      if (typeof lngs === "function") {
        callback = lngs;
        lngs = void 0;
      }
      if (typeof ns === "function") {
        callback = ns;
        ns = void 0;
      }
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, (err) => {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
    use(module2) {
      if (!module2) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
      if (!module2.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
      if (module2.type === "backend") {
        this.modules.backend = module2;
      }
      if (module2.type === "logger" || module2.log && module2.warn && module2.error) {
        this.modules.logger = module2;
      }
      if (module2.type === "languageDetector") {
        this.modules.languageDetector = module2;
      }
      if (module2.type === "i18nFormat") {
        this.modules.i18nFormat = module2;
      }
      if (module2.type === "postProcessor") {
        postProcessor.addPostProcessor(module2);
      }
      if (module2.type === "formatter") {
        this.modules.formatter = module2;
      }
      if (module2.type === "3rdParty") {
        this.modules.external.push(module2);
      }
      return this;
    }
    setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (["cimode", "dev"].indexOf(l) > -1) return;
      for (let li = 0; li < this.languages.length; li++) {
        const lngInLngs = this.languages[li];
        if (["cimode", "dev"].indexOf(lngInLngs) > -1) continue;
        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
    changeLanguage(lng, callback) {
      var _this2 = this;
      this.isLanguageChangingTo = lng;
      const deferred = defer();
      this.emit("languageChanging", lng);
      const setLngProps = (l) => {
        this.language = l;
        this.languages = this.services.languageUtils.toResolveHierarchy(l);
        this.resolvedLanguage = void 0;
        this.setResolvedLanguage(l);
      };
      const done = (err, l) => {
        if (l) {
          setLngProps(l);
          this.translator.changeLanguage(l);
          this.isLanguageChangingTo = void 0;
          this.emit("languageChanged", l);
          this.logger.log("languageChanged", l);
        } else {
          this.isLanguageChangingTo = void 0;
        }
        deferred.resolve(function() {
          return _this2.t(...arguments);
        });
        if (callback) callback(err, function() {
          return _this2.t(...arguments);
        });
      };
      const setLng = (lngs) => {
        if (!lng && !lngs && this.services.languageDetector) lngs = [];
        const l = typeof lngs === "string" ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
        if (l) {
          if (!this.language) {
            setLngProps(l);
          }
          if (!this.translator.language) this.translator.changeLanguage(l);
          if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
        }
        this.loadResources(l, (err) => {
          done(err, l);
        });
      };
      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        if (this.services.languageDetector.detect.length === 0) {
          this.services.languageDetector.detect().then(setLng);
        } else {
          this.services.languageDetector.detect(setLng);
        }
      } else {
        setLng(lng);
      }
      return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
      var _this3 = this;
      const fixedT = function(key, opts) {
        let options;
        if (typeof opts !== "object") {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }
          options = _this3.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = {
            ...opts
          };
        }
        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        if (options.keyPrefix !== "") options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
        const keySeparator = _this3.options.keySeparator || ".";
        let resultKey;
        if (options.keyPrefix && Array.isArray(key)) {
          resultKey = key.map((k) => `${options.keyPrefix}${keySeparator}${k}`);
        } else {
          resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
        }
        return _this3.t(resultKey, options);
      };
      if (typeof lng === "string") {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }
      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
    t() {
      return this.translator && this.translator.translate(...arguments);
    }
    exists() {
      return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
      let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!this.isInitialized) {
        this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
        return false;
      }
      if (!this.languages || !this.languages.length) {
        this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
        return false;
      }
      const lng = options.lng || this.resolvedLanguage || this.languages[0];
      const fallbackLng = this.options ? this.options.fallbackLng : false;
      const lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === "cimode") return true;
      const loadNotPending = (l, n) => {
        const loadState = this.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 0 || loadState === 2;
      };
      if (options.precheck) {
        const preResult = options.precheck(this, loadNotPending);
        if (preResult !== void 0) return preResult;
      }
      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
    loadNamespaces(ns, callback) {
      const deferred = defer();
      if (!this.options.ns) {
        if (callback) callback();
        return Promise.resolve();
      }
      if (typeof ns === "string") ns = [ns];
      ns.forEach((n) => {
        if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
      });
      this.loadResources((err) => {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
    loadLanguages(lngs, callback) {
      const deferred = defer();
      if (typeof lngs === "string") lngs = [lngs];
      const preloaded = this.options.preload || [];
      const newLngs = lngs.filter((lng) => preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }
      this.options.preload = preloaded.concat(newLngs);
      this.loadResources((err) => {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
    dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return "rtl";
      const rtlLngs = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"];
      const languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
      return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
    static createInstance() {
      let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      let callback = arguments.length > 1 ? arguments[1] : void 0;
      return new I18n(options, callback);
    }
    cloneInstance() {
      let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      let callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
      const forkResourceStore = options.forkResourceStore;
      if (forkResourceStore) delete options.forkResourceStore;
      const mergedOptions = {
        ...this.options,
        ...options,
        ...{
          isClone: true
        }
      };
      const clone = new I18n(mergedOptions);
      if (options.debug !== void 0 || options.prefix !== void 0) {
        clone.logger = clone.logger.clone(options);
      }
      const membersToCopy = ["store", "services", "language"];
      membersToCopy.forEach((m) => {
        clone[m] = this[m];
      });
      clone.services = {
        ...this.services
      };
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      if (forkResourceStore) {
        clone.store = new ResourceStore(this.store.data, mergedOptions);
        clone.services.resourceStore = clone.store;
      }
      clone.translator = new Translator(clone.services, mergedOptions);
      clone.translator.on("*", function(event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }
        clone.emit(event, ...args);
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = mergedOptions;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
    toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }
  const instance = I18n.createInstance();
  instance.createInstance = I18n.createInstance;
  instance.createInstance;
  instance.dir;
  instance.init;
  instance.loadResources;
  instance.reloadResources;
  instance.use;
  instance.changeLanguage;
  instance.getFixedT;
  instance.t;
  instance.exists;
  instance.setDefaultNamespace;
  instance.hasLoadedNamespace;
  instance.loadNamespaces;
  instance.loadLanguages;
  const i18next = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: instance
  }, Symbol.toStringTag, { value: "Module" }));
  const general$4 = {
    add: "Hinzufügen",
    cancel: "Abbrechen",
    clear: "Löschen",
    close: "Schließen",
    "delete": "Löschen",
    edit: "Bearbeiten",
    save: "Speichern"
  };
  const de_DE = {
    general: general$4
  };
  const de_DE$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: de_DE,
    general: general$4
  }, Symbol.toStringTag, { value: "Module" }));
  const general$3 = {
    add: "Add",
    cancel: "Cancel",
    clear: "Clear",
    close: "Close",
    "delete": "Delete",
    edit: "Edit",
    save: "Save"
  };
  const en_US = {
    general: general$3
  };
  const en_US$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: en_US,
    general: general$3
  }, Symbol.toStringTag, { value: "Module" }));
  const general$2 = {
    clear: "Limpiar"
  };
  const es_ES = {
    general: general$2
  };
  const es_ES$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: es_ES,
    general: general$2
  }, Symbol.toStringTag, { value: "Module" }));
  const general$1 = {
    clear: "Vider"
  };
  const fr_FR = {
    general: general$1
  };
  const fr_FR$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: fr_FR,
    general: general$1
  }, Symbol.toStringTag, { value: "Module" }));
  const general = {
    clear: "Sgomberare"
  };
  const it_IT = {
    general
  };
  const it_IT$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: it_IT,
    general
  }, Symbol.toStringTag, { value: "Module" }));
  exports2.Accordion = Accordion;
  exports2.AlertCircleSmall = SvgIc24AlertCircle;
  exports2.AlertCircleXs = SvgIcAlertCircle16;
  exports2.ArrowRightSmall = SvgIc24ArrowRight;
  exports2.ArrowRightXs = SvgIc16ArrowRight;
  exports2.Badge = Badge;
  exports2.BadgeInfo = BadgeInfo;
  exports2.BadgeInteractive = BadgeInteractive;
  exports2.BadgeNotify = BadgeNotify;
  exports2.Banner = Banner;
  exports2.BlitzButton = BlitzButton;
  exports2.BlitzButtonCompat = BlitzButtonCompat;
  exports2.Body = Body$1;
  exports2.BodyHighlight = BodyHighlight;
  exports2.BodyLink = BodyLink;
  exports2.BodySmall = BodySmall;
  exports2.BodySmallHighlight = BodySmallHighlight;
  exports2.BodySmallLink = BodySmallLink;
  exports2.Button = Button;
  exports2.Cancel = SvgIcCancel24Px;
  exports2.CancelCircleFilledSmall = SvgIc24CancelCircleFilled;
  exports2.CancelCircleFilledXs = SvgIc16CancelCircleFilled;
  exports2.Caption = Caption;
  exports2.Card = Card;
  exports2.CardContent = CardContent;
  exports2.CardHeader = CardHeader;
  exports2.CardItem = CardItem;
  exports2.CardLogpayMedium = SvgCardLogpayMsp36Px;
  exports2.CardOrderIcon = SvgIcCardOrder96Px;
  exports2.CheckCircleXs = SvgIcCheckCircle16;
  exports2.CheckSmall = SvgIc24Check;
  exports2.Checkbox = Checkbox;
  exports2.CheckboxChecked = SvgIcCheckboxChecked24Px;
  exports2.CheckboxIndeterminate = SvgIcCheckboxIndeterminate24Px;
  exports2.CheckboxUnchecked = SvgIcCheckboxUnchecked24Px;
  exports2.ChevronRight = SvgIcChevronRight24Px;
  exports2.Chip = Chip;
  exports2.ConnectorStatus = ConnectorStatus;
  exports2.Dialog = Dialog;
  exports2.DialogBody = DialogBody;
  exports2.DialogFooter = DialogFooter;
  exports2.DialogHeader = DialogHeader;
  exports2.Display1 = Display1;
  exports2.DownloadSmall = SvgIc24Download;
  exports2.DownloadXs = SvgIc16Download;
  exports2.DropdownSmall = SvgIcDropdown24Px;
  exports2.ElliTheme = theme;
  exports2.FavoriteXs = SvgIcFavorite16Px;
  exports2.FormControlLabel = FormControlLabel;
  exports2.Headline = Headline;
  exports2.HelpCircleSmall = SvgIc24HelpCircle;
  exports2.Icon = Icon$2;
  exports2.IconSwatch = IconSwatch;
  exports2.InfoCircleSmall = SvgIc24InfoCircle;
  exports2.InfoCircleXs = SvgIcInfoCircle16;
  exports2.Label = Label$1;
  exports2.LabelMedium = LabelMedium;
  exports2.LabelSmall = LabelSmall;
  exports2.LanguageDropdown = LanguageDropdown;
  exports2.Link = Link;
  exports2.LinkStandalone = LinkStandalone;
  exports2.OpenInFullSmall = SvgIc24OpenInFull;
  exports2.OpenInFullXs = SvgIc16OpenInFull;
  exports2.OpenInNewSmall = SvgIc24OpenInNew;
  exports2.OpenInNewXs = SvgIc16OpenInNew;
  exports2.ProgressBar = ProgressBar;
  exports2.Radio = Radio;
  exports2.RadioChecked = SvgIcRadiobuttonChecked24Px;
  exports2.RadioTile = RadioTile;
  exports2.RadioUnchecked = SvgIcRadiobuttonUnchecked24Px;
  exports2.StationMedium = SvgIcStationbig40Px;
  exports2.Switch = Switch;
  exports2.Title1 = Title1;
  exports2.Title2 = Title2;
  exports2.VariantMapping = VariantMapping;
  exports2.WorldSmall = SvgIcWorld24Px;
  exports2.getLinkStyles = getLinkStyles;
  exports2.getSpinnerOrIcon = getSpinnerOrIcon;
  exports2.iconNamesList = iconNamesList;
  exports2.useResizeObserver = useResizeObserver;
  Object.defineProperty(exports2, Symbol.toStringTag, { value: "Module" });
});
